if (location.hostname == "localhost") {
  location.hostname = "127.0.0.1";
}
var sharedObj =
  typeof __LOADER__sharedObj == "undefined" ? {} : __LOADER__sharedObj;
// CanvasRenderingContext2D.prototype.save = new Proxy(
//   CanvasRenderingContext2D.prototype.save,
//   {
//     apply: function (target, that, args) {
//       try {
//         var res = Function.prototype.apply.apply(target, [that, args]);
//       } catch (err) {
//         err.stack = err.stack.replace(/\n.*Object\.apply.*/, "");
//         throw err;
//       }
//       if (args != 1) {
//         io_dc(null, "000002");
//       }
//       return res;
//     },
//   },
// );
require("./libs/browser-sentry.js");
var config = require("./config.js");
// var hasRequire = (0, eval)("typeof require == \"function\"") && config.isProd;
var hasRequire = false;
var webdriver = navigator.webdriver;
Object.defineProperty(navigator, "webdriver", {
  configurable: false,
  writable: false,
});
var hasArray = [] instanceof Array;
Object.defineProperty(window, "setTimeout", {
  configurable: false,
  writable: false,
});
Object.defineProperty(window, "clearTimeout", {
  configurable: false,
  writable: false,
});
Object.defineProperty(window, "setInterval", {
  configurable: false,
  writable: false,
});
Object.defineProperty(window, "clearInterval", {
  configurable: false,
  writable: false,
});
Object.defineProperty(CanvasRenderingContext2D.prototype, "measureText", {
  configurable: false,
  writable: false,
});
Object.defineProperty(CanvasRenderingContext2D.prototype, "fillText", {
  configurable: false,
  writable: false,
});

// STORAGE
var canStore = typeof Storage != "undefined";
function deleteVal(e) {
  if (canStore) {
    localStorage.removeItem(e);
  }
}
window.saveVal = function (e, t) {
  if (canStore) {
    localStorage.setItem(e, t);
  }
};
window.getSavedVal = function (e) {
  if (canStore) {
    return localStorage.getItem(e);
  } else {
    return null;
  }
};
var i18n = new (require("./libs/i18n.js"))();
function getCaptcha(callback) {
  if (typeof grecaptcha == "undefined") {
    callback(null, true);
  } else {
    grecaptcha.execute(config.recaptchaKey).then((key) => {
      callback(key);
    });
  }
}

// OPEN LINK:
window.openURL = function (hj) {
  window.open(hj, "_blank");
};
var hiddenPropertyName;
var hiddenPropertyName;
var isDocumentHidden = false;
if (document.hidden === undefined) {
  if (document.msHidden === undefined) {
    if (document.webkitHidden !== undefined) {
      hiddenPropertyName = "webkitHidden";
      hiddenPropertyName = "webkitvisibilitychange";
    }
  } else {
    hiddenPropertyName = "msHidden";
    hiddenPropertyName = "msvisibilitychange";
  }
} else {
  hiddenPropertyName = "hidden";
  hiddenPropertyName = "visibilitychange";
}
if (document.addEventListener !== undefined && hiddenPropertyName !== undefined) {
  document.addEventListener(
    hiddenPropertyName,
    function () {
      isDocumentHidden = document[hiddenPropertyName];
    },
    false,
  );
}
if (navigator.brave != null) {
  braveWarning.style.display = "block";
}
var params = new URLSearchParams(
  window.location.search.replace("#", "%23").replace("+", "%2B"),
);
var autoQueue = params.has("autoQueue");
var party = params.get("party");
var play = params.get("play");
var mod = params.get("mod");
var access_token = params.get("access_token");
var audioInputOptions = {
  default: "Default",
};
window.updateAudioInputs = function () {
  if (
    navigator &&
    navigator.mediaDevices &&
    navigator.mediaDevices.enumerateDevices
  ) {
    navigator.mediaDevices.enumerateDevices().then(function (devices) {
      var audioInputs = devices.filter(function (device) {
        return device.kind == "audioinput";
      });
      audioInputOptions = audioInputs.length
        ? Object.fromEntries(
            Object.keys(audioInputs).map(function (key) {
              return [
                audioInputs[key].deviceId,
                audioInputs[key].label || "Unknown Device",
              ];
            }),
          )
        : {
            default: "Default",
          };
      if (settings && settings.list && settings.list.audioInput) {
        settings.list.audioInput.options = audioInputOptions;
      }
    });
  }
};
window.getAudioInputs = function () {
  return audioInputOptions;
};
window.updateAudioInputs();

// INITIATE MATCHMAKER:
var ClientManager = require("./libs/ClientManager.js").default;
ClientManager.PING_REGION_CACHE_KEY = "pingRegion7";
var client = new ClientManager(config.matchmakerURL, config.availableRegions);
var gameId = null;
function switchServer(id) {
  client.switchGame(id);
}
window.switchServer = switchServer;
window.checkedSwitchServer = function (hj, serverPCount) {
  serverPCount.textContent = "...";
  client
    .fetchGameInfo(hj)
    .then((hl) => {
      var [gameId, regionId, players, maxPlayers, meta] = hl;
      if (players >= maxPlayers) {
        serverPCount.textContent = i18n.t("matchmaker.full");
      } else {
        switchServer(hj);
      }
      setTimeout(() => {
        serverPCount.textContent =
          Math.min(players, maxPlayers) + "/" + maxPlayers;
      }, 1000);
    })
    .catch(() => {
      serverPCount.textContent = "ERROR";
    });
};
var isInitialPartyStatus = false;
var queuedHostReloadTimeoutId = null;
var party = null;
var hasStartedJoinCountdown = false;

// PRIVATE ROOM:
function initQueueSession(clientId, clientKey, status) {
  if (clientId) {
    client.queue({
      clientKey: clientKey,
      clientId: clientId,
      statusCallback: function (res) {
        CONTROLS.idleTimer = 0;
        if (!equal(party, res)) {
          if (res) {
            saveVal("krk_lastPartyId", res.partyId);
          }
          isInitialPartyStatus = party == null;
          party = res;
          updateQueueStatus();
        }
      },
      hostCallback: function (host, port, pendingGameId) {
        queuedHostReloadTimeoutId = setTimeout(function () {
          joiningGame = true;
          saveVal("queueHost", host);
          saveVal("queuePort", port);
          saveVal("pgi", pendingGameId);
          client.unqueue();
          io.send("unqueue", true);
          location = "/";
          window.reload();
        }, joinCountdownSeconds * 1000);
      },
      joinCallback: function (gameId) {
        client.unqueue();
        io.send("unqueue", true);
        client.switchGame(gameId);
      },
      cancelJoinCallback: function () {
        hasStartedJoinCountdown = false;
        clearTimeout(queuedHostReloadTimeoutId);
        clearTimeout(queueCountdownTimerId);
      },
      kickCallback: function () {
        leaveQueue();
      },
    });
    return;
  } else {
    party = null;
    if (status == "AccountAlreadyPlaying") {
      updateQueueStatus(i18n.t("queue.status.already-queued"));
      setTimeout(function () {
        updateQueueStatus();
      }, 2000);
    } else {
      updateQueueStatus();
    }
    return;
  }
}
function joinQueue(startReady = false, partyIdOverride = null) {
  if (!client.queueManager) {
    var region;
    var partyId =
      partyIdOverride ||
      (function () {
        var partyKeyInput = document.getElementById("rankedPartyKey");
        if (!partyKeyInput) {
          return null;
        }
        var partyKeyText = partyKeyInput.value.trim();
        var partyUrlMatch = /\?party=([a-zA-Z0-9%_]+)/.exec(partyKeyText);
        if (partyUrlMatch && partyUrlMatch[1]) {
          partyKeyText = decodeURIComponent(partyUrlMatch[1]).trim();
        }
        return partyKeyText;
      })();
    var queueIds = getSelectedQueueIds();
    region =
      typeof queueRegionSelect == "undefined"
        ? getSavedVal("krunker_rankedRegion") ||
          localStorage[ClientManager.PING_REGION_CACHE_KEY] ||
          "us-ca-sv"
        : queueRegionSelect.value;
    saveVal("krunker_rankedRegion", region);
    io.send(
      "queue",
      client.hostname,
      region,
      queueIds,
      partyId,
      startReady,
      selectedClassIndex,
    );
    updateQueueStatus("Queuing");
  }
}
function leaveQueue() {
  if (!client.queueManager || !!client.queueManager.isQueued) {
    io.send("unqueue");
    client.unqueue();
    party = null;
    updateQueueStatus();
  }
}
window.joinQueue = joinQueue;
window.setPartyQueues = function () {
  if (party) {
    var queueIds = getSelectedQueueIds();
    client.queueUpdateQueues(queueIds);
  }
};
window.kickPartyMember = function (memberClientId) {
  if (party) {
    client.queueKickPartyMember(memberClientId);
  }
};
window.promotePartyMember = function (memberClientId) {
  if (party) {
    client.queuePromotePartyMember(memberClientId);
  }
};
window.copyPartyInviteLink = function (copiedSlotIndex) {
  if (party) {
    UTILS.copyToClipboard(
      "https://" +
        location.host +
        "/?party=" +
        encodeURIComponent(party.partyId),
    );
    windows[26].justCopied = copiedSlotIndex;
    if (windowHolder.style.display != "none") {
      updateWindow(27);
    }
    setTimeout(() => {
      windows[26].justCopied = null;
      if (windowHolder.style.display != "none") {
        updateWindow(27);
      }
    }, 1250);
  }
};
window.leaveQueue = leaveQueue;
window.setPartyReady = function () {
  if (party) {
    client.queueUpdateReady(true);
  } else {
    joinQueue(true);
  }
};
window.setPartyUnready = function () {
  if (party) {
    client.queueUpdateReady(false);
  }
};
var queueStatusMessage = null;
var queueReadyMessage = null;
var queueStatusResetTimeoutId = null;
var joinCountdownSeconds = 5;
function updateQueueStatus(statusOverride = null) {
  if (party || statusOverride) {
    if (statusOverride) {
      queueStatusMessage = statusOverride;
    } else {
      var statusData = party.status.c;
      switch (party.status.t) {
        case "Queuing":
          queueStatusMessage = i18n.t("queue.status.queuing");
          break;
        case "Queued":
          queueStatusMessage =
            party.queueIds.length == 0
              ? client.queueManager != null &&
                party.partyLeaderId == client.queueManager.queueClientId
                ? i18n.t("queue.status.no-queues")
                : i18n.t("queue.status.waiting-for-leader")
              : party.partyMembers.filter((hm) => hm.isReady).length ==
                  party.partyMembers.length
                ? i18n.t("queue.status.queued", statusData.queueSize)
                : i18n.t("queue.status.ready-up");
          break;
        case "CreatingGame":
        case "HostGame":
          if (!hasStartedJoinCountdown) {
            hasStartedJoinCountdown = true;
            (function hm(ho) {
              if (ho > 0) {
                queueCountdownTimerId = setTimeout(function () {
                  hm(ho - 1);
                }, 1000);
                playTick();
                updateQueueStatus("Joining in " + ho);
              } else {
                updateQueueStatus(i18n.t("queue.status.join"));
              }
            })(joinCountdownSeconds);
            return;
          }
          break;
        case "Join":
          queueStatusMessage = i18n.t("queue.status.join");
          break;
        default:
          console.warn("Unknown status", status);
          queueStatusMessage = "?";
      }
    }
    if (party) {
      saveVal("krk_lastQueues", JSON.stringify(party.queueIds));
      var readyMemberCount = party.partyMembers.reduce(
        (count, member) => count + (member.isReady ? 1 : 0),
        0,
      );
      queueReadyMessage =
        readyMemberCount + "/" + party.partyMembers.length + " Ready";
    } else {
      queueReadyMessage = "";
    }
    queueStatus.style.display = "inline-block";
    queueStatusMessage.innerHTML =
      queueStatusMessage + "<br/>" + queueReadyMessage;
    uiBase.classList.toggle("isQueued", true);
  } else {
    queueStatus.style.display = "none";
    uiBase.classList.toggle("isQueued", false);
    clearTimeout(queuedHostReloadTimeoutId);
    clearTimeout(queueStatusResetTimeoutId);
    queueStatusMessage = null;
    queueReadyMessage = null;
    queuedHostReloadTimeoutId = null;
    queueStatusResetTimeoutId = null;
    hasStartedJoinCountdown = false;
  }
  updatePlayInstructions();
  if (windowHolder.style.display != "none") {
    updateWindow(27);
  }
}
function getSelectedQueueIds() {
  var queueIds = Array.from(
    document.getElementsByClassName("rankedQueueOption"),
  )
    .filter((queueOption) => queueOption.checked)
    .map((queueOption) => queueOption.dataset.queueId);
  var savedQueueIdsJson = getSavedVal("krk_lastQueues");
  if (autoQueue && savedQueueIdsJson) {
    try {
      queueIds = JSON.parse(savedQueueIdsJson);
    } catch (parseError) {}
  }
  return queueIds;
}
var autoRespawnTimerId = null;
function customRoomResponse(message, gameId) {
  try {
    hostGameMsg.innerHTML = message;
  } catch (err) {}
  if (gameId) {
    (function (id) {
      var href = client.generateHref(id);
      if (!Game.config.isFromQueue) {
        window.history.replaceState({}, "Krunker", href);
      }
      windows[1].lastLoadTime = 0;
      gameId = id;
    })(gameId);
  }
  selectedCustomMapId = null;
  rawMapDataPreset = null;
}
Object.defineProperty(window, "createPrivateRoom", {
  writeable: false,
  value: function () {
    if (Game.mode && Game.mode.isRanked) {
      hostGameMsg.innerHTML =
        "<span class='error'>Can't host match while in ranked.</span>";
    } else {
      var selectedMapIndexes = [];
      var rawMapDataInput = document.getElementById("rawMapData");
      for (var optionIndex = 0; optionIndex < maps.length; optionIndex++) {
        if (maps[optionIndex] != 13) {
          var mapCheckbox = document.getElementById("gameMap" + optionIndex);
          if (mapCheckbox && mapCheckbox.checked) {
            selectedMapIndexes.push(optionIndex);
          }
        }
      }
      if (
        selectedMapIndexes.length != 0 ||
        selectedCustomMapId ||
        rawMapData.value != ""
      ) {
        var selectedModeIndexes = [];
        for (optionIndex = 0; optionIndex < MODES.length; optionIndex++) {
          if (!MODES[optionIndex].preventCustomGames) {
            if (document.getElementById("gameMode" + optionIndex).checked) {
              selectedModeIndexes.push(optionIndex);
            }
          }
        }
        if (selectedModeIndexes.length != 0) {
          var selectedClassIndexes = [];
          for (
            optionIndex = 0;
            optionIndex < Game.classes.length;
            optionIndex++
          ) {
            if (document.getElementById("gameClass" + optionIndex).checked) {
              selectedClassIndexes.push(optionIndex);
            }
          }
          if (selectedClassIndexes.length != 0) {
            var hostKeyInput = document.getElementById("hostKey");
            if (config.isComp && hostKeyInput.value == "") {
              hostGameMsg.innerHTML =
                "<span class='error'>Please Enter Key</span>";
            } else if (
              windows[7].costVal &&
              (!acc || acc.funds < windows[7].costVal)
            ) {
              hostGameMsg.innerHTML =
                "<span class='error'>Insufficient Funds</span>";
            } else {
              var passCodeInput = document.getElementById("passCode");
              if (
                passCodeInput.value != "" &&
                passCodeInput.value.length > 16
              ) {
                hostGameMsg.innerHTML =
                  "<span class='error'>Password too long</span>";
              } else {
                var shareToHubInput = document.getElementById("shareToHub");
                var customGameConfig = {
                  private: makePrivate.checked,
                  share: (shareToHubInput || {}).checked,
                  customMap: selectedCustomMapId,
                  rawMapData: rawMapDataInput ? rawMapDataInput.value : null,
                  maps: selectedMapIndexes,
                  modes: selectedModeIndexes,
                  classes: selectedClassIndexes,
                  passCode: passCodeInput ? passCodeInput.value : null,
                };
                if (config.isComp) {
                  customGameConfig.key = hostKeyInput
                    ? hostKeyInput.value
                    : null;
                }
                for (
                  optionIndex = 0;
                  optionIndex < config.serverConfig.length;
                  optionIndex++
                ) {
                  settingInput = document.getElementById(
                    "customS" + config.serverConfig[optionIndex].varN,
                  );
                  tmpV = config.serverConfig[optionIndex].bool
                    ? settingInput
                      ? settingInput.checked
                      : 0
                    : config.serverConfig[optionIndex].input
                      ? settingInput
                        ? UTILS.sanitizeStr(settingInput.value)
                        : 0
                      : config.serverConfig[optionIndex].select
                        ? config.serverConfig[optionIndex].options[
                            settingInput.value
                          ] == null
                          ? config.serverConfig[optionIndex].def
                          : parseInt(settingInput.value)
                        : settingInput
                          ? parseFloat(settingInput.value)
                          : 0;
                  customGameConfig[config.serverConfig[optionIndex].varN] =
                    tmpV;
                }
                if (windows[7].wepConf) {
                  for (
                    var weaponIndex = 0;
                    weaponIndex < Game.weapons.length;
                    weaponIndex++
                  ) {
                    for (
                      optionIndex = 0;
                      optionIndex < config.weaponConfig.length;
                      optionIndex++
                    ) {
                      if (
                        Game.weapons[weaponIndex][
                          config.weaponConfig[optionIndex].varN
                        ] != null
                      ) {
                        var settingInput = document.getElementById(
                          "customW" +
                            weaponIndex +
                            config.weaponConfig[optionIndex].varN,
                        );
                        if (config.weaponConfig[optionIndex].bool) {
                          tmpV = settingInput ? settingInput.checked : 0;
                        } else {
                          var decimalPlaces =
                            config.weaponConfig[optionIndex].decs;
                          tmpV = settingInput
                            ? UTILS.fixFloat(settingInput.value, decimalPlaces)
                            : 0;
                        }
                        if (
                          tmpV !=
                          Game.weapons[weaponIndex][
                            config.weaponConfig[optionIndex].varN
                          ]
                        ) {
                          if (!customGameConfig.weps) {
                            customGameConfig.weps = {};
                          }
                          if (!customGameConfig.weps[weaponIndex]) {
                            customGameConfig.weps[weaponIndex] = {};
                          }
                          customGameConfig.weps[weaponIndex][
                            config.weaponConfig[optionIndex].varN
                          ] = tmpV;
                        }
                      }
                    }
                  }
                }
                hostGameMsg.innerHTML = i18n.t("generic.wait");
                getCaptcha(function (key, error) {
                  if (error) {
                    customRoomResponse("Please try again.");
                  } else {
                    io.send("custom", customGameConfig, key);
                  }
                });
              }
            }
          } else {
            hostGameMsg.innerHTML =
              "<span class='error'>" +
              i18n.t("custom.class.missing") +
              "</span>";
          }
        } else {
          hostGameMsg.innerHTML =
            "<span class='error'>" + i18n.t("custom.mode.missing") + "</span>";
        }
      } else {
        hostGameMsg.innerHTML =
          "<span class='error'>" + i18n.t("custom.map.missing") + "</span>";
      }
    }
  },
});

// OVERWRITE CONSOLE:
Object.defineProperty(console, "_commandLineAPI", {
  get: function () {
    throw "";
  },
});
Object.defineProperty(window, "requestAnimFrame", {
  writeable: false,
  value:
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function (hj) {
      window.setTimeout(hj, 1000 / 60);
    },
});
var lastFixedFrameTime = Date.now();
window.requestAnimFrameF = function (frameCallback, frameTime) {
  var delayMs = Math.max(0, 16 - (frameTime - lastFixedFrameTime));
  var timeoutId = window.setTimeout(function () {
    frameCallback(frameTime + delayMs);
  }, delayMs);
  lastFixedFrameTime = frameTime + delayMs;
  return timeoutId;
};
var UI = require("./libs/UI.js");
var streamers = require("./data/streamers.js");
var COLORS = require("./data/colors.js");
var equal = require("fast-deep-equal");
var prices = require("./data/prices.js");
var MODES = require("./data/modes.js");
var Account = require("./data/account.js");
var THREE = require("three");
THREE.OBJLoader = require("./libs/OBJLoader.js")(THREE);
THREE.GLTFLoader = require("./libs/GLTFLoader.js")(THREE);
THREE.Shaders = require("./libs/shaders.js")(THREE);
var UTILS = require("./libs/utils.js");
var overlay = require("./libs/game-overlay.js");
var Game = require("./data/game.js").obj;
var shaderRendering = getSavedVal("kro_setngss_shaderRendering") == "true";
var RENDER = new (require("./libs/render.js"))(
  THREE,
  UTILS,
  COLORS,
  config,
  overlay,
  UI,
  false,
  shaderRendering,
);
var SOUND = (window.SOUND = new (require("./libs/sound.js"))(UTILS, config));
var PARTICLES = new (require("./libs/particles.js"))(RENDER, config);
var DIV = new (require("./libs/animDiv.js"))(RENDER, config);
var API_CLIENT = require("./libs/apiClient.js");
var io = require("./libs/io-client.js");
Game = new Game(false, 0, null, RENDER, SOUND, PARTICLES);
var CONTROLS = new (require("./libs/controls.js"))(
  RENDER,
  THREE,
  UI,
  UTILS,
  Game,
  config,
  io,
);
Game.controls = CONTROLS;
var player;
var acc;
var serverSetting;
var eventOtherPlayer;
var currentInputFrame;
var freeMouseLookAngle;
var billboardBidTimeLeft;
var initGameUI = require("./ui/init.js").init.game(Game, UTILS, config);
var settings = new (require("./libs/settings.js"))(
  UTILS,
  config,
  RENDER,
  PARTICLES,
  CONTROLS,
  Game,
  ClientManager,
  initGameUI,
  UI,
  overlay,
  COLORS,
  io,
  i18n,
);
var maps = require("./data/map.js").maps;
var Player = require("./data/players.js").Player;
var Filter = new (require("unwashed-words"))();
var version = require("../version.json");
var hostSocketId = null;
window.locked = false;
var frameTimeMs;
var deltaMs;
var unscaledDeltaMs;
var lastFrameTime;
var lastRateLimitTime;
var endAnimationTimeLeft;
var tempElement;
var dirs = {};
var lastInputValues = {};
var freeMouseRay = new THREE.Ray();
var inputDeltaTimes = [];
var compressedAimDeltas = [];
var lastSentAimDeltas = [];
var freeMouseHitPoint = new THREE.Vector3();
var freeMouseAimPlane = new THREE.Plane();
var isLobbyHost = false;
var firstInputSeq = null;
var hasChangedInputFields = false;
var inputSendTimer = 0;
var queuedInputCount = 0;
var localTeam = 0;
var propCameraDistance = 30;
var menuCameraYaw = 0;
var pendingScoreDelta = 0;
var currentPing = -1;
var hasSentEndMessage = false;
var activeVoteKickTarget = false;
var fadingMessageEntries = [];
var leaderboardData = null;
var selectedClassIndex = 0;
var localStreakCount = 0;
var customMapSupportData = [];
var hasShownMapSupportPrompt = false;
var handledVoteKickAliases = [];
var hasStartedVoteKick = false;
var lastReconciliationAt = 0;
var kpdData = null;
var useDefaultSkins = false;
var hasReportedInjectedUi = false;
var krk_lastMod = getSavedVal("krk_lastMod") || "";
function setLastMod(value) {
  krk_lastMod = value;
  saveVal("krk_lastMod", value);
}
setLastMod(krk_lastMod);
var crosshairScale;
var packetStatsIntervalId;
var scale = 1;
window.scaleBase = function () {
  if (!settings.tmp.uiScaling) {
    uiBase.style.transform = "";
    uiBase.style.width = "";
    uiBase.style.height = "";
    crosshairScale = window.innerHeight / 1 / 693;
    RENDER.resize();
    return;
  }
  var viewportHeight = window.innerHeight;
  var viewportWidth = window.innerWidth;
  var targetUiWidth = settings.tmp.uiCustomScale * 1700;
  var targetUiHeight = settings.tmp.uiCustomScale * 900;
  var widthScale = viewportWidth / targetUiWidth;
  var heightScale = viewportHeight / targetUiHeight;
  if (heightScale < widthScale) {
    scale = heightScale;
    uiBase.style.transform = "scale(" + heightScale.toFixed(3) + ")";
    uiBase.style.width = (viewportWidth / heightScale).toFixed(3) + "px";
    uiBase.style.height = targetUiHeight + "px";
  } else {
    scale = widthScale;
    uiBase.style.transform = "scale(" + widthScale.toFixed(3) + ")";
    uiBase.style.width = targetUiWidth + "px";
    uiBase.style.height = (viewportHeight / widthScale).toFixed(3) + "px";
  }
  crosshairScale = viewportHeight / scale / 693;
  RENDER.resize();
};

// RESIZE:
window.addEventListener("resize", scaleBase);
scaleBase();
window.refreshChat = function () {
  while (chatList.childNodes.length >= config.chatListLength) {
    var oldestChatNode = chatList.childNodes[0];
    fadingMessageEntries[
      parseInt(oldestChatNode.id.replace("chatMsg_", ""))
    ].life = 0;
    chatList.removeChild(oldestChatNode);
  }
};
window.refreshFeed = function (hj) {
  while (killFeed.childNodes.length >= hj) {
    var hk = killFeed.childNodes[0];
    fadingMessageEntries[parseInt(hk.id.replace("feed_", ""))].life = 0;
    killFeed.removeChild(hk);
  }
};
window.updateChatTimer = function (hj) {
  if (fadingMessageEntries) {
    for (var hk in fadingMessageEntries) {
      fadingMessageEntries[hk].life -= hj * 1000;
    }
  }
};
window.switchLeaderboard = function (leaderboardType) {
  if (settings.tmp.leaderType != leaderboardType) {
    settings.tmp.leaderType = leaderboardType;
    document.getElementsByClassName("topRightCounters")[0].style.width =
      leaderboardType ? "auto" : "400px";
    if (leaderboardData) {
      updateLeaderboard(leaderboardData);
    }
  }
};
window.refreshClassDisplay = function () {
  if (classPreviewScene) {
    dJ();
  }
};
window.updatePacketLoop = function (enabled) {
  updatePacketStats();
  if (enabled) {
    packetStatsIntervalId = setInterval(updatePacketStats, 1000);
  } else {
    clearInterval(packetStatsIntervalId);
  }
};
var challengeModeEnabled = false;
window.toggleChal = function (enabled) {
  challengeModeEnabled = enabled;
};
window.updateWeaponShow = function (weaponCategory, visible) {
  if (player) {
    if (weaponCategory == 0) {
      for (
        var loadoutIndex = 0;
        loadoutIndex < player.loadout.length;
        loadoutIndex++
      ) {
        weaponConfig = Game.weaponConfig[player.loadout[loadoutIndex]];
        if (player.weaponMeshes[loadoutIndex]) {
          if (weaponConfig.melee) {
            if (player.armMeshes[0]) {
              player.armMeshes[0].visible = visible;
            }
            if (player.armMeshes[1]) {
              if (!player.armMeshes[1].realMat) {
                player.armMeshes[1].realMat = player.armMeshes[1].material;
              }
              player.armMeshes[1].material = visible
                ? player.armMeshes[1].realMat
                : RENDER.invisMat;
            }
          } else if (weaponConfig.akimbo) {
            if (player.weaponMeshes[loadoutIndex].children[4]) {
              player.weaponMeshes[loadoutIndex].children[4].visible = visible;
            }
          } else if (player.weaponMeshes[loadoutIndex].children[2]) {
            player.weaponMeshes[loadoutIndex].children[2].visible = visible;
          }
        }
      }
    } else if (weaponCategory == 1) {
      var weaponConfig;
      for (
        loadoutIndex = 0;
        loadoutIndex < player.loadout.length;
        loadoutIndex++
      ) {
        if (
          !(weaponConfig = Game.weaponConfig[player.loadout[loadoutIndex]])
            .secondary &&
          !weaponConfig.melee &&
          player.weaponMeshes[loadoutIndex] &&
          player.weaponIndex == loadoutIndex
        ) {
          player.weaponMeshes[loadoutIndex].visible = visible;
        }
      }
    } else if (weaponCategory == 2) {
      for (
        loadoutIndex = 0;
        loadoutIndex < player.loadout.length;
        loadoutIndex++
      ) {
        if (
          Game.weaponConfig[player.loadout[loadoutIndex]].secondary &&
          player.weaponMeshes[loadoutIndex] &&
          player.weaponIndex == loadoutIndex
        ) {
          player.weaponMeshes[loadoutIndex].visible = visible;
        }
      }
    } else if (weaponCategory == 3) {
      for (
        loadoutIndex = 0;
        loadoutIndex < player.loadout.length;
        loadoutIndex++
      ) {
        if (
          Game.weaponConfig[player.loadout[loadoutIndex]].melee &&
          player.weaponMeshes[loadoutIndex] &&
          player.weaponIndex == loadoutIndex
        ) {
          player.weaponMeshes[loadoutIndex].visible = visible;
        }
      }
    }
  }
};
window.bundleFilters = function (filterScope, saturationOverride) {
  if (saturationOverride != null) {
    var filterCss = "saturate(" + saturationOverride + "%)";
    overlay.canvas.style.filter = filterCss;
    RENDER.renderer.domElement.style.filter = filterCss;
    uiBase.style.filter = filterCss;
    return;
  }
  var filterParts = [];
  var isMenuFilter = filterScope == 1;
  if (settings.list[isMenuFilter ? "menuSaturation" : "saturationn"].val != 1) {
    filterParts.push(
      "saturate(" +
        settings.list[isMenuFilter ? "menuSaturation" : "saturationn"].val *
          100 +
        "%)",
    );
  }
  if (settings.list[isMenuFilter ? "menuHue" : "hue"].val != 0) {
    filterParts.push(
      "hue-rotate(" +
        settings.list[isMenuFilter ? "menuHue" : "hue"].val * 3.6 +
        "deg)",
    );
  }
  if (isMenuFilter) {
    if (filterParts.length) {
      uiBase.style.filter = filterParts.join(" ");
    } else {
      uiBase.style.removeProperty("filter");
    }
  } else if (filterParts.length) {
    overlay.canvas.style.filter = filterParts.join(" ");
    RENDER.renderer.domElement.style.filter = filterParts.join(" ");
  } else {
    overlay.canvas.style.removeProperty("filter");
    RENDER.renderer.domElement.style.removeProperty("filter");
  }
};
window.updateAimDot = function (reticleIndex, customReticleUrl) {
  if (reticleIndex == -1) {
    return (RENDER.aimDot.display = false);
  }
  if (reticleIndex == -2) {
    RENDER.aimDot.savedCustom = customReticleUrl || "";
  } else {
    customReticleUrl = UTILS.assetsUrl(
      "/textures/reticles/reticle_" + reticleIndex + ".png",
    );
  }
  customReticleUrl =
    customReticleUrl &&
    customReticleUrl.length &&
    UTILS.isURL(customReticleUrl) &&
    !/\.svg/.test(customReticleUrl)
      ? customReticleUrl
      : UTILS.assetsUrl("/textures/reticles/reticle_0.png");
  if (/\.(jpg|jpeg|png)/.test(customReticleUrl)) {
    RENDER.aimDot.loaded = false;
    RENDER.aimDot.image.src = customReticleUrl;
    RENDER.aimDot.custom = false;
  } else {
    aimDot.src = customReticleUrl;
    RENDER.aimDot.custom = true;
  }
  RENDER.aimDot.display = true;
  selectedReticleIndex = reticleIndex;
};
settings.init();
window.bdayPlay = function () {
  bdayBlock.style.display = "none";
};
window.checkTerms = function (accepted) {
  if (accepted) {
    consentBlock.style.display = "none";
    saveVal("consent", 1);
  } else {
    (function (ele) {
      if (shakeEffect) {
        shakeEffect.classList.remove("shakeEffect");
        ele.offsetWidth;
      }
      (shakeEffect = ele).classList.add("shakeEffect");
    })(document.getElementById("consentShake"));
  }
};
var preloadImageUrls = [
  "/img/button/button-normal.png",
  "/img/button/button-hover.png",
  "/img/button/button-pressed.png",
  "/img/social-buttons/discord-normal.png",
  "/img/social-buttons/discord-hover.png",
  "/img/social-buttons/discord-pressed.png",
  "/img/social-buttons/reddit-normal.png",
  "/img/social-buttons/reddit-hover.png",
  "/img/social-buttons/reddit-pressed.png",
  "/img/social-buttons/twitter-normal.png",
  "/img/social-buttons/twitter-hover.png",
  "/img/social-buttons/twitter-pressed.png",
  "/img/social-buttons/kr-normal.png",
  "/img/social-buttons/kr-hover.png",
  "/img/social-buttons/kr-pressed.png",
];
var preloadedImages = [];
window.addEventListener("load", function () {
  for (var imageUrl of preloadImageUrls) {
    var preloadedImage = new Image();
    preloadedImage.src = imageUrl;
    preloadedImages.push(preloadedImage);
  }
});
Math.PI2 = Math.PI * 2;
Number.prototype.map = function (inMin, inMax, outMin, outMax) {
  return ((this - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
};
Math.lerpAngle = function (fromAngle, toAngle, t) {
  if (Math.abs(toAngle - fromAngle) > Math.PI) {
    if (fromAngle > toAngle) {
      toAngle += Math.PI2;
    } else {
      fromAngle += Math.PI2;
    }
  }
  var interpolatedAngle = toAngle + (fromAngle - toAngle) * t;
  if (interpolatedAngle >= 0 && interpolatedAngle <= Math.PI2) {
    return interpolatedAngle;
  } else {
    return interpolatedAngle % Math.PI2;
  }
};
console.warn = function () {};
console.info = function () {};
var streamerModeEnabled = false;
window.toggleStrm = function (hideNames, push = false) {
  streamerModeEnabled = hideNames;
  if (!push) {
    if (hideNames) {
      window.history.pushState(document.title, document.title, "/");
    } else {
      window.history.pushState(
        document.title,
        document.title,
        client.generateHref(gameId),
      );
    }
  }
  updateLeaderboard(leaderboardData);
};
var isInGame = false;
UI.loading = false;
Object.defineProperty(window, "enterGame", {
  writeable: false,
  value: function () {
    if (currentEventStream && !currentEventStream.f) {
      currentEventStream = false;
      rotateStreamPanel();
    }
    if (autoRespawnTimerId) {
      clearTimeout(autoRespawnTimerId);
      autoRespawnTimerId = null;
      setPlayStatusSubtitle(null);
    }
    if (
      Game.singlePlayer &&
      (!isInGame || (window.spectating && !wantsSpectate))
    ) {
      startGame("0:00", undefined, ~~wantsSpectate, null, null, 1);
      var spawnPoint = Game.getSpawnPoint(null, true);
      var classConfig = Game.classes[parseInt(selectedClassIndex)];
      if (!wantsSpectate) {
        addPlayers(
          [
            io.socketId,
            1,
            spawnPoint.x,
            spawnPoint.y,
            spawnPoint.z,
            "TEST",
            parseInt(selectedClassIndex),
            classConfig.health,
            classConfig.health,
            null,
            100,
            null,
            [
              selectedSkinsByWeapon[classConfig.loadout[0]] == null
                ? -1
                : selectedSkinsByWeapon[classConfig.loadout[0]],
              selectedSkinsByWeapon[selectedSecondaryIndex] != null &&
              classConfig.secondary
                ? selectedSkinsByWeapon[selectedSecondaryIndex]
                : -1,
            ],
            parseInt(selectedHatIndex),
            parseInt(selectedBackIndex),
            classConfig.secondary ? parseInt(selectedSecondaryIndex) : null,
            false,
            null,
            (-((spawnPoint.dir || 0) + 1) * Math.PI) / 2,
            parseInt(selectedMeleeIndex),
            selectedSkinColor,
            0,
            Game.weaponConfig[classConfig.loadout[0]].forceAttach
              ? 0
              : parseInt(selectedAttachIndex),
            null,
            -1,
            selectedDyeIndex,
            false,
            0,
            false,
            -1,
            0,
            null,
            settings.tmp.slidCont,
            parseInt(selectedWaistIndex),
            0,
            selectedHairColor,
            0,
            selectedFaceIndex,
            null,
          ],
          1,
        );
        updateLeaderboard([1, "TEST", 0, 0, 0, 0]);
      }
      isInGame = true;
      UI.toggleMenu(false);
    } else if (
      io.connected &&
      (!isInGame || (window.spectating && !wantsSpectate))
    ) {
      overlay.bloodOpacity = 0;
      bloodDisplay.style.display = "none";
      isInGame = true;
      CONTROLS.idleTimer = 0;
      UI.toggleMenu(false);
      instructions.innerHTML = i18n.t("generic.loading");
      UI.loading = true;
      classConfig = parseInt(selectedClassIndex);
      var classLoadout = Game.classes[classConfig].loadout;
      var selectedWeaponSkins = [
        useDefaultSkins || selectedSkinsByWeapon[classLoadout[0]] == null
          ? -1
          : selectedSkinsByWeapon[classLoadout[0]] == -2
            ? getRandomOwnedSkin(classLoadout[0] + 1)
            : selectedSkinsByWeapon[classLoadout[0]],
        useDefaultSkins
          ? -1
          : selectedSkinsByWeapon[selectedSecondaryIndex] != null &&
              Game.classes[classConfig].secondary
            ? selectedSkinsByWeapon[selectedSecondaryIndex] == -2
              ? getRandomOwnedSkin(selectedSecondaryIndex + 1)
              : selectedSkinsByWeapon[selectedSecondaryIndex]
            : -1,
      ];
      io.send(
        "ent",
        [
          classConfig,
          useDefaultSkins
            ? -1
            : selectedSprayIndex == -2
              ? UTILS.randInt(0, Game.sprays.length - 1) || 0
              : parseInt(selectedSprayIndex),
          selectedWeaponSkins,
          useDefaultSkins
            ? -1
            : selectedHatIndex == -2
              ? getRandomOwnedSkin(null, 1)
              : parseInt(selectedHatIndex),
          useDefaultSkins
            ? -1
            : selectedBackIndex == -2
              ? getRandomOwnedSkin(null, 2)
              : parseInt(selectedBackIndex),
          parseInt(selectedSecondaryIndex),
          wantsSpectate ? 1 : 0,
          challengeModeEnabled ? 1 : 0,
          selectedTeam,
          useDefaultSkins
            ? -1
            : selectedMeleeIndex == -2
              ? getRandomOwnedSkin(null, 3)
              : parseInt(selectedMeleeIndex),
          selectedSkinColor,
          parseFloat(settings.tmp.lagCompensation),
          parseInt(selectedAttachIndex),
          parseInt(selectedKillcardStatIndex),
          selectedDyeIndex == -2
            ? getRandomOwnedSkin(null, 5)
            : parseInt(selectedDyeIndex),
          settings.tmp.slidCont,
          settings.tmp.servSendR ? 1 : 0,
          useDefaultSkins
            ? -1
            : selectedWaistIndex == -2
              ? getRandomOwnedSkin(null, 6)
              : parseInt(selectedWaistIndex),
          selectedHairColor,
          selectedChatColor,
          settings.tmp.anonMode ? 1 : 0,
          useDefaultSkins
            ? -1
            : selectedFaceIndex == -2
              ? getRandomOwnedSkin(null, 7)
              : parseInt(selectedFaceIndex),
        ],
        16,
        18,
      );
    }
    chatList.scrollTop = chatList.scrollHeight - chatList.clientHeight;
  },
});
window.toggleAd = function () {};
function cf(hj) {
  return config.apiURL + hj;
}
var cg = 0;
var ch = false;
function updateFunds(hj) {
  if (acc) {
    acc.funds = hj;
  }
  cK();
}
function purchaseResponse(hj, hk) {
  CONTROLS.idleTimer = 0;
  if (hj) {
    purchaseError();
  } else {
    if (acc) {
      acc.funds = hk;
    }
    cK();
    updateWindow(null, true);
    UI.toggleMenuHider(true);
    purchaseLoad.style.display = "none";
  }
}
window.cancelPurchase = function () {
  if (ch) {
    CONTROLS.idleTimer = 0;
    purchaseResponse.style.display = "none";
    cg = 0;
    purchaseLoad.style.display = "none";
    ch = false;
  }
};
window.showDrops = function () {
  showWindow(5);
  windows[4].switchTab(3);
};
window.showPurchase = function (hj) {
  if (Game.store.purchases[hj]) {
    CONTROLS.idleTimer = 0;
  }
  cg = hj;
  purchaseHolder.style.display = "block";
  var hk = document.getElementById("paypal-button");
  var confirmHtml = document.getElementById("creatorCodeI") || {};
  if (hk) {
    hk.innerHTML = "";
  }
  if (acc) {
    paypal.Button.render(
      {
        style: {
          size: "large",
        },
        env: "production",
        commit: true,
        payment: function (hm, ho) {
          purchaseHolder.style.display = "none";
          return ho.request
            .post(cf("/my-api/create-payment/"), {
              pIndex: cg,
              acID: acc.id,
              creID: confirmHtml.value || null,
            })
            .then(function (hp) {
              return hp.id;
            });
        },
        onAuthorize: function (hm, ho) {
          return ho.request
            .post(cf("/my-api/execute-payment/"), {
              pIndex: cg,
              acID: acc.id,
              creID: confirmHtml.value || null,
              paymentID: hm.paymentID,
              payerID: hm.payerID,
            })
            .then(function (hp) {
              if (hp && hp.funds != null && hp.funds != null) {
                if (acc) {
                  acc.funds = hp.funds;
                }
                cK();
                updateWindow(null, true);
                UI.toggleMenuHider(true);
                purchaseLoad.style.display = "none";
                if (acc) {
                  popupResponse(
                    "SUCCESS",
                    null,
                    "Added " +
                      UTILS.commaNumber(Game.store.purchases[cg].val) +
                      " KR to your account",
                  );
                }
              } else {
                purchaseError(hp);
              }
            });
        },
        onError: function (hm) {
          purchaseError(hm);
        },
      },
      "#paypal-button",
    );
  }
};
purchaseHolder.onclick = function () {
  purchaseHolder.style.display = "none";
};
window.purchaseError = function (hj) {
  ch = true;
  var hk = "Purchase Error";
  if (hj && hj.err) {
    hk = hj.err;
  }
  purchaseResponse.style.display = "block";
  purchaseRespH.innerHTML =
    hk +
    " <a href='javascript:;' onclick='cancelPurchase()'>" +
    i18n.t("purchase.error.click") +
    "</a>";
};
purchaseResponse.onclick = function () {
  purchaseResponse.style.display = "none";
};
var cl = {};
var cm = {};
var wantsSpectate = false;
var cp = false;
window.noMouseInp = false;
CONTROLS.spect.target = null;
var cq = false;
var cu = true;
var cv = true;
function cw(hj) {
  if ((hj = CONTROLS.spect.target)) {
    var hk = cl[hj.sid] || {};
    var hl = ((hk.HP || 0) / (hk.MHP || 100)) * 100;
    specNames.style.display = "none";
    if (specStats.innerHTML.length) {
      if (!specStats.children[0].src.includes("icon_" + (hj.classIndex || 0))) {
        specStats.children[0].src = UTILS.assetsUrl(
          "textures/classes/icon_" + (hj.classIndex || 0) + ".png",
          true,
        );
      }
      if (specStats.children[1].id != "f_" + hj.flagIndex) {
        specStats.children[1].id = "f_" + hj.flagIndex;
        specStats.children[1].className =
          "specFlag" +
          (hj.flagIndex > -1
            ? " flag flag-" + Game.flags[hj.flagIndex][1]
            : "");
      }
      if (
        specStats.children[2].children[0].id !=
        "lvl_" + hj.level + "_" + hj.challLvl
      ) {
        specStats.children[2].children[0].id =
          "lvl_" + hj.level + "_" + hj.challLvl;
        specStats.children[2].children[0].textContent = hj.level;
        specStats.children[2].children[0].style.color = COLORS.getChallCol(
          hj.challLvl,
        );
      }
      if (specStats.children[2].children[1].id != "s_" + hj.sid) {
        specStats.children[2].children[1].id = "s_" + hj.sid;
        specStats.children[2].children[1].innerHTML =
          (hj.premiumT ? hj.alias : hj.name) +
          (hj.clan
            ? "<span class='" +
              (hj.clanR == 1 ? "rainbowText" : "") +
              "' style='color:" +
              COLORS.getClanCol(hj.clan, hj.clanR, "rgba(255,255,255,0.5)") +
              "'> [" +
              hj.clan +
              "]</span>"
            : "");
      }
      specStats.children[2].children[2].style.display = hj.featured
        ? "inline-block"
        : "none";
      spectHPV.textContent = (hk.HP || 0) + " | " + (hk.MHP || 100);
      spectHPBI.style.width = hl + "%";
      spectHPBI.style.backgroundColor =
        hl <= 30
          ? settings.list.hudHealthLow.val
          : settings.list.hudHealthHigh.val;
    } else {
      var hm =
        "<img class='spectPIcon' src='" +
        UTILS.assetsUrl(
          "textures/classes/icon_" + (hj.classIndex || 0) + ".png",
          true,
        ) +
        "'/><span id='f_" +
        hj.flagIndex +
        "' class='specFlag" +
        (hj.flagIndex > -1 ? " flag flag-" + Game.flags[hj.flagIndex][1] : "") +
        "'></span><div style='display:inline-block;width:200px;vertical-align:top'><div class='specLevelBox' id='lvl_" +
        hj.level +
        "_" +
        hj.challLvl +
        "'style='color:" +
        COLORS.getChallCol(hj.challLvl) +
        ";'>" +
        hj.level +
        "</div><span class='specPHead' id='s_" +
        hj.sid +
        "'>" +
        (hj.premiumT ? hj.alias : hj.name) +
        (hj.clan
          ? "<span class='" +
            (hj.clanR == 1 ? "rainbowText" : "") +
            "' style='color:" +
            COLORS.getClanCol(hj.clan, hj.clanR, "rgba(255,255,255,0.5)") +
            "'> [" +
            hj.clan +
            "]</span>"
          : "") +
        "</span><i class='material-icons specVerified' style='display:" +
        (hj.featured ? "inline-block" : "none") +
        "'>check_circle</i><div id='spectHPB'><span id='spectHPV'>" +
        (hk.HP || 0) +
        " | " +
        (hk.MHP || 100) +
        "</span><div id='spectHPBI' style='width:" +
        hl +
        "%;background-color:" +
        (hl <= 30
          ? settings.list.hudHealthLow.val
          : settings.list.hudHealthHigh.val) +
        "'></div></div></div>";
      specStats.innerHTML = hm;
    }
    specSUS.style.display =
      kpdData && kpdData == hj.id ? "inline-block" : "none";
    specStats.style.display = "inline-block";
  } else {
    specNames.style.display = "block";
    specStats.style.display = "none";
    specSUS.style.display = "none";
  }
}
window.spectating = false;
window.toggleSpect = function (hj) {
  wantsSpectate = hj;
};
window.spectMode = function (hj) {
  if (Game && Game.players) {
    if (hj) {
      var spectateTarget = null;
      for (
        var hl = cq
            ? Game.map.manager.spectateCams[Game.activeObjective || 0]
            : Game.players.list,
          hm = Math.max(
            0,
            CONTROLS.spect.target ? hl.indexOf(CONTROLS.spect.target) : 0,
          ),
          ho = 0;
        ho < hl.length;
        ++ho
      ) {
        if ((hm += hj) >= hl.length) {
          hm = 0;
        } else if (hm < 0) {
          hm = hl.length - 1;
        }
        if ((serverSetting = hl[hm]) && serverSetting.active) {
          spectateTarget = serverSetting;
          break;
        }
      }
      if (CONTROLS.spect.target != spectateTarget) {
        CONTROLS.spect.target = spectateTarget;
        cp = false;
        if (!cq) {
          io.send("fpSp", spectateTarget ? spectateTarget.sid : null);
        }
      }
    } else {
      if (cq) {
        CONTROLS.object.rotation.x = 0;
        CONTROLS.object.rotation.y = 0;
        CONTROLS.object.rotation.z = 0;
      }
      cq = false;
      cp = false;
      interactProg.style.display = "none";
      CONTROLS.spect.target = null;
      cm = {};
      CONTROLS.setCamPosOff();
      io.send("fpSp");
    }
    window.noMouseInp = !!cq;
    cw();
    RENDER.zoom(1);
    RENDER.aimRecticle.opacity = 0;
    aimRecticle.style.opacity = 0;
  }
};
function cx(hj, hk, hl) {
  cl[hj] ||= {};
  cl[hj][hk] = hl;
  if (specStats.style.display == "inline-block") {
    cw();
  }
}
const blob = new FileReader();
var recorder;
var cA;
var cB = false;
var cC = true;
var voiceStreamQueues = {};
function showMenu() {
  isInGame = false;
  CONTROLS.idleTimer = 0;
  if (spinUI.style.display != "block") {
    UI.toggleMenu(true);
    CONTROLS.toggle(false);
  }
}
function cF() {
  changeImg(
    menuMiniProfilePic,
    acc ? acc.id : null,
    acc && acc.premiumT > 0,
    UTILS.assetsUrl("/textures/classes/icon_" + selectedClassIndex + ".png"),
  );
  changeImg(
    hudClassImg,
    acc ? acc.id : null,
    acc && acc.premiumT > 0,
    UTILS.assetsUrl("/textures/classes/icon_" + selectedClassIndex + ".png"),
  );
}
window.addVoiceStream = function (hj, hk, hl) {
  voiceStreamQueues[hk] ||= [];
  var hm = new Howl({
    src: [hl],
    volume: SOUND.volumes[0] * SOUND.volumes[1] * 2,
  });
  hm.srcObj = hj;
  voiceStreamQueues[hk].push(hm);
  hm.once("load", function () {
    if (hm.duration() <= config.voiceChatMaxLength * 1.2) {
      hm.on("end", function () {
        remSpeaker(hk);
      });
      hm.isReady = true;
      if (voiceStreamQueues[hk] && voiceStreamQueues[hk].indexOf(hm) == 0 && hj) {
        hm.play();
      }
    } else {
      remSpeaker(hk, false, true);
    }
  });
};
window.remSpeaker = function (hj, hk, hl) {
  if (
    voiceStreamQueues[hj] &&
    voiceStreamQueues[hj][0] &&
    (hl ? voiceStreamQueues[hj].splice(voiceStreamQueues[hj].length - 1, 1) : voiceStreamQueues[hj].splice(0, 1),
    voiceStreamQueues[hj][0] && voiceStreamQueues[hj][0].isReady && voiceStreamQueues[hj][0].srcObj)
  ) {
    voiceStreamQueues[hj][0].play();
  }
  if (!voiceStreamQueues[hj] || !voiceStreamQueues[hj].length || !!hk) {
    voiceStreamQueues[hj] = null;
    delete voiceStreamQueues[hj];
  }
};
window.voiceChat = function (hj, hk, hl) {
  if (SOUND.volumes[1]) {
    if (streamerModeEnabled && Filter) {
      hk = UTILS.scrambleS(hk);
    }
    try {
      serverSetting = Game.players.findBySid(hl);
      addVoiceStream(serverSetting, hk, hj);
    } catch (hm) {}
  }
};
blob.addEventListener("load", function () {
  var hj = blob.result;
  io.send("vc", hj);
});
window.toggleRecord = function (hj) {
  if (document.activeElement.tagName != "INPUT") {
    if (player || window.spectating) {
      if (hj && !cB && cC) {
        var audioInput = settings.tmp.audioInput;
        navigator.mediaDevices
          .getUserMedia({
            audio:
              audioInput && audioInput != "default"
                ? {
                    deviceId: {
                      exact: audioInput,
                    },
                  }
                : true,
            video: false,
          })
          .then(function (hk) {
            window.updateAudioInputs();
            cC = false;
            voiceDisplay.style.opacity = 0.9;
            cB = true;
            recorder = new MediaRecorder(hk, {
              mimetype: "audio/ogg",
              bitsPerSecond: 6000,
            });
            const parts = [];
            recorder.addEventListener("dataavailable", function (hm) {
              parts.push(hm.data);
            });
            recorder.addEventListener("stop", function () {
              var hm = new Blob(parts, {
                type: "audio/ogg; codecs=opus",
              });
              blob.readAsDataURL(hm);
              parts.length = 0;
            });
            recorder.start();
            cA = setInterval(function () {
              if (recorder.state == "recording") {
                recorder.stop();
              }
              if (cB) {
                recorder.start();
              } else {
                voiceDisplay.style.opacity = 0.5;
                if (cA) {
                  clearInterval(cA);
                }
                cC = true;
              }
            }, config.voiceRate);
          })
          .catch(function () {
            cB = false;
            voiceDisplay.style.opacity = 0.5;
            if (cA) {
              clearInterval(cA);
            }
          });
      } else if (!hj && cB && recorder) {
        cB = false;
      }
    }
  }
};
window.updateSliderLabel = function (hj, hk) {
  var hl = document.getElementById("customSet" + hj);
  if (hl) {
    hl.textContent = hk;
  }
};
window.updateWSliderLabel = function (hj, hk, hl) {
  var hm = document.getElementById("customWSet" + hj + hk);
  if (hm) {
    hm.textContent = hl;
  }
};
Object.defineProperty(window, "setSetting", {
  writeable: false,
  value: function (hj, hk, hl, hm, ho) {
    settings.set(hj, hk, hl, hm, ho);
  },
});
window.resetSettings = function () {
  if (confirm(i18n.t("settings.reset.confirm"))) {
    selectSettingPre(0, undefined, true);
    Object.keys(localStorage)
      .filter((hj) => hj.includes("cont_"))
      .forEach((hj) => localStorage.removeItem(hj));
    CONTROLS.setupBinds();
    CONTROLS.resetBinds();
    showWindow(1, true);
  }
};
window.exportSettings = (hj) => settings.export(hj);
window.importSettings = (hj) => settings.import(hj);
var cG = getSavedVal("preIndex") || 2;
window.selectSettingPre = function (hj, hk, hl) {
  if (cG != hj) {
    if (hj == 0) {
      if (!hl && !confirm(i18n.t("settings.reset.confirm"))) {
        [...document.getElementById("settingsPreset").children].forEach(
          (hp) => {
            hp.selected = hp.value == cG;
          },
        );
        return;
      }
      var hm = {};
      Object.keys(settings.list).forEach(function (hp) {
        if (cG == 2 && settings.list[hp].val != settings.list[hp].def) {
          hm[hp] = settings.list[hp].val;
        }
        setSetting(hp, settings.list[hp].def, true);
      });
      if (cG == 2) {
        saveVal("krk_customPre", JSON.stringify(hm));
      }
    } else if (hj == 1 || hj == 3) {
      hm = {};
      Object.keys(settings.list).forEach(function (hp) {
        if (cG == 2) {
          hm[hp] = settings.list[hp].val;
        }
        setSetting(
          hp,
          settings.list[hp][hj == 1 ? "pro" : "perf"] == null
            ? settings.list[hp].def
            : settings.list[hp][hj == 1 ? "pro" : "perf"],
          true,
        );
      });
      if (cG == 2) {
        saveVal("krk_customPre", JSON.stringify(hm));
      }
    } else if (hj == 2 && !hk) {
      try {
        hm = JSON.parse(getSavedVal("krk_customPre") || "{}");
        for (var ho in hm) {
          if (settings.list[ho]) {
            setSetting(ho, hm[ho], true);
          }
        }
        CONTROLS.checkForScroll();
      } catch (hp) {
        alert(hp);
      }
    }
    cG = hj;
    saveVal("preIndex", cG);
    if (!hl) {
      showWindow(1, true);
    }
  }
};
window.aspectSelect = function (hj, hk) {
  var hl = hk.selectedIndex - 1;
  var hm = document.getElementById("slid_" + hj);
  if (hm) {
    hm.value = hl == 0 ? "" : config.customRatios[hl];
  }
  hk.selectedIndex = 0;
  setSetting(hj, hm.value);
};
var cH = {};
window.delayExecute = function (hj, hk, hl = 600) {
  clearTimeout(cH[hj]);
  cH[hj] = setTimeout(function () {
    setSetting(hj, hk.value);
  }, hl);
  return true;
};
var cI = {};
function updateAccount(data) {
  if (acc) {
    acc.setData(data);
  }
  updateWindow(5);
  cK();
}
function cK() {
  if (acc) {
    signedOutHeaderBar.style.display = "none";
    signedInHeaderBar.style.display = null;
    if (acc.level >= config.rewardMinLvl) {
      claimHolder.style.display = "block";
      merchHolder.style.top = "205px";
      dd(true);
    } else {
      merchHolder.style.top = "110px";
    }
    menuAccountUsername.textContent = acc.premiumT ? acc.alias : acc.name;
    menuKRCount.innerHTML =
      UTILS.commaNumber(acc.funds) + " <span style='color:#fff'>KR</span>";
    menuLevelBar.style.width = acc.levelProg + "%";
    mLevelCont.textContent = acc.level || 1;
    if (signedInHeaderBar.offsetWidth) {
      signedInHeaderBar.style.borderRadius = "0px";
      mLevelCont.style.left = signedInHeaderBar.offsetWidth + "px";
    }
  } else {
    signedOutHeaderBar.style.display = null;
    signedInHeaderBar.style.display = "none";
    claimHolder.style.display = "none";
    merchHolder.style.top = "110px";
  }
  cL();
}
function cL() {
  if (!Game.isCustom) {
    if (!acc) {
      igXPBarProg.style.width = "0%";
      return;
    }
    var hj =
      config.rankVar * Math.sqrt(acc.score + (player ? player.score : 0));
    var hk = ((hj - Math.floor(hj)) * 100).round(3);
    if (igXPBarProg.style.width != hk + "%") {
      igXPBarProg.style.width = hk + "%";
    }
  }
}
function loadSettings(hj) {
  if (hj && hj != "") {
    try {
      JSON.parse(hj);
    } catch (hk) {
      return popupResponse(null, "No settings found");
    }
    importSettings(hj);
    popupResponse("SUCCESS", null, "Settings Loaded");
  } else {
    popupResponse(null, "No settings found");
  }
}
window.delayExecute2 = function (hj, hk, hl = 600) {
  clearTimeout(cI[hj]);
  cI[hj] = setTimeout(function () {
    setShaderInput(hj, hk.value);
  }, hl);
  return true;
};
Object.defineProperty(window, "setShaderInput", {
  writeable: false,
  value: function (hj, hk) {
    var hl = RENDER.shaderInputs[hj];
    if (hl) {
      if (hk == "false") {
        hk = false;
      }
      if (hk == "true") {
        hk = true;
      }
      if (hl.min || hl.max) {
        hk = Math.min(hl.max, Math.max(hl.min, +hk));
      }
      if (hl.toggle) {
        hk = ~~!!hk;
      }
      if (document.getElementById("shader_" + hj)) {
        document.getElementById("shader_" + hj).value = hk;
      }
      if (document.getElementById("shader_input_" + hj)) {
        document.getElementById("shader_input_" + hj).value = hk;
      }
      RENDER.postprocessing.composer.passes[
        RENDER.postprocessing.composer.passes.length - 1
      ].uniforms[hl.name].value = hk;
    }
  },
});
Object.defineProperty(window, "focusChat", {
  writeable: false,
  value: function (hj) {
    if (settings.list.shwChat.val == 1) {
      chatList.style.display = hj ? "block" : "none";
    }
  },
});
window.changeCont = function (hj, hk) {
  if (!hk) {
    showWindow(7, true);
  }
  CONTROLS.inputChanger = CONTROLS.keyInfo[hj] || hj;
  document.getElementById("cont" + hj).innerHTML = i18n.t(
    "settings.controls.press",
  );
};
window.changeContSet = function (hj, hk) {
  CONTROLS.toggleSets[hj - 27] = hk;
  saveVal("cont_" + hj + "_set", hk);
  showWindow(7, true);
};
window.unbindCont = function (hj, hk) {
  CONTROLS.inputChanger = null;
  if (!hk) {
    showWindow(7, true);
  }
  let hl = CONTROLS.keyInfo[hj] || hj;
  document.getElementById("cont" + hj).innerHTML = "UNBOUND";
  if (CONTROLS.binds.moveKeys.val[hl]) {
    CONTROLS.binds.moveKeys.val[hl] = -1;
  } else if (CONTROLS.binds.streakKeys.val[hl - 18]) {
    CONTROLS.binds.streakKeys.val[hl - 18] = -1;
  } else if (CONTROLS.binds.toggleKeys.val[hl - 27]) {
    CONTROLS.binds.toggleKeys.val[hl - 27] = -1;
  } else if (CONTROLS.binds.premiumKeys.val[hl - 34]) {
    CONTROLS.binds.premiumKeys.val[hl - 34] = -1;
  } else {
    CONTROLS.binds[hl].val = -1;
  }
  CONTROLS.checkForScroll();
  saveVal("cont_" + hl, -1);
};
window.uploadSettings = function () {
  if (acc) {
    dP("Loading...");
    io.send("uploadS", exportSettings(true));
    return;
  } else {
    return popupResponse(null, "Must be logged in");
  }
};
window.fetchSettings = function () {
  if (acc) {
    io.send("getS");
    return;
  } else {
    return popupResponse(null, "Must be logged in");
  }
};
var pingColor;
var playStatusSubtitle = null;
function setPlayStatusSubtitle(subtitle) {
  if (io.connected && subtitle != playStatusSubtitle) {
    playStatusSubtitle =
      isInGame ||
      CONTROLS.locked ||
      endMidHolder.style.display == "inline-block"
        ? null
        : subtitle;
    updatePlayInstructions();
  }
}
function updatePacketStats() {
  ingressPacketCount.textContent = io.ingressPacketCount + " P/s";
  ingressDataSize.textContent =
    (io.ingressDataSize / 1000).toFixed(2) + " KB/s";
  egressPacketCount.textContent = io.egressPacketCount + " P/s";
  egressDataSize.textContent = (io.egressDataSize / 1000).toFixed(2) + " KB/s";
  io.resetPacketTally();
}
const fpsFrameTimes = [];
let currentFps;
let lastFpsDisplayUpdate = 0;
function announcement(message) {
  popupResponse("INFO", null, message || config.accAnnounce);
}
function changeImg(ele, profileID, src, fallback) {
  ele.src =
    src > 0
      ? "https://user-assets.krunker.io/p" +
        profileID +
        "/profile.png?v=" +
        Date.now()
      : fallback;
  ele.onerror = function () {
    this.onerror = null;
    this.src = fallback;
  };
}
var authToken = null;
var referralCode = params.get("ref") || 0;
function showAccResp(html) {
  try {
    accResp.innerHTML = html || "";
    accResp.style.display = html ? "block" : "none";
  } catch (hk) {}
}
function sendAccountRequest(authAction, authPayload, captchaKey) {
  if (authAction >= 0) {
    showAccResp(i18n.t("generic.wait"));
  }
  io.send("a", authAction, authPayload, captchaKey);
}
function accountResponse(html, id, username, data, token) {
  if (html) {
    showAccResp(html);
  } else {
    acc = new Account(id, username, null, config);
    saveVal("krunker_id", id);
    saveVal("krunker_username", username);
    // user update
    updateAccount(data);
    if (acc.hack) {
      window.activeHacker = true;
    }
    if (token) {
      saveVal("krunker_token", token);
      authToken = token;
    }
    updateWindow(null, true);
    dJ();
    cF();
    if (access_token && acc) {
      io.send("vtw", access_token);
    }
    access_token = null;
    if (params.has("twitch") && acc && !acc.twitch) {
      linkTwitchPop();
    }
    if (autoQueue) {
      joinQueue(true, party);
      showWindow(27);
      autoQueue = false;
    } else if (party) {
      joinQueue(false, party);
      showWindow(27);
      party = null;
    }
  }
}

window.registerAcc = function () {
  showAccResp(i18n.t("generic.wait"));
  getCaptcha(function (key, error) {
    if (error) {
      showAccResp("Please try again.");
    } else {
      sendAccountRequest(0, [accName.value, accPass.value, referralCode], key);
    }
  });
};
Object.defineProperty(window, "loginAcc", {
  writeable: false,
  value: function () {
    getCaptcha(function (key, error) {
      if (error) {
        showAccResp("Please try again.");
      } else {
        sendAccountRequest(1, [accName.value, accPass.value, null], key);
      }
    });
  },
});
Object.defineProperty(window, "logoutAcc", {
  writeable: false,
  value: function () {
    if (!Game || !Game.mode || !Game.mode.isRanked) {
      sendAccountRequest(-1);
      showAccResp();
      deleteVal("krunker_id");
      deleteVal("krunker_username");
      deleteVal("krunker_token");
      deleteVal("skins");
      deleteVal("hatIndex");
      deleteVal("waistIndex");
      deleteVal("backIndex");
      deleteVal("meleeIndex");
      deleteVal("skinColIndex");
      deleteVal("hairCol");
      deleteVal("chatCol");
      deleteVal("dyeIndex");
      deleteVal("faceIndex");
      selectedHatIndex = -1;
      selectedWaistIndex = -1;
      selectedBackIndex = -1;
      selectedMeleeIndex = -1;
      selectedSkinColor = -1;
      selectedHairColor = -1;
      selectedChatColor = -1;
      selectedDyeIndex = -1;
      selectedFaceIndex = -1;
      selectedSkinsByWeapon = {};
      selectSecondary(2);
      windows[12].clanData = null;
      windows[26].cantQueue = null;
      windows[4].drops = null;
      authToken = null;
      acc = null;
      hasReportedInjectedUi = false;
      updateAccount();
      showWindow(5);
      dJ();
    }
  },
});
var d1 = false;
function changePasswordResponse(hj, hk) {
  if (hk && hk.length > 0) {
    window.newTok(hk);
  }
  newPRes.innerHTML = hj;
}
window.newTok = function (hj) {
  if (hj) {
    saveVal("krunker_token", hj);
    authToken = hj;
  }
};
window.logoutSessions = function (hj) {
  if (hj) {
    hj.style.display = "none";
  }
  d1 = true;
  io.send("las");
};
Object.defineProperty(window, "changePass", {
  writeable: false,
  value: function () {
    newPRes.innerHTML = "Please wait...";
    io.send("upp", oldPass.value, newPass.value, repNPass.value);
  },
});
var d3 = [];
function d4(hj) {
  var hk = "<table class='twoFATable'><tbody>";
  var hl = 0;
  for (var hm = 0; hm < 5; ++hm) {
    hk += "<tr>";
    for (var ho = 0; ho < 5; ++ho) {
      hk +=
        "<td " +
        (d3.indexOf(hl) >= 0 || (hj && hj.indexOf(config.alphabet[hl]) >= 0)
          ? "class='twoFAkeyg'"
          : "") +
        (hj ? "" : " onclick='pick2FAkey(" + hl + ")'") +
        "><span style='opacity:0;padding-left:7px'>10</span></td>";
      hl++;
    }
    hk += "</tr>";
  }
  return (hk += "</tbody></table>");
}
window.pick2FAkey = function (hj) {
  if (twoFAbtn.innerHTML != "Loading...") {
    var hk = d3.indexOf(hj);
    if (hk < 0) {
      d3.push(hj);
    } else {
      d3.splice(hk, 1);
    }
    twoFAGholder.innerHTML = d4();
  }
};
Object.defineProperty(window, "twoFAres", {
  writeable: false,
  value: function (hj, hk, hl) {
    if (hj) {
      if (hj == 1) {
        twoFAPop.style.display = "block";
        twoFAbtn.innerHTML = "Submit";
        twoFAbtn.className = "";
        d3.length = 0;
        twoFAGholder.innerHTML = d4();
      } else if (hj == 2) {
        twoFAPop.style.display = "none";
      }
    } else {
      twoFAB.className = "menuLinkD";
      if (hl) {
        twoFAB.textContent = "Enabled";
        twoFGridR.style.display = "block";
        twoFGridR.innerHTML = d4(hl);
        twoFAprom.innerHTML =
          "Make sure to <b>take a picture</b> of the above pattern and to save it securely. You will need it to login again.";
      } else {
        twoFAB.innerHTML = hk || "Error";
      }
    }
  },
});
Object.defineProperty(window, "sub2FA", {
  writeable: false,
  value: function () {
    twoFAbtn.innerHTML = "Loading...";
    twoFAbtn.className = "twoFAbtnN";
    io.send("2fa", 1, d3);
  },
});
Object.defineProperty(window, "act2FA", {
  writeable: false,
  value: function () {
    twoFAB.innerHTML = "Please wait...";
    twoFAB.className = "menuLinkD";
    io.send("2fa");
  },
});
var d5 = null;
var hasShownTeamPrompt = false;
function showNetworkLagWarning() {
  if (!hasShownTeamPrompt) {
    hasShownTeamPrompt = true;
    networkLag.style.display = "block";
    d5 = setTimeout(function () {
      networkLag.style.display = "none";
      if (d5) {
        clearTimeout(d5);
        d5 = null;
      }
    }, 10000);
  }
}
var d8;
var d9;
var db = 0;
var dc = false;
function dd(hj) {
  if (hj || claimHolder.style.display == "block") {
    db = config.rewardTime - ((frameTimeMs || Date.now()) - acc.lastReward);
    d9 = UTILS.getTimeH(Math.max(0, db));
    if (hj || d8 != d9) {
      d8 = d9;
      claimTimer.textContent =
        d9 == "00:00:00" ? (dc ? "" : "Play 1 Game") : d9;
      claimTimer.style.fontSize =
        d9 == "00:00:00" ? (dc ? "18px" : "13px") : "18px";
      merchHolder.style.top = d9 == "00:00:00" && dc ? "205px" : "237px";
    }
    var hk = db <= 0 && dc ? "./img/claim_0.png" : "./img/claim_1.png";
    if (claimImg.getAttribute("src") != hk) {
      claimImg.src = hk;
    }
  }
}
function claimRewardResponse(hj, hk) {
  updateFunds(hk);
  if (acc) {
    acc.lastReward = hj;
  }
  dd(true);
}
window.claimReward = function () {
  alert("Ad Failed. Contact your Ad Provider");
};
Object.defineProperty(window, "setClassIndex", {
  writeable: false,
  value: function (hj) {
    selectedClassIndex = hj;
    if (party) {
      client.queueUpdateClass(hj);
    }
  },
});
var selectedTeam = 1;
var selectedSkinColor = getSavedVal("skinColIndex") || -1;
var selectedHairColor = getSavedVal("hairCol") || -1;
var selectedChatColor = getSavedVal("chatCol") || -1;
var selectedDyeIndex = getSavedVal("dyeIndex") || -1;
var selectedFaceIndex = getSavedVal("faceIndex") || -1;
var selectedAttachIndex = getSavedVal("attachIndex") || 0;
var selectedReticleIndex = getSavedVal("reticleIndex") || 0;
updateAimDot(selectedReticleIndex, RENDER.aimDot.savedCustom);
var selectedMeleeIndex = getSavedVal("meleeIndex") || -1;
var selectedBackIndex = getSavedVal("backIndex") || -1;
var selectedHatIndex = getSavedVal("hatIndex") || -1;
var selectedWaistIndex = getSavedVal("waistIndex") || -1;
var dy = getSavedVal("skins");
var selectedSkinsByWeapon = dy ? JSON.parse(dy) : {};
setClassIndex(getSavedVal("classindex") || 0);
var selectedSecondaryIndex = getSavedVal("secondaryInd") || 2;
var selectedKillcardStatIndex = getSavedVal("kcStatIndex") || -1;
var dC = 0;
function getRandomOwnedSkin(hj, hk) {
  if (!acc) {
    return -1;
  }
  var hl = acc.skins.filter(
    (hm) =>
      Game.store.skins[hm.ind] &&
      (hk == null
        ? !Game.store.skins[hm.ind].type &&
          Game.store.skins[hm.ind].weapon == hj
        : Game.store.skins[hm.ind].type == hk),
  );
  return (hl.length && UTILS.getRandom(hl).ind) || -1;
}
Object.defineProperty(window, "selectHat", {
  writeable: false,
  value: function (hj) {
    saveVal("hatIndex", hj);
    selectedHatIndex = hj;
    dJ();
    showWindow(3);
  },
});
Object.defineProperty(window, "selectBack", {
  writeable: false,
  value: function (hj) {
    saveVal("backIndex", hj);
    selectedBackIndex = hj;
    dJ();
    showWindow(3);
  },
});
Object.defineProperty(window, "selectWaist", {
  writeable: false,
  value: function (hj) {
    saveVal("waistIndex", hj);
    selectedWaistIndex = hj;
    dJ();
    showWindow(3);
  },
});
Object.defineProperty(window, "selectMelee", {
  writeable: false,
  value: function (hj) {
    saveVal("meleeIndex", hj);
    selectedMeleeIndex = hj;
    dJ();
    showWindow(3);
  },
});
Object.defineProperty(window, "selectSecondary", {
  writeable: false,
  value: function (hj) {
    saveVal("secondaryInd", hj);
    selectedSecondaryIndex = hj;
    dJ();
    showWindow(3);
  },
});
Object.defineProperty(window, "selectSkinColor", {
  writeable: false,
  value: function (hj) {
    saveVal("skinColIndex", hj);
    selectedSkinColor = hj;
    dJ();
    updateWindow(3);
  },
});
Object.defineProperty(window, "selectHairColor", {
  writeable: false,
  value: function (hj) {
    saveVal("hairCol", hj);
    selectedHairColor = hj;
    dJ();
    updateWindow(3);
  },
});
Object.defineProperty(window, "selectChatColor", {
  writeable: false,
  value: function (hj) {
    saveVal("chatCol", hj);
    selectedChatColor = hj;
    dJ();
    updateWindow(3);
  },
});
Object.defineProperty(window, "selectAttachment", {
  writeable: false,
  value: function (hj) {
    saveVal("attachIndex", hj);
    selectedAttachIndex = hj;
    dJ();
    showWindow(3);
  },
});
Object.defineProperty(window, "selectReticle", {
  writeable: false,
  value: function (hj) {
    saveVal("reticleIndex", hj);
    selectedReticleIndex = hj;
    updateAimDot(hj, RENDER.aimDot.savedCustom);
    dJ();
    showWindow(3);
  },
});
Object.defineProperty(window, "selectClass", {
  writeable: false,
  value: function (hj) {
    saveVal("classindex", hj);
    if (Game.classes[hj].txts) {
      showSpeechBubble(
        Game.classes[hj].txts[
          UTILS.randInt(0, Game.classes[hj].txts.length - 1)
        ],
      );
    } else if (!UTILS.randInt(0, 2)) {
      showSpeechBubble(
        ["Let's Go!", "Alright!", "I'm Ready!"][UTILS.randInt(0, 2)],
      );
    }
    setClassIndex(hj);
    dJ();
    showWindow(3);
  },
});
Object.defineProperty(window, "skinSelector", {
  writeable: false,
  value: function (hj, hk) {
    dC = hj;
    if (hk) {
      saveVal("secondaryInd", hj);
      selectedSecondaryIndex = hj;
    }
    dJ();
    showWindow(15);
  },
});
Object.defineProperty(window, "selectStat", {
  writeable: false,
  value: function (hj) {
    saveVal("kcStatIndex", hj);
    selectedKillcardStatIndex = hj;
    dJ();
    updateWindow(3);
  },
});
Object.defineProperty(window, "selectDye", {
  writeable: false,
  value: function (hj) {
    saveVal("dyeIndex", hj);
    selectedDyeIndex = hj;
    dJ();
    showWindow(3);
  },
});
Object.defineProperty(window, "selectFace", {
  writeable: false,
  value: function (hj) {
    saveVal("faceIndex", hj);
    selectedFaceIndex = hj;
    dJ();
    showWindow(3);
  },
});
Object.defineProperty(window, "selectFlag", {
  writeable: false,
  value: function (hj) {
    if (acc) {
      io.send("flg", parseInt(hj));
    }
  },
});
Object.defineProperty(window, "selectSkin", {
  writeable: false,
  value: function (hj, hk) {
    serverSetting = Game.store.skins[hj];
    selectedSkinsByWeapon[hk] = serverSetting || hj == -2 ? hj : undefined;
    saveVal("skins", JSON.stringify(selectedSkinsByWeapon));
    dJ();
    showWindow(3);
  },
});
var classPreviewScene;
var classPreviewPlayer;
var classPreviewCamera = new THREE.PerspectiveCamera(15, 1, 0.1, 100);
var classPreviewRenderer = new THREE.WebGLRenderer({
  canvas: classPreviewCanvas,
  precision: "mediump",
  antialias: false,
  alpha: true,
});
var dI = {};
function dJ() {
  function hj(hu, hv = true) {
    if (hl) {
      hl += " - ";
    }
    var hw = "inherit";
    var hx = Game.weaponConfig[hu].name;
    var hy = false;
    if (selectedSkinsByWeapon[hu] != null) {
      var hz = Game.store.skins[selectedSkinsByWeapon[hu]];
      if (hz) {
        hy = Game.store.rarities[hz.rarity].animate;
        hw = Game.store.rarities[hz.rarity].color;
        hx = hz.name;
      }
    }
    hl +=
      "<span " +
      (RENDER.rarityAnim && hy ? "class='rainbowText' " : "") +
      "style='color:" +
      (hv ? hw : "inherit") +
      "'>" +
      hx +
      "</span>";
  }
  var hk = Game.classes[dI.class || selectedClassIndex];
  menuClassName.textContent = hk.name;
  var hl = "";
  for (var hm of hk.loadout) {
    hj(hm);
  }
  menuClassSubtext.innerHTML = hl;
  var ho = "";
  if (dI.name) {
    ho =
      dI.name +
      " <i class='material-icons menuClassPlayerPremium'>beenhere</i>";
  } else {
    ho +=
      (acc
        ? "<div class='menuClassLevelBox' style='color:" +
          COLORS.getChallCol(acc.chal + 1) +
          ";'>" +
          (acc.level || 0) +
          "</div>"
        : "") +
      "<span class='menuClassPlayerName'>" +
      (acc
        ? (acc.premiumT && acc.alias) || acc.name
        : player
          ? "Guest_" + player.sid
          : "Guest") +
      "</span>" +
      (acc && acc.clan
        ? "<span class='menuClassPlayerClan" +
          (acc.clanRank == 1 ? " rainbowText" : "") +
          "' style='color:" +
          COLORS.getClanCol(acc.clan, acc.clanRank, "rgba(255,255,255,0.5)") +
          "'>[" +
          acc.clan +
          "]</span>"
        : "") +
      (acc && acc.partnerApp
        ? "<i class='material-icons menuClassPlayerPartner'>verified</i>"
        : "") +
      (acc && acc.premiumT
        ? "<i class='material-icons menuClassPlayerPremium'>check_circle</i>"
        : "") +
      (acc && acc.featured
        ? "<i class='material-icons menuClassPlayerVerified'>check_circle</i>"
        : "");
  }
  menuClassNameTag.innerHTML = ho;
  (classPreviewScene = new THREE.Scene()).add(new THREE.AmbientLight(9937064));
  var hp = new THREE.DirectionalLight(15923452, 0.5);
  hp.position.set(10, 17, -10);
  classPreviewScene.add(hp);
  var hq = [
    selectedSkinsByWeapon[hk.loadout[0]] != null ||
    selectedSkinsByWeapon[hk.loadout[0]] != -2
      ? selectedSkinsByWeapon[hk.loadout[0]]
      : -1,
    selectedSkinsByWeapon[hk.loadout[1]] == null
      ? -1
      : selectedSkinsByWeapon[hk.loadout[1]],
  ];
  (classPreviewPlayer = new Player(
    -1,
    this,
    UTILS,
    COLORS,
    config,
    Game,
    true,
  )).sid = -1;
  classPreviewPlayer.init(0, 0, 0, "preview", false);
  classPreviewPlayer.skins = hq;
  classPreviewPlayer.hatIndex =
    dI.hat || (selectedHatIndex == -2 ? -1 : selectedHatIndex);
  classPreviewPlayer.backIndex =
    dI.back || (selectedBackIndex == -2 ? -1 : selectedBackIndex);
  classPreviewPlayer.waistIndex =
    selectedWaistIndex == -2 ? -1 : selectedWaistIndex;
  classPreviewPlayer.meleeIndex =
    selectedMeleeIndex == -2 ? -1 : selectedMeleeIndex;
  classPreviewPlayer.attachIndex = Game.weaponConfig[hk.loadout[0]].forceAttach
    ? 0
    : parseInt(selectedAttachIndex);
  classPreviewPlayer.skinColIndex = selectedSkinColor;
  classPreviewPlayer.hairCol = selectedHairColor;
  classPreviewPlayer.dyeIndex = dI.dye || selectedDyeIndex;
  classPreviewPlayer.faceIndex = dI.face || selectedFaceIndex;
  classPreviewPlayer.secIndex = selectedSecondaryIndex;
  classPreviewPlayer.virus = acc && acc.virus;
  classPreviewPlayer.setClass(
    Game,
    dI.class || selectedClassIndex,
    selectedSecondaryIndex,
    true,
  );
  Game.players.reload(classPreviewPlayer, 0, true);
  classPreviewScene.add(
    Game.players.generateMeshes(classPreviewPlayer, false, true),
  );
  classPreviewPlayer.swapTime = 0;
  classPreviewPlayer.weaponMeshes[0].visible = true;
  dI = {};
  classPreviewCamera.lookAt(new THREE.Vector3(0, config.playerHeight * 0.8, 0));
}
classPreviewCamera.position.x = -10;
classPreviewCamera.position.y = 17;
classPreviewCamera.position.z = -29;
dJ();
var dK = getSavedVal("krk_hideFull") == "true";
window.toggleHF = function (hj) {
  dK = hj;
  saveVal("krk_hideFull", hj);
};
toggleHF(dK);
var dL = getSavedVal("krk_regionPriority") == "true";
window.toggleRP = function (hj) {
  dL = hj;
  saveVal("krk_regionPriority", hj);
};
toggleRP(dL);
function twitchLinkResponse(hj) {
  if (acc) {
    acc.twitch = hj;
  }
  popupResponse("SUCCESS", null, "Twitch Account Linked");
}
function twitchUnlinkResponse() {
  if (acc) {
    acc.twitch = null;
  }
  resetPops();
  twitchPop.style.display = "block";
  twitchPop.innerHTML =
    "<div style='width:100%;text-align:center'><div><i class='material-icons' style='font-size:80px;color:#3be354'>done</i></div><div style='font-size:20px;color:rgba(255,255,255,0.5)'>Twitch Account Unlinked</div>Go to <a href='https://www.twitch.tv/settings/connections'>Twitch Connections</a> and Click disconnect on Krunkerio</div>";
}
function popupResponse(hj, hk, hl) {
  var hm;
  resetPops();
  if (hj == "INFO") {
    popupContent.style.backgroundColor = "#595959";
  }
  popupContent.style.display = "block";
  popupContent.style.width = hj == "INFO" ? "600px" : "300px";
  if (hk && typeof hk == "object") {
    hk = hk.join("<br>");
  }
  if (hl && typeof hl == "object") {
    hl = hl.join("<br>");
  }
  hm =
    hj == "SUCCESS"
      ? "<div style='width:100%;text-align:center'><div><i class='material-icons' style='font-size:80px;color:#3be354'>done</i></div><div style='font-size:20px;color:rgba(255,255,255,0.5)'>" +
        (hl || "Success!") +
        "</div></div>"
      : hj == "INFO"
        ? "<div style='width:100%;text-align:center'><div><i class='material-icons' style='font-size:80px;color:rgba(255,255,255,0.9)'>info</i></div><div style='font-size:20px;color:rgba(255,255,255,0.9)'>" +
          (hl || "Warning!") +
          "</div></div>"
        : "<div style='width:100%;text-align:center'><div><i class='material-icons' style='font-size:80px;color:#e33b3b'>clear</i></div><div style='font-size:20px;color:rgba(255,255,255,0.5)'>" +
          (hk || i18n.get("social.market.failed")) +
          "</div></div>";
  popupContent.innerHTML = hm;
}
function dP(hj) {
  resetPops();
  popupContent.style.width = "300px";
  popupContent.style.display = "block";
  popupContent.innerHTML =
    "<div style='width:100%;text-align:center'><div class='lds-ring sm'><div></div><div></div><div></div><div></div></div><div style='font-size:20px;color:rgba(255,255,255,0.5)'>" +
    hj +
    "</div></div>";
}
window.windows = [
  {
    header: i18n.t("windows.settings.header"),
    sticky: true,
    settingSearch: null,
    tabIndex: 0,
    tabs: [
      {
        name: "General",
        categories: ["local", "network", "experimental", "client"],
      },
      {
        name: "Controls",
        categories: ["gameplay", "controller", "mobile"],
      },
      {
        name: "Display",
        categories: ["interface", "crosshair", "hitmarker", "chat"],
      },
      {
        name: "Render",
        categories: ["shaders", "quality", "editing"],
      },
      {
        name: "Game",
        categories: ["gameprivacy", "viewmodel", "mods"],
      },
      {
        name: "Sound",
        categories: ["audio"],
      },
    ],
    searchList: function () {
      var hj = document.getElementById("settSearch");
      this.settingSearch = hj && hj.value != "" ? hj.value : null;
      if (this.settingSearch) {
        if (this.tabIndex == -1) {
          if ((hj = document.getElementById("settHolder"))) {
            hj.innerHTML = this.getSettings();
          }
        } else {
          this.changeTab((this.tabIndex = -1));
        }
      } else {
        this.changeTab((this.tabIndex = 0));
      }
    },
    collapseFolder: function (hj) {
      let hk = document.getElementById("setBod_" + hj.id.split("setHed_")[1]);
      let hl = hk.style.display == "none";
      hj.children[0].innerHTML = "keyboard_arrow_" + (hl ? "down" : "right");
      hk.style.display = hl ? null : "none";
    },
    changeTab: function (hj) {
      var hk;
      this.tabIndex = hj;
      if (hj > -1) {
        hk = document.getElementById("settSearch");
        this.settingSearch = null;
        if (hk) {
          hk.value = "";
        }
      }
      if ((hk = document.getElementById("settingsTabLayout"))) {
        hk.innerHTML = this.getTabs();
      }
      if ((hk = document.getElementById("settHolder"))) {
        hk.innerHTML = this.getSettings();
      }
    },
    getTabs: function () {
      let hj =
        this.tabIndex == -1
          ? () =>
              "class='settingTab' style='border-bottom: 5px solid transparent'"
          : (hk) =>
              "class='settingTab " +
              (hk == this.tabIndex ? "tabANew" : "") +
              "'";
      return this.tabs
        .map(
          (hk, hl) =>
            "<div " +
            hj(hl) +
            " onclick='window.windows[0].changeTab(" +
            hl +
            ")'>" +
            hk.name +
            "</div>",
        )
        .join("\n");
    },
    getCSettings: function () {
      return "";
    },
    getSettings: function () {
      var hj = "";
      var hk = [];
      var hl = true;
      if (
        this.tabIndex == 1 ||
        (this.settingSearch &&
          this.searchMatches({
            name: "settings.controls.change",
          }))
      ) {
        hj +=
          '<div class="settName" style="margin-top:15px">\n                ' +
          i18n.t("settings.controls.change") +
          '\n                <div class="settingsBtn" style="width: auto;" onclick="showWindow(7)">Edit</div>\n            </div>';
      }
      if (
        this.tabIndex == 3 ||
        (this.settingSearch &&
          this.searchMatches({
            name: "settings.shaders.header",
          }))
      ) {
        try {
          if (RENDER.shaderInputs.length) {
            hj +=
              "<div class='setHed'>" +
              i18n.t("settings.shaders.header") +
              "</div><div>";
            for (var hm = 0; hm < RENDER.shaderInputs.length; hm++) {
              serverSetting = RENDER.shaderInputs[hm];
              var ho =
                RENDER.postprocessing.composer.passes[
                  RENDER.postprocessing.composer.passes.length - 1
                ].uniforms[serverSetting.name].value;
              hj +=
                '<div class="settName" style="margin-top:15px">' +
                serverSetting.name.replace(/[^\w+]/gim, "");
              if (serverSetting.toggle) {
                hj +=
                  "<label class='switch' style='margin-left:10px'>\n                                <input type='checkbox' onclick='setShaderInput(" +
                  hm +
                  ", this.checked)'\n                               " +
                  ((ho = !!ho) ? "checked" : "") +
                  "><span class='slider'></span></label>";
              } else {
                ho = parseFloat(ho) || 0;
                hj +=
                  "<input type='number' class='sliderVal' id='shader_input_" +
                  hm +
                  "' min='" +
                  serverSetting.min +
                  "'\n                                max='" +
                  serverSetting.max +
                  "' value='" +
                  ho +
                  "' onkeypress='return delayExecute2(" +
                  hm +
                  ", this)'\n                                style='margin-right:0px;border-width:0px'/>\n                                <div class='slidecontainer'><input type='range' id='shader_" +
                  hm +
                  "' min='" +
                  serverSetting.min +
                  "'\n                                max='" +
                  serverSetting.max +
                  "' step='" +
                  serverSetting.step +
                  "' value='" +
                  ho +
                  "' class='sliderM'\n                                oninput='setShaderInput(" +
                  hm +
                  ", this.value)'></div>";
              }
              hj += "</div>";
            }
            hj += "</div>";
          }
        } catch (zipError) {}
      }
      if (
        (acc && this.tabIndex == 0) ||
        (this.settingSearch &&
          this.searchMatches({
            name: "settings.backup",
          }))
      ) {
        hj +=
          '<div class="settName" style="margin-top:15px">\n                ' +
          i18n.t("settings.backup") +
          '\n                <div class="settingsBtn" style="width: auto;" onclick="uploadSettings()">Upload</div>\n                <div class="settingsBtn" style="width: auto;" onclick="fetchSettings()">Download</div>\n            </div>';
      }
      for (var hp in settings.list) {
        let hw = () => {
          if (!hk[settings.list[hp].cat]) {
            hk[settings.list[hp].cat] = 0;
            hj += hl ? ((hl = false), "") : "</div>";
            hj +=
              "<div class='setHed' id='setHed_" +
              settings.list[hp].cat +
              "' style='display:none' onclick='window.windows[0].collapseFolder(this)'><span class='material-icons plusOrMinus'>keyboard_arrow_down</span> " +
              i18n.t("settings." + settings.list[hp].cat + ".header") +
              "</div><div id='setBod_" +
              settings.list[hp].cat +
              "'>";
          }
          hj +=
            "<div class='settName' title='" +
            (settings.list[hp].info || "") +
            "'" +
            (settings.list[hp].hide == null
              ? ""
              : "id='" +
                hp +
                "_div' style='display:" +
                (settings.list[hp].hide ? "none" : "block") +
                "'") +
            ">" +
            i18n.t(settings.list[hp].name) +
            (settings.list[hp].needsRestart
              ? " <span style='color: #eb5656'>*</span>"
              : settings.list[hp].verified
                ? " <i class='material-icons' style='color:#2196F3;font-size:33px;vertical-align:bottom;'>check_circle</i>"
                : "") +
            " ";
          hj += settings.list[hp].html
            ? settings.list[hp].html()
            : initGameUI._html.settings.input[settings.list[hp].type]
              ? initGameUI._html.settings.input[settings.list[hp].type](
                  settings.list[hp],
                )
              : initGameUI._html.settings.input.generic(settings.list[hp]);
          hj += "</div>";
          if (!settings.list[hp].hide) {
            hk[settings.list[hp].cat]++;
          }
        };
        if (this.settingSearch) {
          if (
            this.searchMatches(settings.list[hp]) &&
            !settings.list[hp].hide
          ) {
            hw();
          }
        } else if (
          this.tabs[this.tabIndex].categories.includes(settings.list[hp].cat)
        ) {
          hw();
        }
      }
      hj += "</div>";
      for (var hq in hk) {
        if (hk[hq]) {
          hj = hj.replace(
            "id='setHed_" + hq + "' style='display:none'",
            "id='setHed_" + hq + "'",
          );
        }
      }
      var hu = hj + this.getCSettings();
      if (hu.length) {
        return hu;
      } else {
        return "<div class='setHed'>" + i18n.t("settings.none") + "</div>";
      }
    },
    genList: function () {
      var hj =
        "<div class='settingsHeader'>\n            <div style='display:inline-block;text-align:right;float:right;'>\n                <div class=\"settingsBtn\" onclick='resetSettings()'>" +
        i18n.t("settings.reset") +
        "</div>\n                <div class=\"settingsBtn\" onclick='exportSettings()'>" +
        i18n.t("settings.export") +
        "</div>\n                <div class=\"settingsBtn\" onclick='importSettings()'>" +
        i18n.t("settings.import") +
        '</div>\n                <select id="settingsPreset" onchange="selectSettingPre(this.value)" class="inputGrey2" style="margin-left:0px;font-size:14px">\n                    <option value="0" ' +
        (cG == 0 ? "selected" : "") +
        '>Default</option>\n                    <option value="1" ' +
        (cG == 1 ? "selected" : "") +
        '>Pro</option>\n                    <option value="3" ' +
        (cG == 3 ? "selected" : "") +
        '>Performance</option>\n                    <option value="2" ' +
        (cG == 2 ? "selected" : "") +
        ">Custom</option>\n                </select>\n            </div>\n            <div style='display:inline-block;width:220px;'>\n                <input id='settSearch' " +
        (this.settingSearch ? "value='" + this.settingSearch + "'" : "") +
        "\n                    type='text' placeholder='" +
        i18n.t("generic.search") +
        "' oninput='windows[0].searchList()'>\n            </div>\n            <div id='settingsTabLayout'>" +
        this.getTabs() +
        "</div>\n        </div>";
      return (hj += "<div id='settHolder'>" + this.getSettings() + "</div>");
    },
    gen: function () {
      return this.genList();
    },
    searchMatches: function (hj) {
      return (
        !!hj.name &&
        ((i18n.t(hj.name) || "")
          .toLowerCase()
          .indexOf((this.settingSearch || "").toLowerCase()) >= 0 ||
          (i18n.t("settings." + hj.cat + ".header") || "")
            .toLowerCase()
            .indexOf((this.settingSearch || "").toLowerCase()) >= 0)
      );
    },
  },
  {
    header: i18n.t("windows.servers.header"),
    sticky: true,
    lastLoadTime: 0,
    loadedServers: false,
    serverListData: [],
    socialPlayerCount: 0,
    customsInfo: [],
    gen: function () {
      if (Date.now() - this.lastLoadTime < config.serverBrowserRate) {
        return this.genList();
      } else {
        this.lastLoadTime = Date.now();
        return this.loadData();
      }
    },
    loadData: function () {
      var hj = client.fetchGameList();
      fetch(config.socialURL + "/player-count")
        .then((hk) => hk.json())
        .catch(() => {
          console.log("Failed to fetch social");
        })
        .then((hk) => {
          if (hk) {
            windows[1].socialPlayerCount = hk.playerCount;
            if (windows[1].loadedServers) {
              window.showWindow(2, true);
            }
          }
        });
      this.loadedServers = false;
      Promise.all([hj]).then((hk) => {
        var hl = hk[0];
        this.totalPlayerCount = hl.totalPlayerCount;
        var hm = hl.games;
        this.serverListData = hm;
        this.customsInfo.length = 0;
        var ho = false;
        for (var hp of hm) {
          var [hq, hu, hv, hw, hl] = hp;
          if (hl.cs && hl.m) {
            var hx = hl.i.split(/_(.+)/)[1];
            var hy = this.customsInfo.findIndex((hz) => hz.n == hx);
            if (this.customsInfo[hy]) {
              this.customsInfo[hy].c += hv;
            } else {
              this.customsInfo.push({
                n: hx,
                i: hl.m,
                c: hv,
              });
            }
          }
          if (
            (config.useLooseClient || !hl.v || hl.v != version) &&
            hq === gameId
          ) {
            ho = true;
            break;
          }
        }
        this.customsInfo = this.customsInfo.sort(
          (hz, hA) => (hA.c || -1) - (hz.c || -1),
        );
        if (ho) {
          window.showWindow(2, true);
        } else {
          client.fetchGameInfo(gameId).then((hz) => {
            this.privateServerData = hz;
            window.showWindow(2, true);
          });
        }
        windows[1].loadedServers = true;
      });
      return (
        "<div style='padding-top:19px;>" + i18n.t("generic.loading") + "</div>"
      );
    },
    expandedRegion: -1,
    totalPlayerCount: 0,
    serverSearch: null,
    searchList: function (hj) {
      if (hj) {
        this.expandedRegion = 0;
      }
      var hk = document.getElementById("serverSearch");
      if (hj) {
        hk.value = hj;
      }
      this.serverSearch = hk && hk.value != "" ? hk.value : null;
      if ((hk = document.getElementById("serverHolder"))) {
        hk.innerHTML = this.getServers();
      }
    },
    getServers: function (hj) {
      var hk = !!localStorage.debugServerList;
      var hl = "";
      var servers = {
        custom: {
          order: 1,
          name: "Custom Games",
          players: 0,
          games: [],
        },
      };
      var ho = settings.list.defaultRegion.val;
      var privateServer = false;
      for (var hq = 0; hq < this.serverListData.length; hq++) {
        var hu = this.serverListData[hq];
        var [id, regionID, hx, hy, hz] = hu;
        if (hz) {
          if (!servers[regionID]) {
            servers[regionID] = {
              name: config.regionNames[regionID],
              players: 0,
              games: [],
            };
            if (ho == regionID) {
              servers[regionID].order = 1;
            }
          }
          var hA = hz.cs ? "custom" : regionID;
          hu[2] = Math.min(hx, hy);
          if (gameId === id) {
            privateServer = true;
          }
          if (!this.serverSearch || this.searchMatches(hu)) {
            servers[hA].players += hx;
          }
          servers[hA].games.push(hu);
        } else {
          console.warn("Server doesn't have data yet.");
        }
      }
      if (!privateServer) {
        if (this.privateServerData) {
          if (this.privateServerData[4]) {
            servers.custom.games.push(this.privateServerData);
          } else {
            console.warn("Server doesn't have data yet.");
          }
        } else {
          console.warn("Missing private server data.");
        }
      }
      var hB = [];
      for (var regionID in servers) {
        if (servers.hasOwnProperty(regionID)) {
          hB.push(servers[regionID]);
        }
      }
      for (var regionID of (hB = hB.sort(
        (hM, hN) => (hN.order || -1) - (hM.order || -1),
      ))) {
        regionID.games.sort(
          (hM, hN) => (hN[4].pr ? 1 : 0) - (hM[4].pr ? 1 : 0) || hN[2] - hM[2],
        );
        if (regionID.name == "Custom Games" && dL) {
          regionID.games.sort((hM, hN) =>
            ho == hM[1] && ho != hN[1]
              ? -1
              : ho == hN[1] && ho != hM[1]
                ? 1
                : 0,
          );
        }
      }
      if (acc) {
        acc.level;
      }
      if (hj != null) {
        var hC = [];
        if (!(regionID = hB[hj]) || !regionID.games) {
          return hC;
        }
        regionID.games = regionID.games.filter(
          (hM) => hM[2] < hM[3] && hM[2] > 0,
        );
        for (var hD = 0; hD < regionID.games.length; hD++) {
          var foundGames = regionID.games[hD];
          var [id, hF, hx, hy, hz] = foundGames;
          var hG = gameId && gameId == id;
          if ((!this.serverSearch || !!this.searchMatches(foundGames)) && !hG) {
            hC.push(id);
          }
        }
        return hC;
      }
      for (var hH = 0; hH < hB.length; hH++) {
        (regionID = hB[hH]).games = regionID.games.filter(
          (hM) => !dK || hM[2] != hM[3],
        );
        var hI =
          regionID.name +
          "<span style='float:right'>" +
          regionID.players +
          " online</span>";
        var hJ = this.expandedRegion == hH;
        hl +=
          "<div class='menuSelectorHeader' onclick='setExpandedRegion(" +
          (hJ ? -1 : hH) +
          ")' style='cursor: pointer;'><span class='material-icons plusOrMinus'>" +
          (hJ ? "expand_more" : "navigate_next") +
          "</span> " +
          hI +
          "</div><div class='quickJoin' onclick='quickJoinRegion(" +
          hH +
          ")'>Quick Join</div>";
        if (hJ) {
          hl += "<div class='menuSelectorHolder'>";
          var hK = 0;
          for (hD = 0; hD < regionID.games.length; hD++) {
            foundGames = regionID.games[hD];
            var [id, hF, hx, hy, hz] = foundGames;
            hG = gameId && gameId == id;
            if (!this.serverSearch || this.searchMatches(foundGames)) {
              hK++;
              var hL =
                (hk ? id : hz.i) +
                (hz.pr
                  ? " <span class='material-icons' style='color:#FBC02D;vertical-align:middle'>star</span> "
                  : "") +
                (hz.earnKR
                  ? " <i class='material-icons' style='color:#2196F3;font-size:33px;vertical-align:bottom;'>check_circle</i>"
                  : "") +
                "<div class='serverPCount'>" +
                hx +
                "/" +
                hy +
                "</div>" +
                (hz.cs
                  ? "<div class='serverRegion'>" +
                    id.split(":")[0] +
                    " -&nbsp;</div>"
                  : "");
              hl +=
                "<div class='" +
                ("menuSelector" + (hG ? " selectedMenuSelector" : "")) +
                "' onclick='" +
                ('checkedSwitchServer("' +
                  id +
                  '", this.querySelector(".serverPCount"))') +
                "'>" +
                hL +
                "</div>";
            }
          }
          if (!regionID.games.length || !hK) {
            hl +=
              "<div style='margin-left: 30px;margin-top: -5px;margin-bottom: 2px;'>" +
              i18n.t("windows.servers.none") +
              "</div>";
          }
          hl += "</div>";
        }
      }
      return hl;
    },
    genList: function () {
      this.serverSearch = null;
      var hj = this;
      window.setExpandedRegion = function (hm) {
        hj.expandedRegion = hm;
        hj.lastLoadTime = Date.now();
        var ho = document.getElementById("serverHolder");
        if (ho) {
          ho.innerHTML = hj.getServers();
        }
      };
      var hk =
        "<div class='serverHeader'><div class='sideTabs'><a onclick='openHostWindow()'>+ Host Game</a></div><div class='centerTab'><input id='serverSearch' type='text' placeholder='Search Game'" +
        (this.serverSearch ? " value='" + this.serverSearch + "'" : "") +
        " oninput='windows[1].searchList()'></input></div><div class='sideTabs'><div id=\"hideFull\" style=\"display:inline-block;\"><span class='grey'>" +
        i18n.t("windows.servers.hide") +
        "</span><label class='switch2' style='margin-top: 4px;margin-left: 11px;'><input type='checkbox' onclick='toggleHF(this.checked);windows[1].searchList()'" +
        (dK ? " checked" : "") +
        "><span class='slider2'></span></label></div></div></div><div style='height:10px'></div>";
      if (this.customsInfo.length >= 3 && !settings.tmp.oldBrowser) {
        hk += "<div class='carousel' id='carousel-infinite'>";
        this.customsInfo.length = Math.min(31, this.customsInfo.length);
        for (var hl = 0; hl < this.customsInfo.length; hl++) {
          hk +=
            "<div class='slide' onclick='windows[1].searchList(&quot;" +
            UTILS.cleanseString(this.customsInfo[hl].n) +
            "&quot;)'><img class='slideImg' loading='lazy' src='https://user-assets.krunker.io/m" +
            this.customsInfo[hl].i +
            "/thumb.png?v=3456' onerror='this.onerror=null;this.src=\"./img/noimg.png\";'><div class='slideName'>" +
            this.customsInfo[hl].n +
            "</div><div class='slidePlayers'>" +
            this.customsInfo[hl].c +
            " players</div></div>";
        }
        hk += "</div>";
      }
      hk += "<div style='font-size:20px'>";
      hk += "<div id='serverHolder'>" + this.getServers() + "</div>";
      hk +=
        "<div style='height:10px'></div><b style='color:rgba(0,0,0,0.6)'>" +
        i18n.t(
          "windows.servers.online",
          UTILS.commaNumber(this.totalPlayerCount),
        ) +
        "<span style='float:right;color:rgba(0,0,0,0.6)'>" +
        i18n.t(
          "windows.servers.social",
          UTILS.commaNumber(this.socialPlayerCount),
        ) +
        "</span></b>";
      return (hk += "</div>");
    },
    post: function () {
      if (this.customsInfo.length >= 3 && !settings.tmp.oldBrowser) {
        new PureJSCarousel({
          carousel: "#carousel-infinite",
          slide: ".slide",
        });
      }
    },
    searchMatches(hj) {
      var [hk, hl, hm, ho, hp] = hj;
      return (
        !!hp &&
        (hp.i || "")
          .toLowerCase()
          .indexOf((this.serverSearch || "").toLowerCase()) >= 0
      );
    },
  },
  {
    header: i18n.t("windows.loadout.header"),
    action: function (hj) {
      if ((hj == 0 || hj == 2) && loadoutSelect.value == "Select") {
        return;
      }
      let hk = getSavedVal("krk_loadouts");
      hk = hk ? JSON.parse(hk) : {};
      var hl = loadoutName.value.length
        ? loadoutName.value
        : loadoutSelect.value == "Select"
          ? "Preset1"
          : loadoutSelect.value;
      if (hj == 2) {
        if (hk[loadoutSelect.value]) {
          delete hk[loadoutSelect.value];
        }
        saveVal("krk_loadouts", JSON.stringify(hk));
      } else {
        let hm = hj == 1 ? {} : hk[loadoutSelect.value];
        if (hj == 1) {
          hm.skinColIndex = selectedSkinColor;
          hm.hairCol = selectedHairColor;
          hm.chatCol = selectedChatColor;
          hm.dyeIndex = selectedDyeIndex;
          hm.faceIndex = selectedFaceIndex;
          hm.attachIndex = selectedAttachIndex;
          hm.reticleIndex = selectedReticleIndex;
          hm.meleeIndex = selectedMeleeIndex;
          hm.backIndex = selectedBackIndex;
          hm.hatIndex = selectedHatIndex;
          hm.waistIndex = selectedWaistIndex;
          hm.secondaryInd = selectedSecondaryIndex;
          hm.kcStatIndex = selectedKillcardStatIndex;
          hm.classindex = selectedClassIndex;
          hm.skins = JSON.stringify(selectedSkinsByWeapon || {});
          hk[hl] = hm;
          saveVal("krk_loadouts", JSON.stringify(hk));
        } else if (hj == 0) {
          if ("skinColIndex" in hm) {
            saveVal("skinColIndex", hm.skinColIndex);
            selectedSkinColor = hm.skinColIndex;
          }
          if ("hairCol" in hm) {
            saveVal("hairCol", hm.hairCol);
            selectedHairColor = hm.hairCol;
          }
          if ("chatCol" in hm) {
            saveVal("chatCol", hm.chatCol);
            selectedChatColor = hm.chatCol;
          }
          if ("dyeIndex" in hm) {
            saveVal("dyeIndex", hm.dyeIndex);
            selectedDyeIndex = hm.dyeIndex;
          }
          if ("faceIndex" in hm) {
            saveVal("faceIndex", hm.faceIndex);
            selectedFaceIndex = hm.faceIndex;
          }
          if ("attachIndex" in hm) {
            saveVal("attachIndex", hm.attachIndex);
            selectedAttachIndex = hm.attachIndex;
          }
          if ("reticleIndex" in hm) {
            saveVal("reticleIndex", hm.reticleIndex);
            selectedReticleIndex = hm.reticleIndex;
            updateAimDot(selectedReticleIndex, RENDER.aimDot.savedCustom);
          }
          if ("meleeIndex" in hm) {
            saveVal("meleeIndex", hm.meleeIndex);
            selectedMeleeIndex = hm.meleeIndex;
          }
          if ("backIndex" in hm) {
            saveVal("backIndex", hm.backIndex);
            selectedBackIndex = hm.backIndex;
          }
          if ("hatIndex" in hm) {
            saveVal("hatIndex", hm.hatIndex);
            selectedHatIndex = hm.hatIndex;
          }
          if ("waistIndex" in hm) {
            saveVal("waistIndex", hm.waistIndex);
            selectedWaistIndex = hm.waistIndex;
          }
          if ("kcStatIndex" in hm) {
            saveVal("kcStatIndex", hm.kcStatIndex);
            selectedKillcardStatIndex = hm.kcStatIndex;
          }
          if ("secondaryInd" in hm) {
            saveVal("secondaryInd", hm.secondaryInd);
            selectedSecondaryIndex = hm.secondaryInd;
          }
          if ("classindex" in hm) {
            saveVal("classindex", hm.classindex);
            setClassIndex(hm.classindex || 0);
          }
          if ("skins" in hm) {
            dy = hm.skins;
            selectedSkinsByWeapon = dy ? JSON.parse(dy) : {};
            saveVal("skins", JSON.stringify(selectedSkinsByWeapon));
          }
          dJ();
          updateWindow(3);
        }
      }
      windows[2].genLoadouts();
    },
    genLoadouts: function (hj = false) {
      let hk = getSavedVal("krk_loadouts");
      hk = hk ? JSON.parse(hk) : {};
      var hl =
        "<span class='settNameSmall' style='margin:0;margin-bottom:5px;'><input id='loadoutName' type='text' class='formInput' placeholder='Loadout name' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' style='border:none;background:#eee;padding-bottom:6px;float:left;margin-top:5px;margin-bottom:5px;'><select id='loadoutSelect' style='border-radius:6px;margin-left:10px;border:none;background:#eee;;padding:6px;padding-bottom:6px;margin-top:5px;margin-bottom:5px;'><option selected>Select</option>";
      for (let hm in hk) {
        hl += "<option>" + hm + "</option>";
      }
      hl += "</select>";
      hl +=
        "<div class='loadoutBtn' onclick='windows[2].action(2)'>Delete</div><div class='loadoutBtn' onclick='windows[2].action(1)'>Save</div><div class='loadoutBtn' onclick='windows[2].action(0)'>Load</div></span>";
      if (hj) {
        return hl;
      } else {
        loadoutHolder.innerHTML = hl;
        return;
      }
    },
    gen: function () {
      var hj = "";
      hj +=
        "<div id='loadoutHolder' style='text-align:left;margin-bottom:10px'>" +
        windows[2].genLoadouts(true) +
        "</div>";
      var hk = Game.classes[selectedClassIndex];
      if (Game.config.classes.indexOf(parseInt(selectedClassIndex)) < 0) {
        selectedClassIndex = Game.config.classes[0];
        hk = Game.classes[selectedClassIndex];
      }
      var hl = Game.weaponConfig[hk.loadout[0]].name;
      var hm = "#2196F3";
      var ho = false;
      var hp = hk.secondary
        ? Game.weaponConfig[selectedSecondaryIndex].name
        : i18n.t("generic.none");
      var hq = Game.store.skins[selectedMeleeIndex]
        ? Game.store.skins[selectedMeleeIndex].name
        : selectedMeleeIndex == -2
          ? "Random"
          : "Combat Knife";
      var hu = Game.store.skins[selectedHatIndex]
        ? Game.store.skins[selectedHatIndex].name
        : selectedHatIndex == -2
          ? "Random"
          : i18n.t("generic.none");
      var hv = Game.store.skins[selectedBackIndex]
        ? Game.store.skins[selectedBackIndex].name
        : selectedBackIndex == -2
          ? "Random"
          : i18n.t("generic.none");
      var hw = Game.store.skins[selectedDyeIndex]
        ? Game.store.skins[selectedDyeIndex].name
        : selectedDyeIndex == -2
          ? "Random"
          : i18n.t("generic.none");
      var hx = Game.store.skins[selectedWaistIndex]
        ? Game.store.skins[selectedWaistIndex].name
        : selectedWaistIndex == -2
          ? "Random"
          : i18n.t("generic.none");
      var hy = Game.store.skins[selectedFaceIndex]
        ? Game.store.skins[selectedFaceIndex].name
        : selectedFaceIndex == -2
          ? "Random"
          : i18n.t("generic.none");
      var hz = Game.sprays[selectedSprayIndex]
        ? Game.sprays[selectedSprayIndex].name
        : Game.store.skins[selectedSprayIndex] && Game.store.skins[selectedSprayIndex].type == 4
          ? Game.store.skins[selectedSprayIndex].name
          : selectedSprayIndex == -2
            ? "Random"
            : i18n.t("generic.none");
      var hA = false;
      var hB = "#2196F3";
      if (
        !Game.sprays[selectedSprayIndex] &&
        Game.store.skins[selectedSprayIndex] &&
        Game.store.skins[selectedSprayIndex].type == 4
      ) {
        hB = Game.store.rarities[Game.store.skins[selectedSprayIndex].rarity].color;
        hA = Game.store.rarities[Game.store.skins[selectedSprayIndex].rarity].animate;
      }
      var hC =
        Game.weaponConfig[hk.loadout[0]].attach != null &&
        !Game.weaponConfig[hk.loadout[0]].forceAttach;
      var hD =
        hC && Game.attach[selectedAttachIndex]
          ? Game.attach[selectedAttachIndex].name
          : i18n.t("generic.none");
      var hE = Game.weaponConfig[hk.loadout[0]].attach != null;
      var hF =
        hE && Game.reticles[selectedReticleIndex]
          ? Game.reticles[selectedReticleIndex].name
          : selectedReticleIndex == -2
            ? "Custom"
            : i18n.t("generic.none");
      var hG = hk.secondary ? "#2196F3" : "rgba(0,0,0,0.3)";
      var hH = false;
      var hI = "rgba(0,0,0,0.3)";
      var hJ = false;
      var hK = hI;
      var hL = false;
      var hM = "rgba(0,0,0,0.3)";
      var hN = false;
      var hO = hC ? "#2196F3" : "rgba(0,0,0,0.3)";
      var hP = hE ? "#2196F3" : "rgba(0,0,0,0.3)";
      var hQ = "rgba(0,0,0,0.3)";
      var hR = false;
      hP = "rgba(0,0,0,0.3)";
      var hS = false;
      var hT = "rgba(0,0,0,0.3)";
      var hU = false;
      if (acc) {
        if (selectedSkinsByWeapon[hk.loadout[0]] != null) {
          if ((hl = Game.store.skins[selectedSkinsByWeapon[hk.loadout[0]]])) {
            hm = Game.store.rarities[hl.rarity].color;
            ho = Game.store.rarities[hl.rarity].animate;
            hl = hl.name;
          } else if (selectedSkinsByWeapon[hk.loadout[0]] == -2) {
            hl = "Random";
          }
        }
        if (
          hk.secondary &&
          selectedSkinsByWeapon[selectedSecondaryIndex] != null
        ) {
          if (
            (hp =
              Game.store.skins[selectedSkinsByWeapon[selectedSecondaryIndex]])
          ) {
            hG = Game.store.rarities[hp.rarity].color;
            hH = Game.store.rarities[hp.rarity].animate;
            hp = hp.name;
          } else if (selectedSkinsByWeapon[selectedSecondaryIndex] == -2) {
            hp = "Random";
          }
        }
        if (selectedHatIndex >= 0 && Game.store.skins[selectedHatIndex]) {
          hJ =
            Game.store.rarities[Game.store.skins[selectedHatIndex].rarity]
              .animate;
          hI =
            Game.store.rarities[Game.store.skins[selectedHatIndex].rarity]
              .color;
        }
        if (selectedBackIndex >= 0 && Game.store.skins[selectedBackIndex]) {
          hL =
            Game.store.rarities[Game.store.skins[selectedBackIndex].rarity]
              .animate;
          hK =
            Game.store.rarities[Game.store.skins[selectedBackIndex].rarity]
              .color;
        }
        if (selectedMeleeIndex >= 0 && Game.store.skins[selectedMeleeIndex]) {
          hN =
            Game.store.rarities[Game.store.skins[selectedMeleeIndex].rarity]
              .animate;
          hM =
            Game.store.rarities[Game.store.skins[selectedMeleeIndex].rarity]
              .color;
        }
        if (selectedDyeIndex >= 0 && Game.store.skins[selectedDyeIndex]) {
          hR =
            Game.store.rarities[Game.store.skins[selectedDyeIndex].rarity]
              .animate;
          hQ =
            Game.store.rarities[Game.store.skins[selectedDyeIndex].rarity]
              .color;
        }
        if (selectedWaistIndex >= 0 && Game.store.skins[selectedWaistIndex]) {
          hS =
            Game.store.rarities[Game.store.skins[selectedWaistIndex].rarity]
              .animate;
          hP =
            Game.store.rarities[Game.store.skins[selectedWaistIndex].rarity]
              .color;
        }
        if (selectedFaceIndex >= 0 && Game.store.skins[selectedFaceIndex]) {
          hU =
            Game.store.rarities[Game.store.skins[selectedFaceIndex].rarity]
              .animate;
          hT =
            Game.store.rarities[Game.store.skins[selectedFaceIndex].rarity]
              .color;
        }
      }
      var hV = i18n.t("windows.loadout.color.skin");
      hV +=
        acc && acc.premiumT > 0
          ? "<input class='skinColorItem' " +
            (UTILS.isHexColor(selectedSkinColor)
              ? "value='" + selectedSkinColor + "' "
              : "") +
            "type='color' style='border-radius:2px;width:40px;' onmouseenter='playTick()' onchange='selectSkinColor(this.value)'>"
          : "<i class='material-icons premiumSkinCol' onclick='windows[13].premium()'>add_circle_outline</i>";
      for (var hW = config.skinColors.length - 1; hW >= 0; hW--) {
        if (!config.skinColors[hW].req || config.skinColors[hW].req(acc)) {
          hV +=
            "<div class='skinColorItem" +
            (parseInt(selectedSkinColor) == hW ? " activeSkin" : "") +
            "' style='background-color:#" +
            config.skinColors[hW].col.toString(16) +
            "' onmouseenter='playTick()' onclick='selectSkinColor(" +
            hW +
            ")'></div>";
        }
      }
      var hX = i18n.t("windows.loadout.color.hair");
      hX +=
        acc && acc.premiumT > 0
          ? "<input class='skinColorItem' " +
            (UTILS.isHexColor(selectedHairColor)
              ? "value='" + selectedHairColor + "' "
              : "") +
            "type='color' style='border-radius:2px;width:40px;' onmouseenter='playTick()' onchange='selectHairColor(this.value)'>"
          : "<i class='material-icons premiumSkinCol' onclick='windows[13].premium()'>add_circle_outline</i>";
      var hY = i18n.t("windows.loadout.color.chat");
      hY +=
        acc && acc.premiumT > 0
          ? "<input class='skinColorItem' value='" +
            (UTILS.isHexColor(selectedChatColor)
              ? selectedChatColor
              : "#ffffff") +
            "' type='color' style='border-radius:2px;width:40px;' onmouseenter='playTick()' onchange='selectChatColor(this.value)'>"
          : "<i class='material-icons premiumSkinCol' onclick='windows[13].premium()'>add_circle_outline</i>";
      var hZ =
        i18n.t("windows.loadout.stat") +
        "<select onchange='selectStat(this.value)' class='inputGrey2' style='font-size:16px;padding:4px;margin-bottom: 5px;'><option value='-1' " +
        (selectedKillcardStatIndex == -1 ? "selected" : "") +
        ">None</option>";
      for (hW = 0; hW < config.killCardStats.length; hW++) {
        hZ +=
          "<option value='" +
          hW +
          "' " +
          (selectedKillcardStatIndex == hW ? "selected" : "") +
          ">" +
          config.killCardStats[hW].name +
          "</option>";
      }
      hZ += "</select>";
      return (hj +=
        "<div class='settName'>" +
        i18n.t("windows.loadout.class") +
        "<span class='settText floatR' onclick='showWindow(6)'>" +
        hk.name +
        "</span></div><div class='settName'>" +
        i18n.t("windows.loadout.primary") +
        "<span class='settLabel wepLink" +
        (RENDER.rarityAnim && ho ? " rainbowText" : "") +
        "' style='color:" +
        hm +
        "' onclick='skinSelector(" +
        hk.loadout[0] +
        ")'>" +
        hl +
        "</span></div>" +
        (hC
          ? "<div class='settName'>" +
            i18n.t("windows.loadout.primary.attach") +
            "<span class='settLabel wepLink' onclick='showWindow(31)' style='color:" +
            hO +
            "'>" +
            hD +
            "</span></div>"
          : "") +
        (hE
          ? "<div class='settName'>" +
            i18n.t("windows.loadout.primary.reticle") +
            "<span class='settLabel wepLink' onclick='showWindow(32)' style='color:" +
            hP +
            "'>" +
            hF +
            "</span></div>"
          : "") +
        "<div class='settName'>" +
        i18n.t("windows.loadout.secondary") +
        "<span class='settLabel" +
        (hk.secondary
          ? " wepLink" + (RENDER.rarityAnim && hH ? " rainbowText" : "")
          : "") +
        "' " +
        (hk.secondary ? "onclick='showWindow(20)'" : "") +
        " style='color:" +
        hG +
        "'>" +
        hp +
        "</span></div><div class='settName'>" +
        i18n.t("windows.loadout.melee") +
        "<span onclick='showWindow(26)' class='settText floatR" +
        (RENDER.rarityAnim && hN ? " rainbowText" : "") +
        "' style='color:" +
        hM +
        "'>" +
        hq +
        "</span></div><div class='settName'>" +
        i18n.t("windows.loadout.face") +
        "<span onclick='showWindow(39)' class='settText floatR" +
        (RENDER.rarityAnim && hU ? " rainbowText" : "") +
        "' style='color:" +
        hT +
        "'>" +
        hy +
        "</span></div><div class='settName'>" +
        i18n.t("windows.loadout.hat") +
        "<span onclick='showWindow(16)' class='settText floatR" +
        (RENDER.rarityAnim && hJ ? " rainbowText" : "") +
        "' style='color:" +
        hI +
        "'>" +
        hu +
        "</span></div><div class='settName'>" +
        i18n.t("windows.loadout.body") +
        "<span onclick='showWindow(17)' class='settText floatR" +
        (RENDER.rarityAnim && hL ? " rainbowText" : "") +
        "' style='color:" +
        hK +
        "'>" +
        hv +
        "</span></div><div class='settName'>" +
        i18n.t("windows.loadout.waist") +
        "<span onclick='showWindow(38)' class='settText floatR" +
        (RENDER.rarityAnim && hS ? " rainbowText" : "") +
        "' style='color:" +
        hP +
        "'>" +
        hx +
        "</span></div><div class='settName'>" +
        i18n.t("windows.loadout.dye") +
        "<span onclick='showWindow(34)' class='settText floatR" +
        (RENDER.rarityAnim && hR ? " rainbowText" : "") +
        "' style='color:" +
        hQ +
        "'>" +
        hw +
        "</span></div><div class='settName'>" +
        i18n.t("windows.loadout.spray") +
        "<span onclick='showWindow(9)' class='settText floatR" +
        (RENDER.rarityAnim && hA ? " rainbowText" : "") +
        "' style='color:" +
        hB +
        "'>" +
        hz +
        "</span></div><div class='settName'>" +
        hV +
        "</div><div class='settName'>" +
        hX +
        "</div><div class='settName'>" +
        hY +
        "</div><div class='settName'>" +
        hZ +
        "</div>");
    },
  },
  {
    header: i18n.t("windows.mods.header"),
    tabIndex: 0,
    listData: {},
    searchMods: function () {
      searchResultsMO.innerHTML = "Loading...";
      API_CLIENT.searchMod(mdSrch.value, searchResponse);
    },
    searchResp: function (hj) {
      var hk = "";
      if (hj.length) {
        hk += "<div style='height:10px'></div>";
        hk += getCardsList(hj, "mod");
      } else {
        hk = i18n.t("windows.mods.none");
      }
      if (document.getElementById("searchResultsMO")) {
        document.getElementById("searchResultsMO").innerHTML = hk;
      }
    },
    loadMore: function (hj) {
      if (!this.listData[this.tabIndex].waiting) {
        if (hj) {
          hj.className = "loadMoreW";
          hj.innerHTML = "Loading...";
        }
        this.listData[this.tabIndex].waiting = true;
        this.listData[this.tabIndex].loadInd += 1;
        API_CLIENT.listMods(
          this.tabIndex,
          this.listData[this.tabIndex].loadInd,
          acc ? acc.id : null,
          modListResponse,
        );
      }
    },
    modsLoaded: function (hj, hk, hl) {
      if (modList) {
        this.listData[hk].waiting = false;
        if (hj && hj.length) {
          if (hl) {
            if (!this.listData[hk].dat) {
              modList.innerHTML = hl;
              this.listData[hk] = null;
            }
          } else {
            var hm = getCardsList(hj, "mod", hk);
            this.listData[hk].dat = (this.listData[hk].dat || "") + hm;
            if (this.tabIndex == hk) {
              updateWindow(4);
            }
          }
        } else if (!this.listData[hk].dat) {
          modList.innerHTML = i18n.t("windows.mods.none");
          this.listData[hk] = null;
        }
      }
    },
    switchTab: function (hj) {
      if (this.tabIndex != hj) {
        this.tabIndex = hj;
        updateWindow(4);
      }
    },
    gen: function () {
      var hj = config.modTabs[this.tabIndex];
      var hk = "<div class='menuTabsNew'>";
      for (var hl = 0; hl < config.modTabs.length; ++hl) {
        hk +=
          "<div class='menuTabNew" +
          (this.tabIndex == hl ? " tabANew" : "") +
          "' onclick='windows[3].switchTab(" +
          hl +
          ")'>" +
          config.modTabs[hl].n +
          "</div>";
      }
      hk += "</div>";
      var html = "";
      if (hj.search) {
        html =
          "<input type='text' id='mdSrch' class='smlInput' placeholder='Mod Name' onkeydown='if(window.event.keyCode==13)windows[3].searchMods()' /><div class='searchBtn' onclick='windows[3].searchMods()'>" +
          i18n.t("generic.search") +
          "</div><div style='color:rgba(0,0,0,0.5);margin-top:10px' id='searchResultsMO'></div>";
      } else if (this.listData[this.tabIndex]) {
        if (this.listData[this.tabIndex].dat) {
          html = this.listData[this.tabIndex].dat;
          if (this.listData[this.tabIndex].waiting) {
            html += "<div class='loadMoreW'>Loading...</div>";
          } else if (!hj.sendID && !hj.noPages) {
            html +=
              "<div class='loadMoreD' onclick='windows[3].loadMore(this)'>Load More</div>";
          }
        } else {
          html = "<div class='loadMoreW'>Loading...</div>";
        }
      } else {
        html = "<div class='loadMoreW'>Loading...</div>";
        this.listData[this.tabIndex] = {
          loadInd: 0,
        };
        API_CLIENT.listMods(this.tabIndex, 0, acc ? acc.id : null, modListResponse);
      }
      return (
        "<a href='javascript:;' onclick='showWindow(18)' class='menuLink'>Load Mod</a> | <a href='/social.html?p=mods&openPubMo' target='_blank' class='menuLink'>Upload Mod</a><a style='float:right' href='/viewer.html' class='menuLink'>Model Viewer</a><div style='margin-top:15px;margin-bottom:15px'>" +
        hk +
        "</div><div style='color:rgba(0,0,0,0.3)' id='modList'>" +
        html +
        "</div>"
      );
    },
  },
  {
    header: i18n.t("windows.account.header"),
    aSuccess: false,
    aResp: function (hj, hk) {
      if (hj) {
        popupResponse(null, hj);
      } else {
        popupResponse("SUCCESS");
        acc.alias = hk;
        cK();
        dJ();
        updateWindow(null, true);
      }
    },
    tabIndex: 0,
    switchTab: function (hj) {
      windows[4].tabIndex = hj;
      updateWindow(5);
    },
    drops: null,
    dropsLoaded: function (hj) {
      if (hj && hj.length) {
        this.drops = hj;
        updateWindow(5);
      } else {
        this.drops = [];
      }
    },
    gen: function () {
      var hj = "";
      if (acc) {
        hj +=
          "<div style='color:rgba(0,0,0,0.3);margin-top:-5px;margin-bottom:10px'>" +
          i18n.t("windows.store.buyP") +
          " <a href='javascript:;' onclick='windows[13].premium()'>" +
          i18n.t("windows.store.premium2") +
          "</a></div>";
        hj += "<div class='menuTabsNew'>";
        for (var hk = 0; hk < config.profileTabs.length; ++hk) {
          hj +=
            "<div class='menuTabNew" +
            (this.tabIndex == hk ? " tabANew" : "") +
            "' onclick='windows[4].switchTab(" +
            hk +
            ")'>" +
            config.profileTabs[hk] +
            "</div>";
        }
        hj += "</div>";
        if (this.tabIndex == 0) {
          var hl =
            acc.premiumT > 0
              ? /*https://user-assets.krunker.io*/ "/p" +
                acc.id +
                "/profile.png?v=" +
                Date.now()
              : "https://assets.krunker.io/textures/classes/icon_0.png";
          hj +=
            "<div id='profilePicM' class='" +
            (acc.premiumT > 0 ? "" : "blurred") +
            "'><img style='width: inherit;height: inherit;border-radius: inherit;' loading='lazy' src='" +
            hl +
            "' onerror='this.onerror=null;this.parentNode.className='blurred';this.src='https://assets.krunker.io/textures/classes/icon_0.png';'><a class='pfpAction' onmouseenter='SOUND.play(`tick_0`,0.1)' onclick='pfpPopup();'>Change Picture</a></div>";
          hj +=
            "<div style='display:inline-block;vertical-align:top;width:560px;margin-left:10px'><div class='settName' style='width:100%;margin-top:0px'>" +
            i18n.t("generic.name") +
            "<a href='/social.html?p=profile&q=" +
            acc.name +
            "' class='floatR' target='_blank'>" +
            acc.name +
            "</a></div><div class='settName' style='width:100%'>" +
            i18n.t("generic.clan") +
            "<a class='floatR' class='menuLink' onclick='showWindow(13)'>" +
            (acc.clan ? "[" + acc.clan + "]" : "None") +
            "</a></div><div class='settName' style='margin-top:0px'>" +
            i18n.t("generic.level") +
            "<span class='floatR'>" +
            acc.level +
            "</span></div></div>";
          hj +=
            "<div class='xpBar' style='margin-top:10px'><div class='xpBarB' style='width:" +
            acc.levelProg +
            "%'></div><span class='xpBarV'>" +
            UTILS.xpBarText(acc) +
            "</span></div><div class='settName'>" +
            i18n.t("generic.score") +
            "<span class='floatR'>" +
            acc.score +
            "</span></div><div class='settName'>KR<span class='floatR'><span style='color:rgba(0,0,0,0.5)'>" +
            UTILS.commaNumber(acc.funds) +
            "</span> KR</span></div><div class='settName'>" +
            i18n.t("generic.kills") +
            "<span class='floatR'>" +
            acc.kills +
            "</span></div><div class='settName'>" +
            i18n.t("generic.deaths") +
            "<span class='floatR'>" +
            acc.deaths +
            "</span></div><div class='settName'>" +
            i18n.t("generic.kdr") +
            "<span class='floatR'>" +
            (acc.kills / Math.max(acc.deaths, 1)).toFixed(2) +
            "</span></div><div class='settName'>KPG<span class='floatR'>" +
            (acc.kills / Math.max(acc.games, 1)).toFixed(2) +
            "</span></div><div class='settName'>Nukes<span class='floatR'>" +
            (acc.stats.n || 0) +
            "</span></div><div class='settName'>Melee<span class='floatR'>" +
            (acc.stats.mk || 0) +
            "</span></div><div class='settName'>Beatdowns<span class='floatR'>" +
            (acc.stats.fk || 0) +
            "</span></div><div class='settName'>Bullseyes<span class='floatR'>" +
            (acc.stats.tmk || 0) +
            "</span></div><div class='settName'>Headshots<span class='floatR'>" +
            (acc.stats.hs || 0) +
            "</span></div><div class='settName'>Wallbangs<span class='floatR'>" +
            (acc.stats.wb || 0) +
            "</span></div><div class='settName'>" +
            i18n.t("generic.games.played") +
            "<span class='floatR'>" +
            acc.games +
            "</span></div><div class='settName'>" +
            i18n.t("generic.games.won") +
            "<span class='floatR'>" +
            acc.wins +
            "</span></div><div class='settName'>" +
            i18n.t("generic.games.lost") +
            "<span class='floatR'>" +
            Math.max(acc.games - acc.wins, 0) +
            "</span></div><div class='settName'>W/L<span class='floatR'>" +
            (acc.wins / Math.max(acc.games - acc.wins, 1)).toFixed(2) +
            "</span></div><div class='settName'>" +
            i18n.t("generic.timep") +
            "<span class='floatR'>" +
            UTILS.getReadableTime(acc.timePlayed) +
            "</span></div><div style='height:10px'></div>";
          hj +=
            "<div style='font-size:26px;margin-top:10px;font-weight:bold'>Ranked</div><div class='settName'>MMR (1v1)<span class='floatR'>" +
            acc.elo.round(1) +
            UTILS.eloIconHTML(acc.elo.round(1), "margin-left:4px;") +
            "</span></div><div class='settName'>MMR (2v2)<span class='floatR'>" +
            acc.elo2.round(1) +
            UTILS.eloIconHTML(acc.elo2.round(1), "margin-left:4px;") +
            "</span></div><div class='settName'>MMR (4v4)<span class='floatR'>" +
            acc.elo4.round(1) +
            UTILS.eloIconHTML(acc.elo4.round(1), "margin-left:4px;") +
            "</span></div>";
        }
        if (this.tabIndex == 1) {
          var hm = "";
          hj += hm += acc.partnerApp
            ? "<a class='menuLink' onclick='showWindow(28)'>Partner Dashboard</a> <span style='float:right;color:rgba(0,0,0,0.4)'>(Open off Stream)</span><div></div><a class='menuLink' href='./docs/partner.txt'>Partner Terms</a> <span style='float:right;color:rgba(0,0,0,0.4)'>Review Partner Terms</span><div></div><a class='menuLink' href='./docs/partner_tips.txt'>Partner Tips</a> <span style='float:right;color:rgba(0,0,0,0.4)'>Increase Revenue</span>"
            : "<div style='font-size:26px;margin-top:20px;font-weight:bold'>Krunker Partner</div><div style='color:rgba(0,0,0,0.6);margin-bottom:20px'>Krunker Partners earn Money through: <div class='partnerItem' style='margin-top:10px'><b>-</b> Getting KR Sales on their Partner Code</div><div class='partnerItem'><b>-</b> Plays on their Custom Games</div><div class='partnerItem'><b>-</b> Bringing new Players to Krunker</div></div><div style='font-size:26px;margin-top:20px;font-weight:bold'>Partner Application</div><div style='font-size:17px;color:rgba(0,0,0,0.4);margin-top:5px'>By submitting an Application you agree to the <a href='./docs/partner.txt'>Partner Terms</a></div><input type='text' id='crtrCode' class='smlInput' style='width:100%;margin-bottom:8px' placeholder='Partner Code Name' /><input type='text' id='crtrEmail' class='smlInput' style='width:80%;margin-bottom:8px' placeholder='PayPal Email for Payouts' /><a class='menuLink' style='margin-left:20px;vertical-align:middle' onclick='submitCrtrCod()'>" +
              i18n.t("generic.submit") +
              "</a><div id='ctrtRes' style='color:rgba(0,0,0,0.5)'></div></div>";
        }
        if (this.tabIndex == 2) {
          hj +=
            "<div style='font-size:26px;margin-top:12px;'>Account Settings</div>";
          if (acc.premiumT) {
            hj +=
              "<div class='settName'>Display Name<div class='updDisN' onclick='changeName();'>Update</div><input type='search' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' id='displayN' class='smlInput' placeholder='" +
              acc.alias +
              "'><div id='aliasRes'></div></div>";
            this.aSuccess = false;
          }
          if (acc.stats.flg == null) {
            acc.stats.flg = -1;
          }
          hj +=
            "<div class='settName'>" +
            i18n.t("windows.loadout.flag") +
            "<select onchange='selectFlag(this.value)' class='inputGrey2' style='padding:4px;font-size:13px;margin-bottom:-18px'><option value='-1' " +
            (acc.stats.flg == -1 ? "selected" : "") +
            ">None</option>";
          for (hk = 0; hk < Game.flags.length; hk++) {
            hj +=
              "<option value='" +
              hk +
              "' " +
              (acc.stats.flg == hk ? "selected" : "") +
              ">" +
              Game.flags[hk][0] +
              "</option>";
          }
          hj += "</select></div>";
          hj += acc.hack
            ? ""
            : "<div style='font-size:26px;margin-top:20px;'>Account Security</div><div style='font-size:17px;color:rgba(0,0,0,0.4);margin-top:5px'>You can update your password every 30 minutes. <b>Never share your password</b> with anyone and keep it in a secure place</div><input type='password' id='oldPass' class='smlInput' style='width:100%;margin-bottom:8px' placeholder='Current Password' /><input type='password' id='newPass' class='smlInput' style='width:100%;margin-bottom:8px' placeholder='New Password' /><input type='password' id='repNPass' class='smlInput' style='width:82%;margin-bottom:8px' placeholder='Repeat Password' /><div class='subPassChg' onclick='changePass()'>" +
              i18n.t("generic.submit") +
              "</div><div id='newPRes' style='color:rgba(0,0,0,0.5)'></div>";
        }
        if (this.tabIndex == 3) {
          if (this.drops == null) {
            io.send("gtd");
          }
          hj +=
            "<div class='settName'>Twitch (" +
            (acc.twitch || "none") +
            ")<div class='lnkTw' onclick='" +
            (acc.twitch ? "unlinkTwitchPop();" : "linkTwitchPop();") +
            "'>" +
            (acc.twitch ? "Unlink" : "Link") +
            "</div></div>";
          hj += "<div id='skinList'>";
          if (config.redeemDrops) {
            hj += acc.twitch
              ? "<div style='margin-bottom:10px'>Watch <a href='https://www.twitch.tv/directory/game/Krunker' target='_blank' style='color:#6441a5'>Krunker on Twitch</a> to earn more Drops & Items</div>"
              : "<div>Link <a href='https://www.twitch.tv/directory/game/Krunker' target='_blank' style='color:#6441a5'>Twitch</a> to earn Drops & Items</div>";
            var ho = this.drops || [];
            for (hk = 0; hk < ho.length; ++hk) {
              if ((serverSetting = ho[hk]).pt_status == 1) {
                hj +=
                  "<div class='shopCard' onmouseenter='playTick()' onclick='prizeWheel(6, true, " +
                  serverSetting.pt_id +
                  ");' style='background-image: url(&quot;./img/shop/spins/6_0.png&quot;)'>Twitch Drop</span><div class='spinVal' style='color:#fff'>Redeem</div></div>";
              }
            }
            if (!ho.length) {
              hj +=
                "<div style='margin-bottom:10px;color:rgba(0,0,0,0.5);'>You currently have no drops</div>";
            }
          } else {
            hj +=
              "<div style='margin-bottom:10px;color:rgba(0,0,0,0.5);'>Twitch Drops will return soon</div>";
          }
          hj += "</div>";
        }
        hj +=
          "<div style='height:25px'></div><a class='menuLink' onclick='logoutAcc()'>" +
          i18n.t("generic.logout") +
          "</a>" +
          (d1
            ? ""
            : "<a style='float:right' class='menuLink' onclick='logoutSessions(this)'>" +
              i18n.t("generic.logout.sessions") +
              "</a>");
      } else if (referralCode) {
        hj += "<img id='registerBackImg' />";
        hj +=
          "<div style='position:relative;z-index:9'><div id='referralHeader'>Register now to Play!</div><div style='width:100%;text-align:center;margin-bottom:20px;font-size:23px;opacity:0.7'>and to support <b>" +
          referralCode +
          "</b></div><input id='accName' type='text' placeholder='" +
          i18n.t("generic.username") +
          "' class='accountInput' style='margin-top:0' value=''></input><input id='accPass' type='password' placeholder='" +
          i18n.t("generic.password") +
          "' class='accountInput'></input><div id='accResp' style='margin-top:15px;margin-bottom:5px;font-size:18px;text-align:center;width:100%;color:rgba(0,0,0,0.5);'>By playing Krunker you directly support <span style='color:rgba(0,0,0,0.8)'>" +
          referralCode +
          "</span></div><div class='accountButton' style='width:705px' onclick='registerAcc()'>" +
          i18n.t("generic.register") +
          "</div></div>";
      } else {
        hj +=
          "<input id='accName' type='text' placeholder='" +
          i18n.t("generic.username") +
          "' class='accountInput' style='margin-top:0' value='" +
          (getSavedVal("krunker_username") || "") +
          "'></input><input id='accPass' type='password' placeholder='" +
          i18n.t("generic.password") +
          "' class='accountInput'></input><div id='accResp' style='margin-top:10px;font-size:18px;color:rgba(0,0,0,0.5);'>For lost Passwords/Accounts contact <span style='color:rgba(0,0,0,0.8)'>recovery@yendis.ch</span></div><div class='accountButton' onclick='registerAcc()'>" +
          i18n.t("generic.register") +
          "</div><div class='accountButton' onclick='loginAcc()' style='margin-left: 20px'>" +
          i18n.t("generic.login") +
          "</div>";
      }
      return hj;
    },
  },
  {
    header: i18n.t("windows.class.header"),
    gen: function () {
      var hj = "<div class='skinList'>";
      for (var hk = 0; hk < Game.classes.length; ++hk) {
        if (Game.config.classes.indexOf(hk) >= 0) {
          var hl =
            acc && acc.stats && acc.stats["c" + hk] ? acc.stats["c" + hk] : 0;
          var hm = config.rankVar * Math.sqrt(hl);
          hl = Math.floor(hm);
          var ho = Math.round((hm - hl) * 100);
          hl = Math.max(1, hl + 1);
          hj +=
            "<div class='classCard' onclick='selectClass(" +
            hk +
            ")' onmouseenter='playTick()'>" +
            Game.classes[hk].name +
            "<div class='classWeap'>" +
            Game.weaponConfig[Game.classes[hk].loadout[0]].name +
            "</div><img loading='lazy' style='image-rendering:pixelated' class='classImgC' src='" +
            UTILS.assetsUrl("/textures/classes/icon_" + hk + ".png") +
            "'/><div class='classXPBar'><div class='clsXPBarC' style='width:" +
            ho +
            "%'></div></div><div class='classLvl'>lvl " +
            hl +
            "</div><div class='classHP'>" +
            Game.classes[hk].health +
            "<span style='color: #868484;font-size: 20px;'> HP</span></div></div>";
        }
      }
      return (hj += "</div>");
    },
  },
  {
    header: i18n.t("windows.controls.header"),
    gen: function () {
      var hj = "";
      for (
        var hk = [
            [
              "forward",
              0,
              CONTROLS.binds.moveKeys.val[0],
              undefined,
              "Movement",
            ],
            ["backward", 1, CONTROLS.binds.moveKeys.val[1]],
            ["left", 2, CONTROLS.binds.moveKeys.val[2]],
            ["right", 3, CONTROLS.binds.moveKeys.val[3]],
            ["jump", 4, CONTROLS.binds.jumpKey.val],
            ["crouch", 5, CONTROLS.binds.crouchKey.val],
            ["reload", 8, CONTROLS.binds.reloadKey.val, undefined, "Weapon"],
            ["aim", 10, CONTROLS.binds.aimKey.val],
            ["shoot", 25, CONTROLS.binds.shootKey.val],
            ["prim", 13, CONTROLS.binds.primKey.val],
            ["melee", 6, CONTROLS.binds.meleeKey.val],
            ["swap", 7, CONTROLS.binds.swapKey.val],
            ["equip", 33, CONTROLS.binds.equipKey.val],
            ["inspect", 14, CONTROLS.binds.inspKey.val],
            ["spray", 9, CONTROLS.binds.sprayKey.val],
            [
              "interact",
              16,
              CONTROLS.binds.interactKey.val,
              undefined,
              "Interaction",
            ],
            ["interactSec", 23, CONTROLS.binds.interactSecKey.val],
            ["drop", 17, CONTROLS.binds.dropKey.val],
            [
              "chat",
              11,
              CONTROLS.binds.chatKey.val,
              undefined,
              "Interface & Audio",
            ],
            ["voice", 12, CONTROLS.binds.voiceKey.val],
            ["list", 15, CONTROLS.binds.pListKey.val],
            ["board", 26, CONTROLS.binds.sBoardKey.val],
            [
              "streak0",
              18,
              CONTROLS.binds.streakKeys.val[0],
              undefined,
              "Killstreaks & Prop Hunt",
            ],
            ["streak1", 19, CONTROLS.binds.streakKeys.val[1]],
            ["streak2", 20, CONTROLS.binds.streakKeys.val[2]],
            ["streak3", 21, CONTROLS.binds.streakKeys.val[3]],
            ["streak4", 22, CONTROLS.binds.streakKeys.val[4]],
            ["wepVis", 24, CONTROLS.binds.wepVisKey.val, undefined, "Toggles"],
            [
              "toggle0",
              27,
              CONTROLS.binds.toggleKeys.val[0],
              CONTROLS.toggleSets[0],
            ],
            [
              "toggle1",
              28,
              CONTROLS.binds.toggleKeys.val[1],
              CONTROLS.toggleSets[1],
            ],
            [
              "toggle2",
              29,
              CONTROLS.binds.toggleKeys.val[2],
              CONTROLS.toggleSets[2],
            ],
            [
              "toggle3",
              30,
              CONTROLS.binds.toggleKeys.val[3],
              CONTROLS.toggleSets[3],
            ],
            [
              "toggle4",
              31,
              CONTROLS.binds.toggleKeys.val[4],
              CONTROLS.toggleSets[4],
            ],
            [
              "toggle5",
              32,
              CONTROLS.binds.toggleKeys.val[5],
              CONTROLS.toggleSets[5],
            ],
            [
              "premium0",
              34,
              CONTROLS.binds.premiumKeys.val[0],
              undefined,
              "Premium & Host",
            ],
            ["premium1", 35, CONTROLS.binds.premiumKeys.val[1]],
            ["premium2", 36, CONTROLS.binds.premiumKeys.val[2]],
            ["premium3", 37, CONTROLS.binds.premiumKeys.val[3]],
          ],
          hl = 0;
        hl < hk.length;
        hl++
      ) {
        if (hk[hl][4]) {
          hj +=
            "<div class='setHedBind'" +
            (hl == 0 ? " style='margin-top:0px;'" : "") +
            ">" +
            hk[hl][4] +
            "</div>";
        }
        hj += "<div class='settName'>";
        if (hk[hl][3] == null) {
          hj += i18n.t("windows.controls." + hk[hl][0]);
        } else {
          hj +=
            "Toggle <select class='setToggle' onchange='changeContSet(" +
            hk[hl][1] +
            ", this.value)'><option value='-1'" +
            (hk[hl][3] == -1 ? " selected" : "") +
            ">None</option>";
          for (var hm in settings.list) {
            if (settings.list[hm].toggle) {
              hj +=
                "<option value='" +
                hm +
                "'" +
                (hk[hl][3] == hm ? " selected" : "") +
                ">" +
                i18n.t(settings.list[hm].name) +
                " [" +
                i18n.t("settings." + settings.list[hm].cat + ".header") +
                "]</option>";
            }
          }
          hj += "</select>";
        }
        hj +=
          "<span class='unbind' onclick='unbindCont(" +
          hk[hl][1] +
          ")'><i class='material-icons' style='font-size:40px;color:var(--red);'>delete_forever</i></span><span class='settText floatRNoC keyIcon' id='cont" +
          hk[hl][1] +
          "' onmouseover='playTick()' onclick='changeCont(" +
          hk[hl][1] +
          ")'>" +
          UTILS.getKeyName(hk[hl][2]) +
          "</span></div>";
      }
      return hj;
    },
  },
  {
    header: i18n.t("windows.host.header"),
    presets: {},
    updateSet: function (hj, hk) {
      if (hk) {
        windows[7].costVal += hk.checked ? hj : -hj;
        hCustCost.innerHTML = windows[7].costVal
          ? windows[7].costVal + " KR"
          : "None";
      }
    },
    presetLoaded: function (hj, hk) {
      try {
        windows[7].presets[hj].data =
          hj && windows[7].presets[hj] && hk
            ? JSON.parse(UTILS.decompressKeys(hk))
            : "DEFAULT";
      } catch (hl) {
        windows[7].presets[hj].data = "DEFAULT";
      }
      updateWindow(8);
    },
    toggle: function (hj) {
      for (
        var hk = document.querySelectorAll("input[id^='" + hj + "']"), hl = 0;
        hl < hk.length;
        hl++
      ) {
        hk[hl].checked = !hk[hl].checked;
      }
    },
    changeWep: function (hj) {
      if (windows[7].wepConf) {
        for (
          var hk = document.querySelectorAll("div[id^='weaponConf']"), hl = 0;
          hl < hk.length;
          hl++
        ) {
          hk[hl].style.display =
            hk[hl].id == "weaponConf" + hj ? "block" : "none";
        }
      }
    },
    toggleWep: function () {
      windows[7].wepConf = !windows[7].wepConf;
      var hj = windows[7].wepConf ? weaponSelect.value || 0 : -1;
      for (
        var hk = document.querySelectorAll("div[id^='weaponConf']"), hl = 0;
        hl < hk.length;
        hl++
      ) {
        hk[hl].style.display =
          hk[hl].id == "weaponConf" + hj ? "block" : "none";
      }
    },
    gen: function () {
      windows[7].costVal = 0;
      windows[7].wepConf = false;
      var hj = "";
      hj += "<div class='settName b'>" + i18n.t("windows.host.maps") + "</div>";
      hj += "<div style='margin-top:10px'>";
      hj +=
        "<div class='settNameSmall' style='margin:0;margin-top:10px'>" +
        i18n.t("windows.host.cmaps") +
        " <div style='float:right'>" +
        (selectedCustomMapId
          ? "<span><i style='color:#eb5656;font-size:30px;vertical-align:-3px;cursor:pointer' onclick='openHostWindow(true)'class='material-icons'>delete</i> </span>"
          : "") +
        "<a id='commMap' href='javascript:;' onclick='showWindow(10);' class='menuLink' style='font-size:18px'>" +
        (selectedCustomMapId || "Select Game") +
        "</a></div></div><br/>";
      if (!selectedCustomMapId) {
        hj +=
          "<div class='settNameSmall' style='margin:0;margin-top:-24px;'>" +
          i18n.t("windows.host.raw") +
          "<input id='rawMapData' type='text' " +
          (rawMapDataPreset
            ? "value='" + rawMapDataPreset.replace("'", '"') + "'"
            : "placeholder='" + i18n.t("windows.host.raw") + "'") +
          " autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false'></div><br/>";
      }
      hj += "</div>";
      hj += "<div style='margin-top:-15px;margin-bottom:20px;'>";
      if (!selectedCustomMapId) {
        for (var hk = 0; hk < maps.length; hk++) {
          var hl = maps[hk];
          var hm = config.mapInfos[hl.name.toLowerCase()];
          if (hl.name != "Soul Sanctum") {
            hj +=
              "<label class='hostMap'><div class='hostMapName blackShad'>" +
              UTILS.capFirst(hl.name) +
              "</div>" +
              (hm && hm.creator
                ? "<div class='hostMapBy blackShad'>by " + hm.creator + "</div>"
                : "") +
              (hm && hm.year
                ? "<div class='hostMapYear blackShad'>" + hm.year + "</div>"
                : "") +
              (hm && hm.version
                ? "<div class='hostMapVersion blackShad'>v" +
                  hm.version +
                  "</div>"
                : "") +
              "<div class='mapInfoT' style='top:54px'>?</div><input id='gameMap" +
              hk +
              "' type='checkbox'><img loading='lazy' draggable='false' class='hostMapImg' src='/img/maps/map_" +
              hk +
              ".png'></label>";
          }
        }
      }
      hj += "</div>";
      var ho = windows[7].presets[selectedCustomMapId];
      var hp = !selectedCustomMapId || (ho && ho.data);
      if (hp) {
        ho &&= ho.data;
        if (ho == "DEFAULT") {
          ho = null;
        }
        hj +=
          "<div class='settName b'>" +
          i18n.t("windows.host.modes") +
          "<div class='hostToggle' onclick='windows[7].toggle(&quot;gameMode&quot;)'>Toggle</div></div>";
        hj += "<div style='margin-top:5px'>";
        var hq;
        for (hk = 0; hk < MODES.length; hk++) {
          if (!(hq = MODES[hk]).preventCustomGames) {
            var hu = ho ? ho.modes && ho.modes.indexOf(hk) >= 0 : hk == 0;
            hj +=
              "<label class='hostOpt' onmouseenter='playTick()'><span class='optName'>" +
              UTILS.capFirst(hq.name) +
              "</span><input id='gameMode" +
              hk +
              "' type='checkbox'" +
              (hu ? "checked" : "") +
              "><div class='optCheck'></div></label>";
          }
        }
        hj += "</div>";
        hj +=
          "<div class='settName b' style='margin-top:20px'>" +
          i18n.t("windows.host.classes") +
          "<div class='hostToggle' onclick='windows[7].toggle(&quot;gameClass&quot;)'>Toggle</div></div>";
        hj += "<div style='margin-top:5px'>";
        for (hk = 0; hk < Game.classes.length; hk++) {
          var hv = Game.classes[hk];
          hu = !ho || !ho.classes || ho.classes.indexOf(hk) >= 0;
          hj +=
            "<label class='hostOpt' onmouseenter='playTick()'><span class='optName'>" +
            hv.name +
            "</span><img loading='lazy' class='optImg' src='" +
            UTILS.assetsUrl("textures/classes/icon_" + hk + ".png", true) +
            "'/><input id='gameClass" +
            hk +
            "' type='checkbox'" +
            (hu ? "checked" : "") +
            "><div class='optCheck'></div></label>";
        }
        hj += "</div>";
        hj +=
          "<div class='settName b' style='margin-top:25px'>Weapon Config<select id='weaponSelect' class='inputGrey2' onchange='windows[7].changeWep(this.value)'>";
        windows[7].wepConf = ho && ho.weps;
        for (var hw = 0; hw < Game.weapons.length; hw++) {
          hj +=
            "<option value='" +
            hw +
            "' " +
            (hw == 0 ? "selected" : "") +
            ">" +
            Game.weapons[hw].name +
            "</option>";
        }
        hj +=
          "</select><label class='switch'><input type='checkbox' onchange='windows[7].toggleWep()' " +
          (windows[7].wepConf ? "checked" : "") +
          "><span class='slider'></span></label></div>";
        for (hw = 0; hw < Game.weapons.length; hw++) {
          hj +=
            "<div id='weaponConf" +
            hw +
            "' style='display:" +
            (hw == 0 && ho && ho.weps ? "block" : "none") +
            "'>";
          var hx = ho && ho.weps && ho.weps[hw] ? ho.weps[hw] : null;
          for (hk = 0; hk < config.weaponConfig.length; hk++) {
            serverSetting = config.weaponConfig[hk];
            if (Game.weapons[hw][serverSetting.varN] != null) {
              var hy = serverSetting.name;
              var hz =
                hx && hx[serverSetting.varN]
                  ? hx[serverSetting.varN]
                  : Game.weapons[hw][serverSetting.varN];
              hj += serverSetting.bool
                ? "<div class='settNameSmall' style='margin:0;margin-bottom:5px;'>" +
                  hy +
                  " <label class='switch'><input type='checkbox' id='customW" +
                  hw +
                  serverSetting.varN +
                  "' " +
                  (hz ? "checked" : "") +
                  "><span class='slider'></span></label>" +
                  (serverSetting.cost
                    ? "<span style='float:right;margin-right:10px;color:rgba(0,0,0,0.5)'>" +
                      serverSetting.cost +
                      " <b>KR</b></span>"
                    : "") +
                  "</div>"
                : "<div class='settNameSmall' style='margin-left:0'>" +
                  hy +
                  "<span class='sliderVal' id='customWSet" +
                  hw +
                  hk +
                  "'>" +
                  hz +
                  "</span><div class='slidecontainer'><input type='range' min='" +
                  serverSetting.min +
                  "' max='" +
                  serverSetting.max +
                  "' step='" +
                  serverSetting.step +
                  "' id='customW" +
                  hw +
                  serverSetting.varN +
                  "' value='" +
                  hz +
                  "' oninput='updateWSliderLabel(" +
                  hw +
                  "," +
                  hk +
                  ",this.value)' class='sliderM'></div></div>";
            }
          }
          hj += "</div>";
        }
        hj +=
          "<div class='settName b' style='margin-top:25px;margin-bottom:5px'>" +
          i18n.t("windows.host.settings") +
          "</div>";
        var hA = UTILS.getAccountType(acc);
        for (hk = 0; hk < config.serverConfig.length; hk++) {
          serverSetting = config.serverConfig[hk];
          hy = i18n.t("server.config." + serverSetting.varN);
          if (serverSetting.head) {
            hj +=
              "<div class='settName b' style='margin-top:25px;margin-bottom:5px'>" +
              serverSetting.head +
              "</div>";
          }
          if (serverSetting.bool) {
            hu = serverSetting.def;
            if (
              ho &&
              ho.settings &&
              ho.settings[serverSetting.varN] != null &&
              !serverSetting.cost
            ) {
              hu = !!ho.settings[serverSetting.varN];
            }
            hj +=
              "<div class='settNameSmall' style='margin:0;margin-bottom:5px;'>" +
              hy +
              " <label class='switch'><input type='checkbox' onchange='windows[7].updateSet(" +
              (serverSetting.cost || 0) +
              ",this)' id='customS" +
              serverSetting.varN +
              "' " +
              (hu ? "checked" : "") +
              "><span class='slider'></span></label>" +
              (serverSetting.cost
                ? "<span style='float:right;margin-right:10px;color:rgba(0,0,0,0.5)'>" +
                  serverSetting.cost +
                  " <b>KR</b></span>"
                : "") +
              "</div>";
          } else if (serverSetting.input) {
            hj +=
              "<div class='settNameSmall' style='margin:0;margin-bottom:5px;'>" +
              hy +
              "<input id='customS" +
              serverSetting.varN +
              "' value='" +
              serverSetting.def +
              "' type='text'style='border-radius:6px;border:none;background:#eee;padding:6px;padding-bottom:6px;float:right;margin-top:5px;margin-bottom:5px;' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false'></div>";
          } else if (serverSetting.select) {
            hj +=
              "<div class='settNameSmall' style='margin:0;margin-bottom:5px;'>" +
              hy;
            hj +=
              "<select id='customS" +
              serverSetting.varN +
              "' class='inputGrey2'>";
            for (hw = 0; hw < serverSetting.options.length; hw++) {
              hj +=
                "<option value='" +
                hw +
                "' " +
                (hw == serverSetting.def ? "selected" : "") +
                ">" +
                serverSetting.options[hw] +
                "</option>";
            }
            hj += "</select></div>";
          } else {
            var hB = serverSetting.def;
            var hC = serverSetting.max;
            if (hA == 3) {
              hC = serverSetting.maxF || serverSetting.max;
            } else if (hA == 2) {
              hC = serverSetting.maxP || serverSetting.max;
            } else if (hA == 0) {
              hC = serverSetting.maxG || serverSetting.max;
            }
            if (
              ho &&
              ho.settings &&
              ho.settings[serverSetting.varN] != null &&
              !serverSetting.cost
            ) {
              if ((hB = ho.settings[serverSetting.varN]) > hC) {
                hB = hC;
              }
            }
            hj +=
              "<div class='settNameSmall' style='margin-left:0'>" +
              hy +
              "<span class='sliderVal' id='customSet" +
              hk +
              "'>" +
              hB +
              "</span><div class='slidecontainer'><input type='range' min='" +
              serverSetting.min +
              "' max='" +
              hC +
              "' step='" +
              serverSetting.step +
              "' id='customS" +
              serverSetting.varN +
              "' value='" +
              hB +
              "' oninput='updateSliderLabel(" +
              hk +
              ",this.value)' class='sliderM'></div></div>";
          }
        }
        hj +=
          "<div class='settNameSmall' style='margin:0'>" +
          i18n.t("server.config.private") +
          " <label class='switch'><input id='makePrivate' type='checkbox'><span class='slider'></span></label></div>";
        hj +=
          "<div class='settNameSmall' style='margin:0;margin-bottom:5px;'>Server Password<input id='passCode' value='' type='text' placeholder='Enter Password'style='border-radius:6px;border:none;background:#eee;padding:6px;padding-bottom:6px;float:right;margin-top:5px;margin-bottom:5px;' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false'></div>";
        hj +=
          "<div id='hostGamePreset' style='text-align:left;margin-top:30px'>" +
          windows[7].genPresets(true) +
          "</div>";
        if (acc && acc.level >= 10) {
          hj +=
            "<div class='settName b' style='margin-top:25px;margin-bottom:5px'>Social</div>";
          hj +=
            "<div class='settNameSmall' style='margin:0'>Share on Hub <label class='switch'><input id='shareToHub' type='checkbox'><span class='slider'></span></label></div>";
        }
      } else {
        if (!windows[7].presets[selectedCustomMapId]) {
          windows[7].presets[selectedCustomMapId] = {};
          API_CLIENT.getMapPreset(selectedCustomMapId, this.presetLoaded);
        }
        hj +=
          "<div style='color:rgba(0,0,0,0.3)'>" +
          i18n.t("windows.host.preset.load") +
          "</div>";
      }
      if (hp) {
        hj += "<div style='text-align:left;margin-top:30px'>";
        hj +=
          "<div style='color:#919191;margin-bottom:5px' id='hostGameMsg'></div>";
        hj += config.isComp
          ? "<input id='hostKey' type='password' placeholder='Host Key' autocomplete='new-password' autocorrect='off' autocapitalize='off' spellcheck='false'>"
          : "";
        hj +=
          "<a class='menuLink' onclick='createPrivateRoom()'>Start Server</a>";
        hj +=
          "<span style='float:right;color:rgba(0,0,0,0.3)'>Server Cost <span id='hCustCost' style='color:rgba(0,0,0,0.6)'>None</span></span>";
        hj += "</div>";
      }
      return hj;
    },
    presetAction: function (hj) {
      if (hj == 0 && presetSelect.value == "Select") {
        return;
      }
      if (hj == 2 && presetSelect.value == "Select") {
        return;
      }
      let hk = getSavedVal("krk_hostPresets");
      hk = hk ? JSON.parse(hk) : {};
      var hl = presetName.value.length
        ? presetName.value
        : presetSelect.value == "Select"
          ? "Preset1"
          : presetSelect.value;
      if (hj == 2) {
        if (hk[presetSelect.value]) {
          delete hk[presetSelect.value];
        }
        saveVal("krk_hostPresets", JSON.stringify(hk));
      } else {
        let hq = hj == 1 ? {} : hk[presetSelect.value];
        var hm;
        for (var ho = 0; ho < maps.length; ho++) {
          maps[ho];
          if ((hm = document.getElementById("gameMap" + ho))) {
            if (hj == 1) {
              hq["gameMap" + ho] = hm.checked;
            } else if ("gameMap" + ho in hq) {
              hm.checked = hq["gameMap" + ho];
            }
          }
        }
        for (ho = 0; ho < MODES.length; ho++) {
          if (!MODES[ho].preventCustomGames) {
            if ((hm = document.getElementById("gameMode" + ho))) {
              if (hj == 1) {
                hq["gameMode" + ho] = hm.checked;
              } else if ("gameMode" + ho in hq) {
                hm.checked = hq["gameMode" + ho];
              }
            }
          }
        }
        for (ho = 0; ho < Game.classes.length; ho++) {
          Game.classes[ho];
          if ((hm = document.getElementById("gameClass" + ho))) {
            if (hj == 1) {
              hq["gameClass" + ho] = hm.checked;
            } else if ("gameClass" + ho in hq) {
              hm.checked = hq["gameClass" + ho];
            }
          }
        }
        for (ho = 0; ho < config.serverConfig.length; ho++) {
          serverSetting = config.serverConfig[ho];
          if ((hm = document.getElementById("customS" + serverSetting.varN))) {
            if (hj == 1) {
              hq[serverSetting.varN] =
                hm[serverSetting.bool ? "checked" : "value"];
            } else if (serverSetting.varN in hq) {
              if (!serverSetting.bool && !serverSetting.input) {
                document.getElementById("customSet" + ho).textContent =
                  hq[serverSetting.varN];
              }
              hm[serverSetting.bool ? "checked" : "value"] =
                hq[serverSetting.varN];
            }
          }
        }
        for (var hp = 0; hp < Game.weapons.length; hp++) {
          for (ho = 0; ho < config.weaponConfig.length; ho++) {
            serverSetting = config.weaponConfig[ho];
            if (Game.weapons[hp][serverSetting.varN] != null) {
              if (
                (hm = document.getElementById(
                  "customW" + hp + serverSetting.varN,
                ))
              ) {
                if (hj == 1) {
                  hq[serverSetting.varN + "" + hp] =
                    hm[serverSetting.bool ? "checked" : "value"];
                } else if (serverSetting.varN + "" + hp in hq) {
                  if (!serverSetting.bool && !serverSetting.input) {
                    document.getElementById(
                      "customWSet" + hp + ho,
                    ).textContent = hq[serverSetting.varN + "" + hp];
                  }
                  hm[serverSetting.bool ? "checked" : "value"] =
                    hq[serverSetting.varN + "" + hp];
                }
              }
            }
          }
        }
        if (hj == 1) {
          if (selectedCustomMapId) {
            hq.commMap = selectedCustomMapId;
          }
          if ((hm = document.getElementById("rawMapData")) && hm.value != "") {
            hq.rawMapData = hm.value;
          }
          if (
            (hm = document.getElementById("makePrivate")) &&
            hm.checked != 0
          ) {
            hq.makePrivate = hm.checked;
          }
          hk[hl] = hq;
          saveVal("krk_hostPresets", JSON.stringify(hk));
        } else {
          if ("commMap" in hq) {
            document.getElementById("commMap").textContent =
              selectedCustomMapId = hq.commMap;
          }
          if ("rawMapData" in hq) {
            document.getElementById("rawMapData").value = hq.rawMapData;
          }
          if ("makePrivate" in hq) {
            document.getElementById("makePrivate").checked = hq.makePrivate;
          }
        }
      }
      windows[7].genPresets();
    },
    genPresets: function (hj = false) {
      let hk = getSavedVal("krk_hostPresets");
      hk = hk ? JSON.parse(hk) : {};
      var hl =
        "<div class='settName b' style='margin-top:25px'>" +
        i18n.t("windows.host.preset") +
        "</div>";
      hl +=
        "<span class='settNameSmall' style='margin:0;margin-bottom:5px;'><input id='presetName' type='text' class='formInput' placeholder='" +
        i18n.t("windows.host.preset.name") +
        "' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' style='border:none;background:#eee;padding-bottom:6px;float:left;margin-top:5px;margin-bottom:5px;'><select id='presetSelect' style='border-radius:6px;margin-left:10px;border:none;background:#eee;;padding:6px;padding-bottom:6px;margin-top:5px;margin-bottom:5px;'><option selected>Select</option>";
      for (let hm in hk) {
        hl += "<option>" + hm + "</option>";
      }
      hl += "</select>";
      hl +=
        "<div class='hostPresetBtn' onclick='windows[7].presetAction(2)'>" +
        i18n.t("generic.delete") +
        "</div><div class='hostPresetBtn' onclick='windows[7].presetAction(1)'>" +
        i18n.t("generic.save") +
        "</div><div class='hostPresetBtn' onclick='windows[7].presetAction(0)'>" +
        i18n.t("generic.load") +
        "</div></span>";
      if (hj) {
        return hl;
      } else {
        hostGamePreset.innerHTML = hl;
        return;
      }
    },
  },
  {
    header: i18n.t("windows.spray.header"),
    gen: function () {
      var hj = [];
      var hk = "";
      var hl =
        "<div id='skinList'><div class='noBtnCard' onclick='selectSpray(-2)' style='border: 5px solid lightgrey'>" +
        i18n.t("generic.random") +
        "<div class='itemOwn' style='opacity:0;''>by ???</div><img draggable='false' style='margin-top:10px;width:110px;' class='noBtnImgC skinSil' src='" +
        UTILS.assetsUrl("/textures/sprays/0.png") +
        "' onmouseenter='playTick()'><div class='skinRandom blackShad' style='top: 80px;'>?</div></div>";
      if (acc || Game.singlePlayer) {
        for (
          var hm = [
              ...(Game.singlePlayer
                ? Object.keys(Game.store.skins).map((hp) => ({
                    ind: parseInt(hp),
                    cnt: 1,
                  }))
                : acc.skins),
            ].sort(function (hp, hq) {
              return (
                (hq.ind != null && Game.store.skins[hq.ind]
                  ? Game.store.skins[hq.ind].rarity
                  : 0) -
                (hp.ind != null && Game.store.skins[hp.ind]
                  ? Game.store.skins[hp.ind].rarity
                  : 0)
              );
            }),
            ho = 0;
          ho < hm.length;
          ++ho
        ) {
          if (
            (serverSetting = Game.store.skins[hm[ho].ind]) &&
            serverSetting.type == 4
          ) {
            if (
              serverSetting.frames &&
              hj.indexOf(serverSetting.frames) == -1
            ) {
              hj.push(serverSetting.frames);
            }
            hl +=
              "<div class='noBtnCard" +
              (RENDER.rarityAnim &&
              Game.store.rarities[serverSetting.rarity].animate
                ? " rainbow"
                : "") +
              "' style='color:" +
              Game.store.rarities[serverSetting.rarity].color +
              ";border: 5px solid " +
              Game.store.rarities[serverSetting.rarity].color +
              "' onclick='selectSpray(" +
              hm[ho].ind +
              ")'>" +
              serverSetting.name +
              "<div class='itemOwn'>" +
              i18n.t("windows.spray.spin") +
              "</div><div draggable='false' class='sprayImg' onmouseenter='playTick()' style='background: url(&quot;" +
              UTILS.getPreview(serverSetting, Game.store) +
              "&quot;) -1px;" +
              UTILS.getFrameAnim(serverSetting, "sprayAnm") +
              "'></div></div>";
          }
        }
      }
      for (ho = 0; ho < Game.sprays.length; ++ho) {
        if (
          (serverSetting = Game.sprays[ho]).frames &&
          hj.indexOf(serverSetting.frames) == -1
        ) {
          hj.push(serverSetting.frames);
        }
        hl +=
          "<div class='noBtnCard' onclick='selectSpray(" +
          ho +
          ")' style='border: 5px solid lightgrey'>" +
          serverSetting.name +
          "<div class='itemOwn'>" +
          i18n.t("windows.spray.default") +
          "</div><div draggable='false' class='sprayImg' onmouseenter='playTick()' style='background: url(&quot;" +
          UTILS.assetsUrl(
            "/textures/sprays/" + serverSetting.id + ".png",
            false,
            serverSetting.local,
          ) +
          "&quot;) -1px;" +
          UTILS.getFrameAnim(serverSetting, "sprayAnm") +
          "'></div></div>";
      }
      hl += "</div>";
      if (hj.length) {
        hk += "<style>";
        for (ho = 0; ho < hj.length; ho++) {
          hk +=
            "@keyframes sprayAnm" +
            hj[ho] +
            " {100%{background-position:-" +
            hj[ho] * 110 +
            "px}}";
        }
        hk += "</style>";
      }
      return hk + hl;
    },
  },
  {
    header: i18n.t("windows.maps.header"),
    searchMaps: function () {
      searchResultsMA.innerHTML = "Loading...";
      API_CLIENT.searchMap(mpSrch.value, searchResponse);
    },
    searchResp: function (hj) {
      var hk = "";
      if (hj.length) {
        hk += "<div style='height:10px'></div>";
        hk += getCardsList(hj, "map");
      } else {
        hk = i18n.t("windows.maps.none");
      }
      if (document.getElementById("searchResultsMA")) {
        document.getElementById("searchResultsMA").innerHTML = hk;
      }
    },
    loadMore: function (hj) {
      if (!this.listData[this.tabIndex].waiting) {
        if (hj) {
          hj.className = "loadMoreW";
          hj.innerHTML = "Loading...";
        }
        this.listData[this.tabIndex].waiting = true;
        this.listData[this.tabIndex].loadInd += 1;
        API_CLIENT.listMaps(
          this.tabIndex,
          this.listData[this.tabIndex].loadInd,
          acc ? acc.id : null,
          mapListResponse,
        );
      }
    },
    mapsLoaded: function (hj, hk, hl) {
      if (mapList) {
        this.listData[hk].waiting = false;
        if (hj && hj.length) {
          if (hl) {
            if (!this.listData[hk].dat) {
              mapList.innerHTML = hl;
              this.listData[hk] = null;
            }
          } else {
            var hm = getCardsList(hk == 1 ? UTILS.shuffleArray(hj) : hj, "map", hk);
            this.listData[hk].dat = (this.listData[hk].dat || "") + hm;
            if (this.tabIndex == hk) {
              updateWindow(10);
            }
          }
        } else if (!this.listData[hk].dat) {
          mapList.innerHTML = i18n.t("windows.maps.none");
          this.listData[hk] = null;
        }
      }
    },
    tabIndex: 0,
    listData: {},
    switchTab: function (hj) {
      if (this.tabIndex != hj) {
        this.tabIndex = hj;
        updateWindow(10);
      }
    },
    gen: function () {
      var hj = config.mapTabs[this.tabIndex];
      var hk = "<div class='menuTabsNew' style='margin-top:0px'>";
      for (var hl = 0; hl < config.mapTabs.length; ++hl) {
        hk +=
          "<div class='menuTabNew" +
          (this.tabIndex == hl ? " tabANew" : "") +
          "' onclick='windows[9].switchTab(" +
          hl +
          ")'>" +
          config.mapTabs[hl].n +
          "</div>";
      }
      hk += "</div>";
      var hm = "";
      if (hj.search) {
        hm =
          "<input type='text' id='mpSrch' class='smlInput' placeholder='" +
          i18n.t("windows.maps.name") +
          "' onkeydown='if(window.event.keyCode==13)windows[9].searchMaps()' /><div class='searchBtn' onclick='windows[9].searchMaps()'>" +
          i18n.t("generic.search") +
          "</div><div style='color:rgba(0,0,0,0.5);margin-top:10px' id='searchResultsMA'></div>";
      } else if (this.listData[this.tabIndex]) {
        if (this.listData[this.tabIndex].dat) {
          hm = this.listData[this.tabIndex].dat;
          if (this.listData[this.tabIndex].waiting) {
            hm += "<div class='loadMoreW'>Loading...</div>";
          } else if (!hj.sendID && !hj.noPages) {
            hm +=
              "<div class='loadMoreD' onclick='windows[9].loadMore(this)'>Load More</div>";
          }
        } else {
          hm = "<div class='loadMoreW'>Loading...</div>";
        }
      } else {
        hm = "<div class='loadMoreW'>Loading...</div>";
        this.listData[this.tabIndex] = {
          loadInd: 0,
        };
        API_CLIENT.listMaps(this.tabIndex, 0, acc ? acc.id : null, mapListResponse);
      }
      return (
        "<a href='./editor.html' class='menuLink' target='_blank'>" +
        i18n.t("windows.maps.editor") +
        "</a> | <a href='/social.html?p=maps&openPub' target='_blank' class='menuLink'>" +
        i18n.t("windows.maps.publish") +
        "</a><a href='https://discord.gg/Kfypyp5' target='_blank' class='menuLink' style='float:right'>" +
        i18n.t("windows.maps.community") +
        "</a><br/><div style='margin-top:15px;margin-bottom:15px'>" +
        hk +
        "</div><div style='color:rgba(0,0,0,0.3)' id='mapList'>" +
        hm +
        "</div>"
      );
    },
  },
  {
    header: i18n.t("windows.publish.map.header"),
    gen: function () {
      return "";
    },
  },
  {
    header: i18n.t("windows.theatre.header"),
    gen: function () {
      return "";
    },
  },
  {
    header: i18n.t("windows.clans.header"),
    clanData: null,
    kickReq: function (hj, hk) {
      confKickClan(hj, hk);
    },
    kick: function (hj) {
      io.send("cln", 5, hj);
      if (this.clanData && this.clanData.members) {
        for (var hk = this.clanData.members.length - 1; hk >= 0; --hk) {
          if (this.clanData.members[hk].i == hj) {
            this.clanData.members.splice(hk, 1);
          }
        }
        updateWindow(13);
      }
    },
    sendReq: function (hj, hk) {
      var hl = document.getElementById("clanErr");
      if (hl) {
        hl.style.color = "rgba(0,0,0,0.6)";
        hl.innerHTML = i18n.t("generic.loading");
      }
      var hm = (hl = document.getElementById("clanInp" + hj)) ? hl.value : null;
      io.send("cln", hj, hk || hm || 1);
    },
    updReq: function (hj, hk, hl) {
      io.send("clnR", hk, hl);
      if (this.clanData.members && hl == 1) {
        this.clanData.members.push({
          p: this.clanData.requests[hj].player_name,
        });
      }
      this.clanData.requests.splice(hj, 1);
      updateWindow(13);
    },
    delReq: function () {
      confDelClan(acc && this.clanData.clan_playerid == acc.id);
    },
    del: function () {
      this.clanData = null;
      if (acc) {
        acc.clan = null;
      }
      showWindow(5);
    },
    updRolR: function () {},
    updRol: function (hj) {
      var hk = document.getElementById("clanRolD" + hj);
      dP("Please Wait...");
      io.send("cln", 6, hj, {
        r: parseInt(hk.options[hk.selectedIndex].value || 0),
      });
    },
    chngFunds: function (hj) {
      var hk = clanFundsIn.value || 0;
      if (hk) {
        dP("Please Wait...");
        io.send("cln", 7, parseInt(hk), {
          wd: hj,
        });
      }
    },
    calcFee: function (hj) {
      if (hj) {
        var hk = hj.value || 0;
        if (hk < 0) {
          hk = 0;
        }
        if (hk) {
          hj.value = hk;
        }
        var hl = Math.floor(hk * 0.1);
        if ((hj = document.getElementById("clnFeeVal"))) {
          hj.innerHTML = hl
            ? "<span style='color:rgba(255,255,255,0.7)'>-" +
              UTILS.commaFormatNum(hl) +
              " <span style='color:#fff'>KR</span></span>"
            : "None";
        }
      }
    },
    mangFunds: function () {
      var hj = acc && this.clanData.clan_playerid == acc.id;
      var hk =
        "<div style='font-size:21px;color:#fff'>Manage Clan Funds<span style='float:right;color:rgba(255,255,255,0.6)'>" +
        UTILS.commaNumber(this.clanData.clan_funds || 0) +
        " <span style='color:#fff'>KR</span></span></div><div style='margin-top:20px;font-size:18px;color:#FFF'>Deposit Fee<span id='clnFeeVal' style='float:right;color:rgba(255,255,255,0.7)'>None</span></div><input type='number' oninput='windows[12].calcFee(this)' placeholder='Enter KR Amount' id='clanFundsIn'></input><div class='clanFndB' style='background-color:" +
        (hj ? "#fc5a4e" : "#6e6e6e") +
        "' " +
        (hj ? "onclick='windows[12].chngFunds(1)'" : "") +
        ">Withdraw</div><div class='clanFndB' style='margin-left:16px;background-color:#4ca9f5' onclick='windows[12].chngFunds(0)'>Deposit</div>";
      contPopup(hk);
    },
    subCont: function (hj) {
      var hk = this.clanData.members[hj];
      if (hk) {
        var hl = document.getElementById("clnRegDr");
        dP("Please Wait...");
        io.send("cln", 8, hk.i, {
          i: hj,
          r: parseInt(hl.options[hl.selectedIndex].value),
        });
      }
    },
    showCont: function (hj) {
      if (this.clanData && this.clanData.members && this.clanData.members[hj]) {
        var hk = this.clanData.members[hj];
        var hl = Math.max(0, config.clanWarLives - parseInt(hk.de || 0));
        var hm =
          "<div style='width:100%;text-align:center;color:#fff;font-size:24px;margin-top:15px'>Enlistment Contract</br>for " +
          hk.p +
          "</div><div style='margin-top:16px;color:#a3a3a3'>This Contract will expire when <b style='color:#fff'>" +
          hk.p +
          "</b> runs out of lives or leaves the clan. The deployment cost will not be refunded.</div><div style='margin-top:15px;color:#d4d4d4'>Region <span style='float:right;color:#a3a3a3'>" +
          config.clanRegions[parseInt(hk.cr || 1) - 1].name +
          "</span></div><div style='margin-top:5px;color:#d4d4d4'>Kills <span style='float:right;color:#a3a3a3'>" +
          UTILS.commaNumber(hk.ki || 0) +
          "</span></div><div style='margin-top:5px;color:#d4d4d4'>KDR <span style='float:right;color:#a3a3a3'>" +
          (parseInt(hk.ki || 0) / parseInt(hk.de || 1)).round(2) +
          "</span></div><div style='margin-top:5px;color:#d4d4d4'>Lives Remaining <span style='float:right;color:#a3a3a3'>" +
          hl +
          "</span></div><div id='clanWarKP'><div id='clanWarKPB' style='width:" +
          (hl / config.clanWarLives) * 100 +
          "%'></div></div>";
        contPopup(hm);
      } else {
        popupResponse(null, "Error");
      }
    },
    startCont: function (hj) {
      if (this.clanData && this.clanData.members && this.clanData.members[hj]) {
        var hk = this.clanData.members[hj];
        if (hk.st == 2) {
          popupResponse(null, "Player already in Contract");
          return;
        }
        var hl = "<select id='clnRegDr'>";
        for (var hm = 0; hm < config.clanRegions.length; ++hm) {
          hl +=
            "<option value='" +
            hm +
            "'>" +
            config.clanRegions[hm].name +
            "</option>";
        }
        hl += "</select>";
        var ho =
          "<div style='width:100%;text-align:center;color:#fff;font-size:24px;margin-top:15px'>Enlistment Contract</br>for " +
          hk.p +
          "</div><div style='margin-top:16px;color:#a3a3a3'>By deploying <b style='color:#fff'>" +
          hk.p +
          "</b> to the Clan War, you agree to the <a class='menuLink' href='./docs/clan.txt' style='font-size:16px'>Clan War Rules.</a> Breach of Terms may result in Clan Deletion</div><div style='margin-top:15px;color:#d4d4d4'>Region <span style='float:right'>" +
          hl +
          "</span></div><div style='margin-top:5px;color:#d4d4d4'>Deployment Cost <span style='float:right;color:#a3a3a3'>500 <span style='color:#fff'>KR</span></span></div><div style='margin-top:5px;color:#d4d4d4'>Lives <span style='float:right;color:#a3a3a3'>" +
          config.clanWarLives +
          "</span></div><div id='signHolder'><div id='sig-background'><span class='material-icons' style='font-size:60px;vertical-align:middle;margin-top:-15px;margin-right:5px;color:rgba(0,0,0,0.15)'>create</span>Sign Here</div><canvas id='sig-canvas' width='690' height='110'></canvas></div><div id='submitContrB' onclick='windows[12].subCont(" +
          hj +
          ")'>Finalize</div>";
        contPopup(ho);
        (function () {
          function hp(hu, hv) {
            var hw = hu.getBoundingClientRect();
            var hx = hu.width / hw.width;
            var hy = hu.height / hw.height;
            return {
              x: (hv.clientX - hw.left) * hx,
              y: (hv.clientY - hw.top) * hy,
            };
          }
          var hq = document.getElementById("sig-canvas");
          (signatureCanvasContext = hq.getContext("2d")).strokeStyle =
            "#424242";
          signatureCanvasContext.lineWidth = 5;
          isDrawingSignature = false;
          previousSignaturePoint = currentSignaturePoint = {
            x: 0,
            y: 0,
          };
          hq.addEventListener(
            "mousedown",
            function (hu) {
              isDrawingSignature = true;
              previousSignaturePoint = hp(hq, hu);
            },
            false,
          );
          hq.addEventListener(
            "mouseup",
            function () {
              isDrawingSignature = false;
            },
            false,
          );
          hq.addEventListener(
            "mousemove",
            function (hu) {
              currentSignaturePoint = hp(hq, hu);
            },
            false,
          );
        })();
      } else {
        popupResponse(null, "Error");
      }
    },
    resp: function (hj, hk, hl, hm) {
      if (hm == 7) {
        if (hl && hk) {
          acc.funds = hk.pf || 0;
          cK();
          this.clanData.clan_funds = hk.cf || 0;
          updateWindow(13);
          popupResponse("SUCCESS", null, "Success");
        } else {
          popupResponse(null, hj || "Error");
        }
      } else if (hm == 8) {
        if (hl && hk) {
          if (this.clanData.members[hk.i]) {
            this.clanData.clan_funds = hk.cf || 0;
            this.clanData.members[hk.i].st = 1;
            this.clanData.members[hk.i].cr = hk.cr;
            updateWindow(13);
          }
          popupResponse("SUCCESS", null, "Success");
        } else {
          popupResponse(null, hj || "Error");
        }
      } else {
        if (hm == 6) {
          if (hl && hk) {
            var ho = this.clanData.members.find((hq) => hq.i == hk.i);
            if (ho) {
              ho.r = hk.r;
              updateWindow(13);
            }
            popupResponse("SUCCESS", null, "Success");
          } else {
            popupResponse(null, hj || "Error");
          }
          return;
        }
        var hp = document.getElementById("clanErr");
        if (hj && hp) {
          hp.style.color = hl ? "rgba(0,0,0,0.6)" : "rgba(255,0,0,0.6)";
          hp.innerHTML = hj;
        } else if (hk) {
          if (acc) {
            acc.clan = hk.clan_name;
          }
          this.clanData = hk;
          updateWindow(13);
        }
      }
    },
    tabIndex: 0,
    switchTab: function (hj) {
      windows[12].tabIndex = hj;
      updateWindow(13);
    },
    gen: function () {
      var hj = "";
      var hk = "";
      var hl = "";
      var hm = "";
      if (this.clanData && this.clanData.members) {
        var ho = acc && this.clanData.clan_playerid == acc.id;
        hj = "";
        this.clanData.members.sort(function (hO, hP) {
          return hP.s - hO.s;
        });
        for (var hp = config.clanRoles.length - 1; hp >= 0; --hp) {
          var hq = config.clanRoles[hp];
          var hu = 0;
          var hv = "";
          for (var hw = 0; hw < this.clanData.members.length; ++hw) {
            hC = this.clanData.members[hw];
            if (
              (this.clanData.clan_playerid == hC.i && hq.perms == 2) ||
              (hC.r == hp && this.clanData.clan_playerid != hC.i)
            ) {
              hu++;
              var hx =
                "<select class='clanRolD' onchange='windows[12].updRol(" +
                hC.i +
                ", this)' id='clanRolD" +
                hC.i +
                "'>";
              for (var hy = config.clanRoles.length - 1; hy >= 0; --hy) {
                if (config.clanRoles[hy].perms != 2) {
                  hx +=
                    "<option value='" +
                    hy +
                    "' " +
                    (hC.r == hy ? "selected" : "") +
                    ">" +
                    config.clanRoles[hy].name +
                    "</option>";
                }
              }
              hx += "</select>";
              hv +=
                "<div class='settName'>" +
                (hC.su
                  ? "<i class='material-icons' style='color:" +
                    COLORS.premium +
                    ";margin-top:-8px;font-size:28px;vertical-align:middle;margin-right:2px'>beenhere</i>"
                  : "") +
                (hC.ve
                  ? "<i class='material-icons' style='color:" +
                    COLORS.verified.player +
                    ";margin-top:4px;font-size:28px;vertical-align:baseline;margin-right:2px'>check_circle</i>"
                  : "") +
                "<a target='_blank'href='/social.html?p=profile&q=" +
                hC.p +
                "' " +
                (hC.h ? "style='color:#E85656'" : "") +
                ">" +
                hC.p +
                "</a>" +
                (ho && this.clanData.clan_playerid != hC.i
                  ? "<div style='float:right;'><i style='font-size:40px;color:rgba(255,0,0,0.6)'  class='material-icons h' onclick='windows[12].kickReq(&quot;" +
                    hC.p +
                    "&quot;," +
                    hC.i +
                    ")'>clear</i>" +
                    hx +
                    "</div>"
                  : "") +
                "</div>";
            }
          }
          if (hv == "") {
            hv = "No " + hq.name + "s";
          }
          hj +=
            "<div class='setHed' style='margin-top:20px'>" +
            hq.name +
            "s<span style='float:right;color:rgba(0,0,0,0.4)'>" +
            hu +
            (hq.max ? "/" + hq.max : "") +
            " <span style='color:#000'>Members</span></span></div>" +
            hv;
        }
        this.clanData.members.sort(function (hO, hP) {
          return hP.s7 - hO.s7;
        });
        for (hw = 0; hw < this.clanData.members.length; ++hw) {
          hm +=
            "<div class='settName'>" +
            ((hC = this.clanData.members[hw]).su
              ? "<i class='material-icons' style='color:" +
                COLORS.premium +
                ";margin-top:-8px;font-size:28px;vertical-align:middle;margin-right:2px'>beenhere</i>"
              : "") +
            (hC.ve
              ? "<i class='material-icons' style='color:" +
                COLORS.verified.player +
                ";margin-top:4px;font-size:28px;vertical-align:baseline;margin-right:2px'>check_circle</i>"
              : "") +
            "<a target='_blank'href='/social.html?p=profile&q=" +
            hC.p +
            "' " +
            (hC.h ? "style='color:#E85656'" : "") +
            ">" +
            hC.p +
            "</a><div style='float:right;color:rgba(0,0,0,0.8)'>" +
            UTILS.commaNumber(hC.s7) +
            "</div></div>";
        }
      }
      if (this.clanData && this.clanData.requests) {
        hk =
          "<div class='setHed' style='margin-top:18px'>Manage Requests <span style='float:right;color:rgba(0,0,0,0.4)'>" +
          this.clanData.requests.length +
          "</span></div>";
        for (hw = 0; hw < this.clanData.requests.length; ++hw) {
          hk +=
            "<div class='settName'><a target='_blank' href='/social.html?p=profile&q=" +
            this.clanData.requests[hw].player_name +
            "'>" +
            this.clanData.requests[hw].player_name +
            "</a><span style='float:right'><i style='font-size:40px;color:rgba(255,0,0,0.6)'  class='material-icons h' onclick='windows[12].updReq(" +
            hw +
            "," +
            this.clanData.requests[hw].cr_playerid +
            ", 0)'>clear</i><i style='font-size:40px;color:rgba(0,255,0,0.6);margin-left:10px' class='material-icons h' onclick='windows[12].updReq(" +
            hw +
            "," +
            this.clanData.requests[hw].cr_playerid +
            ", 1)'>done</i></span></div>";
        }
        if (!this.clanData.requests.length) {
          hk +=
            "<div style='margin-top:10px;color:rgba(0,0,0,0.4)'>" +
            i18n.t("windows.clans.requests.none") +
            "</div>";
        }
      }
      if (this.clanData && this.clanData.members) {
        var hz = [0, 0, 0];
        var hA = ["", "", ""];
        var hB = [...this.clanData.members].sort(
          (hO, hP) => (hO.de || 0) - (hP.de || 0),
        );
        for (hw = 0; hw < hB.length; ++hw) {
          var hC = hB[hw];
          config.clanRoles[hC.r || 0];
          var hD = hC.de >= config.clanWarLives || hC.st == 3;
          var hE = hD ? 2 : hC.st == 1 ? 0 : 1;
          var hF = Math.max(0, config.clanWarLives - parseInt(hC.de || 0));
          hz[hE]++;
          hA[hE] +=
            "<div class='settName settNHov'>" +
            (hC.su
              ? "<i class='material-icons' style='color:" +
                COLORS.premium +
                ";margin-top:-8px;font-size:28px;vertical-align:middle;margin-right:2px'>beenhere</i>"
              : "") +
            (hC.ve
              ? "<i class='material-icons' style='color:" +
                COLORS.verified.player +
                ";margin-top:4px;font-size:28px;vertical-align:baseline;margin-right:2px'>check_circle</i>"
              : "") +
            "<a target='_blank' href='/social.html?p=profile&q=" +
            hC.p +
            "' " +
            (hC.h ? "style='color:#E85656'" : "") +
            ">" +
            hC.p +
            "</a>" +
            (hD
              ? "<span style='float:right;color:rgba(0,0,0,0.4);'>" +
                (hC.ki || 0) +
                " Kills</span>"
              : "") +
            ((!ho && hC.st != 1) || hD
              ? ""
              : "<div style='float:right;'>" +
                (hE == 0
                  ? "<span style='color:rgba(0,0,0,0.4);vertical-align:top;margin-right:5px'>" +
                    hF +
                    " Lives</span>"
                  : "") +
                "<i style='font-size:40px;color:#525252' title='Enlist'  class='material-icons h' onclick='windows[12]." +
                (hC.st == 1 ? "showCont" : "startCont") +
                "(" +
                this.clanData.members.indexOf(hC) +
                ")'>history_edu</i></div>") +
            "</div>";
        }
        if (hA[0] == "") {
          hA[0] = "No Active Contracts";
        }
        if (hA[1] == "") {
          hA[1] = "No Reserves";
        }
        if (hA[2] == "") {
          hA[2] = "No KIA";
        }
        hl +=
          "<div class='setHed' style='margin-top:16px'>Active Contracts<span style='float:right;color:rgba(0,0,0,0.6)'>" +
          hz[0] +
          "/" +
          config.maxClanContr +
          " Active</span></div>" +
          hA[0];
        hl +=
          "<div class='setHed' style='margin-top:16px'>Killed in Action<span style='float:right;color:rgba(0,0,0,0.6)'>" +
          hz[2] +
          " Players</span></div>" +
          hA[2];
        hl +=
          "<div class='setHed' style='margin-top:16px'>Reserves<span style='float:right;color:rgba(0,0,0,0.6)'>" +
          hz[1] +
          " RSV</span></div>" +
          hA[1];
      }
      var hG = 0;
      var hH = 0;
      var hI = 0;
      var hJ = 0;
      var hK = 0;
      if (acc && acc.clan && this.clanData) {
        hJ = this.clanData.clan_score || 0;
        var hL = config.rankVar * Math.sqrt(hJ);
        hG = Math.floor(hL);
        hH = Math.round((hL - hG) * 100);
        hI = (hG = Math.max(1, hG)) > 1 ? Math.pow(hG / config.rankVar, 2) : 0;
        hK = parseInt(Math.pow((hG + 1) / config.rankVar, 2) - hI);
        hI = parseInt(hJ - hI);
      }
      var hM = "<div class='menuTabsNew' style='margin-top:15px;'>";
      for (hw = 0; hw < config.clanTabs.length; ++hw) {
        hM +=
          "<div class='menuTabNew" +
          (this.tabIndex == hw ? " tabANew" : "") +
          "' onclick='windows[12].switchTab(" +
          hw +
          ")'>" +
          config.clanTabs[hw] +
          "</div>";
      }
      hM += "</div>";
      var hN = acc
        ? acc.clan
          ? "<div class='setHed' style='margin-top:0px'>" +
            i18n.t("windows.clans.page", acc.clan) +
            "<a style='float:right' href='javascript:;' onclick='windows[12].delReq()' class='menuLink'>" +
            (this.clanData
              ? acc && this.clanData.clan_playerid == acc.id
                ? i18n.t("generic.delete")
                : i18n.t("generic.leave")
              : "") +
            "</a></div><div id='clanErr' style='margin-top:0px;color:rgba(0,0,0,0.5)'>" +
            (this.clanData
              ? "<div class='settName'>Rank<span class='floatR'>0</span></div><div class='settName'>Bank<span class='floatR'><span style='color:rgba(0,0,0,0.4)'><a href='javascript:;'  onclick='windows[12].mangFunds()' class='menuLink'>" +
                UTILS.commaNumber(this.clanData.clan_funds || 0) +
                "</a></span> KR</span></div><div class='settName'>" +
                i18n.t("generic.level") +
                "<span class='floatR'>" +
                hG +
                "</span></div><div class='settName'>Total Score<span class='floatR'>" +
                UTILS.commaNumber(hJ) +
                "</span></div><div class='xpBar' style='margin-bottom:10px'><div class='xpBarB' style='width:" +
                hH +
                "%'></div><span class='xpBarV'>" +
                UTILS.commaNumber(hI) +
                " / " +
                UTILS.commaNumber(hK) +
                "</span></div>" +
                hM +
                (this.tabIndex == 1
                  ? "<div class='setHed'>Top Scorers <span style='float:right;color:rgba(0,0,0,0.4)'>Last 7 Days</span></div>" +
                    hm
                  : "") +
                (this.tabIndex == 3
                  ? "<a class='menuLink' target='blank_' href='/social.html?p=clanwars' style='margin-top:10px'>View World Map</a><span style='float:right;color:rgba(0,0,0,0.5)'>" +
                    (this.clanData.clan_contracts || 0) +
                    "/" +
                    config.maxContrsT +
                    " <span style='color:rgba(0,0,0,0.8)'>Contracts used</span></span>" +
                    hl
                  : "") +
                (this.tabIndex == 0 ? hj : "") +
                (this.tabIndex == 2 ? hk : "")
              : i18n.t("generic.loading")) +
            "</div>"
          : "<div class='setHed' style='margin-top:-5px'>" +
            i18n.t("windows.clans.create") +
            "</div><input id='clanInp1' type='text' class='smlInput' maxlength='4' placeholder='" +
            i18n.t("windows.clans.name") +
            "' /><a class='menuLink' style='margin-left:20px' onclick='windows[12].sendReq(1)'>" +
            i18n.t("generic.create") +
            "</a><div style='margin-top:0px' class='setHed'>" +
            i18n.t("windows.clans.join") +
            " <a href='./social.html?p=leaders&q=clans' target='_blank' class='menuLink' style='margin-top:10px;display:inline-block'>" +
            i18n.t("windows.clans.view") +
            "</a></div><input id='clanInp2' type='text' class='smlInput' maxlength='5' placeholder='" +
            i18n.t("windows.clans.name") +
            "' /><a class='menuLink' style='margin-left:20px' onclick='windows[12].sendReq(2)'>" +
            i18n.t("generic.submit") +
            "</a><div id='clanErr' style='margin-top:10px'></div>"
        : renderRequirement(null, i18n.t("windows.clans.login"), true);
      if (acc && acc.clan && !this.clanData) {
        this.sendReq(3);
      }
      return hN;
    },
  },
  {
    header: i18n.t("windows.store.header"),
    resp: function (hj, hk, hl) {
      if (hj) {
        popupResponse(null, hj);
      } else {
        acc.premiumT = hl;
        updateFunds(hk);
        dJ();
        updateWindow(null, true);
        popupResponse("SUCCESS");
      }
    },
    tabIndex: 0,
    switchTab: function (hj) {
      if (hj == 4) {
        return window.open("/social.html?p=market");
      } else {
        windows[13].tabIndex = hj;
        updateWindow(14);
        return;
      }
    },
    purchase: function () {
      windows[13].tabIndex = 2;
      showWindow(14, true);
    },
    premium: function () {
      windows[13].tabIndex = 1;
      showWindow(14, true);
    },
    gen: function () {
      if (!acc) {
        return renderRequirement(null, i18n.t("windows.store.login"), true);
      }
      SOUND.play("store", 0.4);
      var hj = "<div class='menuTabsNew'>";
      for (var hk = 0; hk < config.shopTabs.length; ++hk) {
        hj +=
          "<div class='menuTabNew" +
          (this.tabIndex == hk ? " tabANew" : "") +
          "' onclick='windows[13].switchTab(" +
          hk +
          ")'>" +
          config.shopTabs[hk] +
          "</div>";
      }
      hj += "</div>";
      if (this.tabIndex == 0) {
        hj += "<div id='skinList' style='margin-top:15px'>";
        for (hk = 0; hk < Game.store.wheels.length; ++hk) {
          if (!(serverSetting = Game.store.wheels[hk]).kr) {
            var hl =
              !acc ||
              (serverSetting.free &&
                (acc.followInd == config.followInd ||
                  acc.level < serverSetting.minLvl)) ||
              serverSetting.locked;
            var hm = serverSetting.locked
              ? "Coming Soon"
              : hl
                ? "Sold Out"
                : serverSetting.priceT || serverSetting.price;
            var ho = true;
            if (
              (acc &&
                serverSetting.aReq &&
                acc[serverSetting.aReq.ind] < serverSetting.aReq.val) ||
              serverSetting.locked
            ) {
              hl = true;
              ho = false;
              if (serverSetting.aReq && serverSetting.aReq.txt) {
                hm = serverSetting.aReq.txt;
              }
            }
            hj +=
              "<div class='shopCard" +
              (hl ? " makeGray" : "") +
              "' onmouseenter='playTick()' style='color:" +
              (serverSetting.headCol || "#fff") +
              ";background-image: url(&quot;./img/shop/spins/" +
              hk +
              "_" +
              UTILS.randInt(0, serverSetting.icons - 1) +
              ".png&quot;)'" +
              (hl
                ? ""
                : " onclick='" +
                  (serverSetting.twitch
                    ? "showDrops()"
                    : "prizeWheel(" + hk + ")") +
                  "'") +
              ">" +
              i18n.t("windows.store.spin", serverSetting.name) +
              (serverSetting.lab
                ? "<div class='shopSale' style='background-color:" +
                  serverSetting.lab.col +
                  "'>" +
                  serverSetting.lab.nm +
                  "</div>"
                : "") +
              "<div class='spinVal'>" +
              hm +
              (serverSetting.priceT || !ho
                ? ""
                : " <span style='color:#fff'>KR</span>") +
              "</div></div>";
          }
        }
        hj += "</div>";
      }
      if (this.tabIndex == 1) {
        hj +=
          "<div style='color:rgba(0,0,0,0.3);margin-bottom:10px'>" +
          i18n.t("windows.store.buyP") +
          " <a href='javascript:;' onclick='showWindow(36)'>" +
          i18n.t("windows.store.premium2") +
          "</a></div>";
        hj += "<div id='skinList' style='margin-bottom:10px'>";
        for (hk = 0; hk < Game.store.premium.length; ++hk) {
          hj +=
            "<div class='shopCard' onmouseenter='playTick()' onclick='buyPremium(" +
            hk +
            ")' style='color:" +
            ((serverSetting = Game.store.premium[hk]).headCol || "#fff") +
            ";background-image: url(&quot;./img/shop/premium/" +
            hk +
            ".png&quot;)'>" +
            (serverSetting.tag
              ? "<div class='shopSale' style='background-color:" +
                serverSetting.tagCol +
                "'>" +
                serverSetting.tag +
                "</div>"
              : "") +
            serverSetting.val +
            " Days<div class='spinVal'>" +
            serverSetting.price +
            " <span style='color:#fff'>KR</span></div></div>";
        }
        hj += "</div><div id='premiumRes'></div>";
        hj +=
          "Time Remaining<span id='premTime'>" +
          UTILS.getReadableTime(
            acc && acc.premiumT ? Math.floor(acc.premiumT) : 0,
          ) +
          "</span>";
      }
      if (this.tabIndex == 2) {
        var hp = JSON.parse(getSavedVal("krk_cc") || "{}");
        if (hp && Date.now() - hp.t >= config.creatorReset) {
          deleteVal("krk_cc");
          hp = null;
        } else {
          hp = hp.code;
        }
        hj +=
          "<div style='color:rgba(0,0,0,0.3);font-size:19px;margin-bottom:-3px'>" +
          i18n.t(
            "windows.store.agree",
            "<a target='_blank' href='./docs/terms.txt'>",
          ) +
          "</a>. Support your favorite Content Creator by using a Creator Code</div>";
        hj +=
          "<div><input type='text' id='creatorCodeI' class='smlInput' " +
          (hp
            ? "disabled value='" + hp + "'"
            : "placeholder='Enter Creator Code'") +
          " /><div class='creatorCodeBtn' style='background-color:" +
          (hp ? "#eb5656" : "#41c300") +
          "' onclick='creatorCodeAction(" +
          (hp ? 0 : 1) +
          ")'>" +
          (hp ? "Remove" : "Save") +
          "</div></div>";
        hj += "<div id='skinList'>";
        for (hk = 0; hk < Game.store.purchases.length; ++hk) {
          if (
            !(serverSetting = Game.store.purchases[hk]).hide &&
            !serverSetting.type
          ) {
            hj +=
              "<div class='shopCard' onmouseenter='playTick()' onclick='showPurchase(" +
              hk +
              ")' style='background-image: url(&quot;./img/shop/" +
              hk +
              ".png&quot;)'>" +
              (serverSetting.tag
                ? "<div class='shopSale' style='background-color:" +
                  serverSetting.tagCol +
                  "'>" +
                  serverSetting.tag +
                  "</div>"
                : "") +
              serverSetting.val +
              " <span style='color:#fff'>KR</span><div class='spinVal' style='color:#fff'>$" +
              serverSetting.price +
              " USD</div></div>";
          }
        }
        hj += "</div>";
        hj +=
          "<div style='font-size:9px;margin-top:10px'>* Prices in USD can be converted to your local currency at an exchange rate defined by the payment provider or bank</div>";
      }
      if (this.tabIndex == 3) {
        hj +=
          "<div style='color:rgba(0,0,0,0.3);font-size:19px;margin-bottom:5px'>" +
          i18n.t("windows.store.voucherinfo") +
          "</div><div><input type='text' id='redVouch' class='smlInput' placeholder='Enter KR Code'/><div class='redVouchBtn' onclick='redeemVoucher()'>Redeem</div></div><div id='vouchRes' style='display:none'></div>";
      }
      this.tabIndex;
      return hj;
    },
  },
  {
    header: i18n.t("windows.skin.header"),
    gen: function () {
      var hj =
        "<div id='skinList' style='margin-top: 8px;'><div class='skinCard blackShad' style='border:5px solid lightgrey' onmouseenter='playTick()' onclick='selectSkin(-1," +
        dC +
        ")'>" +
        i18n.t("generic.none") +
        "<div class='itemOwn'>" +
        i18n.t("generic.default") +
        "</div><div class='itemSea' style='opacity:0;'>Season 1</div><img draggable='false' class='skinImg' src='" +
        UTILS.assetsUrl(
          "/textures/previews/weapons/" + Game.weaponConfig[dC].src + ".png",
        ) +
        "'></div><div class='skinCard blackShad' style='border:5px solid lightgrey' onmouseenter='playTick()' onclick='selectSkin(-2," +
        dC +
        ")'>" +
        i18n.t("generic.random") +
        "<div class='itemOwn' style='opacity:0;'>by ???</div><div class='itemSea' style='opacity:0;'>All Seasons</div><img draggable='false' class='skinImg skinSil' onmouseenter='playTick()' src='" +
        UTILS.assetsUrl(
          "/textures/previews/weapons/" + Game.weaponConfig[dC].src + ".png",
        ) +
        "'><div class='skinRandom blackShad' style='top:68px'>?</div></div>";
      if (acc || Game.singlePlayer) {
        for (
          var hk = [
              ...(Game.singlePlayer
                ? Object.keys(Game.store.skins).map((hm) => ({
                    ind: parseInt(hm),
                    cnt: 1,
                  }))
                : acc.skins),
            ].sort(function (hm, ho) {
              var hp =
                ho.ind != null && Game.store.skins[ho.ind]
                  ? Game.store.skins[ho.ind].rarity
                  : 0;
              var hq =
                hm.ind != null && Game.store.skins[hm.ind]
                  ? Game.store.skins[hm.ind].rarity
                  : 0;
              var hu =
                ho.ind != null && Game.store.skins[ho.ind]
                  ? Game.store.skins[ho.ind].seas || 1
                  : 0;
              var hv =
                hm.ind != null && Game.store.skins[hm.ind]
                  ? Game.store.skins[hm.ind].seas || 1
                  : 0;
              if (hp > hq) {
                return 1;
              } else if (hp < hq) {
                return -1;
              } else if (hu > hv) {
                return 1;
              } else if (hu < hv) {
                return -1;
              } else {
                return (ho.ind || 0) - (hm.ind || 0);
              }
            }),
            hl = 0;
          hl < hk.length;
          ++hl
        ) {
          if (
            (serverSetting = Game.store.skins[hk[hl].ind]) &&
            !serverSetting.type &&
            serverSetting.weapon == dC + 1
          ) {
            hj +=
              "<div class='skinCard" +
              (serverSetting.rarity == 5 ? "" : " blackShad") +
              (RENDER.rarityAnim &&
              Game.store.rarities[serverSetting.rarity].animate
                ? " rainbow"
                : "") +
              "' style='color:" +
              Game.store.rarities[serverSetting.rarity].color +
              ";border:5px solid" +
              Game.store.rarities[serverSetting.rarity].color +
              "' onmouseenter='playTick()' onclick='selectSkin(" +
              hk[hl].ind +
              "," +
              (serverSetting.weapon - 1) +
              ")'><div class='itemCnt' data-badge='x" +
              hk[hl].cnt +
              "'></div>" +
              serverSetting.name +
              "<div class='itemOwn'>by " +
              (serverSetting.creator || "Krunker.io") +
              "</div><div class='itemSea'>Season " +
              (serverSetting.seas || 1) +
              "</div><img loading='lazy' draggable='false' class='skinImg" +
              (serverSetting.type ? "C" : "") +
              (serverSetting.rgb ? " rgbHue" : "") +
              "' src='" +
              UTILS.getPreview(serverSetting, Game.store) +
              "'/><div class='selctInfoBtn' onmouseenter='playTick()'onclick='openSales(" +
              hk[hl].ind +
              ")'>?</div></div>";
          }
        }
      }
      return (hj += "</div>");
    },
  },
  {
    header: i18n.t("windows.hat.header"),
    gen: function () {
      return getItemsList("selectHat", 1);
    },
  },
  {
    header: i18n.t("windows.back.header"),
    gen: function () {
      return getItemsList("selectBack", 2);
    },
  },
  {
    header: i18n.t("windows.mods.load.header"),
    gen: function () {
      return (
        "<div id='modPckHead' style='margin-bottom:10px;font-size:22px'>Mod Loader</div><form id='modDropper'><input onchange='loadMod()' id='modInput'type='file'><p id='modLInfo'>" +
        i18n.t("windows.mods.drop") +
        "</p></form><input type='text' id='modURL' class='accountInput' style='width:78%' placeholder='" +
        i18n.t("windows.mods.paste") +
        "'><a class='menuLink' style='display:inline-block;margin-left:10px' onclick='loadModURL()'>" +
        i18n.t("windows.mods.load") +
        "</a>"
      );
    },
  },
  {
    header: i18n.t("windows.publish.mod.header"),
    gen: function () {
      return "";
    },
  },
  {
    header: i18n.t("windows.secondary.header"),
    gen: function () {
      var hj = "<div id='skinList'>";
      for (
        var hk = Game.weaponConfig
            .filter((hq) => hq.secondary)
            .sort(
              (hq, hu) =>
                (hq.minRec == null ? 0 : hq.minRec) -
                (hu.minRec == null ? 0 : hu.minRec),
            ),
          hl = 0;
        hl < hk.length;
        ++hl
      ) {
        if ((serverSetting = hk[hl])) {
          var hm =
            (Game.isCustom && !Game.mode.isRanked) ||
            !serverSetting.minRec ||
            (acc && acc.level >= serverSetting.minRec) ||
            Game.singlePlayer;
          var ho = Game.weaponConfig.findIndex(
            (hq) => hq.name == serverSetting.name,
          );
          var hp =
            selectedSkinsByWeapon[ho] >= 0
              ? (hp = Game.store.skins[selectedSkinsByWeapon[ho]])
              : null;
          hj +=
            "<div class='skinCard blackShad' style='height: 165px;border:5px solid lightgrey'>" +
            serverSetting.name +
            "<div class='itemOwn'>" +
            (serverSetting.minRec
              ? i18n.t(
                  "windows.secondary." + (hm ? "unlocked" : "req"),
                  serverSetting.minRec,
                )
              : i18n.t("generic.default")) +
            "</div><img loading='lazy' draggable='false' class='secImg' onmouseenter='playTick()' src='" +
            (hp
              ? UTILS.getPreview(hp, Game.store)
              : UTILS.assetsUrl(
                  "/textures/previews/weapons/" +
                    Game.weaponConfig[ho].src +
                    ".png",
                )) +
            "'" +
            (hm ? " onclick='skinSelector(" + ho + ", true)'" : "") +
            "/></div>";
        }
      }
      return (hj += "</div>");
    },
  },
  {
    header: i18n.t("windows.advertise.header"),
    resp: function (hj, hk, hl, hm) {
      hl = hl || [];
      if (hj == 1) {
        windows[20].waitBid = false;
        var ho = null;
        if (hm) {
          if ((ho = document.getElementById("hiBBbid")) && hl) {
            ho.innerHTML =
              (hl[0] || 0) + "<span style='color:#696969'> KR</span>";
          }
          if ((ho = document.getElementById("hiBBbidr"))) {
            ho.innerHTML = hl[1]
              ? "<a target='_blank' class='grey' href='/social.html?p=profile&q=" +
                hl[1] +
                "'>" +
                hl[1] +
                "</a>"
              : "None";
          }
        }
        if (hm) {
          if ((ho = document.getElementById("miBBbid"))) {
            ho.innerHTML =
              (hl[0] || 0) +
              config.minBid +
              "<span style='color:#696969'> KR</span>";
          }
          if ((ho = document.getElementById("bidValBB"))) {
            ho.value = (hl[0] || 0) + config.minBid;
          }
        }
        var hp = hk == "Success";
        hk = hp ? "Success! Bid posted" : hk;
        if (hp) {
          if ((ho = document.getElementById("yBBbid"))) {
            ho.innerHTML =
              (hl[0] || 0) + "<span style='color:#696969'> KR</span>";
          }
        }
        if ((ho = document.getElementById("bidInfoT"))) {
          ho.innerHTML = hk || "Error";
        }
      } else if (hj == 2) {
        windows[20].waiting = false;
        if ((ho = document.getElementById("hiBBbid"))) {
          ho.innerHTML =
            (hl[0] || 0) + "<span style='color:#696969'> KR</span>";
        }
        if ((ho = document.getElementById("hiBBbidr"))) {
          ho.innerHTML = hl[6]
            ? "<a target='_blank' class='grey' href='/social.html?p=profile&q=" +
              hl[6] +
              "'>" +
              hl[6] +
              "</a>"
            : "None";
        }
        if ((ho = document.getElementById("yBBbid"))) {
          ho.innerHTML =
            (hl[1] || 0) + "<span style='color:#696969'> KR</span>";
        }
        if ((ho = document.getElementById("miBBbid"))) {
          ho.innerHTML =
            (hl[0] || 0) +
            config.minBid +
            "<span style='color:#696969'> KR</span>";
        }
        ho = document.getElementById("tiBBbid");
        billboardBidTimeLeft = hl[2] || 0;
        if (ho) {
          ho.innerHTML = UTILS.getReadableTime(billboardBidTimeLeft, true);
        }
        if ((ho = document.getElementById("bidValBB"))) {
          ho.value = (hl[0] || 0) + config.minBid;
        }
        if ((ho = document.getElementById("bidTextBB")) && hl[3]) {
          ho.value = hl[3];
        }
        if ((ho = document.getElementById("bidTextColBB")) && hl[4]) {
          ho.value = hl[4] || "#e3e3e3";
        }
        if ((ho = document.getElementById("bidBgColBB")) && hl[5]) {
          ho.value = hl[5] || "#000000";
        }
      }
    },
    placeBid: function () {
      if (!windows[20].waitBid) {
        windows[20].waitBid = true;
        document.getElementById("bidInfoT").innerHTML = "Publishing Bid...";
        io.send("bb", 1, {
          txt: bidTextBB.value,
          txtCol: bidTextColBB.value,
          bgCol: bidBgColBB.value,
          fund: parseInt(bidValBB.value),
        });
      }
    },
    getBidInfo: function () {
      if (!windows[20].waiting) {
        windows[20].waiting = true;
        io.send("bb", 2);
      }
    },
    previewBid: function () {
      var hj = document.getElementById("bidPrevBB");
      if (hj) {
        var hk = UTILS.createCanvasAD(
          bidTextBB.value,
          bidTextColBB.value,
          bidBgColBB.value,
        );
        hj.src = hk.toDataURL("image/png");
        hj.style.display = "block";
      }
    },
    gen: function () {
      var hj =
        "<div class='setHed' style='margin-top:0;margin-bottom:10px'>Advertise in Game</div><div style='color:rgba(0,0,0,0.4)'>You have the ability to place custom text on Billboards in game. The text with the highest bid will be seen by all Krunker Players for " +
        config.billbTime / 3600000 +
        " hours.<div style='height:10px'></div></div><img src='/img/ad_2.png' style='width:100%;margin-top:10px;margin-bottom:10px'/><img id='bidPrevBB' src=''/>";
      if (config.bidEnabled) {
        if (acc) {
          if (acc.level < config.bidMinLvl) {
            hj +=
              "<div style='color:rgba(0,0,0,0.3)'>Must be at least <span style='color:#2e2e2e'>lvl " +
              config.bidMinLvl +
              "</span> to Submit a Bid.</div>";
          } else {
            hj +=
              "<div id='bidPrevBtn' onclick='windows[20].previewBid()'>Update Preview<span class='material-icons' style='color:#fff;font-size:25px;vertical-align:bottom;margin-top:-20px;margin-left:6px'>autorenew</span></div>";
            hj +=
              "<div>Highest Bid <span id='hiBBbid' style='color:rgba(0,0,0,0.3);float:right'>...</span></div><div>Highest Bidder <span id='hiBBbidr' style='color:rgba(0,0,0,0.3);float:right'>...</span></div><div>Your Last Bid <span id='yBBbid' style='color:rgba(0,0,0,0.3);float:right'>...</span></div><div>Minimum Bid <span id='miBBbid' style='color:rgba(0,0,0,0.3);float:right'>...</span></div><div>Time Remaining <span id='tiBBbid' style='color:rgba(0,0,0,0.3);float:right'>...</span></div><div>Estimated Views <span style='color:rgba(0,0,0,0.3);float:right'>~ " +
              UTILS.commaNumber(config.impresstimate * config.billbHours) +
              "<span style='color:#616161'> views</span></span></div><div style='font-size:22px;margin-top:16px;margin-bottom:5px'><b>Create Billboard</b></div><div>Text Color<input id='bidTextColBB' value='#e3e3e3' type='color' style='float:right'></div><div>Background Color<input id='bidBgColBB' value='#000000' type='color' style='float:right'></div><input id='bidValBB' type='number' placeholder='Enter Bid' class='accountInput' style='margin-top:10px'></input><textarea id='bidTextBB' type='text' maxlength='50' placeholder='Enter Text' class='accountInput' style='margin-top:12px;height:100px'></textarea><div id='bidInfoT'>Inappropriate Content will result in Account Deletion</div><div class='joinQueue' onclick='windows[20].placeBid()' style='width:692px'>Place Bid</div>";
            windows[20].getBidInfo();
          }
        } else {
          hj +=
            "<div style='color:rgba(0,0,0,0.3)'>Please <a href='javascript:;' onclick='showWindow(5);' class='menuLink'>Login</a> to Submit a Bid.</div>";
        }
      } else {
        hj +=
          "<div style='color:rgba(0,0,0,0.3)'>Ad bidding system disabled for now</div>";
      }
      return hj;
    },
  },
  {
    header: "Social",
    gen: function () {
      return "TODO";
    },
  },
  {
    header: i18n.t("windows.players.header"),
    gen: function () {
      var hj =
        "<div style='margin-top:0px' class='setHed'>" +
        (Game.players.list.length
          ? i18n.t("windows.players.header") +
            "<div style='float: right;'>[" +
            Game.players.list.length +
            "]</div><hr>"
          : "<center>" + i18n.t("windows.players.none") + "<center>") +
        "</div>";
      hj +=
        "<div style='background-color:gainsboro;border-radius:6px;padding:5px'>";
      if (player) {
        hj +=
          "<div><span class='settNameSmall'>" +
          (isLobbyHost
            ? "<i class='material-icons' style='font-size:25px'>stars</i>"
            : "") +
          (Game.mode && Game.mode.isRanked
            ? UTILS.eloIconHTML(player.maxElo)
            : "") +
          player.alias +
          (player.clan
            ? "<span class='" +
              (player.clanR == 1 ? "rainbowText" : "") +
              "' style='color:" +
              COLORS.getClanCol(player.clan, player.clanR, "#353535") +
              "'> [" +
              player.clan +
              "]</span>"
            : "") +
          "</span><span style='float:right'>" +
          (isLobbyHost || (acc && acc.canGlobalKick)
            ? "<span onmouseenter='playTick()' class='punishButton kick' onclick='punishPlayer(null, 2)'>Kick Spec</span>"
            : "") +
          (acc && acc.isDev
            ? "<span onmouseenter='playTick()' class='punishButton kill' onclick='punishPlayer(\"" +
              player.id +
              "\", 3)'>Kill</span>"
            : "") +
          (acc && acc.isDev
            ? "<span onmouseenter='playTick()' class='punishButton tpall' onclick='punishPlayer(null, 6)'>TPAll</span>"
            : "") +
          "</span></div>";
      }
      for (let hm of Game.players.list.filter(
        (ho) => !config.isProd || !ho.isYou,
      )) {
        var hk =
          acc &&
          !Game.isCustom &&
          handledVoteKickAliases.indexOf(hm.alias) == -1 &&
          (activeVoteKickTarget == hm.alias ||
            (!activeVoteKickTarget && !hasStartedVoteKick));
        var hl =
          (!Game.isCustom || (Game.mode && Game.mode.isRanked)) &&
          acc &&
          acc.level >= config.minKDFCall &&
          hm.level > 0;
        hj +=
          "<div><span class='settNameSmall'>" +
          (hostSocketId == hm.id
            ? "<i class='material-icons' style='font-size:25px'>stars</i>"
            : "") +
          (Game.mode && Game.mode.isRanked
            ? UTILS.eloIconHTML(hm.maxElo)
            : "") +
          "<a target='_blank' class='" +
          (hm.isHacker ? "red" : "grey") +
          "' href='/social.html?p=profile&q=" +
          hm.name +
          "'>" +
          hm.alias +
          (hm.clan
            ? "<span class='" +
              (hm.clanR == 1 ? "rainbowText" : "") +
              "' style='color:" +
              COLORS.getClanCol(hm.clan, hm.clanR, "#353535") +
              "'> [" +
              hm.clan +
              "]</span>"
            : "") +
          "</a></span><span style='float:right'>" +
          (hl
            ? "<span onmouseenter='playTick()' class='punishButton kdf' onclick='confirmPolice(`" +
              hm.alias +
              "`,`" +
              hm.id +
              "`)'><img src='./img/police.png' style='height:25px;vertical-align:middle;margin-top:-6px'></span>"
            : "") +
          (hk
            ? "<span onmouseenter='playTick()' class='punishButton vote' onclick='kickVote(\"" +
              hm.id +
              "\")'>Votekick</span>"
            : "") +
          (isLobbyHost || (acc && acc.canGlobalKick)
            ? "<span onmouseenter='playTick()' class='punishButton kick' onclick='punishPlayer(\"" +
              hm.id +
              "\", 0)'>Kick</span>"
            : "") +
          (isLobbyHost || (acc && acc.canGlobalBan)
            ? "<span onmouseenter='playTick()' class='punishButton ban' onclick='banPlayer(\"" +
              hm.alias +
              '","' +
              hm.id +
              "\")'>Ban</span>"
            : "") +
          (acc && acc.isDev
            ? "<span onmouseenter='playTick()' class='punishButton kill' onclick='punishPlayer(\"" +
              hm.id +
              "\", 3)'>Kill</span>"
            : "") +
          (acc && acc.canTeleport
            ? "<span onmouseenter='playTick()' class='punishButton tp2' onclick='punishPlayer(\"" +
              hm.id +
              "\", 4)'>TP2</span>"
            : "") +
          (acc && acc.canTeleport
            ? "<span onmouseenter='playTick()' class='punishButton tpme' onclick='punishPlayer(\"" +
              hm.id +
              "\", 5)'>TPME</span>"
            : "") +
          "</span></div>";
      }
      return (hj += "</div>");
    },
  },
  {
    header: i18n.t("windows.join.header"),
    gen: function () {
      return (
        "<input id='gameURL' type='text' placeholder='" +
        i18n.t("windows.join.code") +
        "' class='accountInput' style='margin-top:0' value=''></input><div class='accountButton' onclick='joinGame()' style='width:100%'>" +
        i18n.t("windows.join.header") +
        "</div>"
      );
    },
  },
  {
    header: i18n.t("windows.client.header"),
    gen: function () {
      return (
        "<div><ul style='padding:0;display:flex;list-style:none;text-align:center;margin:0;margin-top:-10px'><li style='display: flex;flex-basis:200px;-webkit-box-flex:1;flex-grow:1;margin-right:10px'><a href='//client2.krunker.io/setup.exe' style='display:block;width:100%;padding-top:1em;'><img src ='./img/windows.png' style='width:80px;height:80px;display:block;margin:0 auto 10px;'>" +
        i18n.t("windows.client.windows") +
        "</a></li><li style='display: flex;flex-basis:200px;-webkit-box-flex:1;flex-grow:1;'><a href='//client2.krunker.io/setup.dmg' style='display: block;width: 100%;padding-top:1em;'><img src ='./img/mac.png' style='width:80px;height:80px;display:block;margin:0 auto 10px;'>" +
        i18n.t("windows.client.mac") +
        "</a></li><li style='display: flex;flex-basis:200px;-webkit-box-flex:1;flex-grow:1;'><a href='//client2.krunker.io/setup.AppImage' style='display: block;width: 100%;padding-top:1em;'><img src ='./img/linux.png' style='width:80px;height:80px;display:block;margin:0 auto 10px;'>" +
        i18n.t("windows.client.linux") +
        "</a></li></ul></div>"
      );
    },
  },
  {
    header: i18n.t("windows.melee.header"),
    gen: function () {
      return getItemsList("selectMelee", 3);
    },
  },
  {
    header: i18n.t("windows.ranked.header"),
    cantQueue: false,
    justCopied: null,
    resp: function (hj, hk) {
      if (!hj) {
        this.cantQueue = hk;
        updateQueueStatus();
      }
    },
    gen: function () {
      if (!acc) {
        return renderRequirement(null, i18n.t("windows.ranked.login"), true);
      }
      if (this.cantQueue) {
        return (
          "<span style='font-size: 20px'>You have abandoned a ranked match in the last 5 hours. Please wait " +
          UTILS.getReadableTime(this.cantQueue) +
          " to requeue.</span>"
        );
      }
      var hj =
        "<div style='font-size:22px;margin-bottom:10px'>Ranked Queue<div style='display:inline-block;float:right;vertical-align:top;color:rgba(0,0,0,0.3)'><span>0</span> Valour</div></div>";
      hj += "<div class='rankedHeader'>";
      hj += party
        ? "<a onclick='leaveQueue()' onmouseenter='SOUND.play(`tick_0`,0.1)'>Leave Party</a> | " +
          (this.justCopied == -1
            ? "<a>Copied</a>"
            : "<a onclick='copyPartyInviteLink(-1)' onmouseenter='SOUND.play(`tick_0`,0.1)'>Invite</a>")
        : "\n                <input id='rankedPartyKey' placeholder='Party Key/URL' type='text'></input>\n                <span><a class='partyCreate' onclick='joinQueue()' onmouseenter='SOUND.play(\"tick_0\",0.1)'>Create Party</a>\n                <a class='partyJoin' onclick='joinQueue()' onmouseenter='SOUND.play(\"tick_0\",0.1)'>Join Party</a></span>";
      hj += "</div>";
      if (party) {
        var hk = config.regionNames[party.region];
        hj +=
          "<div class='windowRightInfoText'>" +
          party.partyId +
          " | " +
          hk +
          "</div>";
      } else {
        hj += "<select id='queueRegionSelect' class='inputGrey'>";
        var hl =
          getSavedVal("krunker_rankedRegion") ||
          localStorage[ClientManager.PING_REGION_CACHE_KEY];
        for (var hm of config.availableRegions) {
          hj +=
            "<option value='" + hm + "' " + (hm == hl ? "selected" : "") + ">";
          hj += config.regionNames[hm];
        }
        hj += "</select>";
      }
      var isPartyLeader =
        party == null ||
        (client.queueManager != null &&
          party.partyLeaderId == client.queueManager.queueClientId);
      if (party) {
        hj += "<div id='partyMemberList'>";
        for (var hp = 0; hp < Math.max(party.partyMembers.length, 4); hp++) {
          var hq = party.partyMembers[hp];
          var hu = false;
          if (!hq) {
            for (var hv of config.queues) {
              if (
                party.queueIds.indexOf(hv.id) != -1 &&
                hp >= hv.maxPartySize
              ) {
                hu = true;
              }
            }
          }
          var hw = !!hq && party.partyLeaderId == hq.clientId;
          var hx = hq ? JSON.parse(hq.accountData) : null;
          var hy = hq
            ? COLORS.getClanCol(hx.c, hx.cR, "rgba(0,0,0,0.7)")
            : "rgba(0,0,0,0.7)";
          hj +=
            "\n                    <div class='partyMember  " +
            (hq && hq.isReady ? "ready" : "unready") +
            " " +
            (hq ? "" : "placeholder") +
            "'>\n                        <div class='partyAvatar " +
            (hw ? "leader" : "") +
            "'>\n                            <img src='" +
            UTILS.assetsUrl(
              "/textures/classes/icon_" +
                (hq ? hq.classIndex : hp - 1) +
                ".png",
            ) +
            "'>\n                            " +
            (hu ? "<i class='material-icons partyMemberLock'>lock</i>" : "") +
            "\n                            " +
            (hw
              ? "<div class='partyLeaderIcon'><i class='material-icons'>star</i></div>"
              : "") +
            "\n                            " +
            (hq && isPartyLeader && !hw
              ? "<div class='partyMemberActions'>\n                                        <a class='partyMemberAction' onclick='kickPartyMember(\"" +
                hq.clientId +
                "\")' onmouseenter='SOUND.play(\"tick_0\",0.1)'>Kick</a>\n                                        <div class='partyMemberActionSep'></div>\n                                        <a class='partyMemberAction' onclick='promotePartyMember(\"" +
                hq.clientId +
                "\")' onmouseenter='SOUND.play(\"tick_0\",0.1)'>Promote</a>\n                                    </div>\n                                "
              : "") +
            "\n                        </div>\n                        <div class='partyUsername'>\n                            " +
            (hq
              ? "<span>" +
                hq.accountId +
                (hx.c
                  ? " <span style='color:" + hy + "'> [" + hx.c + "]</span>"
                  : "") +
                "</span>"
              : "") +
            "\n                            " +
            (hq || hu || this.justCopied != hp ? "" : "<a>Copied</a>") +
            "\n                            " +
            (hq || hu || this.justCopied == hp
              ? ""
              : "<a onclick='copyPartyInviteLink(" +
                hp +
                ")' onmouseenter='SOUND.play(\"tick_0\",0.1)'>Invite</a>") +
            "\n                            " +
            (hu ? "<span style='opacity: 0.75'>LOCKED</span>" : "") +
            "\n                            " +
            (hq ? UTILS.eloIconHTML(hx.e, "margin-top:2px") : "") +
            "\n                        </div>\n                    </div>\n                ";
        }
        hj += "</div>";
      }
      hj +=
        "<div class='rankedQueueOptions' style='pointer-events: " +
        (isPartyLeader ? "all" : "none") +
        "'>";
      for (var hv of config.queues) {
        var hz = party && party.partyMembers.length > hv.maxPartySize;
        var hA = document.querySelector("[data-queue-id=" + hv.id + "]");
        var hB = !!party && party.queueIds.indexOf(hv.id) != -1;
        var hC =
          (isPartyLeader && !isInitialPartyStatus && hA ? hA.checked : hB) &&
          !hz
            ? "checked"
            : "";
        var hD = UTILS.eloIconId(acc[hv.key]);
        hj +=
          "<label class='rankedSelection " +
          (hz ? "tooLarge" : "") +
          "' onmouseenter='SOUND.play(`tick_0`,0.1)'>";
        hj += hz
          ? "<i class='material-icons rankedLocked blackShad'>lock</i>"
          : "<div class='rankedType blackShad'>" +
            i18n.t(hv.name) +
            "</div><img class='rankedELO' src='./img/ranks/icon_" +
            UTILS.eloIconId(acc[hv.key]) +
            ".png'><div class='rankedELOTxt blackShad'>" +
            (hD == 0 ? "No Rank" : "Rank " + hD) +
            "</div>";
        hj +=
          "<input type='checkbox' class='rankedQueueOption' onchange='setPartyQueues()' data-queue-id='" +
          hv.id +
          "' " +
          hC +
          " " +
          hz +
          "><img class='rankedImg' src='/img/ranked/" +
          hv.id +
          ".png'></label>";
      }
      hj += "</div>";
      hj += queueStatusMessage
        ? "<span class='rankedWarning'>" + queueStatusMessage + "</span>"
        : "<span class='rankedWarning'>Leaving a match will result in a 2 Hour Ban & loss in Rank</span>";
      if (acc.level < config.minRankedLevel) {
        hj +=
          '<div class="joinQueue jQR">Requires lvl ' +
          config.minRankedLevel +
          "</div>";
      } else if (Game.config.isFromQueue) {
        hj += '<div class="joinQueue jQR">In Ranked Match</div>';
      } else if (client.queueManager && !client.queueManager.isQueued) {
        hj += '<div class="joinQueue jQR">' + queueStatusMessage + "</div>";
      } else {
        var hE =
          client.queueManager &&
          (client.queueManager == null
            ? null
            : party
              ? party.partyMembers.filter(
                  (hF) => hF.clientId == client.queueManager.queueClientId,
                )[0]
              : null
          ).isReady;
        hj += '<div class="joinQueue';
        if (hE) {
          hj += " jQR";
        }
        hj += '" ';
        hj += hE ? 'onclick="setPartyUnready()"' : 'onclick="setPartyReady()"';
        hj += " onmouseenter='SOUND.play(`tick_0`,0.1)'";
        hj += ">";
        hj += hE ? "Unready" : "Ready";
        hj += "</div>";
      }
      return hj;
    },
  },
  {
    header: "Partner Dashboard",
    getData: function (hj) {
      var hk = document.getElementById("creatorDash");
      if (hk) {
        var hl = "Error. Try Again";
        if (hj && acc) {
          hl = "";
          var hm = "krunker.io/?ref=" + acc.partnerName;
          hl +=
            "<div class='partnerStatHead' onclick='copyToClip(`" +
            hm +
            "`)'>Referral Link <a style='float:right'>" +
            hm +
            "</a></div><div>Sign-ups Total <span style='color:rgba(0,0,0,0.4);float:right'>" +
            (hj.suma || 0) +
            "</span></div><div>Sign-ups this Month <span style='color:rgba(0,0,0,0.4);float:right'>" +
            (hj.sum || 0) +
            "</span></div><div>Playtime this Month <span style='color:rgba(0,0,0,0.4);float:right'>" +
            UTILS.getReadableTime(hj.rm || 0) +
            "</span></div><div>Playtime last Month <span style='color:rgba(0,0,0,0.4);float:right'>" +
            UTILS.getReadableTime(hj.rlm || 0) +
            "</span></div><div>Rate Per Hour <span style='color:rgba(0,0,0,0.4);float:right'>" +
            (hj.rst || 0) +
            " <span style='color:#424242'>USD</span></span></div><div>Earnings this Month <span style='color:rgba(0,0,0,0.4);float:right'>~" +
            (hj.rmc || 0) +
            " <span style='color:#424242'>USD</span></span></div><div>Earnings last Month <span style='color:rgba(0,0,0,0.4);float:right'>~" +
            (hj.rlmc || 0) +
            " <span style='color:#424242'>USD</span></span></div><div style='height:25px'></div>";
          hl +=
            "<div class='partnerStatHead'>Partner Code<span style='float:right'>" +
            acc.partnerName +
            "</span></div><div>Sales this Month <span style='color:rgba(0,0,0,0.4);float:right'>" +
            (hj.am || 0) +
            " Sales</span></div><div>Earnings this Month <span style='color:rgba(0,0,0,0.4);float:right'>~" +
            (hj.tm || 0) +
            " <span style='color:#424242'>USD</span></span></div><div>Earnings last Month <span style='color:rgba(0,0,0,0.4);float:right'>~" +
            (hj.lm || 0) +
            " <span style='color:#424242'>USD</span></span></div><div style='height:25px'></div><div class='partnerStatHead'>Custom Games</div><div style='color:rgba(0,0,0,0.4);margin-bottom:10px'>Minimum 30'000 Gameplays required to start earning</div><div>Gameplays this Month <span style='color:rgba(0,0,0,0.4);float:right'>" +
            (hj.smc || 0) +
            "</span></div><div>Gameplays last Month <span style='color:rgba(0,0,0,0.4);float:right'>" +
            (hj.slmc || 0) +
            "</span></div><div>Earnings this Month <span style='color:rgba(0,0,0,0.4);float:right'>~" +
            (hj.sm || 0) +
            " <span style='color:#424242'>USD</span></span></div><div>Earnings last Month <span style='color:rgba(0,0,0,0.4);float:right'>~" +
            (hj.slm || 0) +
            " <span style='color:#424242'>USD</span></span></div><div style='color:rgba(0,0,0,0.5);margin-top:20px'>Paid to <span style='color:#424242'>" +
            hj.poc +
            "</span>. Payouts happen on a monthly basis. The values shown are estimates only</div>";
        }
        hk.innerHTML = hl;
      }
    },
    gen: function () {
      if (acc && acc.partnerApp) {
        io.send("crtD");
        return "<div id='creatorDash'>Loading...</div>";
      } else {
        return "Error";
      }
    },
  },
  {
    header: i18n.t("windows.support.header"),
    gen: function () {
      return "<div style='color:rgba(0,0,0,0.4);margin-top:0px'>To <b>Recover your Account</b> Contact us on <a>recovery@yendis.ch</a> Recovery is only possible if certain information can be provided.<div style='height:10px'></div> <div style='color:rgba(0,0,0,0.4);margin-top:10px'>Contact us on <a>krunker@yendis.ch</a> for support requests relating to <b>Payments or Accounts</b>.<div style='height:25px'></div> For <b>Bug Reports, Suggestions</b> or <b>Other Queries</b> join our <a href='https://discord.gg/Dw8F62u'>Discord</a> or <a href='https://www.reddit.com/r/KrunkerIO'>Reddit</a> communities.<div style='height:15px'></div><div style='color:rgba(0,0,0,0.5)'><b>Product & Property of</b></br>Yendis AG Switzerland CHE-364.191.430</br>Yendis Entertainment AU Pty Ltd</br>Yendis Inc. CA</br></div></br>For Legal matters contact legal@yendis.ch ";
    },
  },
  {
    header: i18n.t("windows.mail.header"),
    mailData: null,
    count: 0,
    mailCount: function (hj) {
      this.count = hj;
      if (hj > 99) {
        hj = "99+";
      }
      if (hj < 0) {
        hj = 0;
      }
      mailCount.innerHTML = hj;
      mailCount.style.display = hj ? "block" : "none";
    },
    onData: function (hj, hk) {
      this.tabIndex = hj;
      this.mailData = hk
        ? {
            d: hk,
          }
        : null;
      updateWindow(30);
    },
    onReadData: function (hj) {
      if (hj) {
        hj = hj[0];
        if ((hl = document.getElementById("mail_" + hj.km_id))) {
          hl.style.border = "";
          hl.classList.remove("mailUnread");
          var hk = hj.km_text
            .replace(/<|>/g, "")
            .replace("&", "")
            .replace(/[^\x00-\x7F]/g, "");
          hl.children[2].innerHTML = hk.length ? hk : "No message provided";
        }
        this.mailCount(this.count - 1);
      } else {
        var hl;
        if ((hl = document.getElementById("mail_" + hj.km_id))) {
          hl.children[2].innerHTML = "Failed to load mail";
        }
      }
    },
    readMail: function (hj, hk) {
      if (hj.children[2].innerHTML.length) {
        hj.children[2].innerHTML = "";
      } else {
        hj.children[2].innerHTML = "Loading...";
        io.send("rml", hk);
      }
    },
    readAll: function () {
      io.send("raml");
      this.switchTab(1);
      this.mailCount(0);
    },
    tabIndex: 0,
    listData: {},
    switchTab: function (hj, hk) {
      if (this.tabIndex != hj || hk) {
        this.tabIndex = hj;
        this.mailData = null;
        updateWindow(30);
      }
    },
    gen: function () {
      var hj = "<div class='menuTabsNew'>";
      for (var hk = 0; hk < config.mailTabs.length; ++hk) {
        hj +=
          "<div class='menuTabNew" +
          (this.tabIndex == hk ? " tabANew" : "") +
          "' onclick='windows[29].switchTab(" +
          hk +
          ")' style='width: 50%;'>" +
          config.mailTabs[hk].n +
          "</div>";
      }
      hj += "</div>";
      hj += "<div id='mailList'>";
      if (this.tabIndex == 0) {
        if (this.mailData) {
          if (this.mailData.d) {
            var hl = this.mailData.d.filter((ho) => !ho.km_archive);
            for (hk = 0; hk < hl.length; ++hk) {
              hj +=
                "<div class='mailObj mailUnread' id='mail_" +
                (serverSetting = hl[hk]).km_id +
                "' onclick='windows[29].readMail(this, " +
                serverSetting.km_id +
                ")' style='border: 2px solid #5699eb;'><div style='position:relative;'><div class='mailDate'>" +
                UTILS.getReadableTime2(
                  new Date().getTime() -
                    new Date(serverSetting.km_datesent).getTime(),
                ) +
                "</div></div><div class='mailFrom'>" +
                serverSetting.km_playerfrom +
                "</div>" +
                serverSetting.km_subject +
                "<div class='mailText'></div></div>";
            }
            if (!hl.length) {
              hj += "No messages";
            }
            this.mailData = null;
          } else {
            hj += "Loading...";
          }
        } else {
          this.mailData = null;
          io.send("kml", this.tabIndex);
          hj += "Loading...";
        }
      } else if (this.tabIndex == 1) {
        if (this.mailData) {
          if (this.mailData.d) {
            var hm = this.mailData.d.filter((ho) => ho.km_archive);
            for (hk = 0; hk < hm.length; ++hk) {
              hj +=
                "<div class='mailObj' id='mail_" +
                (serverSetting = hm[hk]).km_id +
                "' onclick='windows[29].readMail(this, " +
                serverSetting.km_id +
                ")'><div style='position:relative;'><div class='mailDate'>" +
                UTILS.getReadableTime2(
                  new Date().getTime() -
                    new Date(serverSetting.km_datesent).getTime(),
                ) +
                "</div></div><div class='mailFrom'>" +
                serverSetting.km_playerfrom +
                "</div>" +
                serverSetting.km_subject +
                "<div class='mailText'></div></div>";
            }
            if (!hm.length) {
              hj += "No archive messages";
            }
            this.mailData = null;
          } else {
            hj += "Loading...";
          }
        } else {
          this.mailData = null;
          io.send("kml", this.tabIndex);
          hj += "Loading...";
        }
      }
      hj += "</div>";
      return (
        "<div>Your Notifications" +
        (this.tabIndex == 0
          ? "<div class='readAll' onclick='windows[29].readAll()'>Read All</div>"
          : "") +
        "</div>" +
        hj
      );
    },
  },
  {
    header: i18n.t("windows.attach.header"),
    gen: function () {
      var hj =
        "<div id='skinList'><div class='noBtnCard' style='height:150px;border:5px solid lightgrey' onclick='selectAttachment(-1)'>" +
        i18n.t("generic.none") +
        "<div class='skinRandom blackShad' style='top: 60px;'>X</div></div>";
      if (
        Game.weaponConfig[Game.classes[selectedClassIndex].loadout[0]].attach !=
        null
      ) {
        for (var hk = 0; hk < Game.attach.length; ++hk) {
          if ((serverSetting = Game.attach[hk])) {
            hj +=
              "<div class='noBtnCard' style='height:150px;border:5px solid lightgrey' onclick='selectAttachment(" +
              hk +
              ")'>" +
              serverSetting.name +
              "<div></div><img loading='lazy' draggable='false' class='noBtnImgC' src='" +
              UTILS.assetsUrl(
                "/textures/previews/attach/attach_" + hk + ".png",
              ) +
              "'/></div>";
          }
        }
      }
      return (hj += "</div>");
    },
  },
  {
    header: i18n.t("windows.reticle.header"),
    gen: function () {
      var hj =
        "<div id='skinList' style='margin-top:8px'><div class='noBtnCard' style='height:140px;border:5px solid lightgrey' onclick='selectReticle(-1)' onmouseenter='playTick()'>None<div class='skinRandom blackShad' style='top: 60px;' onmouseenter='playTick()'>X</div></div>";
      hj +=
        "<div class='noBtnCard' style='height:140px;border:5px solid lightgrey'>Custom<div></div>" +
        (RENDER.aimDot.savedCustom.length
          ? "<img class='noBtnImgR' style='margin-top:5px;' draggable='false' src='" +
            RENDER.aimDot.savedCustom +
            "' onclick='selectReticle(-2)'/>"
          : "<img class='noBtnImgR skinSil' style='margin-top:5px;' draggable='false' src='" +
            UTILS.assetsUrl("/textures/reticles/reticle_0.png") +
            "' onclick='selectReticle(-2)' onmouseenter='playTick()'/>") +
        "<input type='url' class='customReticle' name='url' id='slid_customADSDot' placeholder='Reticle Image' value='" +
        RENDER.aimDot.savedCustom +
        "' oninput='setSetting(\"customADSDot\", this.value);updateWindow(null, true);'></div>";
      if (
        Game.weaponConfig[Game.classes[selectedClassIndex].loadout[0]].attach !=
        null
      ) {
        for (var hk = 0; hk < Game.reticles.length; ++hk) {
          if ((serverSetting = Game.reticles[hk])) {
            hj +=
              "<div class='noBtnCard' style='height:140px;border:5px solid lightgrey' onclick='selectReticle(" +
              hk +
              ")'>" +
              serverSetting.name +
              "<div class='itemOwn' style='margin-top:1px'>" +
              i18n.t("generic.default") +
              "</div><img loading='lazy' class='noBtnImgR' draggable='false' src='" +
              UTILS.assetsUrl(
                "/textures/reticles/reticle_" + serverSetting.id + ".png",
              ) +
              "' onmouseenter='playTick()'/></div>";
          }
        }
      }
      return (hj += "</div>");
    },
  },
  {
    header: i18n.t("windows.chall.header"),
    gen: function () {
      if (!acc) {
        return renderRequirement(null, i18n.t("windows.chall.login"), true);
      }
      if (acc.level < config.minChalLevel) {
        return renderRequirement(config.minChalLevel, "for Challenges");
      }
      var hj = "";
      if (acc.stats.chgP) {
        if (Game.isCustom) {
          hj +=
            "<div style='color: #eb5656;font-size: 21px;text-align: left;margin-bottom: 5px;'>Challenges can't be completed in Custom Matches</div>";
        }
        var hk = acc.chal >= config.maxChal;
        for (
          var hl = Game.challenges[hk ? config.maxChal - 1 : acc.chal],
            hm = UTILS.getChalProg(acc, Game).split(",").map(Number),
            ho = 0,
            hp = "<div style='margin-top: 5px;'>",
            hq = "",
            hu = 0;
          hu < hl.list.length;
          ++hu
        ) {
          var hv = hk
            ? hl.list[hu].val
            : hl.list[hu].prog(Game, player, parseInt(hm[hu]) || 0);
          var hw =
            hk || hv >= hl.list[hu].val
              ? 100
              : Math.round((hv / hl.list[hu].val) * 100);
          ho += hw;
          hq = hl.list[hu].desc.replace("$", hl.list[hu].val);
          if (hl.list[hu].wep != null) {
            hq = hq.replace("@", Game.weaponConfig[hl.list[hu].wep].name);
          }
          hp +=
            "<div class='chalCard'><img class='chalImgC' src='" +
            UTILS.versionifyUrl("/img/chals/" + hl.list[hu].img + ".png") +
            "'/><div class='chalRight'>" +
            hl.list[hu].name +
            (hl.boss
              ? "<img class='chalBoss' src='" +
                UTILS.versionifyUrl("/img/skull_0.png") +
                "'/>"
              : "") +
            "<div class='chalDesc'>" +
            hq +
            (hl.list[hu].multi ? "" : " in one game") +
            "</div><div class='chalXPBar'><div class='chalXPBarC' style='width:" +
            hw +
            "%'></div><div class='chalProg'>" +
            (hv >= hl.list[hu].val
              ? "COMPLETED"
              : hv + "/" + (hl.list[hu].multi ? hl.list[hu].val : 1)) +
            "</div></div></div></div>";
        }
        hp += "</div>";
        ho = Math.round((ho / (hl.list.length * 100)) * 100);
        ho = Math.min(ho || 0, 100);
        hj +=
          "<div class='settName'>Challenge Level<span class='floatR'>" +
          (hk ? "MAX" : acc.chal + 1) +
          "</span></div><div class='xpBar'><div class='xpBarB' style='width:" +
          ho +
          "%;" +
          (hl.boss ? "background-color:#f32121'" : "") +
          "'></div><span class='xpBarV'>" +
          ho +
          "%" +
          (hl.boss
            ? "<img src='" +
              UTILS.versionifyUrl("/img/skull_0.png") +
              "' style='image-rendering: pixelated;width: 22px;'>"
            : "") +
          "</span></div>";
        hj +=
          "<div class='settName'>Next Reward(s)<span class='floatR'><span style='color: rgba(0, 0, 0, 0.5);'>" +
          (hk ? "" : "+" + hl.reward.funds) +
          "</span> " +
          (hk ? "Coming Soon" : "KR") +
          "</span></div>";
        hj +=
          hl.reward.lvlCol && !hk
            ? "<div class='settName'><span class='floatR' style='color:" +
              hl.reward.lvlCol +
              "'>Level Color</span></div>"
            : "";
        hj += hp;
      } else {
        io.send("chg");
        hj += "Loading";
      }
      return hj;
    },
  },
  {
    header: i18n.t("windows.dye.header"),
    gen: function () {
      return getItemsList("selectDye", 5);
    },
  },
  {
    header: i18n.t("windows.changelog.header"),
    logData: null,
    fetchLog: function () {
      fetch("/docs/versions.txt?t=" + UTILS.randInt(1, 10000000))
        .then((hj) => hj.text())
        .then((hj) => this.onFetched(hj))
        .catch(() => {});
    },
    onFetched: function (hj) {
      if (hj) {
        this.logData = hj.split(
          /^\s*== (?=.*?\bUPDATE|UPADTE|INITIAL|TRICKSHOT\b)(.*) ==/gm,
        );
        updateWindow(35);
      }
    },
    toggleLog: function (hj) {
      hj.children[2].style.display =
        hj.children[2].style.display == "none" ? "block" : "none";
      hj.children[0].innerHTML =
        hj.children[2].style.display == "none"
          ? "arrow_drop_down"
          : "arrow_drop_up";
    },
    fixChanges: function (hj) {
      return hj
        .split(String.fromCharCode(10))
        .map((hk) => hk.trim())
        .filter((hk) => hk.length)
        .join('</div><div class="changeText">');
    },
    gen: function () {
      var hj = "";
      if (this.logData) {
        for (var hk = 1; hk < this.logData.length - 2; ) {
          hj +=
            "<div class='mailObj' onclick='windows[34].toggleLog(this)'><i class='material-icons' style='font-size:34px;float:right;margin-right:5px;'>" +
            (hk > 1 ? "arrow_drop_down" : "arrow_drop_up") +
            "</i><div class='mailFrom'>" +
            this.logData[hk] +
            "</div><div " +
            (hk > 1 ? "style='display:none'" : "") +
            "><div class='changeText'>" +
            this.fixChanges(this.logData[hk + 1]) +
            "</div></div></div>";
          hk += 2;
        }
      } else {
        this.fetchLog();
        hj = "Loading...";
      }
      return "<div>Changelog</div><div id='mailList'>" + hj + "</div>";
    },
  },
  {
    header: i18n.t("windows.premium.header"),
    gen: function () {
      return "<div style='font-size: 22px;margin-bottom:10px'>Things you get with Premium:</div><div style='background-color:#333;padding:15px;border-radius:6px;border:5px solid var(--yellow)'><div class='settNameSmall premText'><i class='material-icons'>grade</i> Golden Badge on Profile</div><div class='settNameSmall premText'><i class='material-icons'>grade</i> Custom Profile Pictures</div><div class='settNameSmall premText'><i class='material-icons'>grade</i> Custom Display Name</div><div class='settNameSmall premText'><i class='material-icons'>grade</i> Monthly giveaway entry: Chance to win 50,000 KR</div><div class='settNameSmall premText'><i class='material-icons'>grade</i> Custom Skin Color</div><div class='settNameSmall premText'><i class='material-icons'>grade</i> Custom Hair Color</div><div class='settNameSmall premText'><i class='material-icons'>grade</i> Custom Chat Name Color</div><div class='settNameSmall premText'><i class='material-icons'>grade</i> Custom Commands: /god /noclip /kill /smite</div><div class='settNameSmall premText'><i class='material-icons'>grade</i> Can host 16 player lobbies</div><div class='settNameSmall premText'><i class='material-icons'>grade</i> Can enter Limited Premium Areas on Custom Maps</div><div class='settNameSmall premText'><i class='material-icons'>grade</i> Increased Object Limit in Customs</div><div class='settNameSmall premText'><i class='material-icons'>grade</i> Increased Max KR per Round to 40</div><div class='settNameSmall premText'><i class='material-icons'>grade</i> Increased Market Sale Limit to 40</div><div class='settNameSmall premText'><i class='material-icons'>grade</i> Bigger Thumbnails for Maps</div><div class='settNameSmall premText'><i class='material-icons'>grade</i> Increased Trade Limit to 10 items</div><div class='settNameSmall premText'><i class='material-icons'>grade</i> Increased Asset File Size</div><div class='settNameSmall premText'><i class='material-icons'>grade</i> Increased Asset Upload Limit</div></div>";
    },
  },
  {
    header: i18n.t("windows.trade.header"),
    trades: [[], []],
    trader: null,
    inv: null,
    otherInv: null,
    gen: function () {
      var hj = Game.players.findBySid(this.trader);
      if (!hj) {
        return "Error";
      }
      this.trades = [[], []];
      var hk = [];
      var hl = "";
      tradeChatHolder.style.display = "inline-block";
      tradeChatList.innerHTML = "";
      for (
        var hm = UTILS.sortItems(this.inv, Game.store.skins),
          ho =
            "<div class='tHolderL'><div class='tListN inv'>Your Inventory</div><div id='invList0' class='tList' style='height: 225px;'>",
          hp = 0;
        hp < hm.length;
        hp++
      ) {
        if (
          (serverSetting = Game.store.skins[hm[hp].i]) &&
          hm[hp].c &&
          !serverSetting.blocked &&
          !serverSetting.noSale
        ) {
          ho +=
            "<div id='trd_inv_" +
            hm[hp].i +
            "' class='tItemHolder' onclick='windows[36].add(" +
            hm[hp].i +
            ")' style='border: 2px solid " +
            Game.store.rarities[serverSetting.rarity].color +
            ";' oncontextmenu='openSales(" +
            hm[hp].i +
            ")'>" +
            (serverSetting.type && serverSetting.type == 4
              ? "<div class='tItemSprayImg' style='background: url(&quot;" +
                UTILS.getPreview(serverSetting, Game.store) +
                "&quot;);" +
                UTILS.getFrameAnim(serverSetting, "sprayAnm") +
                "'></div>"
              : "<img draggable='false' class='tItemImg' loading='lazy' src='" +
                UTILS.getPreview(serverSetting, Game.store) +
                "'>") +
            "<div class='tItemN'>" +
            serverSetting.name +
            "</div><div class='tItemCnt'>x" +
            hm[hp].c +
            "</div></div>";
          if (
            serverSetting.type &&
            serverSetting.type == 4 &&
            serverSetting.frames &&
            hk.indexOf(serverSetting.frames) == -1
          ) {
            hk.push(serverSetting.frames);
          }
        }
      }
      ho += "</div></div>";
      var hq = UTILS.sortItems(this.otherInv, Game.store.skins);
      ho +=
        "<div class='tHolderR'><div class='tListN inv'>" +
        hj.alias +
        "'s Inventory</div><div id='invList1' class='tList' style='height: 225px;'>";
      for (hp = 0; hp < hq.length; hp++) {
        if (
          (serverSetting = Game.store.skins[hq[hp].i]) &&
          hq[hp].c &&
          !serverSetting.blocked &&
          !serverSetting.noSale
        ) {
          ho +=
            "<div class='tItemHolder' style='border: 2px solid " +
            Game.store.rarities[serverSetting.rarity].color +
            ";' oncontextmenu='openSales(" +
            hq[hp].i +
            ")'>" +
            (serverSetting.type && serverSetting.type == 4
              ? "<div class='tItemSprayImg' style='background: url(&quot;" +
                UTILS.getPreview(serverSetting, Game.store) +
                "&quot;);" +
                UTILS.getFrameAnim(serverSetting, "sprayAnm") +
                "'></div>"
              : "<img draggable='false' class='tItemImg' loading='lazy' src='" +
                UTILS.getPreview(serverSetting, Game.store) +
                "'>") +
            "<div class='tItemN'>" +
            serverSetting.name +
            "</div><div class='tItemCnt'>x" +
            hq[hp].c +
            "</div></div>";
          if (
            serverSetting.type &&
            serverSetting.type == 4 &&
            serverSetting.frames &&
            hk.indexOf(serverSetting.frames) == -1
          ) {
            hk.push(serverSetting.frames);
          }
        }
      }
      ho += "</div></div>";
      ho +=
        "<div class='tHolderL'><div id='tHeader0' class='tListN trade'>You <span id='tradeTotal0' class='tTotal'>0/" +
        (acc.premiumT ? config.tradeMaxOutP : config.tradeMaxOut) +
        "</span><span id='tradeReady0' class='tReady'></span></div><div id='tradeList0' class='tList' style='height:125px;margin-bottom: 5px;'></div><div class='estOfferVal' id='offerVal0'>Est. Value <span style='color: rgba(0,0,0,0.7);'>0</span> KR</div></div>";
      ho +=
        "<div class='tHolderR'><div id='tHeader1' class='tListN trade'>" +
        hj.alias +
        " <span id='tradeTotal1' class='tTotal'>0/" +
        (hj.premiumT ? config.tradeMaxOutP : config.tradeMaxOut) +
        "</span><span id='tradeReady1' class='tReady'></span></div><div id='tradeList1' class='tList' style='height:125px;margin-bottom: 5px;'></div><div class='estOfferVal' id='offerVal1'>Est. Value <span style='color: rgba(0,0,0,0.7);'>0</span> KR</div></div>";
      ho +=
        "<label class='tSubHolder' onmouseenter='playTick()'><span id='tSubName'>Accept Offer - 10 KR</span><input id='tSubOffer' type='checkbox' onclick='windows[36].accept()'><div class='tSubCheck'></div></label>";
      ho +=
        "<label class='tSubHolder' onmouseenter='playTick()'><span id='tDecName'>Decline Offer</span><input id='tDecOffer' type='checkbox' onclick='windows[36].decline()'><div class='tDecCheck'></div></label>";
      if (hk.length) {
        hl += "<style>";
        for (hp = 0; hp < hk.length; hp++) {
          hl +=
            "@keyframes sprayAnm" +
            hk[hp] +
            " {100%{background-position:-" +
            hk[hp] * 60 +
            "px}}";
        }
        hl += "</style>";
      }
      return hl + ho;
    },
    add: function (hj) {
      if (this.active) {
        io.send("utrd", hj, 1);
      }
    },
    addItem: function (hj, hk) {
      var hl = hk == player.id ? 0 : 1;
      var hm = Game.store.skins[hj];
      if (this.trades[hl][hj]) {
        this.trades[hl][hj].c++;
      } else {
        this.trades[hl][hj] = {
          i: hj,
          c: 1,
        };
      }
      var ho = document.getElementById("trd_" + hl + "_" + hj);
      serverSetting = this.trades[hl][hj];
      if (ho) {
        ho.children[2].innerHTML = "x" + serverSetting.c;
      } else {
        document
          .getElementById("tradeList" + hl)
          .insertAdjacentHTML(
            "beforeend",
            "<div id='trd_" +
              hl +
              "_" +
              hj +
              "' class='tItemHolder' oncontextmenu='openSales(" +
              hj +
              ")' " +
              (hl ? "" : "onclick='windows[36].remove(" + hj + ")' ") +
              "style='border: 2px solid " +
              Game.store.rarities[hm.rarity].color +
              ";'>" +
              (hm.type && hm.type == 4
                ? "<div class='tItemSprayImg' style='background: url(&quot;" +
                  UTILS.getPreview(hm, Game.store) +
                  "&quot;);" +
                  UTILS.getFrameAnim(hm, "sprayAnm") +
                  "'></div>"
                : "<img draggable='false' class='tItemImg' loading='lazy' src='" +
                  UTILS.getPreview(hm, Game.store) +
                  "'>") +
              "<div class='tItemN'>" +
              hm.name +
              "</div><div class='tItemCnt'>x" +
              serverSetting.c +
              "</div></div>",
          );
      }
      if (!hl) {
        ho = document.getElementById("trd_inv_" + hj);
        var hp = this.inv.find((hu) => hu.i == hj);
        if (ho && hp) {
          ho.children[2].textContent = "x" + (hp.c - serverSetting.c);
        }
      }
      document.getElementById("tradeTotal" + hl).textContent = document
        .getElementById("tradeTotal" + hl)
        .textContent.replace(
          /\d{1,2}\//g,
          this.trades[hl].reduce((hu, hv) => hu + hv.c, 0) + "/",
        );
      var hq = this.trades[hl].reduce(
        (hu, hv) => hu + Math.round(prices.estimateValue(hv.i) * hv.c),
        0,
      );
      document.getElementById("offerVal" + hl).children[0].innerHTML =
        UTILS.commaNumber(hq);
    },
    remove: function (hj) {
      if (this.active) {
        io.send("utrd", hj, 0);
      }
    },
    removeItem: function (hj, hk) {
      var hl = hk == player.id ? 0 : 1;
      if (this.trades[hl][hj]) {
        this.trades[hl][hj].c--;
        var hm = document.getElementById("trd_" + hl + "_" + hj);
        if (this.trades[hl][hj].c <= 0) {
          delete this.trades[hl][hj];
          if (hm) {
            hm.remove();
          }
        } else {
          hm.children[2].innerHTML = "x" + this.trades[hl][hj].c;
        }
        if (!hl) {
          hm = document.getElementById("trd_inv_" + hj);
          var ho = this.inv.find((hu) => hu.i == hj);
          var hp = this.trades[hl][hj] ? this.trades[hl][hj].c : 0;
          if (hm && ho) {
            hm.children[2].textContent = "x" + (ho.c - hp);
          }
        }
        document.getElementById("tradeTotal" + hl).textContent = document
          .getElementById("tradeTotal" + hl)
          .textContent.replace(
            /\d{1,2}\//g,
            this.trades[hl].reduce((hu, hv) => hu + hv.c, 0) + "/",
          );
        var hq = this.trades[hl].reduce(
          (hu, hv) => hu + Math.round(prices.estimateValue(hv.i) * hv.c),
          0,
        );
        document.getElementById("offerVal" + hl).children[0].innerHTML =
          UTILS.commaNumber(hq);
      }
    },
    cancel: function () {
      if (this.active) {
        io.send("ctrd");
      }
    },
    canceled: function () {
      this.active = false;
      showWindow(0);
      tradeChatHolder.style.display = "none";
    },
    accept: function () {
      if (this.active && !tSubOffer.disabled) {
        io.send("atrd");
      }
    },
    accepted: function (hj) {
      if ((hj == player.sid ? 0 : 1) == 0) {
        tSubOffer.disabled = true;
        tSubOffer.checked = true;
        tHeader0.style.backgroundColor = "#5ce05a";
        tradeReady0.textContent = "READY";
      } else {
        tHeader1.style.backgroundColor = "#5ce05a";
        tradeReady1.textContent = "READY";
      }
    },
    decline: function () {
      if (this.active) {
        io.send("dtrd");
      }
    },
    process: function (hj) {
      tSubName.textContent = "Loading " + hj;
    },
    done: function () {
      showWindow(0);
      addChat(null, "Trade Successful", 2, "#5ce05a");
      tradeChatHolder.style.display = "none";
    },
    failed: function (hj) {
      showWindow(0);
      addChat(null, hj, 2, "#ed4242");
    },
    updateButtons: function () {
      tSubOffer.disabled = false;
      tSubOffer.checked = false;
      tHeader0.style.backgroundColor = "#ed4242";
      tHeader1.style.backgroundColor = "#ed4242";
      tradeReady0.textContent = "";
      tradeReady1.textContent = "";
      tSubName.textContent = "Accept Offer - 10 KR";
    },
    close: function () {
      this.cancel();
    },
  },
  {
    header: i18n.t("windows.waist.header"),
    gen: function () {
      return getItemsList("selectWaist", 6);
    },
  },
  {
    header: i18n.t("windows.face.header"),
    gen: function () {
      return getItemsList("selectFace", 7);
    },
  },
];
window.linkTwitchPop = function () {
  resetPops();
  twitchPop.style.display = "block";
  twitchPop.innerHTML =
    "<div style='color:#fff;font-size:20px;position:relative;margin-bottom:15px;'>Are you sure you want to link a twitch account?</div><div id='confirmBtn' onclick='linkTwitch()' onmouseover='SOUND.play(&quot;tick_0&quot;,0.1)'>YES</div><div id='declineBtn' onclick='clearPops()' onmouseover='SOUND.play(&quot;tick_0&quot;,0.1)'>NO</div>";
};
window.linkTwitch = function () {
  if (acc) {
    window.open(
      "https://api.twitch.tv/kraken/oauth2/authorize?response_type=token&client_id=" +
        config.dropsClientId +
        "&scope=user_read+viewing_activity_read&redirect_uri=" +
        location.origin +
        "/twitch.html?auth",
      "_self",
    );
  }
};
window.unlinkTwitchPop = function () {
  resetPops();
  twitchPop.style.display = "block";
  twitchPop.innerHTML =
    "<div style='color:#fff;font-size:20px;position:relative;margin-bottom:15px;'>Are you sure you want to unlink your twitch account?</div><div id='confirmBtn' onclick='unlinkTwitch()' onmouseover='SOUND.play(&quot;tick_0&quot;,0.1)'>YES</div><div id='declineBtn' onclick='clearPops()' onmouseover='SOUND.play(&quot;tick_0&quot;,0.1)'>NO</div>";
};
window.unlinkTwitch = function () {
  if (acc && acc.twitch) {
    dP("Please Wait...");
    io.send("rtw");
  }
};
window.resetPops = function () {
  popupHolder.style.display = "block";
  popupContent.style.display = "none";
  popupContent.style.backgroundColor = "rgba(0, 0, 0, 0.75)";
  confPremiumPop.style.display = "none";
  confPop.style.display = "none";
  gameCodePop.style.display = "none";
  tradePop.style.display = "none";
  twitchPop.style.display = "none";
  pfpPop.style.display = "none";
  dropsPop.style.display = "none";
  hidePolicePop();
};
window.clearPops = function () {
  popupHolder.style.display = "none";
  confPremiumPop.style.display = "none";
  confPop.style.display = "none";
  gameCodePop.style.display = "none";
  tradePop.style.display = "none";
  twitchPop.style.display = "none";
  pfpPop.style.display = "none";
  dropsPop.style.display = "none";
  hidePolicePop();
};
window.contPopup = function (hj) {
  resetPops();
  popupContent.style.display = "block";
  popupContent.style.width = "700px";
  popupContent.innerHTML = hj;
};
window.confDelClan = function (hj) {
  resetPops();
  confPop.style.display = "block";
  var hk =
    "<div style='color:#fff;font-size:20px;position:relative;margin-bottom:15px;'>Are you sure you want to " +
    (hj ? "delete" : "leave") +
    " the clan?</div><div id='confirmBtn' onclick='delClanConfirmed()' onmouseover='SOUND.play(&quot;tick_0&quot;,0.1)'>YES</div><div id='declineBtn' onclick='clearPops()' onmouseover='SOUND.play(&quot;tick_0&quot;,0.1)'>NO</div>";
  confPop.innerHTML = hk;
};
window.delClanConfirmed = function () {
  dP("Please Wait...");
  io.send("cln", 4, 1);
};
window.confKickClan = function (hj, hk) {
  resetPops();
  confPop.style.display = "block";
  confPop.innerHTML =
    "<div style='color:#fff;font-size:20px;position:relative;margin-bottom:15px;'>Are you sure you want kick " +
    hj +
    " from the clan?</div><div id='confirmBtn' onclick='kickClanConfirmed(" +
    hk +
    ")' onmouseover='SOUND.play(&quot;tick_0&quot;,0.1)'>YES</div><div id='declineBtn' onclick='clearPops()' onmouseover='SOUND.play(&quot;tick_0&quot;,0.1)'>NO</div>";
};
window.kickClanConfirmed = function (hj) {
  clearPops();
  windows[12].kick(hj);
};
var policeIdleLines = [
  "I'm here to spin KR and bust hackers...and I'm all out of KR",
  "A fine day for Hacker Hunting",
  "What's a cops favourite food? I DONUT know...",
  "A really good Detective never gets married",
  "I love this song...",
];
var policeIntroLines = [
  "You look Strong. Why don't you join us?",
  "Sign In to Join the Fight against the Hackers!",
  "Your Level isn't High enough to Join us. Call Us if you find a Hacker!",
  "Welcome Back Officer. Let's see who needs our help today...",
];
window.hidePolicePop = function () {
  if (policePop.style.display == "block") {
    dJ();
    SOUND.stop("ambient_9");
  }
  policePop.style.display = "none";
};
window.shoPolicePop = function () {
  resetPops();
  policePop.style.display = "block";
  var hj = 0;
  if (acc) {
    if (acc.level < config.minKDFLvl) {
      hj = 2;
    } else if (acc.isMod) {
      hj = 3;
    }
  } else {
    hj = 1;
  }
  dI = {
    name: "Officer Buddy",
    class: 5,
    back: 1487,
    hat: 1890,
    dye: 1891,
    face: 1842,
  };
  dJ();
  SOUND.play("ambient_9", 0.14, true);
  policeSpeechTimer = UTILS.randInt(15000, 30000);
  showSpeechBubble(policeIntroLines[hj], 3400, true);
  var hk = "";
  if (hj == 3) {
    hk =
      "<div style='margin-top:15px;color:rgba(0,0,0,0.6)'>When responding to a <b>Distress Call</b>, please remember to follow the <a href='./docs/kpd.txt' class='menuLink' style='font-size:15px'>Mod Rules</a></div><div id='kpdCalls' style='margin-top:20px;background-color:rgba(0,0,0,0.2);padding:10px;margin-bottom:10px;max-height:400px;overflow-y:scroll;overflow-x:hidden'>Loading...</div>";
    io.send("kpd", 1);
  } else {
    var hl = 0;
    if (acc) {
      hl = (acc.jobRatingPos || 1) / (acc.jobRating || 1);
    }
    var hm = "#63de26";
    if (hl <= 0.7) {
      hm = "#f7d31e";
    }
    if (hl <= 0.5) {
      hm = "#fc3232";
    }
    hk =
      "<div style='color:rgba(0,0,0,0.6);font-size:19px'>The <b>K.P.D</b> allows you to <b>Combat & Report Hackers</b> in an easier way. <div style='height:15px'></div>If you suspect that there is a Hacker in your Current Lobby you can <b>Call for Aid by pressing the K.P.D Icon on the player list</b>. <div style='height:15px'></div>Any Active <b>Moderators</b> will then be able to respond to your call from a list of Active Distress calls & Deal with the Hacker accordingly.</div><div style='height:15px'></div>" +
      (acc
        ? "<div id='trustProg'><div id='trustProgHD'>" +
          (acc.jobRatingPos || 0) +
          "/" +
          (acc.jobRating || 0) +
          " Helpful Reports</div><div id='trustPrgHD' style='width:" +
          hl * 100 +
          "%;background-color:" +
          hm +
          "'></div></div>"
        : "") +
      "<input class='polApplc' type='text' placeholder='Your Discord ID (USER#0000)'></input><input class='polApplc' type='text' placeholder='Why would you be a good Fit?'></input><div class='button buttonD' id='activateKDM'>Accepting Applications Soon</div>";
  }
  var ho =
    "<div style='font-size:30px;margin-bottom:20px'>Krunker Police Department</div>" +
    hk;
  policePopC.innerHTML = ho;
};
var isPoliceCallActive = false;
window.confirmPolice = function (suspectAlias, suspectId) {
  if (!isPoliceCallActive) {
    resetPops();
    confPop.style.display = "block";
    confPop.innerHTML =
      "<div id='polConfPop'><div style='color:rgba(0,0,0,0.6);font-size:20px;margin-bottom:15px;'>Only call the <b>K.P.D</b> if you strongly suspect <b>" +
      suspectAlias +
      "</b> of using Hacks. <div style='height:10px'></div>False Reports can result in a Ban or Loss of Perms.</div><div id='confirmBtn' style='width:142px;margin-right:5px' onclick='callPolice(`" +
      suspectAlias +
      "`,`" +
      suspectId +
      "`)'>Call<span class='material-icons' style='color:#fff;margin-left:10px;font-size:28px;vertical-align:bottom;margin-bottom:1px'>call</span></div><div id='declineBtn' style='width:142px;margin-left:3px' onclick='clearPops()'>Cancel</div></div>";
  }
};
window.callPolice = function (suspectAlias, suspectId) {
  if (!isPoliceCallActive) {
    clearPops();
    isPoliceCallActive = true;
    isPoliceCallReported = false;
    phoneFlashTimer = 0;
    SOUND.play("dial_0", 0.2);
    phoneRingTimer = 700;
    SOUND.play("whoosh_0", 0.1);
    addChat(null, "Calling K.P.D ...", 2);
    phoneImg.style.marginBottom = "0px";
    io.send("kpd", 0, {
      id: suspectId,
    });
  }
};
window.policeJoin = function (gameId, token, host, port) {
  SOUND.play("siren_1", 0.1);
  saveVal("queuePort", port);
  saveVal("queueHost", host);
  saveVal("bpt", token);
  saveVal("gId", gameId);
  window.switchServer(gameId);
};
window.policeRes = function (responseType, message, data) {
  data = data || {};
  if (responseType == 0) {
    isPoliceCallActive = false;
    SOUND.stop("ring_0");
    if (message == "reported") {
      SOUND.play("siren_1", 0.1);
      message = "Reported " + data.n + " to the K.P.D";
      isPoliceCallReported = true;
      setTimeout(function () {
        phoneImg.style.marginBottom = "-700px";
        SOUND.play("whoosh_0", 0.1);
      }, 2200);
    } else {
      SOUND.play("busy_0", 0.1);
      phoneImg.style.marginBottom = "-700px";
      SOUND.play("whoosh_0", 0.1);
    }
    addChat(null, message, 2);
  }
  if (responseType == 1) {
    var callsElement = document.getElementById("kpdCalls");
    if (callsElement) {
      var callsHtml = data.length ? "" : "No Active Distress Calls";
      data = data.sort(function (leftCall, rightCall) {
        return (rightCall.typ || 0) - (leftCall.typ || 0);
      });
      for (var callIndex = 0; callIndex < data.length; ++callIndex) {
        var suspectRank = Math.max(
          1,
          Math.floor(config.rankVar * Math.sqrt(data[callIndex].cos || 0)),
        );
        var callerRank = Math.max(
          1,
          Math.floor(config.rankVar * Math.sqrt(data[callIndex].crs || 0)),
        );
        var trustRatio = (data[callIndex].jop || 1) / (data[callIndex].jor || 1);
        var trustColor = "#63de26";
        if (trustRatio <= 0.7) {
          trustColor = "#f7d31e";
        }
        if (trustRatio <= 0.5) {
          trustColor = "#fc3232";
        }
        callsHtml +=
          "<div style='width:97%;color:rgba(0,0,0,0.6);text-align:left;padding:10px;border-bottom: 2px solid rgba(0,0,0,0.2);'>" +
          (data[callIndex].typ
            ? "<span class='kpdRepLvl' style='color:#FBC02D'>RANKED</span>"
            : "") +
          "<span class='kpdRepLvl' style='color:" +
          trustColor +
          "'>" +
          (data[callIndex].jop || 0) +
          "/" +
          (data[callIndex].jor || 0) +
          "</span><span class='kpdRepLvl'>" +
          callerRank +
          "</span><a  href='/social.html?p=profile&q=" +
          data[callIndex].can +
          "' class='menuLink' style='font-size:16px;margin-right:4px'>" +
          data[callIndex].can +
          "</a> reported <span class='kpdRepLvl' style='margin-left:6px'>" +
          suspectRank +
          "</span><a  href='/social.html?p=profile&q=" +
          data[callIndex].con +
          "'class='menuLink' style='font-size:16px'>" +
          data[callIndex].con +
          "</a> <span style='float:right'><span style='color:rgba(0,0,0,0.3);margin-right:12px'>" +
          UTILS.getReadableTime(data[callIndex].tim) +
          " ago</span><span class='policeJoinB' onclick='policeJoin(`" +
          data[callIndex].gco +
          "`,`" +
          data[callIndex].tok +
          "`,`" +
          data[callIndex].hos +
          "`,`" +
          data[callIndex].por +
          "`)'>Join Game</span></span></div>";
      }
      callsElement.innerHTML = callsHtml;
    }
  }
};
var isPoliceCallReported = false;
var policeSpeechTimer = 0;
var phoneFlashTimer = 0;
var phoneFlashFrame = 0;
var phoneRingTimer = 0;
function tradeUpdate(message, payload, action, inventories) {
  if (action == 0) {
    (function (playerSid) {
      var tradePlayer = Game.players.findBySid(playerSid);
      if (tradePlayer) {
        addChat(tradePlayer.alias, playerSid, 3);
      }
    })(payload);
  } else if (action == 1) {
    document.exitPointerLock();
    windows[36].trader = payload;
    windows[36].active = true;
    windows[36].inv = inventories[0];
    windows[36].otherInv = inventories[1];
    showWindow(37);
  } else if (action == 2) {
    windows[36].canceled();
  } else if (action == 3) {
    windows[36].accepted(payload);
  } else if (action == 4) {
    windows[36].process(payload);
  } else if (action == 5) {
    windows[36].updateButtons();
  }
  if (message) {
    addChat(null, message, 2);
  }
}
function acceptTradeResponse(error, funds) {
  windows[36].active = false;
  windows[36].trader = null;
  if (error) {
    windows[36].failed(error);
  } else {
    updateFunds(funds);
    windows[36].done();
  }
}
function updateTradeItem(playerId, isAdding, itemId, count) {
  if (isAdding) {
    windows[36].addItem(itemId, playerId, count);
  } else {
    windows[36].removeItem(itemId, playerId, count);
  }
  windows[36].updateButtons();
}
function renderRequirement(level, text, requiresLogin) {
  return (
    "<div class='reqW" +
    (requiresLogin ? " login" : "") +
    "'" +
    (requiresLogin ? " onclick='showWindow(5)'" : "") +
    "><i class='material-icons reqWIcon'>clear</i><div class='reqWLvl'>" +
    (requiresLogin ? "LOGIN REQUIRED" : "LEVEL " + level + " REQUIRED") +
    "</div><div class='reqWTxt'>" +
    text +
    "</div></div>"
  );
}
function stopEvent(event) {
  event.stopPropagation();
  event.cancelBubble = true;
}
function getCardsList(data, typeKey, filterType) {
  var html = "";
  var clickFunc = typeKey == "map" ? "selectHostMap" : "loadUserMod";
  for (var index = 0; index < data.length; ++index) {
    if (data[index].dte) {
      data[index][typeKey + "_date"] = data[index].dte;
    }
    if (data[index].mna) {
      data[index][typeKey + "_name"] = data[index].mna;
    }
    if (data[index].mid != null) {
      data[index][typeKey + "_id"] = data[index].mid;
    }
    if (data[index].inf != null) {
      data[index][typeKey + "_info"] = data[index].inf;
    }
    if (data[index].minf != null) {
      data[index][typeKey + "_info"] = data[index].minf;
    }
    if (data[index].pli != null) {
      data[index][typeKey + "_player"] = data[index].pli;
    }
    if (data[index].ctn) {
      data[index].creatorname = data[index].ctn;
    }
    if (data[index].url) {
      data[index][typeKey + "_url"] = data[index].url;
    }
    if (data[index].vte != null) {
      data[index][typeKey + "_votes"] = data[index].vte;
    }
    if (data[index].upd != null) {
      data[index][typeKey + "_updatecounter"] = data[index].upd;
    }
    var ageDays = -1;
    if (data[index] && data[index][typeKey + "_date"]) {
      var ageMs = 0;
      var createdDate = new Date(data[index][typeKey + "_date"]);
      if (createdDate) {
        ageMs = frameTimeMs - (createdDate.getTime() || 0);
      }
      ageDays = ageMs / 86400000;
    }
    var info = {};
    try {
      info = JSON.parse(data[index][typeKey + "_info"]);
    } catch (parseError) {}
    if (
      filterType == null ||
      !(config.buM9.indexOf(data[index].creatorname.toLowerCase()) > -1)
    ) {
      var isFavorite = data[index].fav || filterType == 3;
      if (typeKey == "mod" && data[index].mod_url == "ua") {
        data[index].mod_url =
          "https://user-assets.krunker.io/md" + data[index].mod_id + "/mod.zip";
      }
      html +=
        "<div class='mapListItem'>" +
        (ageDays >= 0 && ageDays <= 7
          ? "<div class='mapAgeD' style='background-color:" +
            (data[index][typeKey + "_updatecounter"] > 1 ? "#5699EB" : "#E040FB") +
            "'>" +
            (data[index][typeKey + "_updatecounter"] > 1 ? "UPDATED" : "NEW") +
            "</div>"
          : "") +
        "<div class='mapInfoB' onclick='openURL(&quot;/social.html?p=" +
        typeKey +
        "&q=" +
        data[index][typeKey + "_name"] +
        "&quot;);'>?</div>" +
        (typeKey == "map"
          ? "<span class='material-icons searchIcon' onclick='playMap(&quot;" +
            data[index][typeKey + "_name"] +
            "&quot;);'>play_arrow</span>"
          : "") +
        "<div class='creationActions'>" +
        (acc && acc.canDeleteCreations
          ? "<span class='material-icons creationAction del' onclick='deleteCreationConf(" +
            data[index][typeKey + "_id"] +
            "," +
            (typeKey == "map" ? 0 : 1) +
            ");'>delete_forever</span>"
          : "") +
        (acc && acc.canFeatureCreations
          ? "<span class='material-icons creationAction" +
            (data[index][typeKey + "_featured"] ? " sel" : "") +
            "' onclick='featureCreation(this, " +
            data[index][typeKey + "_id"] +
            "," +
            (typeKey == "map" ? 0 : 1) +
            ");'>check_circle</span>"
          : "") +
        "<span class='material-icons creationAction" +
        (isFavorite ? " sel" : "") +
        "' onclick='favoriteM(" +
        (typeKey == "map" ? 0 : 1) +
        ", this, " +
        data[index][typeKey + "_id"] +
        ");'>grade</span></div><div style='height:100px;width:220px;overflow: hidden;'><img class='mapListThumb' loading='lazy' src='" +
        (info && info.t
          ? "https://user-assets.krunker.io/m" +
            (typeKey == "mod" ? "d" + data[index].mod_id : data[index][typeKey + "_id"]) +
            "/thumb.png?v=" +
            (data[index][typeKey + "_updatecounter"] || 0)
          : data[index][typeKey + "_image"] || "./img/noimg.png") +
        "' onclick='" +
        clickFunc +
        "(&quot;" +
        data[index][typeKey + "_name"] +
        "&quot;,&quot;" +
        data[index].mod_url +
        "&quot;,&quot;" +
        data[index][typeKey + "_id"] +
        "&quot;,&quot;" +
        UTILS.cleanseString(data[index].creatorname) +
        "&quot;)'/></div><div style='margin-top:1px'><a href='javascript:;' onclick='" +
        clickFunc +
        "(&quot;" +
        data[index][typeKey + "_name"] +
        "&quot;,&quot;" +
        data[index].mod_url +
        "&quot;,&quot;" +
        data[index][typeKey + "_id"] +
        "&quot;,&quot;" +
        UTILS.cleanseString(data[index].creatorname) +
        "&quot;)'/>" +
        data[index][typeKey + "_name"] +
        "</a></div><div style='display: flex'><span style='color:rgba(0,0,0,0.2);font-size:15px'> by <a target='_blank' class='grey' href='/social.html?p=profile&q=" +
        UTILS.cleanseString(data[index].creatorname) +
        "'>" +
        data[index].creatorname +
        "</a></span><div style='font-size:15px;text-align:right;flex-grow:1'>" +
        data[index][typeKey + "_votes"] +
        "</div></div></div>";
    }
  }
  return html;
}
function getItemsList(funcName, type) {
  var imageClass = type ? (type == 5 ? "skinImgD" : "skinImgC") : "skinImg";
  var html =
    "<div id='skinList'><div class='skinCard blackShad' style='border:5px solid lightgrey' onmouseenter='playTick()' onclick='" +
    funcName +
    "(-1)'>" +
    (type == 3 ? "Combat Knife" : i18n.t("generic.none")) +
    "<div class='itemOwn'>" +
    i18n.t("generic.default") +
    "</div>" +
    (type == 5 ? "" : "<div class='itemSea' style='opacity:0;'>Season 1</div>") +
    "<img class='" +
    imageClass +
    "' src='" +
    UTILS.assetsUrl("/textures/previews/cosmetics/" + type + "_default.png") +
    "'></div><div class='skinCard blackShad' style='border:5px solid lightgrey' onmouseenter='playTick()' onclick='" +
    funcName +
    "(-2)'>" +
    i18n.t("generic.random") +
    "<div class='itemOwn' style='opacity:0;'>by ???</div>" +
    (type == 5
      ? ""
      : "<div class='itemSea' style='opacity:0;'>All Seasons</div>") +
    "<img class='" +
    imageClass +
    " skinSil' src='" +
    UTILS.assetsUrl("/textures/previews/cosmetics/" + type + "_default.png") +
    "'><div class='skinRandom blackShad'>?</div></div>";
  if (acc || Game.singlePlayer) {
    for (
      var sortedItems = [
          ...(Game.singlePlayer
            ? Object.keys(Game.store.skins).map((skinId) => ({
                ind: parseInt(skinId),
                cnt: 1,
              }))
            : acc.skins),
        ].sort(function (leftItem, rightItem) {
          var rightRarity =
            rightItem.ind != null && Game.store.skins[rightItem.ind]
              ? Game.store.skins[rightItem.ind].rarity
              : 0;
          var leftRarity =
            leftItem.ind != null && Game.store.skins[leftItem.ind]
              ? Game.store.skins[leftItem.ind].rarity
              : 0;
          var rightSeason =
            rightItem.ind != null && Game.store.skins[rightItem.ind]
              ? Game.store.skins[rightItem.ind].seas || 1
              : 0;
          var leftSeason =
            leftItem.ind != null && Game.store.skins[leftItem.ind]
              ? Game.store.skins[leftItem.ind].seas || 1
              : 0;
          if (rightRarity > leftRarity) {
            return 1;
          } else if (rightRarity < leftRarity) {
            return -1;
          } else if (rightSeason > leftSeason) {
            return 1;
          } else if (rightSeason < leftSeason) {
            return -1;
          } else {
            return (rightItem.ind || 0) - (leftItem.ind || 0);
          }
        }),
        index = 0;
      index < sortedItems.length;
      ++index
    ) {
      if (
        (serverSetting = Game.store.skins[sortedItems[index].ind]) &&
        serverSetting.type == type
      ) {
        html +=
          "<div class='skinCard" +
          (serverSetting.rarity == 5 ? "" : " blackShad") +
          (RENDER.rarityAnim &&
          Game.store.rarities[serverSetting.rarity].animate
            ? " rainbow"
            : "") +
          "' style='color:" +
          Game.store.rarities[serverSetting.rarity].color +
          ";border:5px solid" +
          Game.store.rarities[serverSetting.rarity].color +
          "' onmouseenter='playTick()'onclick='" +
          funcName +
          "(" +
          sortedItems[index].ind +
          ")'><div class='itemCnt' data-badge='x" +
          sortedItems[index].cnt +
          "'></div>" +
          serverSetting.name +
          "<div class='itemOwn'>by " +
          (serverSetting.creator || "Krunker.io") +
          "</div>" +
          (type == 5
            ? ""
            : "<div class='itemSea'>Season " +
              (serverSetting.seas || 1) +
              "</div>") +
          "<img loading='lazy' class='" +
          imageClass +
          (serverSetting.rgb ? " rgbHue" : "") +
          "' src='" +
          UTILS.getPreview(serverSetting, Game.store) +
          "'/><div class='selctInfoBtn' onmouseenter='playTick()'onclick='openSales(" +
          sortedItems[index].ind +
          ")'>?</div></div>";
      }
    }
  }
  return (html += "</div>");
}
window.dropsPopup = function () {
  var eventStartDate = new Date("August 29, 2020 10:00 AM UTC");
  var eventEndDate = new Date("August 29, 2020 6:00 PM UTC");
  var msUntilStart = eventStartDate.getTime() - Date.now();
  var msUntilEnd = eventEndDate.getTime() - Date.now();
  if (!(msUntilEnd <= 0)) {
    resetPops();
    dropsPop.style.display = "block";
    var twitchWheel = Game.store.wheels.find((wheel) => wheel.twitch);
    for (
      var dropSkins = Game.store.skins
          .filter(
            (skin) =>
              skin && skin.limT && skin.limT == twitchWheel.limType && skin.rarity >= 2,
          )
          .sort(() => Math.random() - Math.random())
          .slice(0, 3),
        html =
          "<div class='dropsActive'>Live Charity Event!</div><div><a href='https://www.twitch.tv/heyimzed' target='_blank'>Watch</a> the stream to earn Unique Items & to Support Charity!</div><div style='margin-top:10px;'>",
        index = 0;
      index < dropSkins.length;
      ++index
    ) {
      html +=
        "<div class='dropCard" +
        ((serverSetting = dropSkins[index]).rarity == 5 ? "" : " blackShad") +
        (RENDER.rarityAnim && Game.store.rarities[serverSetting.rarity].animate
          ? " rainbow"
          : "") +
        "' style='color:" +
        Game.store.rarities[serverSetting.rarity].color +
        ";border:5px solid" +
        Game.store.rarities[serverSetting.rarity].color +
        "'>" +
        serverSetting.name +
        "<img draggable='false' class='dropImg" +
        (serverSetting.rgb ? " rgbHue" : "") +
        "' src='" +
        UTILS.getPreview(serverSetting, Game.store) +
        "'/></div>";
    }
    html +=
      "</div><div>Event " +
      (msUntilStart > 0 ? "starts" : "ends") +
      " in " +
      UTILS.getReadableTime(msUntilStart > 0 ? msUntilStart : msUntilEnd) +
      "</div>";
    dropsPop.innerHTML = "<div style='text-align:center'>" + html + "</div>";
    saveVal("dropPop", Date.now());
  }
};
window.pfpPopup = function () {
  if (!acc) {
    return popupResponse(null, "Must be logged in");
  }
  if (acc.premiumT <= 0) {
    return popupResponse(null, "Must have premium");
  }
  resetPops();
  pfpPop.style.display = "block";
  fileCosts = [];
  fileSizes = [];
  var html =
    "<div style='margin-top:-8px;font-size: 22px;margin-bottom:10px;'>Upload or Update Profile Pic</div>";
  html +=
    "<div style='color:rgba(0,0,0,0.4);font-size:18px' id='pfpH'><input onclick='selectFile(&quot;pfp&quot;)' type='button' id='pfpBtn' style='cursor:pointer' value='Select'><input id='pfp' name='profilepic' type='file' accept='image/png' style='width:1px;visibility:hidden;' onchange='updateFile(this.id)'><span style='color:rgba(0,0,0,0.4);margin-left:10px;font-size: 14px;' id='pfpName'>Image (.png) - Max " +
    config.maxPfp +
    "KB</span><span style='color:rgba(0,0,0,0.4);font-size: 14px;float:right;margin-top: 5px;' id='pfpSize'></span></div>";
  html +=
    "<div id='pfpResHolder' style='margin-top:8px;margin-bottom:5px;display:inline-block'><div id='pfpUpResp' style='color:rgba(0,0,0,0.3);display: inline-block;'>Inappropriate Images will result in a ban</div></div><div id='pubPfp' onclick='uploadProfilePic()'>Publish/Update</div>";
  pfpPop.innerHTML = html;
};
window.updateFile = function (inputId) {
  var file = null;
  try {
    file = document.getElementById(inputId).files[0];
  } catch (fileError) {}
  document.getElementById(inputId + "Name").innerHTML = file
    ? file.name
    : i18n.t("generic.failed");
  var fileSizeKb =
    (function (id) {
      return document.getElementById(id).files[0];
    })(inputId).size / 1000;
  document.getElementById(inputId + "Size").innerHTML =
    (fileSizeKb || 0) + " <span style='color:rgba(0,0,0,0.8);'>kb</span>";
};
window.selectFile = function (inputId) {
  document.getElementById(inputId).click();
};
window.uploadProfilePic = function () {
  uploadResponse("Loading...", 1);
  var file = null;
  try {
    file = document.getElementById("pfp").files[0];
  } catch (fileError) {}
  if (file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      if (UTILS.thumbnailSize(reader.result) > config.maxPfp) {
        uploadResponse(i18n.t("image.upload.limit", config.maxPfp), 1);
        return;
      } else {
        io.send("uploadP", reader.result);
        return;
      }
    };
    reader.onerror = function () {
      uploadResponse("Picture Error", 1);
    };
  } else {
    uploadResponse("Upload Error", 1);
  }
};
window.confPremium = function (premiumIndex) {
  resetPops();
  confPremiumPop.style.display = "block";
  var confirmHtml =
    "<div style='color:#fff;font-size:20px;position:relative;margin-bottom:15px;'>Are you sure you want to purchase " +
    Game.store.premium[premiumIndex].val +
    " days of Premium?</div><div id='confirmBtn' onclick='premiumConfirmed(" +
    premiumIndex +
    ")' onmouseover='SOUND.play(&quot;tick_0&quot;,0.1)'>YES</div><div id='declineBtn' onclick='clearPops()' onmouseover='SOUND.play(&quot;tick_0&quot;,0.1)'>NO</div>";
  confPremiumPop.innerHTML = confirmHtml;
};
window.premiumConfirmed = function (premiumIndex) {
  dP("Please Wait...");
  io.send("prm", premiumIndex);
};
Object.defineProperty(window, "buyPremium", {
  writeable: false,
  value: function (premiumIndex) {
    if (Game.store.premium[premiumIndex]) {
      CONTROLS.idleTimer = 0;
    }
    if (acc && acc.funds >= Game.store.premium[premiumIndex].price) {
      confPremium(premiumIndex);
    } else {
      popupResponse(null, "Not enough KR");
    }
  },
});
Object.defineProperty(window, "changeName", {
  writeable: false,
  value: function () {
    dP("Please Wait...");
    var displayNameInput = document.getElementById("displayN");
    if (acc && acc.premiumT && displayNameInput && displayNameInput.value.length) {
      io.send("nme", displayNameInput.value);
    } else {
      popupResponse(null, "Invalid name");
    }
  },
});
window.acceptRequest = function (playerSid) {
  io.send("trd", playerSid, 1);
};
window.openSales = function (itemId) {
  stopEvent(this.event);
  openURL("/social.html?p=itemsales&i=" + itemId);
};
window.openTwitch = function (channelName) {
  stopEvent(this.event);
  openURL("https://twitch.tv/" + channelName, "_blank");
};
window.quickJoinRegion = function (regionIndex) {
  let servers = windows[1].getServers(regionIndex);
  var attemptsLeft = 10;
  for (
    let index = 0;
    index < servers.length && (client.switchGame(servers[index]), !(--attemptsLeft <= 0));
    index++
  );
};
window.advertMapCreator = function () {
  var promptRoll = UTILS.randInt(1, 3);
  if (
    customMapSupportData.length &&
    !hasShownMapSupportPrompt &&
    promptRoll == 2 &&
    player
  ) {
    var supportHtml =
      "<div class='supportRate'>Do you enjoy this map?</div><div class='voteHint'>Rate</div><i id='mapSupVoteD' onclick='voteMapSupport(" +
      customMapSupportData[0] +
      ",-1)' class='material-icons vote'>thumb_down</i><i id='mapSupVoteU' onclick='voteMapSupport(" +
      customMapSupportData[0] +
      ",1)' class='material-icons vote'>thumb_up</i><div style='font-size: 17px;'>If you would like to support the creator of this map consider gifting them some KR.<div class='supportGift' onclick='openURL(&quot;/social.html?p=profile&q=" +
      customMapSupportData[1] +
      "&autoGift=1&quot;)'>GIFT KR</div>";
    supportMapCreator.innerHTML = supportHtml;
    supportMapCreator.style.display = "inline-block";
    hasShownMapSupportPrompt = true;
  }
};
Object.defineProperty(window, "creatorCodeAction", {
  writeable: false,
  value: function (enabled) {
    if (enabled) {
      var creatorCodeInput = document.getElementById("creatorCodeI");
      if (creatorCodeInput && creatorCodeInput.value.length) {
        saveVal(
          "krk_cc",
          JSON.stringify({
            code: creatorCodeInput.value,
            t: Date.now(),
          }),
        );
      }
    } else {
      deleteVal("krk_cc");
    }
    updateWindow(14);
  },
});
for (var windowIndex = 0; windowIndex < windows.length; ++windowIndex) {
  windows[windowIndex].html = "";
}
var activeMenuWindowId = 0;
function voucherRedeemResponse(funds, message) {
  if (funds == null || funds == null) {
    tmpEl = document.getElementById("vouchRes");
    if (tmpEl) {
      tmpEl.style.display = "block";
      tmpEl.innerHTML = message || "Failed to Redeem";
    }
  } else {
    updateFunds(funds);
    updateWindow(null, true);
  }
}
function readMailResponse(data) {
  windows[29].onReadData(data);
}
function updateMailCount(count) {
  windows[29].mailCount(count);
}
function mailListResponse(data, append) {
  windows[29].onData(data, append);
}
Object.defineProperty(window, "updateWindow", {
  writeable: false,
  value: function (windowId, forceRefresh) {
    if (windowHolder.style.display == "block") {
      if (activeMenuWindowId == windowId && windowId != null) {
        showWindow(windowId, true);
      } else if (forceRefresh) {
        showWindow(activeMenuWindowId, true);
      }
    }
  },
});
Object.defineProperty(window, "showWindow", {
  writeable: false,
  value: function (windowId, forceRefresh) {
    if (!!UTILS.isNumber(windowId) && !(windowId < 0)) {
      CONTROLS.idleTimer = 0;
      if (document.getElementById("myGUI") && !hasReportedInjectedUi) {
        io.send("ahl", 2);
        hasReportedInjectedUi = true;
      }
      if (document.getElementById("skidmenuHolder") && !hasReportedInjectedUi) {
        io.send("ahl", 3);
        hasReportedInjectedUi = true;
      }
      if (windows.length > 39) {
        windows.length = 39;
      }
      if (windows[21].header != "Social" && !hasReportedInjectedUi) {
        io.send("ahl");
        hasReportedInjectedUi = true;
      }
      if (windowId != 37 && Game && Game.mode && Game.mode.canTrade) {
        tradeChatHolder.style.display;
      }
      if (Game && Game.mode && Game.mode.canTrade && windowId != 37) {
        windows[36].cancel();
      }
      closeWindow();
      if (
        forceRefresh ||
        (windowId &&
          (windowHolder.style.display != "block" ||
            windowId != activeMenuWindowId))
      ) {
        windowId;
        UI.toggleMenu(true);
        menuWindow.innerHTML = windows[windowId - 1].gen
          ? windows[windowId - 1].gen()
          : windows[windowId - 1].html;
        activeMenuWindowId = windowId;
        windows[windowId - 1].closed = false;
        menuWindow.classList.toggle(
          "stickyHeader",
          !!windows[windowId - 1].sticky,
        );
        menuWindow.style.overflowY = windows[windowId - 1].hideScroll
          ? "hidden"
          : "auto";
        menuWindow.style.width = windows[windowId - 1].width
          ? windows[windowId - 1].width + "px"
          : "";
        windowHeader.innerHTML = windows[windowId - 1].header;
        UI.toggleWindow(true, CONTROLS.gamepad.active);
        if (windows[windowId - 1].post) {
          windows[windowId - 1].post();
        }
      } else {
        UI.toggleWindow(false, CONTROLS.gamepad.active);
        CONTROLS.inputChanger = null;
      }
    }
  },
});
Object.defineProperty(window, "closeWindow", {
  writeable: false,
  value: function () {
    null;
    if (
      activeMenuWindowId &&
      windows[activeMenuWindowId - 1].close &&
      !windows[activeMenuWindowId - 1].closed
    ) {
      windows[activeMenuWindowId - 1].closed = true;
      windows[activeMenuWindowId - 1].close();
    }
  },
});
window.copyToClip = function (text) {
  UTILS.copyToClipboard(text);
  alert("Link Copied!");
};
window.playTick = function () {
  SOUND.play("tick_0", 0.2);
};
window.copyInviteLink = function () {
  if (!Game.mode || !Game.mode.isRanked) {
    UTILS.copyToClipboard(
      location.protocol + "//" + location.host + "/?game=" + gameId,
    );
    inviteButton.textContent = i18n.t("menu.btn.invite.clicked");
    setTimeout(
      () => (inviteButton.textContent = i18n.t("menu.btn.invite")),
      1250,
    );
  }
};
Object.defineProperty(window, "punishPlayer", {
  writeable: false,
  value: function (playerId, action) {
    if (action > 5 || action == 2) {
      io.send("pnh", action, null);
    } else {
      for (var index = 0; index < Game.players.list.length; ++index) {
        if ((serverSetting = Game.players.list[index]).id == playerId) {
          io.send("pnh", action, serverSetting.id);
          break;
        }
      }
    }
  },
});
Object.defineProperty(window, "banPlayer", {
  writeable: false,
  value: function (playerName, playerId) {
    resetPops();
    confPop.style.display = "block";
    confPop.innerHTML =
      "<div style='color:#fff;font-size:20px;position:relative;margin-bottom:15px;'>Are you sure you want ban " +
      playerName +
      " from this game?</div><div id='confirmBtn' onclick='banPlayerConfirmed(\"" +
      playerId +
      "\")' onmouseover='SOUND.play(&quot;tick_0&quot;,0.1)'>YES</div><div id='declineBtn' onclick='clearPops()' onmouseover='SOUND.play(&quot;tick_0&quot;,0.1)'>NO</div>";
  },
});
window.banPlayerConfirmed = function (playerId) {
  clearPops();
  punishPlayer(playerId, 1);
};
window.crtrCodRes = function (message, dashboardData, extraData) {
  if (message) {
    if (message == "Success") {
      if (acc) {
        acc.partnerApp = 1;
      }
      updateWindow(28);
    } else {
      tmpEl = document.getElementById("ctrtRes");
      if (tmpEl) {
        tmpEl.innerHTML = message;
      }
    }
  } else {
    windows[27].getData(dashboardData, extraData);
  }
};
window.submitCrtrCod = function () {
  var emailInput = document.getElementById("crtrEmail");
  var codeInput = document.getElementById("crtrCode");
  if (emailInput.value && codeInput.value) {
    tmpEl = document.getElementById("ctrtRes");
    if (tmpEl) {
      tmpEl.innerHTML = "Loading...";
    }
    io.send("crtC", codeInput.value, emailInput.value);
  }
};
Object.defineProperty(window, "redeemVoucher", {
  writeable: false,
  value: function () {
    var voucherInput = document.getElementById("redVouch");
    if (voucherInput && voucherInput.value) {
      var voucherCode = voucherInput.value;
      if ((voucherInput = document.getElementById("vouchRes"))) {
        voucherInput.style.display = "block";
        voucherInput.innerHTML = "Loading...";
      }
      io.send("vo", voucherCode);
    }
  },
});
var spinnerScene;
var spinnerPreview;
var spinWheel;
var spinCanvas = spinWindow;
var spinCanvasContext = spinCanvas.getContext("2d");
var winItem = null;
var isSpinning = false;
var endAnimTarget = 0;
var spinWhlMlt = 0;
var spinVal = 0;
var spinIndex = 0;
var endAnimVal = 0;
var canSpin = true;
var canRespin = false;
var spinItemBobTime = 0;
var tickCounter = 0;
var spinTwitchToken = null;
var spinItemCamera = new THREE.PerspectiveCamera(45, 1, 0.1, 100);
var spinItemRenderer = new THREE.WebGLRenderer({
  precision: "mediump",
  antialias: false,
  alpha: true,
});
function unboxMessage(name, itemID, krAmount) {
  if (settings.tmp.showUnboxings) {
    var item;
    if (
      (item = krAmount
        ? {
            rarity: Game.store.freeKR[itemID].rarity,
            name: krAmount + " KR",
          }
        : Game.store.skins[itemID])
    ) {
      var hasRarityAnim = RENDER.rarityAnim && Game.store.rarities[item.rarity].animate;
      addChat(
        null,
        "<span style='color:#fff'>" +
          i18n.t(
            "windows.store.unboxed",
            UTILS.fixStr(
              streamerModeEnabled && Filter ? UTILS.scrambleS(name) : name,
            ),
            "</span>",
          ) +
          " <span class='click" +
          (hasRarityAnim ? " rainbowText" : "") +
          "' style='color:" +
          Game.store.rarities[item.rarity].color +
          "'" +
          (krAmount ? "" : " onclick='openSales(" + itemID + ")'") +
          ">[" +
          UTILS.fixStr(item.name) +
          "]</span>",
        spinUI.style.display == "block" ? 4 : 1,
      );
    }
  }
}
function showSpinError(message) {
  if (message == "Spin Error 9") {
    windows[13].purchase();
  } else {
    alert(message);
    if (spinUI.style.display == "block") {
      prizeWheel(spinIndex);
    }
  }
}
function spinResponse(error, randNum, itemID, funds, follow) {
  isSpinning = false;
  if (error) {
    showSpinError("Spin Error 3");
  } else {
    var ownedCount = 0;
    if (acc) {
      if (follow == config.followInd) {
        acc.followInd = follow;
      }
      acc.funds = funds;
      cK();
      spinKR.innerHTML =
        "<span style='color:rgba(255,255,255,0.6)'>" +
        UTILS.commaNumber(acc.funds) +
        "</span> KR";
      if (acc.skins.some((skinEntry) => skinEntry.ind === itemID)) {
        var ownedSkin = acc.skins.find((skinEntry) => skinEntry.ind === itemID);
        if (ownedSkin) {
          ownedSkin.cnt++;
          ownedCount = ownedSkin.cnt;
        }
      } else {
        acc.skins.push({
          ind: itemID,
          cnt: 1,
        });
        ownedCount = 1;
      }
      if (spinWheel && spinWheel.twitch) {
        io.send("gtd");
      }
    }
    winItem = Game.store.skins[itemID];
    spinItemName.innerHTML =
      winItem.name +
      "<div style='color:rgba(255,255,255,0.5)'>by " +
      (winItem.creator || "Krunker.io") +
      "</div><div style='color:rgba(255,255,255,0.5)'>" +
      (ownedCount > 1
        ? "<span style='color:#fff'>x" + ownedCount + "</span> Owned"
        : "<span style='color:#fff'>NEW</span>") +
      "</div>";
    spinVal = Math.PI * 2 * (randNum / 100 + 13) + Math.PI / 2;
    spinCost.innerHTML = "";
    spinRotation = 0;
    spinItemBobTime = 0;
    (spinnerScene = new THREE.Scene()).add(new THREE.AmbientLight(5197647));
    var light = new THREE.DirectionalLight(16777215, 0.5);
    light.position.set(3, 1, 0);
    spinnerScene.add(light);
    var previewConfig = winItem.type ? winItem : Game.store.previews[winItem.weapon] || {};
    (spinnerPreview = RENDER.genObj3D(
      0,
      1 + (previewConfig.yOff || 0),
      previewConfig.xOff || 0,
    )).rotateX(winItem.type && winItem.type == 5 ? -Math.PI / 11 : -Math.PI / 7);
    spinnerPreview.rotateY(Math.PI + 0.5 + (previewConfig.zRota || 0));
    spinnerPreview.rotateZ(-0.5);
    spinnerPreview.orgXR = spinnerPreview.rotation.x;
    spinnerPreview.orgYP = spinnerPreview.position.y;
    if (winItem.type && winItem.type == 5) {
      (serverSetting = new Player(
        -1,
        this,
        UTILS,
        COLORS,
        config,
        Game,
        true,
      )).sid = -1;
      serverSetting.init(0.5, 0, -7, "preview", false);
      serverSetting.skins = [-1, -1];
      serverSetting.dyeIndex = parseInt(itemID);
      serverSetting.setClass(Game, 9, 2, true);
      Game.players.reload(serverSetting, 0, true);
      Game.players.generateMeshes(serverSetting, false, true);
      let previewPlayer = serverSetting;
      spinnerPreview.add(previewPlayer.objInstances);
      serverSetting.swapTime = 0;
      serverSetting.weaponMeshes[0].visible = true;
      serverSetting.weaponGeos[0].visible = false;
      Game.players.updateMsh(serverSetting, true);
    } else if (winItem.type && winItem.type == 4) {
      (serverSetting = new THREE.Mesh(new THREE.PlaneGeometry(1, 1))).scale.set(
        9,
        7.2,
        1,
      );
      serverSetting.material = RENDER.getMat("sprays/" + (winItem.id || 0), {
        local: winItem.local,
        depthWrite: false,
        transparent: true,
        frames: winItem.frames,
        frameT: winItem.frameT,
        centerZ: true,
      });
      spinnerPreview.add(serverSetting);
      serverSetting.rotation.y = Math.PI * 1.1;
    } else {
      RENDER.loadMesh(
        {
          local: winItem.local,
          localM: winItem.localM,
          src:
            Game.store.types[winItem.type || 0] +
            (winItem.type ? winItem.id : winItem.weapon) +
            (winItem.mid == null ? "" : "_" + winItem.mid),
          texSrc:
            winItem.mid == null
              ? winItem.type && winItem.type == 3
                ? winItem.pat
                  ? winItem.tex
                  : "melee/melee_" + (winItem.id || 0) + (winItem.tex ? "_" + winItem.tex : "")
                : winItem.type
                  ? winItem.tex
                    ? Game.store.types[winItem.type || 0] + winItem.id + "_" + winItem.tex
                    : null
                  : winItem.tex
                    ? winItem.tex
                    : "weapons/skins/weapon_" + winItem.weapon + "_" + winItem.id
              : UTILS.getReModel(Game.store, winItem),
          movT: winItem.movT,
          pulsT: winItem.pulsT,
          repeatY: winItem.tileS || 0,
          repeatX: winItem.tileS || 0,
          frames: winItem.frames,
          frameT: winItem.frameT,
          sameGlow: winItem.sameGlow,
          glowText: winItem.glow || winItem.sameGlow,
          emissive: winItem.glow || winItem.sameGlow ? winItem.emiss || 16777215 : null,
          rgb: winItem.rgb,
          rgbS: winItem.rgbS,
          noGreen: true,
          uv2: true,
          fillScale: 60,
          centerZ: true,
          color: winItem.color || null,
          rAnim: winItem.rAnim,
          rAnimA: winItem.rAnimA,
          transparent: winItem.opac != null || winItem.trans,
          wireframe: winItem.wire,
          side: winItem.side || 0,
          opacity: winItem.opac || 1,
          shaderId: winItem.shaderId,
        },
        0,
        0,
        0,
        (winItem.type && winItem.type != 3 ? Math.PI : Math.PI / 2) + (previewConfig.xRot || 0),
        (winItem.spnScl || previewConfig.scl || 1) * 2.2,
        spinnerPreview,
      );
    }
    spinnerScene.add(spinnerPreview);
    spinItemCamera.lookAt(spinnerScene.position);
  }
}
function skinReward(itemID) {
  if (acc) {
    if (acc.skins.some((skinEntry) => skinEntry.ind === itemID)) {
      var ownedSkin = acc.skins.find((skinEntry) => skinEntry.ind === itemID);
      if (ownedSkin) {
        ownedSkin.cnt++;
      }
    } else {
      acc.skins.push({
        ind: itemID,
        cnt: 1,
      });
    }
  }
  var item = Game.store.skins[itemID];
  if (item) {
    skinRewards.style.display = "block";
    var hasRarityAnim = RENDER.rarityAnim && Game.store.rarities[item.rarity].animate;
    skinRewards.innerHTML =
      "<div class='skinRewCard' onclick='openSales(" +
      itemID +
      ")' onmouseenter='playTick()'><img class='skinRewImg" +
      (hasRarityAnim ? " rainbowBorder" : "") +
      "' src='" +
      UTILS.getPreview(item, Game.store) +
      "' style='border: 3px solid " +
      Game.store.rarities[item.rarity].color +
      "'/><div class='skinRewRight'>" +
      item.name +
      "<div class='skinRewDesc'>Item Unlocked!</div></div></div>";
    setTimeout(function () {
      skinRewards.style.display = "none";
      skinRewards.innerHTML = "";
    }, 5000);
    addChat(
      null,
      "<span style='color:#fff'>You</span> unlocked <span class='click" +
        (hasRarityAnim ? " rainbowText" : "") +
        "' style='color:" +
        Game.store.rarities[item.rarity].color +
        "' onclick='openSales(" +
        itemID +
        ")'>[" +
        UTILS.fixStr(item.name) +
        "]</span>",
      1,
    );
  }
}
function freeKrSpinResponse(lastReward, randNum, rewardIndex, funds, error) {
  isSpinning = false;
  if (error) {
    showSpinError("Spin Error 3");
  } else {
    winItem = Game.store.getFreeKR(rewardIndex, acc);
    spinItemName.innerHTML = winItem.kr + " KR";
    spinVal = Math.PI * 2 * (randNum / 100 + 13) + Math.PI / 2;
    if (acc) {
      acc.lastReward = lastReward;
      acc.funds = funds;
      cK();
    }
    dd(true);
    spinCost.innerHTML = "";
    spinRotation = 0;
    spinItemBobTime = 0;
    (spinnerScene = new THREE.Scene()).add(new THREE.AmbientLight(5197647));
    var light = new THREE.DirectionalLight(16777215, 0.5);
    light.position.set(3, 1, 0);
    spinnerScene.add(light);
    (spinnerPreview = RENDER.genObj3D(0, 1, 0)).rotateX(-Math.PI / 7);
    spinnerPreview.rotateY(1.07);
    spinnerPreview.rotateZ(-2.4499999999999997);
    spinnerPreview.orgXR = spinnerPreview.rotation.x;
    spinnerPreview.orgYP = spinnerPreview.position.y;
    RENDER.loadMesh(
      {
        src: "krunkie_0",
        texSrc: "krunkie_0",
        noGreen: true,
        uv2: true,
        fillScale: 60,
        centerZ: true,
      },
      0,
      0,
      0,
      0.3,
      4.840000000000001,
      spinnerPreview,
    );
    spinnerScene.add(spinnerPreview);
    spinItemCamera.lookAt(spinnerScene.position);
  }
}
spinItemRenderer.setPixelRatio(window.devicePixelRatio * 0.6);
spinItemCamera.position.y = 10;
spinItemCanvas.appendChild(spinItemRenderer.domElement);
Object.defineProperty(window, "prizeWheel", {
  writeable: false,
  value: function (wheelIndex, autoSpin, twitchToken) {
    if ((spinWheel = Game.store.wheels[wheelIndex]).openURL) {
      var followUrl =
        config.followURLS[UTILS.randInt(0, config.followURLS.length - 1)];
      if (followUrl.indexOf("channel") !== -1) {
        followUrl += "?sub_confirmation=1";
      }
      window.openURL(followUrl);
    }
    if (spinWheel.twitch) {
      if (!twitchToken) {
        return;
      }
      spinTwitchToken = twitchToken;
    }
    spinRespin.style.display = spinWheel.free || spinWheel.twitch ? "none" : "";
    spinRespinInfo.style.display = spinWheel.free || spinWheel.twitch ? "none" : "";
    spinIndex = wheelIndex;
    showWindow(0);
    spinWhlMlt = 0;
    canSpin = !isSpinning;
    canRespin = false;
    spinVal = 0;
    tickCounter = 0;
    spinRotation = 0;
    endAnimVal = endAnimTarget = 0;
    if (spinUI.style.display != "block") {
      UI.toggleMenuHider(false);
    }
    spinItem.style.display = "none";
    respinUI.style.display = "none";
    spinUI.style.display = "block";
    spinItemName.style.display = "none";
    spinItemCamera.position.x = 300;
    spinButton.style.opacity = 1;
    spinText.style.display = "table-cell";
    spinHeader.innerHTML = "SPIN";
    spinCost.innerHTML = "-" + spinWheel.price + "KR";
    spinRespin.innerHTML =
      "<i class='material-icons' style='margin-left:-10px;text-shadow:none;vertical-align:sub;font-size:35px;'>refresh</i> " +
      spinWheel.price +
      " KR";
    var html =
      "<div style='font-size:50px;color:#fff'>" +
      spinWheel.name.toUpperCase() +
      "</div>";
    for (var rarityIndex = 0; rarityIndex < Game.store.rarities.length; ++rarityIndex) {
      if (
        !(serverSetting = Game.store.rarities[rarityIndex]).noSpin &&
        spinWheel.getRarities(acc)[rarityIndex]
      ) {
        html +=
          "<div style='margin-top:5px;color:#fff'>" +
          (RENDER.rarityAnim && serverSetting.animate
            ? "<div class='colCub rainbowBG'></div>"
            : "<div class='colCub' style='background-color:" +
              serverSetting.color +
              "'></div>") +
          (spinWheel.kr
            ? "<span style='color:rgba(255,255,255,0.5)'>&emsp;" +
              Game.store.getFreeKR(rarityIndex, acc).kr +
              " KR</span>"
            : serverSetting.name +
              "<span style='color:rgba(255,255,255,0.5);float:right'>&emsp;" +
              spinWheel.getRarities(acc)[rarityIndex] +
              "%</span>") +
          "</div>";
      }
    }
    spinInfo.innerHTML = html;
    if (acc) {
      spinKR.innerHTML =
        "<span style='color:rgba(255,255,255,0.6)'>" +
        UTILS.commaNumber(acc.funds) +
        "</span> KR";
    }
    html = "";
    var previewItemID;
    var rarities = spinWheel.getRarities(acc);
    var lastRarityIndex = rarities.indexOf(
      rarities
        .filter((chance) => chance > 0)
        .slice(-1)
        .pop(),
    );
    var previewItems = Game.store.getSpnItems(spinWheel, lastRarityIndex, acc, config);
    for (var index = 0; index < 4; ++index) {
      previewItemID = previewItems[UTILS.randInt(0, previewItems.length - 1)];
      if ((serverSetting = Game.store.skins[previewItemID])) {
        html +=
          "<img class='spinPrevIcon' style='border-color:" +
          Game.store.rarities[serverSetting.rarity].color +
          "' onclick='openSales(" +
          previewItemID +
          ")' src='" +
          UTILS.getPreview(serverSetting, Game.store) +
          "' />";
      }
    }
    html +=
      "<span style='color:#fff;line-height:85px;margin-left:6px'>+ More</span>";
    spinItems.innerHTML = html;
    if (autoSpin) {
      spinButton.click();
    }
  },
});
spinRespin.onclick = function () {
  if (canRespin) {
    prizeWheel(spinIndex, true);
  }
};
spinRespinInfo.onclick = function () {
  if (canRespin) {
    openURL(
      "/social.html?p=itemsales&i=" +
        Game.store.skins.findIndex((skin) => skin == winItem),
    );
  }
};
spinButton.onclick = function (event) {
  event.stopPropagation();
  event.preventDefault();
  CONTROLS.idleTimer = 0;
  if (io && !isSpinning && canSpin && acc) {
    if (acc.funds < spinWheel.price) {
      return showSpinError("Spin Error 9");
    }
    isSpinning = true;
    canSpin = false;
    if (spinWheel.kr) {
      getCaptcha(function (key, error) {
        if (error) {
          alert("Please try again later.");
        } else {
          io.send("fkr", key);
        }
      });
    } else if (spinWheel.twitch) {
      io.send("spin", spinIndex, spinTwitchToken);
      spinTwitchToken = null;
    } else {
      io.send("spin", spinIndex);
    }
    spinHeader.innerHTML = "";
    spinCost.innerHTML = i18n.t("windows.store.purchasing");
    SOUND.play("buy_1", 0.1);
  } else if (canRespin && event.shiftKey) {
    prizeWheel(spinIndex, true);
  }
};
spinUI.onclick = function (event) {
  showWindow(14);
  UI.toggleMenuHider(true);
  spinUI.style.display = "none";
  confetti.reset();
  if (io) {
    io.send("unbx");
  }
  if (acc) {
    spinKR.innerHTML =
      "<span style='color:rgba(255,255,255,0.6)'>" +
      UTILS.commaNumber(acc.funds) +
      "</span> KR";
  }
  if (canRespin && event.shiftKey) {
    prizeWheel(spinIndex, true);
  }
};
var rawMapDataPreset;
var selectedCustomMapId;
var spinHue = 0;
function premiumResponse(status, value, funds, premiumTime) {
  try {
    windows[13].resp(status, value, funds, premiumTime);
  } catch (responseError) {}
}
function nameChangeResponse(status, name) {
  try {
    windows[4].aResp(status, name);
  } catch (responseError) {}
}
function mapListResponse(error, response) {
  try {
    if (response && mapList) {
      windows[9].mapsLoaded(response.data, response.index, response.error);
    }
  } catch (responseError) {}
}
function modListResponse(error, response) {
  try {
    if (response && modList) {
      windows[3].modsLoaded(response.data, response.index, response.error);
    }
  } catch (responseError) {}
}
function searchResponse(error, response) {
  if (response) {
    windows[response.index].searchResp(response.data);
  }
}
function clanResponse(status, data, extra, meta) {
  windows[12].resp(status, data, extra, meta);
}
function clanLeaveResponse() {
  windows[12].del();
}
function queueResponse(status, data) {
  windows[26].resp(status, data);
}
function clanBulletinResponse(status, data, extra, meta) {
  windows[20].resp(status, data, extra, meta);
}
function dropsLoaded(data) {
  windows[4].dropsLoaded(data);
}
function updateChallengeProgress(challengeIndex, progress) {
  if (challengeIndex != null) {
    acc.chal = challengeIndex;
    acc.stats.chgP = progress;
  }
  if (!isInGame) {
    updateWindow(33);
  }
}
function challengeCompleted(challengeIndex) {
  var challenge = Game.challenges[acc.chal];
  endChals.insertAdjacentHTML(
    "beforeend",
    "<div class='endChalCard' onclick='showWindow(33, true)' onmouseenter='playTick()'><img class='endChalImg' src='" +
      UTILS.versionifyUrl("/img/chals/" + challenge.list[challengeIndex].img + ".png") +
      "'/><div class='endChalRight'>" +
      challenge.list[challengeIndex].name +
      "<div class='endChalDesc'>Completed!</div></div></div>",
  );
}
function updateAccountFlags(flags) {
  if (acc) {
    acc.stats.flg = flags == null ? acc.stats.flg : flags;
    updateWindow(5);
  }
}
function uploadResponse(message, target) {
  try {
    if (pfpUpResp && target == 1) {
      pfpUpResp.innerHTML = message;
    }
  } catch (profileError) {}
  try {
    if (setUpResp && target == 2) {
      setUpResp.innerHTML = message;
    }
  } catch (settingsError) {}
}
function profileUploadResponse() {
  cF();
  updateWindow(5);
  popupResponse("SUCCESS", null, "Uploaded!");
}
Object.defineProperty(window, "selectHostMap", {
  writeable: false,
  value: function (mapId, rawMapData = null) {
    selectedCustomMapId = mapId;
    rawMapDataPreset = rawMapData == "undefined" ? null : rawMapData;
    showWindow(8);
  },
});
Object.defineProperty(window, "autoHostMap", {
  writeable: false,
  value: function (mapToPlay) {
    if ((!Game.mode || !Game.mode.isRanked) && !config.isComp) {
      API_CLIENT.getMapPreset(mapToPlay, function (mapToPlay, preset) {
        var gamePreset = null;
        try {
          gamePreset =
            mapToPlay && preset
              ? JSON.parse(UTILS.decompressKeys(preset))
              : null;
        } catch (presetError) {
          gamePreset = null;
        }
        var availableModes = [];
        for (
          var settingIndex = 0;
          settingIndex < MODES.length;
          settingIndex++
        ) {
          if (!MODES[settingIndex].preventCustomGames) {
            if (
              gamePreset
                ? gamePreset.modes &&
                  gamePreset.modes.indexOf(settingIndex) >= 0
                : settingIndex == 0
            ) {
              availableModes.push(settingIndex);
            }
          }
        }
        if (!availableModes.length) {
          availableModes.push(0);
        }
        var availableClasses = [];
        for (
          settingIndex = 0;
          settingIndex < Game.classes.length;
          settingIndex++
        ) {
          Game.classes[settingIndex];
          if (
            !gamePreset ||
            !gamePreset.classes ||
            gamePreset.classes.indexOf(settingIndex) >= 0
          ) {
            availableClasses.push(settingIndex);
          }
        }
        var customData = {
          private: false,
          customMap: mapToPlay,
          rawMapData: null,
          maps: [],
          modes: availableModes,
          classes: availableClasses,
          passCode: null,
        };
        var accountType = UTILS.getAccountType(acc);
        for (
          settingIndex = 0;
          settingIndex < config.serverConfig.length;
          settingIndex++
        ) {
          if ((serverSetting = config.serverConfig[settingIndex]).bool) {
            tmpV = serverSetting.def;
            if (
              gamePreset &&
              gamePreset.settings &&
              gamePreset.settings[serverSetting.varN] != null &&
              !serverSetting.cost
            ) {
              tmpV = !!gamePreset.settings[serverSetting.varN];
            }
          } else if (serverSetting.input) {
            tmpV = "";
          } else if (serverSetting.select) {
            tmpV = serverSetting.def;
          } else {
            var value = serverSetting.def;
            var maxValue = serverSetting.max;
            if (accountType == 3) {
              maxValue = serverSetting.maxF || serverSetting.max;
            } else if (accountType == 2) {
              maxValue = serverSetting.maxP || serverSetting.max;
            } else if (accountType == 0) {
              maxValue = serverSetting.maxG || serverSetting.max;
            }
            if (
              gamePreset &&
              gamePreset.settings &&
              gamePreset.settings[serverSetting.varN] != null &&
              !serverSetting.cost
            ) {
              if ((value = gamePreset.settings[serverSetting.varN]) > maxValue) {
                value = maxValue;
              }
            }
            tmpV = parseFloat(value) || 0;
          }
          customData[serverSetting.varN] = tmpV;
        }
        getCaptcha(function (key, error) {
          if (!error) {
            io.send("custom", customData, key, true);
          }
        });
      });
    }
  },
});
Object.defineProperty(window, "openHostWindow", {
  writeable: false,
  value: function (forceRefresh) {
    if (Game.mode.isRanked) {
      return showWindow(0);
    } else {
      selectedCustomMapId = null;
      rawMapDataPreset = null;
      showWindow(8, forceRefresh);
      return;
    }
  },
});
Object.defineProperty(window, "openJoinWindow", {
  writeable: false,
  value: function () {
    if (navigator.clipboard) {
      navigator.clipboard
        .readText()
        .then(function (clipboardText) {
          handleJoinInput(clipboardText);
        })
        .catch(() => {
          showWindow(24);
        });
      return;
    } else {
      return showWindow(24);
    }
  },
});
window.downloadFile = function (filename, jsonData) {
  var downloadLink = document.createElement("a");
  downloadLink.setAttribute(
    "href",
    "data:text/plain;charset=utf-8," +
      encodeURIComponent(JSON.stringify(jsonData)),
  );
  downloadLink.setAttribute("download", filename);
  downloadLink.style.display = "none";
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};
zip.workerScriptsPath = "./libs/";
var localModFileReader = new FileReader();
function ModTextureProcessor(entryPath) {
  this.imgAsDataURL = "";
  this.process = function (blob) {
    if (entryPath) {
      this.imgAsDataURL = URL.createObjectURL(blob);
      try {
        if (entryPath == "textures/logo.png") {
          if (settings.tmp.canChangeLogo) {
            mainLogo.src = this.imgAsDataURL;
          }
        } else if (entryPath == "textures/muzflash.png") {
          overlay.updateMuzzle(this.imgAsDataURL);
        } else {
          var image = new Image();
          image.onload = function () {
            RENDER.updateTexture(
              entryPath.replace("textures/", "").replace(".png", ""),
              this,
            );
          };
          image.src = this.imgAsDataURL;
        }
      } catch (textureError) {}
    }
    modExtractionTracker.close();
  };
}
function ModSoundProcessor(entryPath) {
  this.process = function (blob) {
    var objectUrl = URL.createObjectURL(blob);
    if (objectUrl) {
      try {
        var soundName = entryPath.split("/")[1];
        SOUND.updateSound(soundName, objectUrl);
        var ambientIndex = parseInt(
          Game.mode.ambInd || Game.map.maps[Game.mapIndex].ambInd || 1,
        );
        if (soundName == "ambient_" + ambientIndex) {
          SOUND.play("ambient_" + ambientIndex, config.amvVols[ambientIndex] || 0.12, true, 1);
        }
      } catch (soundError) {}
    }
    modExtractionTracker.close();
  };
}
function ModModelProcessor(entryPath) {
  this.process = function (blob) {
    if (entryPath) {
      try {
        var reader = new FileReader();
        reader.addEventListener("loadend", (event) => {
          var modelText = event.srcElement.result;
          RENDER.updateMesh(
            entryPath.replace("models/", "").replace(".obj", ""),
            modelText,
          );
        });
        reader.readAsText(blob);
      } catch (modelError) {}
    }
    modExtractionTracker.close();
  };
}
localModFileReader.onload = (e) => loadModPack(e.target.result);
var booleanModSettingNames = [
  "aimAnim",
  "hideADS",
  "showHands",
  "showWeapon",
  "showWeaponSec",
  "showWeaponMel",
];
function ModScriptProcessor(entryPath) {
  this.process = function (hk) {
    if (entryPath) {
      try {
        var hl = entryPath.replace("scripts/", "").replace(".txt", "");
        var hm = new FileReader();
        hm.addEventListener("loadend", (ho) => {
          var hp = ho.srcElement.result;
          if (hl == "settings") {
            (function (hq) {
              if (hq && UTILS.isString(hq)) {
                var hu;
                for (
                  var hv = hq
                      .split(/\r?\n/)
                      .filter((hx) => hx.length)
                      .map((hx) => hx.trim()),
                    hw = 0;
                  hw < hv.length;
                  hw++
                ) {
                  hu = hv[hw].split(",");
                  if (config.scriptSetts.indexOf(hu[0]) > -1) {
                    if (booleanModSettingNames.indexOf(hu[0]) > -1) {
                      if (parseInt(hu[1]) == 0) {
                        hu[1] = false;
                      }
                      if (parseInt(hu[1]) == 1) {
                        hu[1] = true;
                      }
                    }
                    setSetting(hu[0], hu[1], true, true, true);
                  } else if (hu[0] == "defaultSkins") {
                    useDefaultSkins = !!hu[1];
                  }
                }
              }
            })(hp);
          }
        });
        hm.readAsText(hk);
      } catch (ho) {}
    }
    modExtractionTracker.close();
  };
}
function ModShaderProcessor(entryPath) {
  this.process = function (hk) {
    if (entryPath) {
      try {
        entryPath.replace("shaders/", "").replace(".json", "");
        var hl = new FileReader();
        hl.addEventListener("loadend", (hm) => {
          var ho = hm.srcElement.result;
          RENDER.updateShaderPass(JSON.parse(ho));
        });
        hl.readAsText(hk);
      } catch (hm) {}
    }
    modExtractionTracker.close();
  };
}
function ModCssProcessor(entryPath) {
  this.process = function (hk) {
    if (entryPath) {
      try {
        entryPath.replace("css/", "").replace(".css", "");
        var hl = new FileReader();
        hl.addEventListener("loadend", (hm) => {
          for (
            var ho = hm.srcElement.result,
              hp =
                /\\|import|url|data|expression|behavior|-moz-binding|javascript|content|exec|'|"|`|aHolder|aMerger|aContainer|supportKrunker|krunkerio_728x90_1|mapVote|mapVoteD|mapVoteU|modVoteHold|modVoteD|modVoteU|modVote|tSubHolder|tSubName|tSubOffer|tDecOffer|tDecName|tDecCheck|tSubCheck|jumpSIMG|jumpSVID|jumpSVIDHolder/gim;
            hp.test(ho);
          ) {
            ho = ho.replace(hp, "");
          }
          var hq = document.getElementById("customCSS");
          if (!hq) {
            (hq = document.createElement("style")).id = "customCSS";
            document.head.appendChild(hq);
          }
          hq.innerHTML = ho;
        });
        hl.readAsText(hk);
      } catch (hm) {}
    }
    modExtractionTracker.close();
  };
}
function updateModLoadStatus(message) {
  try {
    modLInfo.textContent = message;
  } catch (hk) {}
}
var modExtractionTracker = new (function () {
  this.init = function (hj, hk) {
    this.numFiles = hk;
    this.progress = 0;
    this.reader = hj;
  };
  this.close = function () {
    if (this.reader) {
      this.progress++;
      updateModLoadStatus(
        i18n.t("mod.extracting", this.progress, this.numFiles),
      );
      if (this.numFiles === this.progress) {
        spriteIndex = 0;
        updateModLoadStatus(i18n.t("generic.success"));
        this.reader.close();
        this.reader = undefined;
      }
    }
  };
})();
function handleJoinInput(inputText) {
  var joinLinkMatch = inputText.match(
    /^(https?:\/\/)?(www\.)?(.+)(krunker\.io|127\.0\.0\.1:8080)\/\?(party|game)=(.+)$/,
  );
  if (joinLinkMatch && joinLinkMatch.length == 7) {
    if (getJoinLinkHostKey(inputText) == getJoinLinkHostKey(location.href)) {
      if (joinLinkMatch[5] == "game") {
        location.href = inputText;
      } else if (joinLinkMatch[5] == "party") {
        joinQueue(false, joinLinkMatch[6]);
        showWindow(27);
      } else {
        showWindow(24);
      }
    } else {
      location.href = inputText;
    }
  } else if (inputText.match(/^([A-Z]+):(\w+)$/)) {
    window.switchServer(inputText);
  } else {
    showWindow(24);
  }
}
function getJoinLinkHostKey(joinUrl) {
  return joinUrl
    .match(
      /^(https?:\/\/)?(www\.)?(.+)(krunker\.io|127\.0\.0\.1:8080)\/\?(party|game)=(.+)$/,
    )
    .slice(3, 5)
    .join("");
}
function startGame(
  timer,
  team,
  spectating,
  useSkullIcon,
  moveLocked,
  canStart,
  newKpdData,
) {
  if (moveLocked != null) {
    Game[moveLocked ? "lockMove" : "unlockMove"]();
  }
  kpdData = newKpdData;
  overlay.kpdData = kpdData;
  if (!kpdData) {
    specKPDContr.style.display = "none";
  }
  localTeam = team;
  window.spectating = spectating;
  if (!localTeam && spectating) {
    localTeam = 1;
  }
  updateTimer(timer);
  UI.toggleMenu(false);
  medalQueue.length = 0;
  overlay.hits.length = 0;
  UI.toggleGameUI(true);
  DIV.reset();
  overlay.reset();
  CONTROLS.reset();
  lockPlayer(false);
  Game.players.forcePos();
  Game.players.resetAim();
  // game.AI.hideAll();
  dirs = {};
  inputDeltaTimes.length = 0;
  inputSendTimer = 0;
  queuedInputCount = 0;
  propCameraDistance = 30;
  overlay.speedDisplay.max = 0;
  compressedAimDeltas.length = 0;
  lastSentAimDeltas = [];
  lastInputValues = {};
  firstInputSeq = null;
  hasChangedInputFields = false;
  window.noMouseInp = false;
  UI.loading = false;
  CONTROLS.idleTimer = 0;
  teamName.style.opacity = 0;
  hiddenMsg.style.display = "none";
  interactProg.style.display = "none";
  updatePlayInstructions();
  specTeam1.innerHTML = "";
  specTeam0.innerHTML = "";
  spectatorPlayerRows.length = 0;
  CONTROLS.spect.target = null;
  null;
  hasShownTeamPrompt = false;
  UI.toggleControlUI(CONTROLS.enabled);
  killCount.style.display =
    Game.mode.friendly || !settings.list.showKillC.val
      ? "none"
      : "inline-block";
  challIcon.src = useSkullIcon ? "./img/skull_0.png" : "./img/hp_0.png";
  if (!canStart) {
    disconnect(null, "000003");
  }
}
function showServerPasswordPrompt() {
  gameCode();
}
function updateServerPasswordCountdown(hj) {
  var hk = document.getElementById("confirmBtn");
  if (hk) {
    hk.innerHTML = "Submit - " + hj + "s";
  }
}
Object.defineProperty(window, "loadUserMod", {
  writeable: false,
  value: function (name, url, id, creatorName) {
    showWindow(18);
    updateModLoadStatus(i18n.t("generic.loading"));
    loadModPack(url, true, false, name, id, creatorName);
  },
});
window.loadModURL = function () {
  if (modURL.value) {
    loadModPack(modURL.value, true);
  }
};
Object.defineProperty(window, "loadModPack", {
  writeable: false,
  value: function (url, fromWeb, skipSaveLast, name, id, creatorName) {
    if (
      ((!!UTILS.isDropbox(url) || !!UTILS.isUserAsset(url)) &&
        !(url.indexOf("&") > -1)) ||
      !fromWeb
    ) {
      if (!settings.tmp.canLoadMods) {
        updateModLoadStatus(i18n.t("mod.disabled"));
        return;
      }
      modVote.innerHTML = "";
      if (fromWeb && !skipSaveLast && settings.list.autoLoadLast.val) {
        setLastMod(url);
      }
      if (name != null && id != null) {
        modVoteVal = 0;
        modVote.innerHTML =
          "<span id='modVoteHold'><div class='voteHint vHR' onclick='openURL(&quot;/social.html?p=profile&q=" +
          creatorName +
          "&autoGift=1&mn=" +
          name +
          "&quot;)'>Donate</div><i id='modVoteD' onclick='voteMod(" +
          id +
          ",-1)' class='material-icons vote'>thumb_down</i><i id='modVoteU' onclick='voteMod(" +
          id +
          ",1)' class='material-icons vote'>thumb_up</i></br></span>" +
          name +
          " Mod";
      }
      try {
        url = url
          .replace("dropbox.com", "dl.dropboxusercontent.com")
          .replace(/&/g, "nope");
        var entryRoot = "";
        var zipReader = fromWeb ? new zip.HttpReader(url) : new zip.Data64URIReader(url);
        zip.createReader(
          zipReader,
          function (reader) {
            reader.getEntries(function (entries) {
              if (entries.length) {
                modExtractionTracker.init(reader, entries.length);
                var entry;
                for (var entryIndex = 0; entryIndex < entries.length; entryIndex++) {
                  if ((entry = entries[entryIndex]).directory) {
                    modExtractionTracker.close();
                  } else if ((entryRoot = entry.filename.split("/")[0]) == "textures") {
                    entry.getData(
                      new zip.BlobWriter("image/png"),
                      new ModTextureProcessor(entry.filename).process,
                      function () {},
                    );
                  } else if (entryRoot == "sound") {
                    entry.getData(
                      new zip.BlobWriter("audio/mp3"),
                      new ModSoundProcessor(entry.filename.replace(".mp3", ""))
                        .process,
                      function () {},
                    );
                  } else if (entryRoot == "models") {
                    if ((!Game.mode || !Game.mode.isRanked) && !config.isComp) {
                      entry.getData(
                        new zip.BlobWriter("application/x-tgif"),
                        new ModModelProcessor(entry.filename).process,
                        function () {},
                      );
                    }
                  } else if (entryRoot == "scripts") {
                    entry.getData(
                      new zip.BlobWriter("text/plain"),
                      new ModScriptProcessor(entry.filename).process,
                      function () {},
                    );
                  } else if (entryRoot == "shaders") {
                    entry.getData(
                      new zip.BlobWriter("application/json"),
                      new ModShaderProcessor(entry.filename).process,
                      function () {},
                    );
                  } else if (entryRoot == "css") {
                    entry.getData(
                      new zip.BlobWriter("text/css"),
                      new ModCssProcessor(entry.filename).process,
                      function () {},
                    );
                  } else {
                    modExtractionTracker.close();
                  }
                }
              }
            });
          },
          function () {
            updateModLoadStatus(i18n.t("mod.error"));
          },
        );
      } catch (zipError) {
        updateModLoadStatus(i18n.t("mod.error"));
      }
    }
  },
});
if (settings.list.autoLoadLast.val && krk_lastMod.length) {
  loadModPack(krk_lastMod, true);
}
window.loadMod = function () {
  if (modInput.files && modInput.files[0]) {
    var file = modInput.files[0];
    if (file.name.split(".").pop().toLowerCase() == "zip") {
      updateModLoadStatus(i18n.t("mod.loading"));
      localModFileReader.readAsDataURL(file);
    } else {
      updateModLoadStatus(i18n.t("mod.invalid"));
    }
  }
};
window.joinGame = function () {
  handleJoinInput(gameURL.value || "");
};

// TOGGLE TEAM:
window.toggleTeam = function (useTeamTwo) {
  selectedTeam = useTeamTwo ? 2 : 1;
  teamNm1.style.color = useTeamTwo ? "rgba(255,255,255,0.5)" : "#fff";
  teamNm2.style.color = useTeamTwo ? "#fff" : "rgba(255,255,255,0.5)";
};
window.gameCode = function () {
  resetPops();
  gameCodePop.style.display = "block";
  gameCodePop.innerHTML =
    "<div style='color:#fff;font-size:20px;position:relative;'>Enter Server Password to join</div><input type='text' id='codeInput' placeholder='Password'><div id='confirmBtn' onclick='submitGameCode()' onmouseover='SOUND.play(&quot;tick_0&quot;,0.1)'>Submit</div><div id='declineBtn' onclick='location=location.origin' onmouseover='SOUND.play(&quot;tick_0&quot;,0.1)'>Leave</div>";
};
window.submitGameCode = function () {
  var codeInput = document.getElementById("codeInput");
  if (codeInput && codeInput.value) {
    io.send("code", codeInput.value);
  }
};
var modVoteVal;
var didSupportKrunker = false;
function initGame(
  mapIndex,
  gameMode,
  teamScoresArr,
  objective,
  hostSocketId,
  gameConfig,
  customWeapons,
  serverModURL,
  customMapObj,
  gameState,
  initData,
) {
  console.info("[client io_init] received init", {
    mapIndex,
    gameMode,
    hasCustomMap: !!customMapObj,
    hasGameState: !!gameState,
    hostSocketId,
    initData,
    gameConfigMaps: gameConfig && gameConfig.maps,
  });
  if (customMapObj) {
    console.info("[client io_init] custom map payload", {
      id: customMapObj.id,
      creator: customMapObj.creator,
      thumb: customMapObj.thumb,
      dataType: typeof customMapObj.data,
      dataLength: customMapObj.data ? customMapObj.data.length : 0,
    });
  }
  if (play) {
    play = false;
  } else {
    if (mod) {
      API_CLIENT.searchMod(mod, function (err, searchResult) {
        if (searchResult && searchResult.data && searchResult.data.length) {
          var modInfo = searchResult.data.find((candidateMod) => candidateMod.mod_name == mod);
          if (modInfo) {
            if (modInfo.mod_url == "ua") {
              modInfo.mod_url =
                "https://user-assets.krunker.io/md" + modInfo.mod_id + "/mod.zip";
            }
            loadModPack(
              modInfo.mod_url,
              true,
              true,
              modInfo.mod_name,
              modInfo.mod_id,
              UTILS.cleanseString(modInfo.creatorname),
            );
          }
        }
        mod = null;
      });
    }
    UI.hasEndScreen = false;
    SOUND.endLoops();
    voiceStreamQueues = {};
    if (gameConfig.isFromQueue) {
      window.history.replaceState({}, "Krunker", "/");
    }
    hasSentEndMessage = false;
    if (customMapObj) {
      if (customMapObj.data) {
        const customMapResult = Game.customMap(
          customMapObj.data,
          customMapObj.id,
          customMapObj.creator,
          null,
          acc,
          true,
        );
        if (customMapResult) {
          console.warn(
            "[client io_init] game.customMap rejected map",
            customMapResult,
          );
        } else {
          console.info("[client io_init] game.customMap accepted map", {
            mapIndex,
            customMapId: customMapObj.id,
            creator: customMapObj.creator,
          });
        }
      }
    } else {
      console.info(
        "[client io_init] no custom map payload, using built-in map set",
      );
      Game.map.setMaps();
    }
    if (!(gameState = gameState || {}).gor && !Game.singlePlayer) {
      disconnect(null, "000004");
    }
    Game.isCustom = !!hostSocketId;
    hostSocketId = hostSocketId;
    isLobbyHost = hostSocketId && hostSocketId == io.socketId;
    mapVote.innerHTML = "";
    mapVoteVal = 0;
    customMapSupportData.length = 0;
    hasShownMapSupportPrompt = false;
    Game.hasThumb = null;
    if (hostSocketId && customMapObj && customMapObj.id != null) {
      Game.hasThumb = customMapObj.thumb
        ? "https://user-assets.krunker.io/m" +
          customMapObj.id +
          "/thumb.png?v=" +
          Math.random()
        : null;
      customMapSupportData = [customMapObj.id, customMapObj.creator];
      mapVote.innerHTML =
        "<div class='voteHint'  onclick='openURL(&quot;/social.html?p=profile&q=" +
        customMapObj.creator +
        "&autoGift=2&mn=" +
        Game.map.maps[mapIndex].name +
        "&quot;)'>Donate</div><i id='mapVoteD' onclick='voteMap(" +
        customMapObj.id +
        ",-1)' class='material-icons vote'>thumb_down</i><i id='mapVoteU' onclick='voteMap(" +
        customMapObj.id +
        ",1)' class='material-icons vote'>thumb_up</i>";
    }
    Game.updateBillboards(gameState.bill);
    (gameConfig = gameConfig || {}).weps = customWeapons;
    Game.applyConfig(gameConfig, customMapObj ? customMapObj.accType : 1);
    Game.init(mapIndex, gameMode, initData, false);
    if (Game.mode && Game.mode.objWep) {
      Game.setWeapon(objective);
    } else {
      Game.setObjective(objective);
    }
    loadingBg.style.display = "none";
    inviteButton.classList.toggle("buttonD", !!Game.mode.isRanked);
    menuBtnHost.classList.toggle("buttonD", !!Game.mode.isRanked);
    if (Game.mode && Game.mode.isRanked) {
      window.onbeforeunload = function () {
        return true;
      };
    }
    specContr.children[2].style.display =
      Game.mode.objective && Object.keys(Game.map.manager.spectateCams).length
        ? ""
        : "none";
    if (gameState.dest) {
      for (var syncIndex = 0; syncIndex < gameState.dest.length; ++syncIndex) {
        Game.destroyObj(gameState.dest[syncIndex]);
      }
    }
    if (gameState.flg) {
      for (syncIndex = 0; syncIndex < gameState.flg.length; ++syncIndex) {
        Game.updateFlag(...gameState.flg[syncIndex]);
      }
    }
    if (gameState.spwns) {
      for (syncIndex = 0; syncIndex < gameState.spwns.length; ++syncIndex) {
        Game.createSpawnable(...gameState.spwns[syncIndex]);
      }
    }
    if (gameState.pkups) {
      for (syncIndex = 0; syncIndex < gameState.pkups.length; ++syncIndex) {
        Game.updatePickup(...gameState.pkups[syncIndex]);
      }
    }
    if (gameState.gates) {
      for (syncIndex = 0; syncIndex < gameState.gates.length; ++syncIndex) {
        Game.updateGate(...gameState.gates[syncIndex]);
      }
    }
    if (gameState.banks) {
      for (syncIndex = 0; syncIndex < gameState.banks.length; ++syncIndex) {
        Game.updateBank(...gameState.banks[syncIndex]);
      }
    }
    if (gameState.zone) {
      Game.updateZone(...gameState.zone);
    }
    if (gameState.lck != null) {
      Game[gameState.lck ? "lockMove" : "unlockMove"]();
    }
    if (Game.mode && Game.mode.canTrade) {
      API_CLIENT.getPrices(function (err, data) {
        prices.update(data || {});
      });
    }
    specNameTm0.textContent = teamNm1.textContent =
      Game.mode && Game.mode.teamOptions
        ? Game.mode.teamOptions[0]
        : Game.config.nameTeam1.replace(/\s/g, "").length > 0
          ? Game.config.nameTeam1
          : "Team 1";
    specNameTm1.textContent = teamNm2.textContent =
      Game.mode && Game.mode.teamOptions
        ? Game.mode.teamOptions[1]
        : Game.config.nameTeam1.replace(/\s/g, "").length > 0
          ? Game.config.nameTeam2
          : "Team 2";
    teamScores.style.display = "none";
    spec0.style.display = "none";
    spec1.style.display = "none";
    if (Game.mode.teams && teamScoresArr) {
      teamScores.style.display = "inline-block";
      spec0.style.display = "inline-block";
      spec1.style.display = "inline-block";
      var teamScoresHtml = "";
      for (syncIndex = 0; syncIndex < teamScoresArr.length; ++syncIndex) {
        Game.teams[teamScoresArr[syncIndex][0]] = teamScoresArr[syncIndex][1];
        teamScoresHtml += Game.mode.flags
          ? "<div class='tScore'><span class='tScoreT' id='tScoreV" +
            teamScoresArr[syncIndex][0] +
            "'>" +
            teamScoresArr[syncIndex][1] +
            "</span><i class='material-icons tScoreF' id='tScoreF" +
            teamScoresArr[syncIndex][0] +
            "'>flag</i><span class='tScoreM' id='tScoreM" +
            teamScoresArr[syncIndex][0] +
            "'>" +
            (teamScoresArr[syncIndex][2] || "AT BASE") +
            "</span></div>"
          : "<div class='tScore'><div id='tScoreC" +
            teamScoresArr[syncIndex][0] +
            "' class='tScoreC'></div><span class='tScoreT' id='tScoreV" +
            teamScoresArr[syncIndex][0] +
            "'>" +
            teamScoresArr[syncIndex][1] +
            "</span></div>";
        document.getElementById(
          "specScoreTm" + (teamScoresArr[syncIndex][0] - 1),
        ).textContent = teamScoresArr[syncIndex][1];
      }
      teamScores.innerHTML = teamScoresHtml;
    }
    if (serverModURL && serverModURL != "") {
      loadModPack(serverModURL, true, true);
    }
    var scoreZoneCountValue = 0;
    var scoreZonePoints = 0;
    for (syncIndex = 0; syncIndex < Game.map.manager.objects.length; ++syncIndex) {
      if (Game.map.manager.objects[syncIndex].score) {
        scoreZoneCountValue++;
        scoreZonePoints += Game.map.manager.objects[syncIndex].scoreP;
      }
    }
    if (scoreZoneCountValue) {
      scoreZoneCount.style.display = "inline-block";
      scoreZoneCount.innerHTML =
        "<i class='material-icons' style='color:#fff;font-size:35px'>flag</i> " +
        scoreZonePoints;
    } else {
      scoreZoneCount.style.display = "none";
    }
    if (Game.config.lives || Game.mode.lives) {
      livesCount.style.display = "inline-block";
      livesCount.innerHTML =
        "<i class='material-icons' style='color:#fff;font-size:35px'>favorite</i> <span id='livesDisp' style='color:rgba(255,255,255,0.6)'>" +
        (Game.config.lives || Game.mode.lives || 0) +
        "</span>";
    } else {
      livesCount.style.display = "none";
    }
    UI.setShowSpect(Game.config.allowSpect);
    UI.setShowSelTeam(Game.config.selTeam);
    endAnimationTimeLeft = null;
    CONTROLS.reset();
    var tmpMap = Game.map.maps[mapIndex];
    var camPos = tmpMap.camPos ? tmpMap.camPos : [0, 0, 0];
    CONTROLS.moveCam(camPos[0] || 0, camPos[1] || 0, camPos[2] || 0);
    CONTROLS.rotateCam(0, 0, 0);
    RENDER.clearSprays();
    RENDER.scene.add(CONTROLS.object);
    player = null;
    overlay.showObjective =
      !!Game.mode.objective && Game.map.manager.objectives.length > 0;
    killStreakHolder.innerHTML = "";
    overlay.bloodOpacity = 0;
    bloodDisplay.style.display = "none";
    killsVal.textContent = 0;
    deathsVal.textContent = 0;
    myScoreVal.textContent = 0;
    localStreakCount = 0;
    streakVal.textContent = localStreakCount;
    pendingScoreDelta = 0;
    handledVoteKickAliases.length = 0;
    activeVoteKickTarget = false;
    hasStartedVoteKick = false;
    voteToKick.style.display = "none";
    cq = false;
    cp = false;
    CONTROLS.spect.target = null;
    cm = {};
    cw();
    cl = {};
    customMapObj = null;
    showMenu();
    CONTROLS.masterLock = false;
    CONTROLS.camOffset =
      Game.map.config &&
      (Game.map.config.camOffX ||
        Game.map.config.camOffY ||
        Game.map.config.camOffZ);
    CONTROLS.camRot = Game.map.config && Game.map.config.camRot;
    CONTROLS.UsePointerLock =
      (!!CONTROLS.camRot || !CONTROLS.camOffset) && !UI.isMobile;
    CONTROLS.freeMouse = !CONTROLS.UsePointerLock && !UI.isMobile;
    CONTROLS.camType.isNormal = Game.map.config.camType == 0;
    CONTROLS.camType.isTop = Game.map.config.camType == 1;
    CONTROLS.camType.isSideX = Game.map.config.camType == 2;
    CONTROLS.camType.isSideZ = Game.map.config.camType == 3;
    RENDER.aimFov = CONTROLS.camType.isNormal;
    CONTROLS.spect.maxD = Game.mode.specMaxD || config.specMaxD;
    updatePlayInstructions();
    if (!didSupportKrunker) {
      setTimeout(function () {
        var supportKrunker = document.getElementById("supportKrunker");
        if (
          (!document.querySelector("div[id^=google_ads_iframe_]") ||
            krunkerio_728x90_1.offsetHeight === 0) &&
          supportKrunker &&
          config.isProd
        ) {
          supportKrunker.style.display = "block";
        }
        didSupportKrunker = true;
      }, 2500);
    }
    if (config.dropsEnabled) {
      var hE = getSavedVal("dropPop") || 0;
      if (Date.now() - hE >= 3600000) {
        dropsPopup();
      }
    }
  }
}
function setGameInstanceId(instanceId) {
  gameId = instanceId;
  client
    .fetchGameInfo(instanceId)
    .then((serverInfo) => {
      var [gameId, regionId, players, maxPlayers, meta] = serverInfo;
      regionId;
      menuRegionLabel.textContent = config.regionNames[regionId];
    })
    .catch((error) => console.error("Failed to fetch game info", error));
}
function lockPlayer(locked) {
  window.locked = locked;
  blockerDiv.style.display = locked ? "block" : "none";
}
function requestCaptcha() {
  getCaptcha(function (key, error) {
    if (!error) {
      io.send("reCaR", key);
    }
  });
}
Object.defineProperty(window, "updMatchVote", {
  writeable: false,
  value: function (votes, options) {
    for (var optionIndex = 0; optionIndex < options.length; ++optionIndex) {
      if ((serverSetting = document.getElementById("voteT" + options[optionIndex]))) {
        var voteCount = 0;
        if (votes) {
          for (var socketId in votes) {
            if (votes.hasOwnProperty(socketId) && options[optionIndex] == votes[socketId]) {
              voteCount++;
            }
          }
        }
        serverSetting.innerHTML = voteCount;
        serverSetting.style.color =
          votes && votes[io.socketId] == options[optionIndex]
            ? COLORS.matchVote.selected
            : COLORS.matchVote.notSelected;
      }
    }
  },
});
Object.defineProperty(window, "voteOnMatch", {
  writeable: false,
  value: function (option) {
    io.send("maVote", option);
  },
});
window.voteMod = function (id, vote) {
  if (acc) {
    var upButton = document.getElementById("modVoteU");
    var downButton = document.getElementById("modVoteD");
    var voteIncrement = 0;
    if (vote == 1) {
      voteIncrement = 1;
      if (modVoteVal == 1) {
        voteIncrement = 0;
      }
    } else if (vote == -1) {
      voteIncrement = -1;
      if (modVoteVal == -1) {
        voteIncrement = 0;
      }
    }
    modVoteVal = voteIncrement;
    io.send("vote", acc.id, authToken, id, voteIncrement, 1);
    upButton.parentNode.removeChild(upButton);
    downButton.parentNode.removeChild(downButton);
  } else {
    var voteHolder = document.getElementById("modVoteHold");
    if (voteHolder) {
      voteHolder.innerHTML = "";
    }
  }
};
window.voteMap = function (id, vote, showMessage) {
  if (acc) {
    var upButton = document.getElementById("mapVoteU");
    var downButton = document.getElementById("mapVoteD");
    var voteIncrement = 0;
    if (vote == 1) {
      voteIncrement = 1;
      if (mapVoteVal == 1) {
        voteIncrement = 0;
      }
    } else if (vote == -1) {
      voteIncrement = -1;
      if (mapVoteVal == -1) {
        voteIncrement = 0;
      }
    }
    mapVoteVal = voteIncrement;
    io.send("vote", acc.id, authToken, id, voteIncrement);
    if (showMessage) {
      addChat(
        null,
        "Map " +
          (mapVoteVal == 0
            ? "Voted Removed"
            : mapVoteVal == 1
              ? "Upvoted"
              : "Downvoted"),
        2,
      );
    }
    upButton.parentNode.removeChild(upButton);
    downButton.parentNode.removeChild(downButton);
  } else {
    mapVote.innerHTML = "";
  }
};
window.voteMapSupport = function (id, vote) {
  if (acc) {
    document.getElementById("mapSupVoteU");
    document.getElementById("mapSupVoteD");
    var voteIncrement = 0;
    if (vote == 1) {
      voteIncrement = 1;
      if (mapVoteVal == 1) {
        voteIncrement = 0;
      }
    } else if (vote == -1) {
      voteIncrement = -1;
      if (mapVoteVal == -1) {
        voteIncrement = 0;
      }
    }
    mapVoteVal = voteIncrement;
    io.send("vote", acc.id, authToken, id, voteIncrement);
  }
};
var canSendChatCaptcha = true;
function sendChatMessage(message) {
  if (canSendChatCaptcha) {
    canSendChatCaptcha = false;
    getCaptcha(function (key, error) {
      if (error) {
        canSendChatCaptcha = true;
        return;
      } else {
        io.send("ct", message, key);
        return;
      }
    });
  } else {
    io.send("ct", message);
  }
}
function endGame(skip, victory, endData, winningTeam, rewardData, canClaimReward) {
  // [patched] end-of-round map vote re-enabled — the server now drives the
  // full endGame → vote-window → cycleToMap flow, so we want the end screen
  // (and vote UI) to render normally.
  victorySub.style.display = "none";
  victorySub.src = "";
  window.onbeforeunload = null;
  playStatusSubtitle = null;
  updatePlayInstructions();
  let victoryType = victory == -1 ? "dra" : victory ? "vic" : "def";
  victorySub.src = "./img/" + victoryType + ".png";
  overlay.vicTitle.type = victoryType;
  endChals.innerHTML = "";
  UI.toggleWindow(false, CONTROLS.gamepad.active);
  if (!!settings.list.endMessage.val.length && !kpdData && !hasSentEndMessage) {
    sendChatMessage(settings.list.endMessage.val);
    hasSentEndMessage = true;
  }
  if ((player && player.active) || window.spectating) {
    UI.showEndScreen(spinUI.style.display == "block");
    overlay.vicTitle.show = true;
    endAnimationTimeLeft = config.endAnim;
    setTimeout(function () {
      if (io.connected) {
        CONTROLS.disable();
        showEndTable(victory, endData, rewardData, winningTeam);
      }
    }, config.endAnim);
  } else if (skip) {
    CONTROLS.disable();
    UI.showEndScreen(spinUI.style.display == "block");
    showEndTable(victory, endData, rewardData, winningTeam);
  }
  if ((dc = canClaimReward)) {
    dd(true);
  }
}
function showEndTable(victory, endData, rewardData, winningTeam) {
  endInfo.style.display = "block";
  endUI.style.backgroundColor = "transparent";
  victorySub.style.display = "";
  overlay.vicTitle.show = false;
  endAHolderR.style.display = "none";
  endAHolderR.style.opacity = 1;
  endAHolderL.style.display = "none";
  endAHolderL.style.opacity = 1;
  endAHolderL.style.display = "inline-block";
  endAHolderR.style.display = "inline-block";
  endMidHolder.style.display = "inline-block";
  let isSpectatorEnd;
  let playerEndStats = {};
  if (player && player.sid != null) {
    let endStats = Game.mode.endStats || config.endStats;
    let statCount = endStats.length;
    let playerRankIndex = endData.ed
      .filter((entry, index) => !(index % statCount))
      .indexOf(player.sid);
    let playerRowStart = playerRankIndex * statCount;
    let playerRow = endData.ed.slice(playerRowStart, playerRowStart + statCount);
    playerEndStats = {
      rank: "#" + (playerRankIndex + 1),
      score: playerRow[endStats.indexOf("score")] || 0,
      kills: ["kills", "melees"]
        .map((statName) => playerRow[endStats.indexOf(statName)] || 0)
        .reduce((total, value) => total + value),
      deaths: ["deaths", "setbacks"]
        .map((statName) => playerRow[endStats.indexOf(statName)] || 0)
        .reduce((total, value) => total + value),
      funds: playerRow[endStats.indexOf("reward")] || playerRow[endStats.indexOf("MMR")] || "NONE",
      victory: victory,
    };
  } else {
    isSpectatorEnd = true;
  }
  (function (data) {
    if (data && data.ed.length) {
      var voteHtml = "";
      var modeOptions = data.mts;
      matchVoteHolder.style.display = "inline-block";
      matchVoteHolder.classList.toggle("isRanked", !!Game.mode.isRanked);
      if (Game.mode && Game.mode.isRanked) {
        var requeueUrl = "/?autoQueue=true";
        var lastPartyId = getSavedVal("krk_lastPartyId");
        if (lastPartyId) {
          requeueUrl += "&party=" + encodeURIComponent(lastPartyId);
        }
        matchVoteHolder.innerHTML =
          "<div class='button small buttonR' style='margin-right:10px' onclick='location = \"/\"'>Leave Game</div>";
        matchVoteHolder.innerHTML +=
          "<div class='button small' onclick='location = \"" +
          requeueUrl +
          "\"'>Requeue</div>";
        endMidHolder.style.maxHeight = "calc(100% - 450px)";
      } else if (modeOptions.length > 1) {
        for (var optionIndex = 0; optionIndex < modeOptions.length; ++optionIndex) {
          var optionParts = modeOptions[optionIndex].split(",");
          var mode = Game.map.modes[parseInt(optionParts[0])];
          var map = Game.map.maps[parseInt(optionParts[1])];
          if (mode && map) {
            voteHtml +=
              "<label class='matchVote'" +
              (optionIndex == 0 ? ' style="margin-left: 8px;" ' : "") +
              "onclick='voteOnMatch(\"" +
              modeOptions[optionIndex] +
              "\")'><img src='" +
              (Game.hasThumb ||
                "/img/" +
                  (parseInt(optionParts[1]) == 0 && map.name != "Burg"
                    ? "noimg"
                    : "maps/map_" + parseInt(optionParts[1])) +
                  ".png") +
              "' class='matchVoteThumb'><div class='matchVoteMap'>" +
              map.name +
              "</div><div class='matchVoteMode'>" +
              mode.id.toUpperCase() +
              "</div><div class='matchVoteTotal' id='voteT" +
              modeOptions[optionIndex] +
              "'>0</div></label>";
          }
        }
        matchVoteHolder.innerHTML = voteHtml;
        if (voteHtml.length) {
          endMidHolder.style.maxHeight = "calc(100% - 490px)";
        }
        if (data.vo) {
          updMatchVote(data.vo, data.mts);
        }
      } else {
        matchVoteHolder.style.display = "none";
        endMidHolder.style.top = "205px";
      }
    }
  })(endData);
  initGameUI.endScreen.init(acc, isSpectatorEnd, playerEndStats, rewardData, Game.isCustom, function () {
    (function (data, winningTeam) {
      if (data && data.ed.length) {
        var tableHtml = "";
        var teamScores = data.tms;
        endMidHolder.style.top =
          Game.mode.isRanked || data.mts.length <= 1 ? "205px" : "310px";
        if (teamScores) {
          teamTotal0.innerHTML =
            (winningTeam == 1
              ? "<div class='material-icons teamWin0'>emoji_events</div>"
              : "") +
            '<span class="teamTotalN0">' +
            teamNm1.textContent +
            '</span><span class="teamTotalScore">' +
            (teamScores[0][1] || 0) +
            "</span>";
          teamTotal1.innerHTML =
            '<span class="teamTotalScore">' +
            (teamScores[1][1] || 0) +
            '</span><span class="teamTotalN1">' +
            teamNm2.textContent +
            "</span>" +
            (winningTeam == 2
              ? "<div class='material-icons teamWin1'>emoji_events</div>"
              : "");
          teamTotal0.style.display = "inline-block";
          teamTotal1.style.display = "inline-block";
        } else {
          teamTotal0.style.display = "none";
          teamTotal1.style.display = "none";
        }
        endMidHolder.style.display = "inline-block";
        tableHtml = "<tr><th>Rank</th>";
        var endStats = Game.mode.endStats || config.endStats;
        for (var statCount = endStats.length, rowIndex = 1; rowIndex < statCount; ++rowIndex) {
          tableHtml += "<th>" + UTILS.capFirst(endStats[rowIndex]) + "</th>";
        }
        tableHtml += "<th></th></tr>";
        var rank = 1;
        var localTeam =
          player && player.team ? player.team : window.spectating ? 1 : 0;
        for (rowIndex = 0; rowIndex < data.ed.length; ) {
          serverSetting = Game.players.findBySid(data.ed[rowIndex]);
          tableHtml +=
            "<tr style='" +
            (rowIndex + statCount >= data.ed.length ? "border-bottom:none" : "") +
            "'><td style='color:#fff'>" +
            rank +
            ".</td>";
          for (var statIndex = 1; statIndex < statCount; ++statIndex) {
            tableHtml +=
              "<td>" +
              (serverSetting && statIndex == 1 && Game.mode && Game.mode.isRanked
                ? UTILS.eloIconHTML(
                    serverSetting.maxElo,
                    "transform: translateY(2px)",
                  )
                : "") +
              (serverSetting && statIndex == 1 && serverSetting.partner
                ? "<i class='material-icons' style='color:" +
                  COLORS.partner +
                  ";margin-top:-8px;font-size:28px;vertical-align:middle;'>verified</i>"
                : "") +
              (serverSetting && statIndex == 1 && serverSetting.premiumT
                ? "<i class='material-icons' style='color:" +
                  COLORS.premium +
                  ";margin-top:-8px;font-size:28px;vertical-align:middle;'>beenhere</i>"
                : "") +
              (serverSetting && statIndex == 1 && serverSetting.featured
                ? "<i class='material-icons' style='color:" +
                  COLORS.verified.player +
                  ";margin-top:4px;font-size:28px;vertical-align:baseline;'>check_circle</i>"
                : "") +
              (statIndex == 1
                ? "<a class='endTableN' href='" +
                  UTILS.toSocial(data.ed[rowIndex + statIndex][0] || data.ed[rowIndex + statIndex] || "") +
                  "' target='_blank' style='color:" +
                  (player && serverSetting && player.sid == serverSetting.sid
                    ? "#fff'"
                    : serverSetting && localTeam == serverSetting.team
                      ? "rgba(255,255,255,0.6)'"
                      : COLORS.teams[1] + "'") +
                  ">"
                : "") +
              (statIndex == 1
                ? streamerModeEnabled && Filter
                  ? UTILS.scrambleS(
                      serverSetting && serverSetting.premiumT
                        ? serverSetting.alias
                        : data.ed[rowIndex + statIndex][0] || data.ed[rowIndex + statIndex],
                    )
                  : serverSetting && serverSetting.premiumT
                    ? serverSetting.alias
                    : data.ed[rowIndex + statIndex][1] || data.ed[rowIndex + statIndex][0] || data.ed[rowIndex + statIndex]
                : data.ed[rowIndex + statIndex] || 0) +
              (statIndex == 1 && serverSetting && serverSetting.clan
                ? "<span class='" +
                  (serverSetting.clanR == 1 ? "rainbowText" : "") +
                  "' style='color:" +
                  COLORS.getClanCol(
                    serverSetting.clan,
                    serverSetting.clanR,
                    "#fff",
                  ) +
                  "'> [" +
                  serverSetting.clan +
                  "]</span>"
                : "") +
              (statIndex == 1 ? "</a>" : "") +
              "</td>";
          }
          var actionHtml = "";
          if (acc) {
            if (player && player == serverSetting) {
              if (!Game || !Game.isCustom) {
                actionHtml +=
                  "<div class='material-icons reportBut shareBut' title='Report Player' onclick='shareResult()'>share</div>";
              }
            } else if (serverSetting && serverSetting.level) {
              actionHtml +=
                "<div class='material-icons reportBut' title='Report Player' onclick='reportPlayer(`" +
                serverSetting.name +
                "`,this)'>report</div>";
            }
          }
          tableHtml +=
            "<td style='width: 1px;white-space: nowrap;padding-right: 0px;padding-left: 0px;'>" +
            actionHtml +
            "</td></tr>";
          rank++;
          rowIndex += statCount;
        }
        endTable.innerHTML = tableHtml;
      } else {
        endMidHolder.style.display = "none";
      }
    })(endData, winningTeam);
  });
}
function voteKickUpdate(targetAlias, votes, requiredVotes, isNewVote, callerAlias) {
  if (acc) {
    if (isNewVote) {
      if (callerAlias == player.alias) {
        hasStartedVoteKick = true;
      }
      activeVoteKickTarget = targetAlias;
      voteKickInfo.innerHTML = callerAlias + " voted to kick " + targetAlias;
      voteKickName.innerHTML = "Kick " + targetAlias;
      voteKickNum.innerHTML = "Votes: " + votes + "/" + requiredVotes;
      voteToKick.style.display = "block";
      voteKickName.style.display = callerAlias == player.alias ? "none" : "block";
      voteKickKeys.style.display = callerAlias == player.alias ? "none" : "block";
    } else if (targetAlias) {
      if (targetAlias == player.alias) {
        addChat(null, "Vote Submitted - " + votes + "/" + requiredVotes, 2);
        voteKickName.style.display = "none";
        voteKickKeys.style.display = "none";
      } else {
        voteToKick.style.display = "block";
      }
      voteKickNum.innerHTML = "Votes: " + votes + "/" + requiredVotes;
    } else {
      activeVoteKickTarget = false;
      voteToKick.style.display = "none";
    }
  }
}
function playRawSound(sound, volume, mode, x, y, z) {
  if (mode == 1) {
    SOUND.play(sound, volume);
  } else {
    SOUND.play3D(sound, x, y, z, volume);
  }
}
function playPlayerSound(sound, sid, x, y, z, volume, rate, targetPlayer, rawSound) {
  Game.playerSound(
    UTILS.isNumber(sound) && !rawSound ? config.networkSounds[sound] : sound,
    sid,
    x,
    y,
    z,
    volume,
    rate,
    false,
    targetPlayer,
    rawSound,
  );
}
function applyPlayerInteraction(playerSid, loadoutArgs, weaponIndex, pickupId, pickupState, updatePickup = true, active = true, extra) {
  if ((serverSetting = Game.players.findBySid(playerSid))) {
    if (serverSetting == player) {
      SOUND.play("pick_0", 0.2);
    }
    serverSetting.updateLoadout(Game, weaponIndex, true, ...loadoutArgs);
  }
  if (updatePickup) {
    Game.updatePickup(pickupId, pickupState, null, active, extra);
  }
}
function applyPlayerInteractionAll(loadoutArgs, weaponIndex) {
  for (var index = 0; index < Game.players.list.length; index++) {
    if ((serverSetting = Game.players.list[index]) == player) {
      SOUND.play("pick_0", 0.2);
    }
    serverSetting.updateLoadout(Game, weaponIndex, true, ...loadoutArgs);
  }
}
Object.defineProperty(window, "followPlayer", {
  writeable: false,
  value: function (name, element) {
    if (element) {
      element.style.visibility = "hidden";
    }
    io.send("fo", name);
  },
});
Object.defineProperty(window, "shareResult", {
  writeable: false,
  value: function () {
    UI.toggleMenu(true);
    contPopup(
      "<div style='color:#fff;font-size:20px;position:relative;margin-bottom:15px;'>Share Match Results</div><textarea type='text' rows='5' id='shareTxt' style='width:100%' placeholder='Include a message with your stats'></textarea><div id='shareError'></div><div id='confirmBtn' style='width: calc(100% - 15px)' onmouseover='SOUND.play(\"tick_0\",0.1)' onclick='shareMatch()'>Share</div>",
    );
  },
});
Object.defineProperty(window, "shareMatch", {
  writeable: false,
  value: function () {
    var message = "";
    var shareInput = document.getElementById("shareTxt");
    if (shareInput && shareInput.value && shareInput.value != "") {
      message = shareInput.value;
    }
    io.send("smr", message);
    clearPops();
  },
});
Object.defineProperty(window, "reportPlayer", {
  writeable: false,
  value: function (name) {
    openURL("/social.html?p=profile&q=" + name + "&autoReport=1");
  },
});
Object.defineProperty(window, "kickVote", {
  writeable: false,
  value: function (playerId) {
    for (var index = 0; index < Game.players.list.length; ++index) {
      if ((serverSetting = Game.players.list[index]).id == playerId) {
        io.send("v2k", serverSetting.alias, 1);
        handledVoteKickAliases.push(serverSetting.alias);
        updateWindow(23);
        break;
      }
    }
  },
});
var selectedSprayIndex = getSavedVal("sprayindex") || 0;
function addSpray(x, sprayIndex, y, z, scale, rotation, ownerSid) {
  var spray = Game.sprays[0];
  if (Game.sprays[sprayIndex]) {
    spray = Game.sprays[sprayIndex];
  } else if (Game.store.skins[sprayIndex] && Game.store.skins[sprayIndex].type == 4) {
    spray = Game.store.skins[sprayIndex];
  }
  RENDER.addSpray(x, sprayIndex, y, z, scale, rotation, ownerSid, spray);
}
function nukeUpdate(state) {
  if (state == 0) {
    SOUND.play("siren_0");
  } else if (state == 1) {
    SOUND.play("nuke_0");
    imgFlash.style.display = "block";
    imgFlash.style.opacity = 1;
    imgFlash.style.backgroundImage = "";
    RENDER.shake(1);
  }
}
function updateTimer(timeText, isEndTimer) {
  if (isEndTimer) {
    endTimer.innerHTML = i18n.t("timer.end", timeText);
  } else {
    timerVal.innerHTML = timeText;
    specTimer.innerHTML = timeText;
    timerDisplay.style.display = timeText == "0:00" ? "none" : "inline-block";
  }
}
Object.defineProperty(window, "selectSpray", {
  writeable: false,
  value: function (sprayIndex) {
    saveVal("sprayindex", sprayIndex);
    selectedSprayIndex = sprayIndex;
    showWindow(3);
  },
});
var spectatorPlayerRows = [];
function fF(hj, hk, hl) {
  var hm = null;
  var ho = 0;
  for (var hp = 0; hp < spectatorPlayerRows.length; ++hp) {
    if (!spectatorPlayerRows[hp].player) {
      hm = spectatorPlayerRows[hp];
      ho = hp;
      break;
    }
  }
  if (hm) {
    hm.player = hj;
  } else {
    hm = {};
    ho = spectatorPlayerRows.length;
    hm.player = hj;
    spectatorPlayerRows.push(hm);
  }
  if (hm.elm) {
    hm.elm.remove();
  }
  (tempElement = document.createElement("div")).className =
    "specPlayerHolder" + hl;
  tempElement.innerHTML =
    "<img src='" +
    UTILS.assetsUrl(
      "textures/classes/icon_" + (hj.classIndex || 0) + ".png",
      true,
    ) +
    "' class='specPlayerIcon" +
    (hj.active ? "" : " silhouette") +
    "' id='specPI_" +
    (hj.classIndex || 0) +
    "'><div class='specPlayerFlag" +
    (hj.flagIndex > -1 ? " flag flag-" + Game.flags[hj.flagIndex][1] : "") +
    "' id='sf_" +
    hj.flagIndex +
    "'></div><div class='specPlayerName'>" +
    hj.alias +
    "</div><div class='specNum'>" +
    (ho < 9 ? ho + 1 : "") +
    "</div><span class='material-icons' style='color:rgba(255,255,255,0.7);font-size:20px;text-shadow:none;margin-top:-47px;vertical-align: middle;' id='specH_" +
    hj.sid +
    "'>visibility</span><span class='material-icons' id='specKPD'>search</span>";
  hm.elm = tempElement;
  hm.team = hk;
  (hl ? specTeam1 : specTeam0).insertAdjacentElement("beforeend", hm.elm);
}
function fG(hj) {
  if (window.spectating) {
    if (frameTimeMs - 0 >= 1000) {
      for (var hk = 0; hk < Game.players.list.length; ++hk) {
        if (!(serverSetting = Game.players.list[hk]).isYou) {
          var hl = Game.mode.teams ? serverSetting.team - 1 : hk & 1;
          if (
            !spectatorPlayerRows.length ||
            !spectatorPlayerRows.find(
              (hm) => hm.player && hm.player.sid == serverSetting.sid,
            )
          ) {
            fF(serverSetting, serverSetting.team, hl);
          }
        }
      }
    }
    (function () {
      for (var hm = 0; hm < spectatorPlayerRows.length; hm++) {
        if ((serverSetting = spectatorPlayerRows[hm]).player) {
          if (serverSetting.player.team != serverSetting.team) {
            if (serverSetting.elm) {
              serverSetting.elm.remove();
            }
            serverSetting.elm = null;
            serverSetting.team = null;
            serverSetting.player = null;
          }
          if (serverSetting.elm) {
            if (
              serverSetting.elm.children[0].id !=
              "specPI_" + (serverSetting.player.classIndex || 0)
            ) {
              serverSetting.elm.children[0].src = UTILS.assetsUrl(
                "textures/classes/icon_" +
                  (serverSetting.player.classIndex || 0) +
                  ".png",
                true,
              );
              serverSetting.elm.children[0].id =
                "specPI_" + (serverSetting.player.classIndex || 0);
            }
            if (
              serverSetting.elm.children[1].id !=
              "sf_" + serverSetting.player.flagIndex
            ) {
              serverSetting.elm.children[1].className =
                "specPlayerFlag" +
                (serverSetting.player.flagIndex > -1
                  ? " flag flag-" +
                    Game.flags[serverSetting.player.flagIndex][1]
                  : "");
              serverSetting.elm.children[1].id =
                "sf_" + serverSetting.player.flagIndex;
            }
            serverSetting.elm.children[0].classList.toggle(
              "silhouette",
              !serverSetting.player.active,
            );
            serverSetting.elm.children[4].style.display =
              CONTROLS.spect.target &&
              CONTROLS.spect.target.isPlayer &&
              CONTROLS.spect.target.sid == serverSetting.player.sid
                ? "inline-block"
                : "none";
            serverSetting.elm.children[5].style.display =
              kpdData && kpdData == serverSetting.player.id
                ? "inline-block"
                : "none";
          }
        } else {
          if (serverSetting.elm) {
            serverSetting.elm.remove();
            serverSetting.elm = null;
          }
          if (serverSetting.player) {
            serverSetting.team = null;
            serverSetting.player = null;
          }
        }
      }
    })();
  }
}
function addPlayers(data, keepSocketOpen) {
  var isYou;
  for (var i = 0; i < data.length; ) {
    isYou = data[i] == io.socketId;
    (serverSetting = Game.players.add(
      data[i],
      data[i + 1],
      data[i + 2],
      data[i + 3],
      data[i + 4],
      data[i + 5],
      data[i + 6],
      data[i + 12],
      data[i + 37],
      data[i + 13],
      data[i + 14],
      data[i + 33],
      data[i + 19],
      data[i + 20],
      data[i + 35],
      data[i + 25],
      data[i + 22],
      data[i + 24],
      data[i + 15],
      data[i + 21],
      data[i + 9],
      isYou,
      data[i + 16],
      data[i + 17],
      null,
      data[i + 28],
      data[i + 31],
    )).health = data[i + 7] == null ? serverSetting.maxHealth : data[i + 7];
    serverSetting.maxHealth = data[i + 8];
    serverSetting.hpChase = serverSetting.health / serverSetting.maxHealth;
    serverSetting.team = data[i + 9];
    serverSetting.level = data[i + 10];
    serverSetting.clan = data[i + 11];
    serverSetting.clanR = data[i + 36];
    serverSetting.maxElo = data[i + 23];
    serverSetting.eloCur = data[i + 38];
    serverSetting.yaw = data[i + 18];
    serverSetting.featured = data[i + 26];
    serverSetting.partner = data[i + 39];
    serverSetting.premiumT = data[i + 30];
    serverSetting.challLvl = data[i + 27] + 1;
    serverSetting.flagIndex = parseInt(data[i + 29]);
    serverSetting.slidCont = data[i + 32];
    serverSetting.accid = data[i + 34];
    if (isYou) {
      lastReconciliationAt = Date.now();
      player = serverSetting;
      if (Game.mode.showTeam) {
        teamName.style.opacity = 1;
        teamName.style.backgroundColor = Game.mode.teamColors
          ? Game.mode.teamColors[player.team - 1]
          : "rgba(0,0,0,0.6)";
        teamName.innerHTML = Game.mode.teamOptions[player.team - 1];
      }
      if (player.team) {
        var ho = document.getElementById(
          (Game.mode.flags ? "tScoreF" : "tScoreC") + player.team,
        );
        if (ho) {
          ho.className =
            (Game.mode.flags ? "material-icons tScoreF" : "tScoreC") + " you";
        }
      }
      cF();
      var hp =
        Game.mode.teamOptions &&
        Game.mode.teamOptions[player.team - 1] == "Prop";
      botRightHider.style.display = hp ? "none" : "block";
      propInstruct.style.display = hp ? "block" : "none";
      CONTROLS.object.rotation.y = player.yaw;
      CONTROLS.xDr = CONTROLS.object.rotation.y % Math.PI2;
    } else {
      serverSetting.objInstances.visible = false;
    }
    changeHealth(serverSetting.health, serverSetting.sid, null, null);
    i += 40;
  }
  if (!keepSocketOpen) {
    io.socket.close();
  }
}
function updatePlayerNames(data, keepSocketOpen) {
  for (var hl = 0; hl < data.length; ) {
    for (var i = 0; i < Game.players.list.length; ++i) {
      if (Game.players.list[i].id == data[hl]) {
        Game.players.list[i].name = data[hl + 1];
        Game.players.list[i].alias = data[hl + 2];
      }
    }
    hl += 3;
  }
  if (!keepSocketOpen) {
    io.socket.close();
  }
}
lastReconciliationAt = 0;
function reconcilePlayer(reconciliation, applyServerState) {
  io.send("v");
  if (player) {
    var now = Date.now();
    var msSinceLastReconciliation = now - lastReconciliationAt;
    if (UTILS.inRange(msSinceLastReconciliation, 3000, 20000)) {
      showNetworkLagWarning();
    }
    lastReconciliationAt = now;
    if (applyServerState) {
      player.x;
      player.x = reconciliation[2];
      player.y = reconciliation[3];
      player.z = reconciliation[4];
      player.onGround = reconciliation[9];
      player.didJump = reconciliation[10];
      player.didJumpW = reconciliation[11];
      player.onWall = reconciliation[12];
      player.onLadder = reconciliation[13];
      player.aimVal = reconciliation[14];
      player.crouchVal = reconciliation[15];
      player.velY = reconciliation[5];
      player.velX = reconciliation[6];
      player.velZ = reconciliation[7];
      player.xVelC = reconciliation[21];
      player.zVelC = reconciliation[22];
      player.yaw = reconciliation[8];
      Game.players.reload(
        player,
        0,
        false,
        reconciliation[16],
        undefined,
        true,
      );
      player.slideTimer = reconciliation[17];
      player.canSlide = reconciliation[18];
      player.onTerrain = reconciliation[19];
      for (
        var pendingInputIndex = 0;
        pendingInputIndex < CONTROLS.tmpInpts.length;
      ) {
        if (
          CONTROLS.tmpInpts[pendingInputIndex][0] <= reconciliation[0] ||
          CONTROLS.tmpInpts.length >= 2000
        ) {
          CONTROLS.tmpInpts.splice(pendingInputIndex, 1);
        } else {
          player.procInputs(CONTROLS.tmpInpts[pendingInputIndex], Game, true);
          pendingInputIndex++;
        }
      }
    } else {
      for (
        pendingInputIndex = 0;
        pendingInputIndex < CONTROLS.tmpInpts.length;
      ) {
        if (CONTROLS.tmpInpts[pendingInputIndex][0] <= reconciliation[0]) {
          CONTROLS.tmpInpts.splice(pendingInputIndex, 1);
        } else {
          pendingInputIndex++;
        }
      }
    }
    if (reconciliation[1]) {
      var pingChanged = currentPing != reconciliation[1];
      currentPing = reconciliation[1];
      if (pingChanged) {
        pingColor = COLORS.ping.low;
        if (currentPing >= 150) {
          pingColor = COLORS.ping.high;
        } else if (currentPing >= 50) {
          pingColor = COLORS.ping.medium;
        }
        pingText.textContent = currentPing == -1 ? "-" : currentPing;
        if (pingIcon.style.color != pingColor) {
          pingIcon.style.color = pingColor;
        }
        if (menuHolder.style.display != "none") {
          menuPingText.textContent = currentPing == -1 ? "-" : currentPing;
          if (menuPingIcon.style.color != pingColor) {
            menuPingIcon.style.color = pingColor;
          }
        }
      }
    }
  }
}
function socketPing() {
  io.send("po");
}
function socketPingResult(hj) {
  hj;
}
var fM;
var fN = Date.now();
function updateGameMessage(hj, hk) {
  if (hj == "wt") {
    hj = i18n.t("player.waiting");
  }
  if (hj) {
    hj += hk ? " " + hk : "";
  }
  gameMessage.textContent = hj || "";
  specGMessage.textContent = hj || "";
}
function updateTeam(hj, hk) {
  if ((serverSetting = Game.players.findBySid(hj))) {
    serverSetting.team = hk;
    if (serverSetting == player) {
      localTeam = hk;
      if (Game.mode.showTeam && Game.mode.teamOptions) {
        teamName.style.opacity = 1;
        teamName.style.backgroundColor = Game.mode.teamColors
          ? Game.mode.teamColors[hk - 1]
          : "rgba(0,0,0,0.6)";
        teamName.innerHTML = Game.mode.teamOptions[hk - 1];
      }
      if (Game.mode.teamOptions && Game.mode.teamOptions[hk - 1] == "Stalker") {
        Game.players.resetAim();
      }
    }
  }
}
function updateAmmo(hj) {
  if (player) {
    player.ammos = hj;
    Game.players.updatePlayerAmmo(player);
  }
}
function lockMoveArea(hj, hk, hl, hm) {
  Game.lockMove(player, hj, hk, hl, hm);
}
var fS = null;
function openTerminal(hj) {
  fS = hj;
  (function (hk) {
    if (fM) {
      fM.classList.remove("terminalEffect");
      hk.offsetWidth;
    }
    (fM = hk).classList.add("terminalEffect");
  })(terminalText);
  terminalHolder.style.display = "inline-block";
  terminalInput.focus();
}
function updateNoclip(hj) {
  if (player) {
    player.noclip = hj;
    addChat(null, "Noclip - " + (player.noclip ? "Enabled" : "Disabled"), 2);
  }
}
function updateUnlimitedAmmo(hj) {
  if (player) {
    player.unlimitedAmmo = hj;
    addChat(
      null,
      "Unlimited Ammo - " + (player.unlimitedAmmo ? "Enabled" : "Disabled"),
      2,
    );
  }
}
function updateForceHide(hj) {
  if (player) {
    player.forceHide = hj;
    addChat(null, "Hide - " + (player.forceHide ? "Enabled" : "Disabled"), 2);
  }
}
function setPlayerKey(hj, hk) {
  if (player) {
    player[hj] = hk;
  }
}
function refillKnife() {
  if (player) {
    player.refillKnife();
  }
}
function updatePlayerPositions(hj, hk) {
  Game.players.hideAll();
  if (hj) {
    for (var hl = 0; hl < hj.length; ) {
      if (
        (serverSetting = Game.players.findBySid(hj[hl])) &&
        serverSetting != player
      ) {
        serverSetting.objInstances.visible = !serverSetting.lodActive;
        serverSetting.sendRateA = hk;
        serverSetting.latestData = true;
        if (serverSetting.forcePos) {
          serverSetting.x = hj[hl + 1];
          serverSetting.y = hj[hl + 2];
          serverSetting.z = hj[hl + 3];
          serverSetting.yaw = hj[hl + 4];
          serverSetting.pitch = hj[hl + 5];
          serverSetting.interpolate = false;
          serverSetting.forcePos = false;
        } else {
          serverSetting.dt = 0;
          serverSetting.x1 = serverSetting.x;
          serverSetting.x2 = hj[hl + 1];
          serverSetting.y1 = serverSetting.y;
          serverSetting.y2 = hj[hl + 2];
          serverSetting.z1 = serverSetting.z;
          serverSetting.z2 = hj[hl + 3];
          serverSetting.xDir1 = serverSetting.yaw;
          serverSetting.xDir2 = hj[hl + 4];
          serverSetting.yDir1 = serverSetting.pitch;
          serverSetting.yDir2 = hj[hl + 5];
          serverSetting.interpolate = true;
        }
        serverSetting.onGround = hj[hl + 6];
        serverSetting.crouchVal = hj[hl + 7];
        serverSetting.aimVal = hj[hl + 9];
        Game.players.reload(serverSetting, 0, false, hj[hl + 8]);
      }
      hl += 10;
    }
  }
}
function removePlayer(hj) {
  cl[hj] &&= null;
  if (spectatorPlayerRows && spectatorPlayerRows.length) {
    var hk = spectatorPlayerRows.find((hl) => hl.player && hl.player.sid == hj);
    if (hk) {
      hk.player = null;
    }
  }
  Game.players.findBySid(hj);
  Game.players.remove(hj);
}
function killPlayer(hj, hk, hl, hm, ho, hp) {
  serverSetting = Game.players.findBySid(hj);
  eventOtherPlayer = Game.players.findBySid(hl);
  killCardKick.style.display = "none";
  var hq = false;
  if (serverSetting) {
    Game.players.kill(serverSetting);
    if (serverSetting.isYou) {
      reloadMsg.style.display = "none";
      deathsVal.textContent = hk || 0;
      localStreakCount = 0;
      streakVal.textContent = localStreakCount;
      var hu = "";
      if (eventOtherPlayer) {
        if (serverSetting != eventOtherPlayer) {
          if (
            (eventOtherPlayer.level <= 10 || !eventOtherPlayer.level) &&
            acc &&
            !Game.isCustom &&
            handledVoteKickAliases.indexOf(eventOtherPlayer.alias) == -1
          ) {
            hq = true;
          }
          CONTROLS.camLookAt(
            eventOtherPlayer.x,
            eventOtherPlayer.y + eventOtherPlayer.height / 1.5,
            eventOtherPlayer.z,
          );
          eventOtherPlayer.interpolate = false;
          eventOtherPlayer.isSpectating = true;
          if (eventOtherPlayer.objInstances) {
            eventOtherPlayer.objInstances.visible = true;
          }
        }
        hu =
          "<img id='kCProfile' src='https://assets.krunker.io/textures/classes/icon_" +
          eventOtherPlayer.classIndex +
          ".png' />";
        var hv = Math.floor(config.rankVar * Math.sqrt(hm[2] || 0));
        hu += "<div class='kClvl'>lvl " + (hv = Math.max(1, hv + 1)) + "</div>";
        hu +=
          "<div class='kCFlag" +
          (eventOtherPlayer.flagIndex > -1
            ? " flag flag-" + Game.flags[eventOtherPlayer.flagIndex][1]
            : "") +
          "'></div>";
        hu +=
          "<div id='kCName'>" +
          (Game.mode && Game.mode.isRanked
            ? UTILS.eloIconHTML(eventOtherPlayer.maxElo, "margin-right:3px")
            : "") +
          (eventOtherPlayer
            ? streamerModeEnabled && Filter
              ? UTILS.scrambleS(eventOtherPlayer.alias)
              : eventOtherPlayer.alias
            : "You") +
          (eventOtherPlayer.clan
            ? "<span class='" +
              (eventOtherPlayer.clanR == 1 ? "rainbowText" : "") +
              "' style='color:" +
              COLORS.getClanCol(
                eventOtherPlayer.clan,
                eventOtherPlayer.clanR,
                "rgba(255,255,255,0.3)",
              ) +
              "'> [" +
              eventOtherPlayer.clan +
              "]</span>"
            : "") +
          "</div>";
        var hw = eventOtherPlayer.loadout.indexOf(hm[0]);
        var hx =
          eventOtherPlayer.skins[hw] == null
            ? null
            : eventOtherPlayer.skins[hw];
        if (hx != null) {
          hx = Game.store.skins[hx];
        }
        if (hx && hx.weapon - 1 != eventOtherPlayer.loadout[hw]) {
          hx = null;
        }
        var hy = hx
          ? Game.store.rarities[hx.rarity].color
          : "rgba(255,255,255,0.7)";
        var hz = hx ? hx.name : Game.weaponConfig[hm[0]].name;
        var hA = !!hx && Game.store.rarities[hx.rarity].animate;
        if (hz == "Combat Knife" && ho && ho.fs) {
          hz = "Fists";
          hy = "rgba(255,255,255,0.7)";
          hA = false;
        } else if (
          hz == "Combat Knife" &&
          eventOtherPlayer.meleeIndex >= 0 &&
          Game.store.skins[eventOtherPlayer.meleeIndex]
        ) {
          hz = Game.store.skins[eventOtherPlayer.meleeIndex].name;
          hy =
            Game.store.rarities[
              Game.store.skins[eventOtherPlayer.meleeIndex].rarity
            ].color;
          hA =
            Game.store.rarities[
              Game.store.skins[eventOtherPlayer.meleeIndex].rarity
            ].animate;
        }
        hu +=
          "<br/><div id='kCInfo'" +
          (RENDER.rarityAnim && hA ? " class='rainbowText'" : "") +
          " style='color:" +
          hy +
          "'>[" +
          hz +
          "]</div>";
      }
      hu +=
        hm && hm[1]
          ? "<div id='kCInfoS' style='color:" +
            settings.list.scoreColor.val +
            ";'>+" +
            hm[1] +
            "</div>"
          : "";
      hu +=
        hm && hm[3]
          ? "<div id='kCStat'>" +
            hm[3][1] +
            " <span style='color:#fff'>" +
            hm[3][0] +
            "</span></div>"
          : "";
      killCardBy.textContent = eventOtherPlayer ? "Killed by" : "You died";
      killCardBy.style.float = eventOtherPlayer ? "left" : "none";
      killCard.style.display = eventOtherPlayer ? "inline-block" : "none";
      killCardKick.innerHTML =
        "<span style='color:#FBC02D'>[" +
        UTILS.getKeyName(CONTROLS.binds.pListKey.val) +
        "]</span> to Report";
      killCardKick.style.display = hq ? "inline-block" : "none";
      killCard.innerHTML = hu;
      if (eventOtherPlayer) {
        changeImg(
          kCProfile,
          eventOtherPlayer ? eventOtherPlayer.accid : null,
          settings.tmp.showPfp &&
            eventOtherPlayer &&
            eventOtherPlayer.premiumT > 0,
          "https://assets.krunker.io/textures/classes/icon_" +
            eventOtherPlayer.classIndex +
            ".png",
        );
      }
      if (Game.mode && Game.mode.canTrade) {
        window.closeWindow();
      }
      UI.toggleGameUI(false);
      setTimeout(function () {
        showMenu();
        if (Game.forceSpawn) {
          (function hD(hE) {
            playTick();
            setPlayStatusSubtitle("Auto Respawning in " + (hE - 1));
            if (hE > 1 && playStatusSubtitle) {
              autoRespawnTimerId = setTimeout(function () {
                if (playStatusSubtitle) {
                  hD(hE - 1);
                } else {
                  setPlayStatusSubtitle(null);
                }
              }, 1000);
            } else {
              setPlayStatusSubtitle(null);
            }
          })(Game.forceSpawn + 1);
        }
      }, config.deathDelay);
    }
    if (!hp && settings.tmp.showKillFeed) {
      var hB =
        serverSetting == player
          ? "<span style='color:" + COLORS.killFeed.you + "'>You</span>"
          : "<span style='color:" +
            (localTeam && localTeam == serverSetting.team
              ? COLORS.killFeed.ally
              : COLORS.killFeed.enemy) +
            "'>" +
            UTILS.fixStr(
              streamerModeEnabled && Filter
                ? UTILS.scrambleS(serverSetting.alias)
                : serverSetting.alias,
            ) +
            (serverSetting.clan && settings.tmp.leaderType == 1
              ? "<span class='" +
                (serverSetting.clanR == 1 ? "rainbowText" : "") +
                "' style='color:" +
                COLORS.getClanCol(
                  serverSetting.clan,
                  serverSetting.clanR,
                  "#fff",
                ) +
                "'> [" +
                UTILS.fixStr(serverSetting.clan) +
                "]</span>"
              : "") +
            "</span>";
      var hC =
        serverSetting == eventOtherPlayer
          ? ""
          : eventOtherPlayer == player
            ? "<span style='color:" + COLORS.killFeed.you + "'>You</span>"
            : eventOtherPlayer
              ? "<span style='color:" +
                (localTeam && localTeam == eventOtherPlayer.team
                  ? COLORS.killFeed.ally
                  : COLORS.killFeed.enemy) +
                "'>" +
                UTILS.fixStr(
                  streamerModeEnabled && Filter
                    ? UTILS.scrambleS(eventOtherPlayer.alias)
                    : eventOtherPlayer.alias,
                ) +
                (eventOtherPlayer.clan && settings.tmp.leaderType == 1
                  ? "<span class='" +
                    (eventOtherPlayer.clanR == 1 ? "rainbowText" : "") +
                    "' style='color:" +
                    COLORS.getClanCol(
                      eventOtherPlayer.clan,
                      eventOtherPlayer.clanR,
                      "#fff",
                    ) +
                    "'> [" +
                    UTILS.fixStr(eventOtherPlayer.clan) +
                    "]</span>"
                  : "") +
                "</span>"
              : "";
      if (eventOtherPlayer) {
        addKillFeed(eventOtherPlayer, ho, hC, hB);
      } else {
        addKillFeed(
          null,
          null,
          null,
          hB +
            " committed " +
            UTILS.fixStr(
              config.suicides[UTILS.randInt(0, config.suicides.length - 1)],
            ),
        );
      }
    }
  }
}
function updateKillStreak(hj, hk) {
  if (player) {
    if (hk) {
      if (player.streaks[hj]) {
        player.streaks[hj].cnt = hk;
      } else {
        player.streaks[hj] = {
          cnt: hk,
          streak: Game.streaks[hj],
        };
      }
    } else {
      player.streaks[hj] = null;
    }
    var hl = "";
    for (var hm = 0; hm < Game.streaks.length; ++hm) {
      if (player.streaks[hj]) {
        hl +=
          "<div class='killStreakItem' style='background-image: url(&quot;./img/streaks/" +
          hm +
          ".png&quot;)'><span>[" +
          UTILS.getKeyName(CONTROLS.binds.streakKeys.val[hm]) +
          "]</span><div class='killStreakCnt'>x" +
          player.streaks[hj].cnt +
          "</div></div>";
      }
    }
    killStreakHolder.innerHTML = hl;
  }
}
function killStreakMessage(hj, hk) {
  if ((serverSetting = Game.players.findBySid(hj))) {
    var hl =
      serverSetting == player
        ? "<span style='color:" + COLORS.killFeed.you + "'>You're</span>"
        : "<span style='color:" +
          (localTeam && localTeam == serverSetting.team
            ? COLORS.killFeed.ally
            : COLORS.killFeed.enemy) +
          "'>" +
          UTILS.fixStr(
            streamerModeEnabled && Filter
              ? UTILS.scrambleS(serverSetting.alias)
              : serverSetting.alias,
          ) +
          "</span> is";
    addChat(null, i18n.t("player.killstreak", hl, UTILS.fixStr(hk)), 1);
  }
}
function actionFeed(hj, hk, hl) {
  serverSetting = Game.players.findBySid(hj);
  eventOtherPlayer = Game.players.findBySid(hk);
  if (serverSetting) {
    var hm =
      serverSetting == player
        ? "<span style='color:" + COLORS.killFeed.you + "'>You</span>"
        : "<span style='color:" +
          (localTeam && localTeam == serverSetting.team
            ? COLORS.killFeed.ally
            : COLORS.killFeed.enemy) +
          "'>" +
          UTILS.fixStr(
            streamerModeEnabled && Filter
              ? UTILS.scrambleS(serverSetting.alias)
              : serverSetting.alias,
          ) +
          "</span>";
    var ho =
      eventOtherPlayer && eventOtherPlayer == player
        ? "<span style='color:#fff'>You</span>"
        : eventOtherPlayer
          ? "<span style='color:" +
            (localTeam && localTeam == eventOtherPlayer.team
              ? COLORS.killFeed.ally
              : COLORS.killFeed.enemy) +
            "'>" +
            UTILS.fixStr(
              streamerModeEnabled && Filter
                ? UTILS.scrambleS(eventOtherPlayer.alias)
                : eventOtherPlayer.alias,
            ) +
            "</span>"
          : "";
    addChat(null, hm + " " + UTILS.fixStr(hl) + " " + ho, 1);
  }
}
function updateLeaderboard(hj) {
  leaderboardData = hj;
  var hk = Game.mode.teams && !Game.mode.fakeNames;
  if (hj) {
    var hl = settings.tmp.leaderType ? "newL" : "l";
    if (hk && settings.tmp.leaderType) {
      var hm = [1, 1];
      (hu = ["", ""])[0] +=
        "<div class='newLeaderTeam'>" +
        teamNm1.textContent +
        "<div class='newLeaderTeamScore'>" +
        (Game.teams[1] || 0) +
        "</div></div>";
      hu[1] +=
        "<div class='newLeaderTeam'>" +
        teamNm2.textContent +
        "<div class='newLeaderTeamScore'>" +
        (Game.teams[2] || 0) +
        "</div></div>";
      var ho;
      for (var hp = 0; hp < hj.length; hp += 2) {
        if ((serverSetting = Game.players.findBySid(hj[hp]))) {
          hu[(ho = serverSetting.team - 1)] += "<div class='newLeaderItem'>";
          hu[ho] += "<div class='newLeaderCounter'>" + hm[ho] + ".</div>";
          hu[ho] +=
            Game.mode && Game.mode.isRanked && serverSetting.eloCur != null
              ? UTILS.eloIconHTML(serverSetting.eloCur, "margin-top:2px")
              : "";
          hu[ho] += serverSetting.partner
            ? " <i class='material-icons' style='color:" +
              COLORS.partner +
              ";margin-top:3px;font-size:23px;vertical-align:middle;'>verified</i>"
            : "";
          hu[ho] +=
            serverSetting.premiumT > 0
              ? " <i class='material-icons' style='color:" +
                COLORS.verified.clan +
                ";margin-top:3px;font-size:23px;vertical-align:middle;'>beenhere</i>"
              : "";
          hu[ho] += serverSetting.featured
            ? " <i class='material-icons' style='color:" +
              COLORS.verified.player +
              ";margin-top:3px;font-size:23px;vertical-align:middle;'>check_circle</i>"
            : "";
          hu[ho] +=
            "<div class='newLeaderName" +
            (player && hj[hp] == player.sid
              ? "M"
              : Game.mode.fakeNames ||
                  (localTeam && localTeam == serverSetting.team)
                ? "F"
                : "") +
            "'>" +
            (streamerModeEnabled
              ? UTILS.scrambleS(serverSetting.alias)
              : serverSetting.alias) +
            (serverSetting.clan
              ? "<span class='" +
                (serverSetting.clanR == 1 ? "rainbowText" : "") +
                "' style='color:" +
                COLORS.getClanCol(
                  serverSetting.clan,
                  serverSetting.clanR,
                  "#fff",
                ) +
                "'> [" +
                serverSetting.clan +
                "]</span>"
              : "") +
            "</div>";
          hu[ho] +=
            "<div class='newLeaderScore'>" +
            UTILS.formatNum(hj[hp + 1], 2) +
            "</div>";
          hu[ho] += "</div>";
          hm[ho]++;
        }
      }
      if (hm[0] <= 1) {
        hu[0] += "<div class='newLeaderNoPlayers'>No players</div>";
      }
      if (leaderContainer0) {
        leaderContainer0.innerHTML = hu[0];
        leaderContainer0.style.display = "block";
      }
      if (hm[1] <= 1) {
        hu[1] += "<div class='newLeaderNoPlayers'>No players</div>";
      }
      if (leaderContainer1) {
        leaderContainer1.innerHTML = hu[1];
        leaderContainer1.style.display = "block";
      }
      if (leaderContainerD) {
        leaderContainerD.style.display = "none";
      }
    } else {
      var hq = 1;
      var hu = "";
      for (
        hp = 0;
        hp < hj.length &&
        (!(serverSetting = Game.players.findBySid(hj[hp])) ||
          !((ho = serverSetting.team - 1),
          (hu += "<div class='" + hl + "eaderItem'>"),
          (hu += "<div class='" + hl + "eaderCounter'>" + hq + ".</div>"),
          (hu +=
            Game.mode && Game.mode.isRanked && serverSetting.eloCur != null
              ? UTILS.eloIconHTML(serverSetting.eloCur, "margin-top:2px")
              : ""),
          (hu += serverSetting.partner
            ? " <i class='material-icons' style='color:" +
              COLORS.partner +
              ";margin-top:5px;font-size:23px'>verified</i>"
            : ""),
          (hu +=
            serverSetting.premiumT > 0
              ? " <i class='material-icons' style='color:" +
                COLORS.verified.clan +
                ";margin-top:5px;font-size:23px'>beenhere</i>"
              : ""),
          (hu += serverSetting.featured
            ? " <i class='material-icons' style='color:" +
              COLORS.verified.player +
              ";margin-top:5px;font-size:23px'>check_circle</i>"
            : ""),
          (hu +=
            "<div class='" +
            hl +
            "eaderName" +
            (player && hj[hp] == player.sid
              ? "M"
              : Game.mode.fakeNames ||
                  (localTeam && localTeam == serverSetting.team)
                ? "F"
                : "") +
            "'>" +
            (streamerModeEnabled
              ? UTILS.scrambleS(serverSetting.alias)
              : serverSetting.alias) +
            (serverSetting.clan
              ? "<span class='" +
                (serverSetting.clanR == 1 ? "rainbowText" : "") +
                "' style='color:" +
                COLORS.getClanCol(
                  serverSetting.clan,
                  serverSetting.clanR,
                  "#fff",
                ) +
                "'> [" +
                serverSetting.clan +
                "]</span>"
              : "") +
            "</div>"),
          (hu +=
            "<div class='" +
            hl +
            "eaderScore'>" +
            UTILS.formatNum(hj[hp + 1], 2) +
            "</div>"),
          (hu += "</div>"),
          hq++,
          hq > 10));
        hp += 2
      );
      if (settings.tmp.leaderType) {
        if (leaderContainerD) {
          leaderContainerD.innerHTML =
            hq <= 1
              ? "<div class='newLeaderNoPlayers'>" +
                i18n.t("leaderboard.empty") +
                "</div>"
              : hu;
          leaderContainerD.style.display = "block";
        }
        if (leaderContainer0) {
          leaderContainer0.style.display = "none";
        }
        if (leaderContainer1) {
          leaderContainer1.style.display = "none";
        }
      } else {
        if (leaderContainer) {
          leaderContainer.innerHTML = hu;
        }
        if (hq <= 1) {
          leaderContainer.innerHTML = i18n.t("leaderboard.empty");
        }
      }
    }
  }
}
function g6(hj) {
  newLeaderDisplay.style.display =
    hj && settings.tmp.leaderType == 1 ? "inline-block" : "none";
}
function showTracer(hj) {
  if ((player && player.active) || window.spectating) {
    var hk = hj[1];
    var hl = hj[2];
    var hm = hj[3];
    var ho = hj[4];
    var hp = hj[5];
    var hq = hj[6];
    var hu = hj[7];
    var hv = hj[8];
    var hw = hj[9];
    var hx = hj[10];
    if (
      (serverSetting = Game.players.findBySid(hj[0])) &&
      PARTICLES.showTracers
    ) {
      if (serverSetting.latestData) {
        hy =
          serverSetting.y +
          serverSetting.height -
          config.cameraHeight -
          serverSetting.crouchVal * config.crouchDst;
        hz = UTILS.getD3D(serverSetting.x, hy, serverSetting.z, hk, hl, hm);
        hA = UTILS.direction2D(serverSetting.z, serverSetting.x, hm, hk);
        hB = UTILS.direction2D(
          UTILS.distance2D(serverSetting.x, serverSetting.z, hk, hm),
          hl,
          0,
          hy,
        );
        PARTICLES.physObj(
          serverSetting.x,
          hy,
          serverSetting.z,
          hA,
          hB,
          hz,
          hq,
          0,
        );
      } else {
        var hy =
          hv +
          hw -
          config.cameraHeight -
          serverSetting.crouchVal * config.crouchDst;
        var hz = UTILS.getD3D(hu, hy, hx, hk, hl, hm);
        var hA = UTILS.direction2D(hx, hu, hm, hk);
        var hB = UTILS.direction2D(UTILS.distance2D(hu, hx, hk, hm), hl, 0, hy);
        PARTICLES.physObj(hu, hy, hx, hA, hB, hz, hq, 0);
      }
    }
    if (
      ho != null &&
      player &&
      (serverSetting.latestData
        ? UTILS.distance2D(
            player.x,
            player.y,
            player.z,
            serverSetting.x,
            serverSetting.y,
            serverSetting.z,
          )
        : UTILS.distance2D(player.x, player.y, player.z, hu, hv, hx)) <= 160 &&
      Game.canSee(player, hk, hl, hm) == null
    ) {
      PARTICLES.effect(hk, hl, hm, ho, hp, 0);
      if (player) {
        SOUND.play3Dv(
          "rico_" + UTILS.randInt(1, 2),
          hk,
          hl,
          hm,
          55,
          0.55,
          1,
          player,
        );
      }
    }
  }
}
function endProjectile(hj, hk, hl, hm, ho, hp) {
  PARTICLES.disablePhys(hj, hk, hp, hl, hm, ho);
  if (hp) {
    PARTICLES.effect(hl, hm, ho, 0, 0, 0);
  }
}
function showProjectile(hj, hk, hl, hm, ho, hp, hq, hu, hv) {
  var hw;
  if (!isDocumentHidden) {
    if ((hw = hu ? Game.projectiles.stored[hp] : Game.weapons[hp].projectile)) {
      PARTICLES.physObj(
        hj,
        hk,
        hl,
        hm,
        ho,
        hw.range,
        false,
        null,
        null,
        hw,
        hq,
        null,
        hv,
      );
    }
  }
}
function explosion(hj, hk, hl, hm) {
  if (!isDocumentHidden && (player || window.spectating)) {
    serverSetting = RENDER.camera.getWorldPosition();
    var ho =
      1 -
      UTILS.getD3D(
        hj,
        hk,
        hl,
        serverSetting.x,
        serverSetting.y,
        serverSetting.z,
      ) /
        config.explosionRange;
    if (ho > 0) {
      RENDER.shake(ho * 0.14);
    }
    SOUND.play3D("explosion", hj, hk, hl, 1);
    PARTICLES.ExplosionManager.explodeAt(hj, hk, hl, hm * 0.08);
  }
}
function updateTeamScore(hj, hk) {
  Game.teams[hj] = hk;
  var hl = document.getElementById("tScoreV" + hj);
  if (hl) {
    hl.textContent = hk;
  }
  var hm = document.getElementById("specScoreTm" + (hj - 1));
  if (hm) {
    hm.textContent = hk;
  }
}
function updateFlagInfo(hj, hk) {
  var hl = document.getElementById("tScoreM" + hj);
  if (hl) {
    hl.textContent = hk;
  }
}
function getScore(hj, hk) {
  if (hj) {
    pendingScoreDelta += hj;
    overlay.animateText(
      overlay.scoreText,
      (pendingScoreDelta > 0 ? "+" : "") + pendingScoreDelta,
      settings.tmp.scoreTextScale * 100,
      0.38,
      1100,
      100,
      0,
      function () {
        pendingScoreDelta = 0;
      },
    );
    if (!hk) {
      player.score += hj;
      myScoreVal.textContent = player.score;
      cL();
    }
  }
}
function checkpointSet() {
  if (settings.tmp.showMedals) {
    overlay.animateText(
      overlay.checkText,
      i18n.t("popup.checkpoint"),
      75,
      0.38,
      1100,
      100,
      0,
      null,
    );
  }
}
function updateLives(lives) {
  if ((serverSetting = document.getElementById("livesDisp"))) {
    serverSetting.textContent = lives;
  }
}
var medalQueue = [];
function getKill(data, killSound, kills, streakIncrement) {
  localStreakCount += streakIncrement || 1;
  addMedal(data);
  if (killSound && killSound != -1) {
    SOUND.play(
      UTILS.isNumber(killSound) ? config.networkSounds[killSound] : killSound,
    );
  }
  killsVal.textContent = kills;
  streakVal.textContent = localStreakCount;
}
function showAssistMedal() {
  addMedal(["Assist", config.assistScore]);
}
function addMedal(data) {
  if (data) {
    var isNew = medalQueue.length == 0;
    for (var i = 0; i < data.length; ++i) {
      if (data[i] == "") {
        i++;
      } else {
        medalQueue.push(data[i]);
      }
    }
    if (isNew) {
      (function showMedal(ho) {
        if (settings.tmp.showMedals) {
          if (medalQueue.length > 0) {
            overlay.animateDiv(
              overlay.chalName,
              medalQueue[0],
              medalQueue[1] ? "+" + medalQueue[1] : null,
              130,
              0.4,
              config.medalAnim,
              100,
              ho,
              function () {
                medalQueue.splice(0, 2);
                showMedal(0);
              },
            );
          }
        }
      })(config.medalDelay);
    }
  }
}
function updateProp(sid, prop) {
  if ((serverSetting = Game.players.findBySid(sid))) {
    Game.players.updateProp(serverSetting, prop, true);
  }
}
function updateInteractProgress(progress) {
  interactProg.style.display = progress && progress > 0 ? "block" : "none";
  if (progress) {
    interProgB.style.width = progress * 100 + "%";
  }
}
var tradeChatEntry;
var chatStyle;
var chatClass;
var lastHealth = 0;
function changeHealth(val, sid, x, z) {
  if (
    (player || window.spectating) &&
    (serverSetting =
      sid == null || sid == null ? player : Game.players.findBySid(sid))
  ) {
    serverSetting.health = val;
    if (serverSetting.health > serverSetting.maxHealth) {
      serverSetting.maxHealth = serverSetting.health;
    }
    cx(sid, "HP", serverSetting.health);
    cx(sid, "MHP", serverSetting.maxHealth);
    var ho = val / serverSetting.maxHealth;
    if (serverSetting == player && player) {
      healthValue.innerHTML =
        val + " <span id='maxHP'>| " + serverSetting.maxHealth + "</span>";
      var hp = "";
      for (
        var hq = Game.classes[player.classIndex].segs,
          hu = hq * ho,
          hv = hu,
          hw = 0;
        hw < hq;
        ++hw
      ) {
        hp +=
          "<div class='healthBarSeg'><div class='hpBSeg' style='width:" +
          Math.max(0, Math.min(1, hv)) * 100 +
          "%;background-color:" +
          (hu <= 3
            ? settings.list.hudHealthLow.val
            : settings.list.hudHealthHigh.val) +
          "'></div></div>";
        hv -= 1;
      }
      healthBar.innerHTML = hp;
      if (settings.tmp.showDMGOverlay) {
        if (overlay.bloodCustom) {
          bloodDisplay.style.display = ho <= 0.8 ? "block" : "none";
          bloodDisplay.style.opacity = 1 - ho / 0.8;
        } else {
          overlay.bloodOpacity = 1 - ho / 0.8;
        }
      }
      if (val < lastHealth) {
        if (x != null && x != null) {
          (function (hx, hy) {
            if (overlay.showHits) {
              var hz = null;
              for (var hA = 0; hA < overlay.hits.length; ++hA) {
                if (!overlay.hits[hA].life) {
                  hz = overlay.hits[hA];
                  break;
                }
              }
              if (!hz) {
                hz = {};
                overlay.hits.push(hz);
              }
              hz.life = config.hitLife;
              hz.x = hx;
              hz.z = hy;
            }
          })(x, z);
        }
        SOUND.play("impact_0", 0.8);
      }
      lastHealth = val;
    }
  }
}
function appendChatMessage(html, className, style, type) {
  while (chatList.childNodes.length >= config.chatListLength) {
    var ho = chatList.childNodes[0];
    fadingMessageEntries[parseInt(ho.id.replace("chatMsg_", ""))].life = 0;
    chatList.removeChild(ho);
  }
  var hp = null;
  var hq = null;
  for (var hu = 0; hu < fadingMessageEntries.length; ++hu) {
    if (!fadingMessageEntries[hu].life && !fadingMessageEntries[hu].elm) {
      hp = fadingMessageEntries[hu];
      hq = hu;
      break;
    }
  }
  if (!hp) {
    hp = {};
    hq = fadingMessageEntries.length;
    fadingMessageEntries.push(hp);
  }
  if (hp.elm) {
    hp.elm.remove();
  }
  hp.type = 0;
  hp.life = settings.list.chatTimer.val * 1000;
  (tempElement = document.createElement("div")).id = "chatMsg_" + hq;
  tempElement.innerHTML =
    "<div class='chatItem" +
    (className && className.length ? " " + className : "") +
    "'" +
    (style && style.length ? " style='" + style + "'" : "") +
    ">" +
    html +
    "</div><br>";
  hp.elm = tempElement;
  chatList.insertAdjacentElement("beforeend", hp.elm);
  if (isInGame || type == 4) {
    chatList.scrollTop = chatList.scrollHeight - chatList.clientHeight;
  }
}
function appendTradeChatMessage(html, className, style) {
  while (tradeChatList.childNodes.length >= config.chatListLength) {
    var hm = tradeChatList.childNodes[0];
    tradeChatList.removeChild(hm);
  }
  (tradeChatEntry = document.createElement("div")).innerHTML =
    "<div class='tradeChatItem" +
    (className && className.length ? " " + className : "") +
    "'" +
    (style && style.length ? " style='" + style + "'" : "") +
    ">" +
    html +
    "</div><br>";
  tradeChatList.insertAdjacentElement("beforeend", tradeChatEntry);
  tradeChatList.scrollTop =
    tradeChatList.scrollHeight - tradeChatList.clientHeight;
}
function addTradeChat(sender, msg, type) {
  chatStyle =
    settings.tmp.chatBGOpacity == 0.2
      ? ""
      : "background-color: rgba(0, 0, 0, " + settings.tmp.chatBGOpacity + ")";
  chatClass = settings.tmp.chatTextOutline ? "chatTextOutline" : "";
  if ((streamerModeEnabled || settings.tmp.filterChat) && Filter) {
    msg = Filter.clean(msg);
  }
  if (streamerModeEnabled) {
    sender = UTILS.scrambleS(sender);
  }
  msg = UTILS.fixStr(msg);
  appendTradeChatMessage(
    type == 2
      ? "<span class='chatMsg' style='color:#fc03ec'>" + msg + "</span>"
      : UTILS.fixStr(sender || "unknown") +
          ": <span class='chatMsg'>" +
          msg +
          "</span>",
    chatClass,
    chatStyle,
  );
}
function addChat(sender, msg, type, color, senderColor) {
  if (type || settings.tmp.showPlayerMsg) {
    chatStyle =
      settings.tmp.chatBGOpacity == 0.2
        ? ""
        : "background-color: rgba(0, 0, 0, " + settings.tmp.chatBGOpacity + ")";
    chatClass = settings.tmp.chatTextOutline ? "chatTextOutline" : "";
    if (
      (streamerModeEnabled || settings.tmp.filterChat) &&
      Filter &&
      type != 3
    ) {
      msg = Filter.clean(msg);
    }
    if (streamerModeEnabled && (!type || !(type < 3))) {
      sender = UTILS.scrambleS(sender);
    }
    if (type != 3) {
      msg = UTILS.fixStr(msg);
    }
    if (type == 1 || type == 4) {
      appendChatMessage(
        "<span class='chatMsg'>" + msg + "</span>",
        chatClass,
        chatStyle,
        type,
      );
    } else if (type == 2) {
      appendChatMessage(
        "<span class='chatMsg' style='color:" +
          (color || "#fc03ec") +
          "'>" +
          msg +
          "</span>",
        chatClass,
        chatStyle,
        type,
      );
    } else if (type == 3) {
      appendChatMessage(
        UTILS.fixStr(sender || "unknown") +
          " wants to trade <span class='tradeMsg' style='color:" +
          (color || "#5ce05a") +
          "' onclick='acceptRequest(" +
          msg +
          ");this.innerHTML=`[Accepted]`;'>[Accept]</span>",
        chatClass,
        chatStyle,
        type,
      );
    } else {
      sender = UTILS.fixStr(sender || "unknown");
      if (senderColor) {
        sender =
          "<span style='color:" + senderColor + "'>" + sender + "</span>";
      }
      appendChatMessage(
        sender + ": <span class='chatMsg'>" + msg + "</span>",
        chatClass,
        chatStyle,
        type,
      );
    }
  }
}
window.welcome = function (hj) {
  addChat(null, hj, 2);
};
var feedWeaponConfig;
var meleeIconPadding = [
  5, -10, 5, -7, 2, 5, 0, 2, 6, 6, 7, 5, 5, 0, -8, 10, 0, -6, 7, -28, -28, 5,
];
function addKillFeed(killer, killData, killerName, feedText) {
  var ho = settings.tmp.leaderType == 0;
  if (ho) {
    while (chatList.childNodes.length >= config.chatListLength) {
      var hp = chatList.childNodes[0];
      fadingMessageEntries[parseInt(hp.id.replace("chatMsg_", ""))].life = 0;
      chatList.removeChild(hp);
    }
    chatStyle =
      settings.tmp.chatBGOpacity == 0.2
        ? ""
        : "background-color: rgba(0, 0, 0, " + settings.tmp.chatBGOpacity + ")";
    chatClass = settings.tmp.chatTextOutline ? "chatTextOutline" : "";
  } else {
    while (killFeed.childNodes.length >= settings.list.feedLimit.val) {
      hp = killFeed.childNodes[0];
      fadingMessageEntries[parseInt(hp.id.replace("feed_", ""))].life = 0;
      killFeed.removeChild(hp);
    }
  }
  if ((streamerModeEnabled || settings.tmp.filterChat) && Filter) {
    feedText = Filter.clean(feedText);
  }
  var hq = null;
  var hu = null;
  for (var hv = 0; hv < fadingMessageEntries.length; ++hv) {
    if (!fadingMessageEntries[hv].life && !fadingMessageEntries[hv].elm) {
      hq = fadingMessageEntries[hv];
      hu = hv;
      break;
    }
  }
  if (!hq) {
    hq = {};
    hu = fadingMessageEntries.length;
    fadingMessageEntries.push(hq);
  }
  if (hq.elm) {
    hq.elm.remove();
  }
  hq.type = ho ? 0 : 1;
  hq.life = ho ? settings.list.chatTimer.val * 1000 : 4000;
  var hw = ho ? "chat" : "kf";
  (tempElement = document.createElement("div")).id =
    (ho ? "chatMsg_" : "feed_") + hu;
  if (killer == null) {
    tempElement.innerHTML =
      "<div class='" +
      hw +
      "Item" +
      (chatClass && chatClass.length && ho ? " " + chatClass : "") +
      "'" +
      (chatStyle && chatStyle.length && ho
        ? " style='" + chatStyle + "'"
        : "") +
      "><span class='" +
      hw +
      "Msg'>" +
      feedText +
      "</span></div><br>";
  } else {
    feedWeaponConfig =
      Game.weaponConfig[
        killData.wId == null ? killer.loadout[killer.weaponIndex] : killData.wId
      ];
    var hx =
      "<div class='" +
      hw +
      "Item" +
      (chatClass && chatClass.length && ho ? " " + chatClass : "") +
      "'" +
      (chatStyle && chatStyle.length && ho
        ? " style='" + chatStyle + "'"
        : "") +
      ">";
    hx += "<span class='" + hw + "Msg'>" + killerName;
    if (killData.stk != null) {
      hx +=
        "<img class='streakChatIcon' src='./img/streaks/" +
        killData.stk +
        ".png' />";
    } else if (killData.fs) {
      hx +=
        "<img class='fistChatIcon' src='" +
        UTILS.assetsUrl("/textures/weapons/icon_0.png") +
        "' />";
    } else if (feedWeaponConfig.melee) {
      var hy = Game.store.skins[killer.meleeIndex];
      if (killData.pj) {
        hx += "<img class='thrownChatIcon' src='./img/thrown_0.png'>";
      }
      hx +=
        "<img style='opacity:0.7;margin-right:" +
        meleeIconPadding[(hy && hy.id) || 0] +
        "px;' class='meleeChatIcon' src='" +
        UTILS.assetsUrl(
          "/textures/melee/icon_" + ((hy && hy.id) || 0) + ".png",
        ) +
        "' />";
    } else {
      hx +=
        "<img style='opacity:0.7;margin-right:" +
        (feedWeaponConfig.icnPad || 0) +
        "px;' class='weaponChatIcon' src='" +
        UTILS.assetsUrl("/textures/weapons/" + feedWeaponConfig.icon + ".png") +
        "' />";
      if (killData.wb) {
        hx += "<img class='headShotChatIcon' src='./img/wallbang_0.png'>";
      }
      if (killData.hs) {
        hx += "<img class='headShotChatIcon' src='./img/headshot_0.png'>";
      }
    }
    hx += feedText + "</span></div><br>";
    tempElement.innerHTML = hx;
  }
  hq.elm = tempElement;
  (ho ? chatList : killFeed).insertAdjacentElement("beforeend", hq.elm);
  if (ho && isInGame) {
    chatList.scrollTop = chatList.scrollHeight - chatList.clientHeight;
  }
}
function doDamage(targetSid, damage, crit, isKill, isAI) {
  SOUND.play("hit_0", 3.1);
  if (overlay.hitmarker.custom) {
    DIV.animateDiv(hitmarker, 350, 100, 105);
  } else if (overlay.hitmarker.image) {
    overlay.animateDiv(overlay.hitmarker, 350, 100, 105);
  } else {
    overlay.showHit(!!isKill);
  }
  if (damage && targetSid != null) {
    if (isAI) {
      if ((hp = Game.AI.findBySid(targetSid))) {
        overlay.dmgVal(hp.x, hp.y, hp.z, damage, crit);
      }
    } else {
      var hp;
      if ((hp = Game.players.findBySid(targetSid))) {
        overlay.dmgVal(hp.x, hp.y, hp.z, damage, crit);
      }
    }
  }
}
function toggleSettingByIndex(toggleIndex) {
  var settingKey = CONTROLS.toggleSets[toggleIndex];
  if (settings.list[settingKey]) {
    setSetting(settingKey, !settings.list[settingKey].val);
  }
}
function createSpawnable(spawnableType, sid, x, y, z, team) {
  Game.createSpawnable(spawnableType, sid, x, y, z, team, player);
}
function editMapResponse(mapData) {
  if (mapData) {
    window.saveVal("mapToEdit", mapData);
    window.open("/editor.html", "_blank");
  }
}
function respondKPDCall(response) {
  if (specKPDContr) {
    specKPDContr.style.display = "none";
  }
  io.send("rkpd", response);
}
window.grabMap = function (mapId) {
  if (acc) {
    io.send("edMp", mapId);
  }
};
window.favoriteM = function (type, element, creationId) {
  if (acc) {
    var isSelected = element.classList.contains("sel");
    element.classList.toggle("sel", !isSelected);
    io.send("fvM", type, creationId, ~~!isSelected);
  }
};
window.featureCreation = function (element, creationId, type) {
  if (acc && acc.canFeatureCreations) {
    var isSelected = element.classList.contains("sel");
    element.classList.toggle("sel", !isSelected);
    io.send("ftC", creationId, ~~!isSelected, type);
  }
};
window.deleteCreation = function (creationId, type) {
  if (acc && acc.canDeleteCreations) {
    dP("Please Wait...");
    io.send("delC", creationId, type);
  }
};
window.deleteCreationConf = function (creationId, type) {
  if (!acc) {
    return popupResponse(null, "Must be logged in");
  }
  resetPops();
  confPop.style.display = "block";
  var confirmHtml =
    "<div style='color:#fff;font-size:19px;position:relative;margin-bottom:15px;'>Are you sure you want to delete this " +
    (type == 0 ? "Map" : type == 1 ? "Mod" : "Asset") +
    "?</div><div id='confirmBtn' onclick='deleteCreation(" +
    creationId +
    ", " +
    type +
    ")' onmouseover='SOUND.play(&quot;tick_0&quot;,0.1)'>YES</div><div id='declineBtn' onclick='showPopup()' onmouseover='SOUND.play(&quot;tick_0&quot;,0.1)'>NO</div>";
  confPop.innerHTML = confirmHtml;
};
window.playMap = function (mapName) {
  window.open("/?play=" + mapName, "_self");
};
window.pressButton = function (keyCode) {
  if (keyCode == 27) {
    if (!CONTROLS.UsePointerLock) {
      CONTROLS.toggle(false);
      CONTROLS.resetKeys();
    }
    UI.toggleEndScreen();
  }
  if (
    activeVoteKickTarget &&
    player &&
    player.active &&
    handledVoteKickAliases.indexOf(activeVoteKickTarget) == -1
  ) {
    if (keyCode == 49) {
      io.send("v2k", activeVoteKickTarget, 1);
      handledVoteKickAliases.push(activeVoteKickTarget);
    } else if (keyCode == 50) {
      io.send("v2k", activeVoteKickTarget);
      voteToKick.style.display = "none";
      handledVoteKickAliases.push(activeVoteKickTarget);
    }
  }
  if (window.spectating) {
    if (keyCode == 70) {
      spectMode();
    }
    if (keyCode == 72) {
      if (
        !Game.mode.objective ||
        !Object.keys(Game.map.manager.spectateCams).length
      ) {
        return;
      }
      cq = true;
      cp = false;
      spectMode(-1);
    }
    if (keyCode == 48 && cq) {
      if (
        (spectateTarget = Game.map.manager.spectateCams[-1][0]) &&
        spectateTarget.active
      ) {
        CONTROLS.spect.target = spectateTarget;
      }
      cp = false;
    }
    if (keyCode > 48 && keyCode < 58) {
      var spectateTarget = null;
      if (cq) {
        spectateTarget =
          Game.map.manager.spectateCams[Game.activeObjective || 0][
            keyCode - 49
          ];
      } else if ((serverSetting = spectatorPlayerRows[keyCode - 49])) {
        spectateTarget = Game.players.list.find(
          (candidatePlayer) => candidatePlayer.sid == serverSetting.player.sid,
        );
      }
      if (spectateTarget && spectateTarget.active) {
        CONTROLS.spect.target = spectateTarget;
        cp = false;
        if (!cq) {
          io.send("fpSp", spectateTarget.sid);
        }
        cw();
      }
    }
    if (keyCode == 82) {
      (function (thirdPerson) {
        RENDER.aimRecticle.opacity = 0;
        aimRecticle.style.opacity = 0;
        if ((cu = thirdPerson)) {
          cv = true;
        } else {
          cv = null;
          window.noMouseInp = false;
        }
        CONTROLS.setCamPosOff();
        specIns.textContent = cu ? "Third Person" : "First Person";
      })(!cu);
    }
    if (kpdData) {
      if (keyCode == 78) {
        respondKPDCall(0);
      } else if (keyCode == 89) {
        respondKPDCall(1);
      }
    }
  }
  if (keyCode == CONTROLS.binds.chatKey.val) {
    if (document.activeElement == terminalInput) {
      if (terminalInput.value != "") {
        io.send("tmc", fS, terminalInput.value);
      }
      terminalInput.value = "";
      terminalInput.blur();
      terminalHolder.style.display = "none";
    } else if (document.activeElement == tradeChatInput) {
      if (tradeChatInput.value != "") {
        io.send("tct", tradeChatInput.value);
        tradeChatInput.value = "";
      }
      tradeChatInput.blur();
    } else if (document.activeElement == chatInput) {
      if (chatInput.value != "") {
        if (!sharedObj.disC) {
          sendChatMessage(chatInput.value);
        }
        chatInput.value = "";
      }
      chatInput.blur();
    } else if (document.activeElement != tradeChatInput && windows[36].active) {
      tradeChatInput.focus();
    } else if (document.activeElement != chatInput) {
      chatInput.focus();
    }
  }
  if (keyCode == CONTROLS.binds.pListKey.val) {
    if (document.activeElement.tagName == "INPUT") {
      return;
    }
    if (endUI.style.display == null) {
      return;
    }
    CONTROLS.resetKeys();
    if (CONTROLS.hasPointerlock) {
      CONTROLS.toggle(false);
    }
    setTimeout(() => showWindow(23), 0);
  }
  if (keyCode == CONTROLS.binds.sBoardKey.val) {
    g6(1);
  }
  if (player && player.active) {
    var actionIndex;
    if (keyCode == CONTROLS.binds.sprayKey.val) {
      io.send("int", 0);
    }
    if (keyCode == CONTROLS.binds.interactKey.val) {
      Game.players.interact(player, false);
      io.send("int", 1);
    }
    if (keyCode == CONTROLS.binds.interactSecKey.val) {
      io.send("int", 1, true);
    }
    if (keyCode == CONTROLS.binds.dropKey.val) {
      io.send("int", 2);
    }
    if (keyCode == CONTROLS.binds.inspKey.val) {
      Game.players.wInspect(player);
    }
    if ((actionIndex = CONTROLS.binds.streakKeys.val.indexOf(keyCode)) >= 0) {
      io.send("k", actionIndex);
    }
    if (keyCode == CONTROLS.binds.wepVisKey.val) {
      (function (activePlayer) {
        var weaponId = activePlayer.loadout[activePlayer.weaponIndex];
        if (Game.weaponConfig[weaponId].melee) {
          setSetting("showWeaponMel", !settings.tmp.showWeaponMel);
        } else if (Game.weaponConfig[weaponId].secondary) {
          setSetting("showWeaponSec", !settings.tmp.showWeaponSec);
        } else if (
          !Game.weaponConfig[weaponId].melee &&
          !Game.weaponConfig[weaponId].secondary
        ) {
          setSetting("showWeapon", !settings.tmp.showWeapon);
        }
      })(player);
    }
    for (
      var toggleIndex = 0;
      toggleIndex < CONTROLS.binds.toggleKeys.val.length;
      toggleIndex++
    ) {
      if (CONTROLS.binds.toggleKeys.val[toggleIndex] == keyCode) {
        toggleSettingByIndex(toggleIndex);
      }
    }
    if ((actionIndex = CONTROLS.binds.premiumKeys.val.indexOf(keyCode)) >= 0) {
      io.send("prmA", actionIndex);
    }
  }
};
window.releaseButton = function (keyCode) {
  if (keyCode == CONTROLS.binds.sBoardKey.val) {
    g6(0);
  }
};
var signatureCanvasContext = null;
var isDrawingSignature = false;
var previousSignaturePoint = null;
var currentSignaturePoint = null;
var useStandardFrameScheduler = true;
function gameLoop() {
  if (settings.tmp.updateRate) {
    var rateLimitNow = performance.now();
    if (rateLimitNow - lastRateLimitTime < 1000 / settings.tmp.updateRate) {
      requestAnimFrame(gameLoop);
      return;
    }
    lastRateLimitTime = rateLimitNow;
  }
  frameTimeMs = Date.now();
  deltaMs = frameTimeMs - lastFrameTime;
  deltaMs = Math.min(deltaMs, config.dltMx);
  unscaledDeltaMs = deltaMs;
  lastFrameTime = frameTimeMs;
  (function () {
    if (settings.list.showFPS.val) {
      while (
        fpsFrameTimes.length > 0 &&
        fpsFrameTimes[0] <= frameTimeMs - 1000
      ) {
        fpsFrameTimes.shift();
      }
      fpsFrameTimes.push(frameTimeMs);
      currentFps = fpsFrameTimes.length;
      if (currentFps && frameTimeMs - lastFpsDisplayUpdate >= 100) {
        lastFpsDisplayUpdate = frameTimeMs;
        ingameFPS.textContent = currentFps;
        if (menuHolder.style.display != "none") {
          menuFPS.textContent = currentFps;
        }
      }
    }
  })();
  CONTROLS.updateMouseInp();
  TWEEN.update();
  if (endAnimationTimeLeft > 0) {
    if ((endAnimationTimeLeft -= deltaMs) <= 0) {
      endAnimationTimeLeft = 0;
    }
  }
  SOUND.rate = Game.config.deltaMlt;
  if (endAnimationTimeLeft != null && spinUI.style.display != "block") {
    deltaMs *= endAnimationTimeLeft / config.endAnim;
    SOUND.rate = Game.config.deltaMlt * (endAnimationTimeLeft / config.endAnim);
  }
  if (!player && !window.spectating) {
    menuCameraYaw += deltaMs * 0.0001;
    menuCameraYaw %= Math.PI * 2;
    CONTROLS.rotateCam(menuCameraYaw, 0, 0);
  }
  if (
    classPreviewScene &&
    classPreviewCanvas.offsetWidth > 0 &&
    classPreviewCanvas.offsetHeight > 0
  ) {
    Game.players.playerStep(classPreviewPlayer, deltaMs * 0.015, true);
    classPreviewPlayer.idleAnim += config.idleAnimS * deltaMs;
    Game.players.updateMsh(classPreviewPlayer, true);
    classPreviewCamera.aspect = 660 / 350;
    classPreviewCamera.updateProjectionMatrix();
    classPreviewRenderer.setSize(660, 350);
    classPreviewRenderer.setPixelRatio(
      window.devicePixelRatio * settings.list.resolution.val,
    );
    classPreviewRenderer.render(classPreviewScene, classPreviewCamera);
    (function (deltaMs) {
      if (phoneImg.style.marginBottom == "0px") {
        if ((phoneRingTimer -= deltaMs) <= 0 && !isPoliceCallReported) {
          phoneRingTimer = 2200;
          SOUND.play("ring_0", 0.2);
        }
        if (isPoliceCallReported) {
          if ((phoneFlashTimer -= deltaMs) <= 0) {
            phoneFlashFrame = phoneFlashFrame ? 0 : 1;
            phoneImg.src = "./img/phone_" + (phoneFlashFrame ? "r" : "b") + ".png";
            phoneFlashTimer = UTILS.randInt(100, 300);
          }
        }
      }
      if (policePop.style.display == "block") {
        if ((policeSpeechTimer -= deltaMs) <= 0) {
          policeSpeechTimer = UTILS.randInt(15000, 30000);
          showSpeechBubble(policeIdleLines[UTILS.randInt(0, policeIdleLines.length - 1)], 3400, true);
        }
      }
    })(deltaMs);
  }
  (function (deltaMs) {
    if (
      spinUI.style.display == "block" &&
      ((spinCanvas.width = spinCanvas.clientWidth),
      (spinCanvas.height = spinCanvas.clientHeight),
      (spinItemCanvas.style.width = spinCanvas.clientWidth * 2.1 + "px"),
      (spinItemCanvas.style.height = spinCanvas.clientWidth * 2.1 + "px"),
      spinItemRenderer.setSize(
        spinCanvas.clientWidth * 2.1,
        spinCanvas.clientWidth * 2.1,
      ),
      spinCanvas.width > 0)
    ) {
      if (spinWhlMlt < 1) {
        if ((spinWhlMlt += deltaMs * 0.008) >= 1) {
          spinWhlMlt = 1;
        }
      }
      if (endAnimVal < endAnimTarget) {
        if ((endAnimVal += deltaMs * 0.4) >= endAnimTarget) {
          endAnimVal = endAnimTarget;
        }
        if (!spinWheel.free && !spinWheel.twitch) {
          canRespin = true;
        }
        spinItem.style.display = "block";
        spinItemName.style.display = "inline-block";
        respinUI.style.display = "inline-block";
      }
      if (spinRotation != spinVal) {
        spinRotation += (spinVal - spinRotation) * 0.024;
        if ((tickCounter -= (spinVal - spinRotation) * 0.024) <= 0) {
          tickCounter += Math.PI / 1.5;
          SOUND.play("tick_0", 0.2);
        }
        if (spinVal - spinRotation <= 0.002) {
          spinRotation = spinVal;
          endAnimTarget = 100 - spinWheel.getRarities(acc)[winItem.rarity];
          SOUND.play("reward", 0.3);
          confetti({
            spread: 360,
            origin: {
              x: 0.5,
              y: 0.5,
            },
            particleCount: Game.store.rarities[winItem.rarity].confC,
            colors: Game.store.rarities[winItem.rarity].confCols,
          });
          if (io) {
            io.send("unbx");
          }
          if (spinWheel.kr && acc) {
            spinKR.innerHTML =
              "<span style='color:rgba(255,255,255,0.6)'>" +
              UTILS.commaNumber(acc.funds) +
              "</span> KR";
          }
          if (winItem.rarity >= 1) {
            SOUND.play("cheer_0", 0.1);
          }
        }
      }
      var spinButtonOpacity = 1 - (endAnimTarget ? endAnimVal / endAnimTarget : 0);
      spinCanvasContext.translate(2, 2);
      var wheelRadius = (spinCanvas.width / 2) * 0.95 * spinWhlMlt;
      spinButton.style.opacity = spinButtonOpacity;
      var hw = wheelRadius * 0.3 * (1 - spinButtonOpacity);
      spinButton.style.width = wheelRadius * 2 * 0.6 * 0.8 + hw + "px";
      spinButton.style.height = wheelRadius * 2 * 0.6 * 0.8 + hw + "px";
      spinText.style.fontSize = wheelRadius * 2 * 0.6 * 0.15 + hw + "px";
      spinCost.style.fontSize = wheelRadius * 2 * 0.6 * 0.08 + hw + "px";
      spinCanvasContext.fillStyle = "#fff";
      spinCanvasContext.beginPath();
      spinCanvasContext.arc(
        spinCanvas.width / 2,
        spinCanvas.height / 2,
        wheelRadius,
        0,
        Math.PI * 2,
      );
      spinCanvasContext.closePath();
      spinCanvasContext.fill();
      var hx = 0;
      spinCanvasContext.save(1);
      spinCanvasContext.translate(spinCanvas.width / 2, spinCanvas.height / 2);
      if (endAnimTarget) {
        var hy = 0;
        for (var hz = 0; hz < Game.store.rarities.length; hz++) {
          if (winItem.rarity == hz) {
            hy += spinWheel.getRarities(acc)[hz] / 2;
            break;
          }
          hy += spinWheel.getRarities(acc)[hz];
        }
        hy /= 100;
        hy = (Math.PI * 2 * hy * (endAnimVal / endAnimTarget)) % (Math.PI * 2);
        spinCanvasContext.rotate(hy - Math.PI * (endAnimVal / endAnimTarget));
      }
      for (hz = 0; hz < Game.store.rarities.length; hz++) {
        serverSetting = Game.store.rarities[hz];
        spinCanvasContext.fillStyle = serverSetting.color;
        spinCanvasContext.beginPath();
        var hA = spinWheel.getRarities(acc)[hz];
        if (endAnimTarget) {
          if (winItem.rarity == hz) {
            if (RENDER.rarityAnim && serverSetting.animate) {
              spinCanvasContext.fillStyle = UTILS.hexFromHue(Math.round(spinHue));
              if ((spinHue += deltaMs * 0.3) >= 360) {
                spinHue = 0;
              }
            }
            hA += endAnimVal;
          } else {
            hA -= endAnimVal * (spinWheel.getRarities(acc)[hz] / endAnimTarget);
          }
        }
        if (hA > 0) {
          spinCanvasContext.moveTo(0, 0);
          spinCanvasContext.arc(
            0,
            0,
            wheelRadius * 0.95,
            hx,
            hx + Math.PI * 2 * (hA / 100),
            false,
          );
          spinCanvasContext.lineTo(0, 0);
          spinCanvasContext.fill();
        }
        hx += Math.PI * 2 * (hA / 100);
      }
      spinCanvasContext.restore();
      spinCanvasContext.fillStyle = "#F44336";
      spinCanvasContext.shadowColor = "black";
      spinCanvasContext.shadowBlur = 20;
      spinCanvasContext.save(1);
      spinCanvasContext.translate(spinCanvas.width / 2, spinCanvas.height / 2);
      spinCanvasContext.rotate(spinRotation);
      spinCanvasContext.beginPath();
      var hB =
        (spinButton.getBoundingClientRect().width / spinButton.offsetWidth -
          1) *
        (wheelRadius * 0.6) *
        0.3;
      spinCanvasContext.moveTo(
        0,
        (wheelRadius * 0.6 * -1.2 - hB) * spinButtonOpacity,
      );
      spinCanvasContext.lineTo(wheelRadius * 0.6 * spinButtonOpacity, 0);
      spinCanvasContext.lineTo(wheelRadius * -0.6 * spinButtonOpacity, 0);
      spinCanvasContext.closePath();
      spinCanvasContext.fill();
      spinCanvasContext.restore();
      spinCanvasContext.fillStyle = "#fff";
      spinCanvasContext.beginPath();
      spinCanvasContext.arc(
        spinCanvas.width / 2,
        spinCanvas.height / 2,
        wheelRadius * 0.6,
        0,
        Math.PI * 2,
      );
      spinCanvasContext.closePath();
      spinCanvasContext.fill();
      if (spinItem.style.display == "block" && spinnerScene) {
        var itemNameFocus = 1 - Math.abs(spinItemCamera.position.x - 30) / 270;
        spinItemName.style.opacity = itemNameFocus;
        spinItemName.style.marginTop = wheelRadius * 0.6 + "px";
        spinItemName.style.fontSize =
          (wheelRadius / 6.5) * itemNameFocus + "px";
        if (!spinWheel.kr) {
          spinItemName.children[0].style.fontSize =
            (wheelRadius / 12) * itemNameFocus + "px";
        }
        if (!spinWheel.kr) {
          spinItemName.children[1].style.fontSize =
            (wheelRadius / 12) * itemNameFocus + "px";
        }
        spinItemName.style.padding = (wheelRadius / 20) * itemNameFocus + "px";
        spinItemName.style.paddingLeft =
          (wheelRadius / 2) * itemNameFocus + "px";
        spinItemName.style.paddingRight =
          (wheelRadius / 2) * itemNameFocus + "px";
        if (spinItemCamera.position.x != 30) {
          spinItemCamera.position.x -= (spinItemCamera.position.x - 30) * 0.24;
          if (Math.abs(30 - spinItemCamera.position.x) <= 0.05) {
            spinItemCamera.position.x = 30;
          }
          spinItemCamera.lookAt(spinnerScene.position);
        }
        spinItemBobTime += deltaMs * 0.0018;
        spinnerPreview.position.y =
          spinnerPreview.orgYP + Math.sin(spinItemBobTime) * 0.55;
        spinnerPreview.rotation.x =
          spinnerPreview.orgXR + Math.sin(spinItemBobTime * 0.9) * -0.042;
        spinItemRenderer.render(spinnerScene, spinItemCamera);
      }
    }
  })(deltaMs);
  if (menuHolder.style.display != "none") {
    dd();
  }
  CONTROLS.update(deltaMs * Game.config.deltaMlt);
  if (player && player.active && !window.locked) {
    if (Game.config.thirdPerson) {
      RENDER.camera.position.set(config.thrdPX, 2, config.thrdPZ);
    } else if (
      Game.mode &&
      Game.mode.teamOptions &&
      Game.mode.teamOptions[player.team - 1] == "Prop"
    ) {
      propCameraDistance += CONTROLS.scrollDelta * 5;
      propCameraDistance = Math.min(Math.max(10, propCameraDistance), 100);
      RENDER.camera.position.set(0, 0, propCameraDistance);
    } else {
      RENDER.camera.position.set(0, 0, 0);
    }
    var inputYaw = CONTROLS.xDr;
    if (CONTROLS.camOffset) {
      RENDER.camera.position.x += Game.map.config.camOffX;
      RENDER.camera.position.y += Game.map.config.camOffY;
      RENDER.camera.position.z += Game.map.config.camOffZ;
    }
    if (CONTROLS.freeMouse) {
      RENDER.camera.lookAt(
        player.x,
        player.y + player.height - config.cameraHeight,
        player.z,
      );
      RENDER.camera.getWorldPosition(freeMouseRay.origin);
      freeMouseRay.direction.set(
        (CONTROLS.mouseX / window.innerWidth) * 2 - 1,
        (-CONTROLS.mouseY / window.innerHeight) * 2 + 1,
        0.5,
      );
      freeMouseRay.direction.unproject(RENDER.camera);
      freeMouseRay.direction.sub(freeMouseRay.origin).normalize();
      if (CONTROLS.camType.isTop) {
        freeMouseAimPlane.normal.set(0, 1, 0);
        freeMouseRay.origin.y -= player.y + player.height;
        freeMouseRay.direction.y = Math.min(freeMouseRay.direction.y, -0.0001);
      } else if (CONTROLS.camType.isSideX) {
        freeMouseAimPlane.normal.set(0, 0, 1);
        freeMouseRay.origin.z -= player.z;
        freeMouseRay.direction.z = Math.min(freeMouseRay.direction.z, -0.0001);
      } else if (CONTROLS.camType.isSideZ) {
        freeMouseAimPlane.normal.set(1, 0, 0);
        freeMouseRay.origin.x -= player.x;
        freeMouseRay.direction.x = Math.max(freeMouseRay.direction.x, 0.0001);
      }
      var freeMouseHitPointE = freeMouseHitPoint;
      freeMouseRay.intersectPlane(freeMouseAimPlane, freeMouseHitPointE);
      if (CONTROLS.camType.isTop) {
        inputYaw =
          -(freeMouseLookAngle = Math.atan2(
            freeMouseHitPointE.z - player.z,
            freeMouseHitPointE.x - player.x,
          )) -
          Math.PI / 2;
        CONTROLS.yDr = 0;
      } else if (CONTROLS.camType.isSideX || CONTROLS.camType.isSideZ) {
        freeMouseLookAngle = Math.atan2(
          freeMouseHitPointE.y - (player.y + player.height),
          CONTROLS.camType.isSideX
            ? freeMouseHitPointE.x - player.x
            : freeMouseHitPointE.z - player.z,
        );
        var sideViewFacingForward = Math.abs(freeMouseLookAngle) < Math.PI / 2;
        if (CONTROLS.camType.isSideX) {
          inputYaw = ((sideViewFacingForward ? -1 : 1) * Math.PI) / 2;
        } else if (CONTROLS.camType.isSideZ) {
          inputYaw = (sideViewFacingForward ? 1 : 0) * Math.PI;
        }
        if (!sideViewFacingForward) {
          freeMouseLookAngle =
            -freeMouseLookAngle + Math.PI * Math.sign(freeMouseLookAngle);
        }
        CONTROLS.yDr = freeMouseLookAngle;
      }
    }
    CONTROLS.skipScroll = false;
    currentInputFrame = [
      CONTROLS.getISN(),
      Math.round(deltaMs * Game.config.deltaMlt),
      Math.round(inputYaw.round(3) * 1000),
      Math.round(CONTROLS.yDr.round(3) * 1000),
      Game.moveLock ? -1 : config.movDirs.indexOf(CONTROLS.moveDir),
      CONTROLS.isShooting || CONTROLS.keys[CONTROLS.binds.shootKey.val] ? 1 : 0,
      CONTROLS.isAiming || CONTROLS.keys[CONTROLS.binds.aimKey.val] ? 1 : 0,
      !Game.moveLock && CONTROLS.didPressed[CONTROLS.binds.jumpKey.val] ? 1 : 0,
      CONTROLS.keys[CONTROLS.binds.crouchKey.val] ? 1 : 0,
      CONTROLS.keys[CONTROLS.binds.reloadKey.val] ? 1 : 0,
      CONTROLS.scrollToSwap
        ? CONTROLS.scrollDelta * settings.tmp.scrollDirM
        : 0,
      CONTROLS.switchAction,
      1 - CONTROLS.speedLmt.round(1),
    ];
    if (CONTROLS.scrollDelta) {
      CONTROLS.skipScroll = CONTROLS.scrollToSwap;
      if (!CONTROLS.scrollToSwap) {
        CONTROLS.fakeKey(20000, 1);
      }
    }
    CONTROLS.scrollDelta = 0;
    CONTROLS.switchAction = 0;
    CONTROLS.didPressed = {};
    if (hh > 0) {
      if ((hh -= deltaMs) <= 0) {
        hh = -1;
        jumpScare(hg - 1);
      }
    }
    CONTROLS.tmpInpts.push(currentInputFrame);
    player.procInputs(currentInputFrame, Game, false, Game.moveLock);
    if (!CONTROLS.freeMouse) {
      CONTROLS.rotateCam(
        RENDER.shakeY,
        RENDER.shakeX +
          player.recoilAnimY * config.recoilMlt +
          player.landBobY * 0.1,
        0,
      );
    }
    CONTROLS.moveCam(
      player.x,
      player.y + player.height - config.cameraHeight,
      player.z,
    );
    UI.updateCrosshair(
      Math.max(58, player.spread * 1.1 * crosshairScale),
      (!Game.config.thirdPerson && !CONTROLS.camOffset) || player.weapon.scope
        ? player.aimVal *
            (player.inspecting ? 0 : 1) *
            (player.weapon && player.weapon.noCross ? 0 : 1) *
            (Game.mode &&
            Game.mode.teamOptions &&
            Game.mode.teamOptions[player.team - 1] == "Prop"
              ? 0
              : 1) *
            (player.reloadTimer > 0 ? 0 : 1) *
            (CONTROLS.freeMouse ? 0 : 1)
        : 1,
    );
    if (!Game.singlePlayer && !endAnimationTimeLeft) {
      (function (inputFrame) {
        if (firstInputSeq === null) {
          firstInputSeq = inputFrame[0];
        }
        inputDeltaTimes.push(inputFrame[1]);
        for (var inputFieldIndex = 2; inputFieldIndex < 4; ++inputFieldIndex) {
          if (compressedAimDeltas.length < 2) {
            compressedAimDeltas.push(inputFrame[inputFieldIndex]);
          } else {
            var aimDelta =
              inputFrame[inputFieldIndex] -
              (lastInputValues[inputFieldIndex] || 0);
            compressedAimDeltas.push(aimDelta);
          }
          lastInputValues[inputFieldIndex] = inputFrame[inputFieldIndex];
        }
        for (
          inputFieldIndex = 4;
          inputFieldIndex < inputFrame.length;
          ++inputFieldIndex
        ) {
          if (
            lastInputValues[inputFieldIndex] == null ||
            lastInputValues[inputFieldIndex] != inputFrame[inputFieldIndex]
          ) {
            lastInputValues[inputFieldIndex] = inputFrame[inputFieldIndex];
            dirs[queuedInputCount + "-" + inputFieldIndex] =
              inputFrame[inputFieldIndex];
            hasChangedInputFields = true;
          }
        }
        queuedInputCount++;
        if ((inputSendTimer += deltaMs) >= config.clientSendRate) {
          inputSendTimer -= config.clientSendRate;
          (function () {
            if (!Game.singlePlayer && player && player.active) {
              if (!hasChangedInputFields) {
                dirs = 0;
              }
              var mouseDX = "";
              var deltaStringLength = 0;
              var mouseDY = 0;
              serverSetting = "";
              for (
                var batchIndex = 0;
                batchIndex < inputDeltaTimes.length;
                ++batchIndex
              ) {
                serverSetting = inputDeltaTimes[batchIndex].toString();
                mouseDX += serverSetting;
                deltaStringLength = serverSetting.length;
                if (mouseDY) {
                  if (mouseDY != deltaStringLength) {
                    mouseDY = 0;
                    mouseDX = inputDeltaTimes;
                    break;
                  }
                } else {
                  mouseDY = deltaStringLength;
                }
              }
              if (compressedAimDeltas && compressedAimDeltas.length > 2) {
                var zeroAimDeltaPairCount = 0;
                for (
                  batchIndex = 2;
                  batchIndex < compressedAimDeltas.length;
                ) {
                  if (
                    compressedAimDeltas[batchIndex] != 0 ||
                    compressedAimDeltas[batchIndex + 1] != 0
                  ) {
                    zeroAimDeltaPairCount = 0;
                    break;
                  }
                  zeroAimDeltaPairCount++;
                  batchIndex += 2;
                }
                if (zeroAimDeltaPairCount) {
                  compressedAimDeltas.length = 2;
                }
              }
              var aimDeltasUnchanged = true;
              for (
                batchIndex = 0;
                batchIndex < compressedAimDeltas.length;
                ++batchIndex
              ) {
                if (
                  compressedAimDeltas[batchIndex] !=
                  lastSentAimDeltas[batchIndex]
                ) {
                  aimDeltasUnchanged = false;
                  break;
                }
              }
              io.send(
                "q",
                firstInputSeq,
                aimDeltasUnchanged ? 0 : compressedAimDeltas,
                dirs,
                mouseDX,
                mouseDY,
              );
              dirs = {};
              lastSentAimDeltas = [...compressedAimDeltas];
              compressedAimDeltas.length = 0;
              inputDeltaTimes.length = 0;
              hasChangedInputFields = false;
              firstInputSeq = null;
              queuedInputCount = 0;
            }
          })();
        }
      })(currentInputFrame);
    }
    Howler.pos(
      player.x,
      player.y + player.height - config.cameraHeight,
      player.z,
    );
    Howler.orientation(
      Math.sin(CONTROLS.xDr + Math.PI),
      CONTROLS.yDr,
      Math.cos(CONTROLS.xDr + Math.PI),
    );
    if (Game.singlePlayer && player.y <= Game.map.deathY) {
      killPlayer(player.sid, player.deaths);
    }
  } else if (window.spectating) {
    if (CONTROLS.spect.target) {
      window.noMouseInp = false;
      if (
        CONTROLS.spect.target.isPlayer &&
        Game.players &&
        Game.players.list &&
        Game.players.list.indexOf(CONTROLS.spect.target) < 0
      ) {
        spectMode();
      } else if (cq) {
        window.noMouseInp = true;
        if (!cp) {
          cp = true;
          CONTROLS.object.rotation.x = CONTROLS.spect.target.yR;
          CONTROLS.object.rotation.y = CONTROLS.spect.target.xR;
          CONTROLS.object.rotation.z = CONTROLS.spect.target.zR;
          var ho = CONTROLS.spect.target;
          CONTROLS.object.position.set(ho.x, ho.y, ho.z);
          RENDER.camera.position.set(0, 0, 0);
          RENDER.camera.updateProjectionMatrix();
          RENDER.updateFrustum();
        }
      } else if (CONTROLS.spect.target.active) {
        if (cv && cu) {
          window.noMouseInp = true;
          overlay.fakeCross = true;
          var hp =
            (ho = CONTROLS.spect.target).y +
            CONTROLS.spect.target.height -
            config.cameraHeight;
          if (CONTROLS.spect.target.isPlayer) {
            if (!cm.crouch) {
              cm.crouch = 0;
            }
            if (cm.crouch < CONTROLS.spect.target.crouchVal) {
              cm.crouch += deltaMs * 0.0085;
              if (cm.crouch >= CONTROLS.spect.target.crouchVal) {
                cm.crouch = CONTROLS.spect.target.crouchVal;
              }
            } else if (cm.crouch > CONTROLS.spect.target.crouchVal) {
              cm.crouch -= deltaMs * 0.0085;
              if (cm.crouch <= CONTROLS.spect.target.crouchVal) {
                cm.crouch = CONTROLS.spect.target.crouchVal;
              }
            }
            hp -= cm.crouch * config.crouchDst;
            if (CONTROLS.spect.target.weapon) {
              if (cm.aim == null) {
                cm.aim = 1;
              }
              if (cm.aim < CONTROLS.spect.target.aimVal) {
                cm.aim += deltaMs * 0.009;
                if (cm.aim >= CONTROLS.spect.target.aimVal) {
                  cm.aim = CONTROLS.spect.target.aimVal;
                }
              } else if (cm.aim > CONTROLS.spect.target.aimVal) {
                cm.aim -= deltaMs * 0.009;
                if (cm.aim <= CONTROLS.spect.target.aimVal) {
                  cm.aim = CONTROLS.spect.target.aimVal;
                }
              }
              RENDER.zoom(
                1 + (CONTROLS.spect.target.weapon.zoom - 1) * (1 - cm.aim),
              );
              if (CONTROLS.spect.target.weapon.scope) {
                if (RENDER.aimRecticle.custom) {
                  aimRecticle.style.opacity = 1 - CONTROLS.spect.target.aimVal;
                } else {
                  RENDER.aimRecticle.opacity = 1 - CONTROLS.spect.target.aimVal;
                }
              }
            }
          }
          ho = CONTROLS.spect.target;
          CONTROLS.moveCam(ho.x, hp, ho.z);
          CONTROLS.object.rotation.y = CONTROLS.spect.target.yaw;
          CONTROLS.pitchObj.rotation.x = CONTROLS.spect.target.pitch;
          if (CONTROLS.spect.target.objInstances) {
            CONTROLS.spect.target.objInstances.visible = false;
          }
        } else {
          CONTROLS.followCam(CONTROLS.spect.target, deltaMs);
          if (CONTROLS.spect.target.objInstances) {
            CONTROLS.spect.target.objInstances.visible = true;
          }
        }
      } else {
        spectMode();
      }
    }
    if (
      !CONTROLS.spect.target &&
      (!Game || !Game.mode || !Game.mode.noFreeCam)
    ) {
      CONTROLS.updateFreeCam(deltaMs);
    }
    Howler.pos(
      CONTROLS.object.position.x,
      CONTROLS.object.position.y,
      CONTROLS.object.position.z,
    );
    Howler.orientation(
      Math.sin(CONTROLS.xDr + Math.PI),
      CONTROLS.yDr,
      Math.cos(CONTROLS.xDr + Math.PI),
    );
    fG();
  }
  Game.update(deltaMs, frameTimeMs, player);
  Game.updateFlags(player, deltaMs);
  Game.updateSpawnables(player, deltaMs);
  (function (hq) {
    for (var hu = 0; hu < fadingMessageEntries.length; hu++) {
      if (fadingMessageEntries[hu].life) {
        fadingMessageEntries[hu].life -= hq;
        if (fadingMessageEntries[hu].life <= 0) {
          if (fadingMessageEntries[hu].elm) {
            fadingMessageEntries[hu].elm.remove();
          }
          fadingMessageEntries[hu].elm = null;
          fadingMessageEntries[hu].life = 0;
        }
      }
    }
  })(deltaMs);
  DIV.update(deltaMs);
  if (signatureCanvasContext && isDrawingSignature) {
    signatureCanvasContext.moveTo(
      previousSignaturePoint.x,
      previousSignaturePoint.y,
    );
    signatureCanvasContext.lineTo(
      currentSignaturePoint.x,
      currentSignaturePoint.y,
    );
    signatureCanvasContext.stroke();
    previousSignaturePoint = currentSignaturePoint;
  }
  if (billboardBidTimeLeft != null) {
    if ((billboardBidTimeLeft -= deltaMs) < 0) {
      billboardBidTimeLeft = 0;
    }
    if (menuHolder.style.display != "none") {
      tmpEl = document.getElementById("tiBBbid");
      if (tmpEl) {
        tmpEl.innerHTML = UTILS.getReadableTime(billboardBidTimeLeft, true);
      }
    }
  }
  if (imgFlash.style.display == "block") {
    imgFlash.style.opacity -= deltaMs * 0.002;
    if (imgFlash.style.opacity <= 0) {
      imgFlash.style.opacity = 0;
      imgFlash.style.display = "none";
    }
  }
  overlay.render(
    scale,
    Game,
    CONTROLS,
    RENDER,
    player,
    deltaMs,
    unscaledDeltaMs,
    voiceStreamQueues,
  );
  if (
    !window.spectating &&
    menuHolder.style.display == "block" &&
    !!config.isProd &&
    !isLobbyHost &&
    (!acc || !acc.developer) &&
    (!Game.config || !Game.config.isFromQueue) &&
    (!Game || !Game.mode || !Game.mode.noKick)
  ) {
    CONTROLS.idleTimer += deltaMs;
    if (CONTROLS.idleTimer >= config.kickTimer) {
      disconnect(i18n.t("player.inactive"), "000005");
    }
  }
  if (
    menuHider.style.display == "block" &&
    lastStreamPanelUpdateTime &&
    frameTimeMs - lastStreamPanelUpdateTime >= config.streamRotation
  ) {
    rotateStreamPanel();
  }
  if (frameTimeMs - fN >= config.nameVisRate) {
    fN = frameTimeMs;
    (function () {
      if (
        !Game.singlePlayer &&
        ((player && player.active) || window.spectating)
      ) {
        for (var hq = 0; hq < Game.players.list.length; ++hq) {
          if (
            (serverSetting = Game.players.list[hq]).active &&
            serverSetting.objInstances &&
            serverSetting != player
          ) {
            serverSetting.isSpectating =
              !window.spectating || serverSetting != CONTROLS.spect.target;
            if (serverSetting.latestData) {
              if (
                !window.spectating &&
                (!localTeam ||
                  localTeam != serverSetting.team ||
                  Game.mode.fakeNames) &&
                (!localTeam ||
                  localTeam == serverSetting.team ||
                  !Game.mode.teamSee ||
                  Game.mode.teamSee[0] != localTeam ||
                  Game.mode.teamSee[1] != serverSetting.team) &&
                (Game.config.nameTags ||
                  Game.mode.hideNames ||
                  Game.canSee(
                    player,
                    serverSetting.x,
                    serverSetting.y,
                    serverSetting.z,
                  ) != null)
              ) {
                serverSetting.isSpectating = false;
              }
              if (
                (settings.list.hideNames.val == 1 &&
                  (!Game.mode.teams ||
                    (localTeam && localTeam != serverSetting.team))) ||
                (settings.list.hideNames.val == 2 &&
                  localTeam &&
                  localTeam == serverSetting.team) ||
                settings.list.hideNames.val == 3 ||
                Game.mode.hideNames
              ) {
                serverSetting.isSpectating = false;
              }
              Game.players.toggleLOD(
                serverSetting,
                !!window.spectating ||
                  Game.canSee(
                    RENDER.fpsCamera.getWorldPosition(),
                    serverSetting.x,
                    serverSetting.y + serverSetting.height + 1,
                    serverSetting.z,
                    15,
                    true,
                  ) == null,
              );
            } else {
              serverSetting.isSpectating = false;
              Game.players.toggleLOD(serverSetting, !!window.spectating);
            }
          }
        }
        for (hq = 0; hq < Game.AI.ais.length; ++hq) {
          if ((serverSetting = Game.AI.ais[hq]).active) {
            serverSetting.canBSeen =
              window.spectating ||
              Game.canSee(
                player,
                serverSetting.x,
                serverSetting.y,
                serverSetting.z,
                0,
                0,
                true,
              ) == null;
          }
        }
      }
    })();
  }
  if (useStandardFrameScheduler) {
    if (CONTROLS.isShooting && settings.list.aimFreezeFix.val) {
      useStandardFrameScheduler = false;
    }
    requestAnimFrame(gameLoop);
  } else {
    requestAnimFrameF(gameLoop, frameTimeMs);
    useStandardFrameScheduler = true;
  }
}
var bubbleHideTimeoutId;
var activeConnectionError;
function showSpeechBubble(html, durationMs, playSighSound) {
  if (html) {
    if (playSighSound) {
      SOUND.play(["sigh_0", "sigh_1"][UTILS.randInt(0, 1)], 0.2);
    }
    txtBubble.innerHTML = html;
    bubbleContainer.style.transform = "scale(1.0)";
    if (bubbleHideTimeoutId) {
      clearTimeout(bubbleHideTimeoutId);
    }
    bubbleHideTimeoutId = setTimeout(function () {
      bubbleContainer.style.transform = "scale(0.0)";
    }, durationMs || 2100);
  }
}
function showConnectionErrorScreen(errorMessage, errorCode) {
  console.trace("Error message", errorMessage);
  instructionHolder.style.display = "block";
  if (errorMessage == "GAME UPDATING") {
    instructions.style.display = "none";
    instructionsUpdate.style.display = "block";
    instructionsUpdateBG.style.backgroundImage =
      'url("./img/menu-bg/' + UTILS.randInt(0, 2) + '.png")';
    instructionsUpdateBG.style.display = "block";
    instructionsUpdateCredit.style.display = "block";
    instructionsUpdate.innerHTML =
      "<div style='color: rgba(255, 255, 255, 0.6);margin-top: 5px;'>GAME UPDATING</div><iframe id='updatingStream' style='width:635px;height:360px;border:none;margin-top:10px;display:none'></iframe><iframe id='updatingStreamChat' style='width:270px;height:360px;border:none;margin-top:10px;display:none' frameborder='0' scrolling='no'></iframe><div style='margin-top:10px;font-size:15px;color:rgba(255,255,255,0.4)'>While you wait <a target='_blank' href='https://www.twitch.tv/directory/game/Krunker'>go chat</a> with some Krunker Streamers</a></div><div style='color: rgba(255, 255, 255, 0.6);font-size: 20px;margin-bottom: 13px;margin-top: 10px;'><a href='javascript:;' onclick='showWindow(2)'>Find Game</a> | <a href='javascript:;' onclick='showWindow(1)'>Settings</a> | <a href='javascript:;' onclick='showWindow(35)'>Changelog</a></div>";
    API_CLIENT.listStreams(1, function (err, featuredStream) {
      if (featuredStream && featuredStream.n) {
        instructionsUpdate.style.width = "920px";
        updatingStream.src =
          "https://player.twitch.tv/?channel=" +
          featuredStream.n +
          "&parent=" +
          location.hostname;
        updatingStreamChat.src =
          "https://www.twitch.tv/embed/" +
          featuredStream.n +
          "/chat?darkpopout&parent=" +
          location.hostname;
        updatingStream.style.display = "inline-block";
        updatingStreamChat.style.display = "inline-block";
      }
    });
  } else {
    instructions.innerHTML =
      "<span style='color: rgba(255, 255, 255, 0.6)'>" +
      errorMessage +
      "</span><br/><span style='color: rgba(255, 255, 255, 0.6)'>" +
      i18n.t("error.seek") +
      " <a href='/'>here</a>.</span><div style='margin-top:10px;font-size:20px;color:rgba(255,255,255,0.4)'>" +
      i18n.t("error.extentions") +
      " (Error 0x" +
      (errorCode || window.krunkerErrorCode || "000000") +
      ")</div>";
  }
  instructionHolder.style.pointerEvents = "all";
}
function updatePlayInstructions() {
  if (
    !io.socket ||
    (io.socket.readyState != WebSocket.CLOSING &&
      io.socket.readyState != WebSocket.CLOSED)
  ) {
    var playInstructionsHtml = CONTROLS.gamepad.active
      ? i18n.t("app.play.controller")
      : UI.isMobile
        ? "TAP TO PLAY"
        : i18n.t("app.play");
    if (queueStatusMessage) {
      playInstructionsHtml +=
        "<div id='instructionsSubtitle'>" +
        queueStatusMessage.toUpperCase() +
        "</div>";
      playInstructionsHtml +=
        "<div id='instructionsSubtitle'>" + queueReadyMessage + "</div>";
    }
    playInstructionsHtml += RENDER.assetProgress
      ? "<div id='instructionsSubtitle'>" +
        RENDER.assetProgress.toUpperCase() +
        "</div>"
      : "";
    playInstructionsHtml += playStatusSubtitle
      ? "<div id='instructionsSubtitle'>" +
        playStatusSubtitle.toUpperCase() +
        "</div>"
      : "";
    instructions.innerHTML = playInstructionsHtml;
  }
}
function fatalError(errorMessage, errorCode) {
  io.connected = false;
  activeConnectionError = errorMessage;
  showWindow(0);
  CONTROLS.disable();
  UI.hideUI();
  UI.hideDiscon();
  showConnectionErrorScreen(errorMessage, errorCode);
  if (io.socket) {
    io.socket.onclose = function () {};
  }
  disconnect = function () {};
}
function disconnect(disconnectMessage, errorCode, silent) {
  if (!activeConnectionError && !Game.singlePlayer) {
    if (io && io.socket) {
      io.socket.onclose = function () {};
      io.socket.close();
    }
    if (!silent) {
      showWindow(0);
      CONTROLS.disable();
      UI.hideUI();
      UI.hideDiscon();
      showConnectionErrorScreen(
        disconnectMessage || i18n.t("player.disconnect"),
        errorCode,
      );
    }
  }
}
UI.updatePlayInstructions = updatePlayInstructions;
window.openTab = function (hj) {
  window.open(hj, "_blank");
};
var currentEventStream = false;
var seenEventStream = false;
var cachedLiveStreams = [];
var lastStreamPanelUpdateTime = 0;
var streamPanelMode = 0;
function renderStreamPanel(streamPayload) {
  lastStreamPanelUpdateTime = Date.now();
  streamPanelMode = (streamPayload && streamPayload.c) || 0;
  var streamPanelHtml = "";
  if ((streamPayload = streamPayload.d) && streamPayload.length) {
    if (streamPanelMode == 0) {
      cachedLiveStreams = streamPayload;
    }
    if (!seenEventStream) {
      if (
        (currentEventStream = cachedLiveStreams
          ? cachedLiveStreams.find((hm) => hm.e)
          : null) &&
        !currentEventStream.f
      ) {
        seenEventStream = currentEventStream;
      }
    }
    if (currentEventStream) {
      streamPanelHtml +=
        "<div class='streamItem'><div class='strmCat esports'>Live Event!</div></div>";
      streamPanelHtml +=
        "<div class='streamItem' style='margin-top:10px' onclick='openTwitch(&quot;" +
        currentEventStream.n +
        "&quot;)'><iframe src='https://player.twitch.tv/?channel=" +
        currentEventStream.n +
        "&amp;parent=" +
        location.hostname +
        "' height='160' width='280' frameborder='0' scrolling='no' autoplay='true' allowfullscreen='false'></iframe></div>";
    } else {
      streamPanelHtml +=
        "<div class='streamItem' onclick='openTab(&quot;" +
        (streamPanelMode
          ? "https://www.youtube.com/channel/UCqH34FGuOae5o-wO2wOa38A"
          : "https://www.twitch.tv/directory/game/Krunker") +
        "&quot;)'><div class='strmCat " +
        (streamPanelMode
          ? "youtube'>Featured Creators"
          : "twitch'>" +
            (config.dropsEnabled ? "Drops Enabled" : "Streaming LIVE") +
            "!") +
        "</div></div>";
      if (streamPayload.length > 3) {
        streamPayload.length = 3;
      }
      for (
        var streamIndex = 0;
        streamIndex < streamPayload.length && streamPayload[streamIndex].a;
        ++streamIndex
      ) {
        streamPanelHtml +=
          "<div class='streamItem' onclick='" +
          (streamPanelMode
            ? "openTab(&quot;" + streamPayload[streamIndex].l + "&quot;)"
            : "onTwitchClick(&quot;" +
              streamPayload[streamIndex].n +
              "&quot;)") +
          "'><div class='streamName'>" +
          (streamPayload[streamIndex].p
            ? "<div style='display:inline-block;'><i class='material-icons streamPartner'>check_circle</i></div>"
            : "") +
          "<div class='strmLink blackShad'>" +
          streamPayload[streamIndex].n +
          "</div><div class='strmViews' style='" +
          (streamPayload[streamIndex].c == 2 ? "color:#d72ded" : "") +
          "'>" +
          (streamPayload[streamIndex].c
            ? streamPayload[streamIndex].c == 2
              ? "Artist"
              : "Youtuber"
            : i18n.t("streamers.views", streamPayload[streamIndex].v)) +
          "</div></div><img class='strmIcn' src='" +
          (streamPayload[streamIndex].c
            ? streamPayload[streamIndex].lo
            : "https://static-cdn.jtvnw.net/jtv_user_pictures/" +
              streamPayload[streamIndex].lo) +
          "'/></div>";
      }
    }
  } else {
    streamPanelHtml =
      "<span style='color:rgba(244,60,60,0.5)'>" +
      i18n.t("streamers.none") +
      "</span>";
  }
  streamContainer.innerHTML = streamPanelHtml;
}
function rotateStreamPanel() {
  if (!currentEventStream) {
    if (++streamPanelMode > 1) {
      streamPanelMode = 0;
    }
    if (streamPanelMode == 0) {
      renderStreamPanel({
        c: 0,
        d: cachedLiveStreams,
      });
    } else if (streamPanelMode == 1) {
      var shuffledCreators = [...streamers];
      shuffledCreators.sort(() => Math.random() - Math.random()).slice(0, 3);
      renderStreamPanel({
        c: 1,
        d: shuffledCreators,
      });
    }
  }
}
function playCustomMap(data) {
  Game.singlePlayer = true;
  if (io && io.socket) {
    io.socket.close();
  }
  io.send = function () {};
  try {
    initGame(
      0,
      null,
      null,
      null,
      null,
      {
        maps: [0],
      },
      null,
      0,
      {
        data: data,
      },
      null,
      true,
    );
  } catch (e) {}
  deleteVal("custMap");
  showMenu();
  window.history.replaceState({}, "Krunker Offline", "offline");
}
function initLoad(validationCode) {
  if (!getSavedVal("frostgiv")) {
    bdayBlock.style.display = "block";
    saveVal("frostgiv", 1);
  }
  io.send(
    "load",
    typeof __LOADER__calcGameValidationCode == "undefined"
      ? null
      : __LOADER__calcGameValidationCode(io, validationCode, "###PVT###"),
  );
  if (typeof Module != "undefined") {
    Module.csv().then((hk) => {
      io.send("csv", hk);
    });
  }
}
function readyLoad(sendVanityName, isReady) {
  if (isReady) {
    API_CLIENT.listStreams(0, function (err, streamPayload) {
      renderStreamPanel(streamPayload || {});
    });
    (function () {
      if (!referralCode) {
        authToken = getSavedVal("krunker_token");
        var savedUsername = getSavedVal("krunker_username");
        if (authToken && savedUsername) {
          sendAccountRequest(1, [savedUsername, null, authToken]);
        }
        var lastSeenAt = getSavedVal("krunker_last");
        var now = Date.now();
        saveVal("krunker_last", now);
        if (!lastSeenAt || now - lastSeenAt >= 600000) {
          io.send("sb", "welc", savedUsername);
        }
      }
    })();
    if (referralCode) {
      showWindow(5);
    }
    if (sendVanityName) {
      io.send("van", getSavedVal("krunker_username"));
    }
  } else {
    io.socket.close();
  }
}
function receiveClientValidation(hj) {
  Module.rsvr(hj);
}
window.onTwitchClick = function (hj) {
  var hk =
    "<div class='twitchIframe'><iframe src='https://player.twitch.tv/?channel=" +
    hj +
    "&amp;parent=" +
    location.hostname +
    "' height='340' width='600' frameborder='0' scrolling='no' autoplay='true' allowfullscreen='false'></iframe><iframe src='https://www.twitch.tv/embed/" +
    hj +
    "/chat?darkpopout&amp;parent=" +
    location.hostname +
    "' frameborder='0' scrolling='no' height='340' width='250'></iframe></div>";
  twitchHolder.innerHTML = hk;
  twitchHolder.style.display = "block";
};
window.closeTwitch = function () {
  twitchHolder.innerHTML = "";
  twitchHolder.style.display = "none";
};
if (!getSavedVal("consent")) {
  consentBlock.style.display = "block";
}
var connecting = false;
function joinServer(host, port, gameId, clientKey, pgi, bypassToken) {
  if (settings.tmp.useNetRerouting && host.startsWith("ip_")) {
    host = "cf_" + host;
  }
  port;
  host;
  var params = [];
  if (gameId) {
    params.push("gameId=" + gameId);
  }
  if (clientKey) {
    params.push("clientKey=" + clientKey);
  }
  if (pgi) {
    params.push("pgi=" + pgi);
  }
  if (bypassToken) {
    params.push("bpt=" + bypassToken);
  }
  var url = "//" + host + ":" + port + "/ws?" + params.join("&");
  if (io && io.socket) {
    io.socket.onclose = function () {};
    io.socket.close();
    io.socket = null;
    io.connected = false;
  }
  io.connect(
    url,
    function (err) {
      if (err) {
        console.warn("IO connect error", err);
        if (activeConnectionError != null) {
          return;
        }
        disconnect(null, "000001");
      } else if (play) {
        autoHostMap(play);
      } else {
        showMenu();
        if (settings.tmp.chatDisplay) {
          settings.tmp.chatDisplay = false;
          chatUI.style.display = "block";
        }
        infoHolder.style.display = null;
        aHolder.style.display = null;
        var mapToLoad = getSavedVal("mapToLoad");
        deleteVal("mapToLoad");
        if (mapToLoad) {
          selectHostMap(mapToLoad);
        }
        var custToLoad = getSavedVal("custToLoad");
        deleteVal("custToLoad");
        if (custToLoad) {
          selectHostMap(false, custToLoad);
        }
        var mapToPlay = getSavedVal("mapToPlay");
        deleteVal("mapToPlay");
        if (mapToPlay) {
          autoHostMap(mapToPlay);
        }
      }
    },
    {
      n: nukeUpdate,
      0: addPlayers,
      "00": updatePlayerNames,
      k: updatePlayerPositions,
      code: showServerPasswordPrompt,
      codeT: updateServerPasswordCountdown,
      init: initGame,
      "inst-id": setGameInstanceId,
      load: initLoad,
      csv: receiveClientValidation,
      iq: initQueueSession,
      qr: queueResponse,
      bb: clanBulletinResponse,
      vr: voucherRedeemResponse,
      ctrR: crtrCodRes,
      kml: mailListResponse,
      cust: customRoomResponse,
      ready: readyLoad,
      cln: clanResponse,
      start: startGame,
      nwT: newTok,
      pur: purchaseResponse,
      clm: claimRewardResponse,
      gmsg: updateGameMessage,
      pc: playCustomMap,
      inat: applyPlayerInteraction,
      inatA: applyPlayerInteractionAll,
      sb: showSpeechBubble,
      clnL: clanLeaveResponse,
      upR: uploadResponse,
      upPR: profileUploadResponse,
      lock: lockPlayer,
      end: endGame,
      spin: spinResponse,
      skin: skinReward,
      spinKR: freeKrSpinResponse,
      ts: updateTeamScore,
      t: updateTimer,
      pErr: purchaseError,
      error: fatalError,
      dc: disconnect,
      unb: unboxMessage,
      zn: Game.updateZone,
      uf: updateFunds,
      l: reconcilePlayer,
      ufi: updateFlagInfo,
      noc: updateNoclip,
      unl: updateUnlimitedAmmo,
      s: playPlayerSound,
      7: updateLeaderboard,
      sp: addSpray,
      ch: addChat,
      tch: addTradeChat,
      9: showTracer,
      10: showAssistMedal,
      h: changeHealth,
      so: playRawSound,
      6: getKill,
      p: updateInteractProgress,
      lv: updateLives,
      ua: updateAccount,
      ex: explosion,
      ac: actionFeed,
      vc: voiceChat,
      a: accountResponse,
      4: doDamage,
      5: getScore,
      ufp: Game.updateFlagPing,
      fh: updateForceHide,
      bnk: Game.updateBank,
      uamo: updateAmmo,
      upp: changePasswordResponse,
      c2fa: twoFAres,
      ro: Game.respawnObj,
      st: updateKillStreak,
      2: removePlayer,
      kpd: policeRes,
      clog: console.log,
      3: killPlayer,
      ufl: Game.updateFlag,
      kst: killStreakMessage,
      am: addMedal,
      gte: Game.updateGate,
      lm: lockMoveArea,
      rml: readMailResponse,
      gmc: updateMailCount,
      chp: checkpointSet,
      ulm: Game.unlockMove,
      is: Game.triggerImgSound,
      pi: socketPing,
      mv: updMatchVote,
      frs: enterGame,
      chg: updateChallengeProgress,
      vk: voteKickUpdate,
      pir: socketPingResult,
      ot: openTerminal,
      scr: jumpScare,
      up: updateProp,
      pr: showProjectile,
      chgC: challengeCompleted,
      flgr: updateAccountFlags,
      tm: updateTeam,
      pre: endProjectile,
      wep: Game.setWeapon,
      do: Game.destroyObj,
      edMp: editMapResponse,
      obj: Game.setObjective,
      prmR: premiumResponse,
      nmeR: nameChangeResponse,
      trd: tradeUpdate,
      pRes: popupResponse,
      ann: announcement,
      utrd: updateTradeItem,
      atrd: acceptTradeResponse,
      tdR: dropsLoaded,
      vm: window.voteMap,
      loadS: loadSettings,
      crsp: createSpawnable,
      dsp: Game.disposeSpawnable,
      vtRes: twitchLinkResponse,
      rtRes: twitchUnlinkResponse,
      reCa: requestCaptcha,
      aai: Game.AI.cSpawn,
      ai: Game.AI.syncAll,
      spk: setPlayerKey,
      rfl: refillKnife,
    },
  );
}
if (window.captchaReady) {
  grecaptcha.ready(function () {});
} else {
  window.captchaCallback = function () {
    grecaptcha.ready(function () {});
  };
}
// free KR
var preConC = document.getElementById("pre-content-container");
// window.cpmstarAPI(function (api) {
//   api.game.setTarget(preConC);
//   api;
// });
var shakeEffect;
var jumpScares = [
  {
    img: "jumpS_2.png",
  },
  {
    vid: "jumpS_1.mp4",
  },
];
var hg = params.get("scr") || 0;
var hh = hg ? 30000 : 0;
window.jumpScare = function (i) {
  if (jumpScares[i]) {
    if (jumpScares[i].img) {
      jumpSIMG.src = "/scares/" + jumpScares[i].img;
      if (jumpScares[i].loaded) {
        jumpSIMG.style.display = "block";
        SOUND.play("jumpS_1", 2);
        setTimeout(function () {
          jumpSIMG.style.display = "none";
        }, 3000);
      } else {
        SOUND.onLoad("jumpS_1", function () {
          jumpScares[i].loaded = true;
          jumpSIMG.style.display = "block";
          SOUND.play("jumpS_1", 2);
          setTimeout(function () {
            jumpSIMG.style.display = "none";
          }, 3000);
        });
      }
    } else if (jumpScares[i].vid) {
      jumpSVID.src = "/scares/" + jumpScares[i].vid;
      jumpSVID.play();
      jumpSVIDHolder.style.display = "block";
      setTimeout(function () {
        jumpSVIDHolder.style.display = "none";
      }, 4000);
    }
  }
};
window.getGameActivity = function () {
  return {
    id: Game.mode.isRanked ? null : gameId,
    time: timerVal.textContent
      ? timerVal.textContent
          .split(":")
          .reverse()
          .reduce((hj, hk, hl) => hj + hk * Math.pow(60, hl), 0)
      : null,
    user: acc ? acc.alias : "Guest" + (player ? "_" + player.sid : ""),
    class: {
      name: Game.classes[selectedClassIndex].name || null,
      index: player ? player.classIndex : selectedClassIndex,
    },
    map: Game.map.maps[Game.map.lastGen].name,
    mode: Game.mode ? Game.mode.name : null,
    custom: Game.isCustom,
  };
};
(function () {
  if (
    !hasRequire &&
    !webdriver &&
    hasArray &&
    (console.log("GameLoader: " + (Date.now() - window._debugTimeStart) + "ms"),
    (instructions.innerHTML = i18n.get("generic.connecting")),
    !connecting)
  ) {
    connecting = true;
    var testMap = params.has("test") ? config.blankMap : null;
    var savedCustomMap = getSavedVal("custMap");
    deleteVal("custMap");
    if (savedCustomMap || testMap) {
      playCustomMap(savedCustomMap || testMap);
    } else {
      (function () {
        var savedPgi = getSavedVal("pgi");
        var savedQueuePort = getSavedVal("queuePort");
        var savedQueueHost = getSavedVal("queueHost");
        deleteVal("queueHost");
        deleteVal("queuePort");
        deleteVal("pgi");
        var savedBypassToken = getSavedVal("bpt");
        deleteVal("bpt");
        var savedGameId = getSavedVal("gId");
        deleteVal("gId");
        if (savedBypassToken) {
          joinServer(
            savedQueueHost,
            savedQueuePort,
            savedGameId,
            null,
            savedPgi,
            savedBypassToken,
          );
        } else if (savedPgi) {
          joinServer(savedQueueHost, savedQueuePort, null, null, savedPgi);
        } else {
          (typeof __LOADER__mmTokenPromise == "undefined"
            ? Promise.resolve(null)
            : __LOADER__mmTokenPromise
          )
            .then((mmToken) => {
              mmToken;
              if (play) {
                instructions.innerHTML = "Searching for available games...";
                return client.fetchGameList().then((gameList) => {
                  var targetGameId = null;
                  for (var game of gameList.games) {
                    var [gameId, gameInfo, playerCount, maxPlayers, gameData] =
                      game;
                    if (
                      gameData.i.split(/_(.+)/)[1] == play &&
                      playerCount < maxPlayers
                    ) {
                      targetGameId = gameId;
                      play = null;
                      break;
                    }
                  }
                  instructions.innerHTML = targetGameId
                    ? "Joining Game..."
                    : "Hosting Game...";
                  return client.seek({
                    gameId: targetGameId || null,
                    autoChangeGame: false,
                    dataQuery: {
                      v: config.useLooseClient ? undefined : version,
                    },
                    skipReplaceState: streamerModeEnabled,
                    validationToken: mmToken,
                  });
                });
              } else {
                return client.seek({
                  autoChangeGame: false,
                  dataQuery: {
                    v: config.useLooseClient ? undefined : version,
                  },
                  skipReplaceState: streamerModeEnabled,
                  validationToken: mmToken,
                });
              }
            })
            .then((seekResult) => {
              joinServer(
                seekResult.host,
                seekResult.port,
                seekResult.gameId,
                seekResult.clientId,
                null,
              );
            })
            .catch((err) => {
              console.warn("Matchmaker error:", err, err.message, err.response);
              let errorMessage = err.message;
              if (err.response) {
                errorMessage =
                  err.response.data && err.response.data.error
                    ? err.response.data.error
                    : "GameFull";
                if (errorMessage == "InvalidGameId") {
                  errorMessage = i18n.t("matchmaker.invalid");
                } else if (errorMessage == "GameFull") {
                  errorMessage = i18n.t("matchmaker.full2");
                } else if (errorMessage == "NoServersMatchQuery") {
                  errorMessage = i18n.t("matchmaker.updating");
                } else if (errorMessage == "NoAvailableServers") {
                  errorMessage = i18n.t("matchmaker.none");
                } else {
                  console.warn("Unhandled error message", errorMessage);
                }
              } else {
                console.warn("No error response", err.response);
              }
              fatalError(errorMessage);
            });
        }
      })();
    }
    lastRateLimitTime = performance.now();
    lastFrameTime = Date.now();
    gameLoop();
  }
})();
